import qr, { getCurrentInstance as fi, useSlots as ma, computed as me, defineComponent as ge, ref as R, onMounted as Ht, isRef as Kr, unref as wr, getCurrentScope as fh, onScopeDispose as mh, watch as ze, toRefs as pu, customRef as gh, nextTick as ga, onBeforeMount as vh, shallowRef as va, readonly as Mh, reactive as Se, useAttrs as Zs, onBeforeUnmount as Ma, provide as dn, h as mt, toRef as yh, watchEffect as fu, inject as hn } from "vue";
function Lr(i, e = !1, t) {
  var l;
  const r = (l = fi()) == null ? void 0 : l.proxy, n = ma(), a = me(() => {
    const { input: u, ...h } = (r == null ? void 0 : r.$listeners) || {};
    return { ...h, [e ? "change" : "input"]: t };
  }), o = (u) => {
    const h = u.target;
    if (h)
      switch (h.type) {
        case "checkbox":
          i("input", h.checked);
          break;
        default:
          i("input", h.value);
      }
  }, s = (u) => {
    t = u;
  };
  t || s(o);
  const c = me(() => !!n.default);
  return {
    listeners: a,
    hasLabel: c,
    setEmitter: s,
    emitValue: o
  };
}
const xh = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(i, { emit: e }) {
    const { listeners: t, hasLabel: r } = Lr(e);
    return { __sfc: !0, emit: e, listeners: t, hasLabel: r };
  }
});
function Ge(i, e, t, r, n, a, o, s) {
  var c = typeof i == "function" ? i.options : i;
  e && (c.render = e, c.staticRenderFns = t, c._compiled = !0), r && (c.functional = !0), a && (c._scopeId = "data-v-" + a);
  var l;
  if (o ? (l = function(d) {
    d = d || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !d && typeof __VUE_SSR_CONTEXT__ < "u" && (d = __VUE_SSR_CONTEXT__), n && n.call(this, d), d && d._registeredComponents && d._registeredComponents.add(o);
  }, c._ssrRegister = l) : n && (l = s ? function() {
    n.call(
      this,
      (c.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : n), l)
    if (c.functional) {
      c._injectStyles = l;
      var u = c.render;
      c.render = function(v, M) {
        return l.call(M), u(v, M);
      };
    } else {
      var h = c.beforeCreate;
      c.beforeCreate = h ? [].concat(h, l) : [l];
    }
  return {
    exports: i,
    options: c
  };
}
var Ih = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("label", { staticClass: "checkbox", class: { "no-text": !r.hasLabel } }, [t("div", { staticClass: "input" }, [t("input", e._g(e._b({ attrs: { type: "checkbox" }, domProps: { value: e.value, checked: e.value } }, "input", e.$attrs, !1), r.listeners)), t("span", { staticClass: "label" }, [e._t("default")], 2)])]);
}, bh = [], wh = /* @__PURE__ */ Ge(
  xh,
  Ih,
  bh,
  !1,
  null,
  null,
  null,
  null
);
const _h = wh.exports, Ah = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: _h
}, Symbol.toStringTag, { value: "Module" }));
var As = { exports: {} }, mu = { exports: {} };
(function() {
  var i = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", e = {
    rotl: function(t, r) {
      return t << r | t >>> 32 - r;
    },
    rotr: function(t, r) {
      return t << 32 - r | t >>> r;
    },
    endian: function(t) {
      if (t.constructor == Number)
        return e.rotl(t, 8) & 16711935 | e.rotl(t, 24) & 4278255360;
      for (var r = 0; r < t.length; r++)
        t[r] = e.endian(t[r]);
      return t;
    },
    randomBytes: function(t) {
      for (var r = []; t > 0; t--)
        r.push(Math.floor(Math.random() * 256));
      return r;
    },
    bytesToWords: function(t) {
      for (var r = [], n = 0, a = 0; n < t.length; n++, a += 8)
        r[a >>> 5] |= t[n] << 24 - a % 32;
      return r;
    },
    wordsToBytes: function(t) {
      for (var r = [], n = 0; n < t.length * 32; n += 8)
        r.push(t[n >>> 5] >>> 24 - n % 32 & 255);
      return r;
    },
    bytesToHex: function(t) {
      for (var r = [], n = 0; n < t.length; n++)
        r.push((t[n] >>> 4).toString(16)), r.push((t[n] & 15).toString(16));
      return r.join("");
    },
    hexToBytes: function(t) {
      for (var r = [], n = 0; n < t.length; n += 2)
        r.push(parseInt(t.substr(n, 2), 16));
      return r;
    },
    bytesToBase64: function(t) {
      for (var r = [], n = 0; n < t.length; n += 3)
        for (var a = t[n] << 16 | t[n + 1] << 8 | t[n + 2], o = 0; o < 4; o++)
          n * 8 + o * 6 <= t.length * 8 ? r.push(i.charAt(a >>> 6 * (3 - o) & 63)) : r.push("=");
      return r.join("");
    },
    base64ToBytes: function(t) {
      t = t.replace(/[^A-Z0-9+\/]/ig, "");
      for (var r = [], n = 0, a = 0; n < t.length; a = ++n % 4)
        a != 0 && r.push((i.indexOf(t.charAt(n - 1)) & Math.pow(2, -2 * a + 8) - 1) << a * 2 | i.indexOf(t.charAt(n)) >>> 6 - a * 2);
      return r;
    }
  };
  mu.exports = e;
})();
var Ss = {
  utf8: {
    stringToBytes: function(i) {
      return Ss.bin.stringToBytes(unescape(encodeURIComponent(i)));
    },
    bytesToString: function(i) {
      return decodeURIComponent(escape(Ss.bin.bytesToString(i)));
    }
  },
  bin: {
    stringToBytes: function(i) {
      for (var e = [], t = 0; t < i.length; t++)
        e.push(i.charCodeAt(t) & 255);
      return e;
    },
    bytesToString: function(i) {
      for (var e = [], t = 0; t < i.length; t++)
        e.push(String.fromCharCode(i[t]));
      return e.join("");
    }
  }
}, go = Ss;
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var Sh = function(i) {
  return i != null && (gu(i) || Dh(i) || !!i._isBuffer);
};
function gu(i) {
  return !!i.constructor && typeof i.constructor.isBuffer == "function" && i.constructor.isBuffer(i);
}
function Dh(i) {
  return typeof i.readFloatLE == "function" && typeof i.slice == "function" && gu(i.slice(0, 0));
}
(function() {
  var i = mu.exports, e = go.utf8, t = Sh, r = go.bin, n = function(a, o) {
    a.constructor == String ? o && o.encoding === "binary" ? a = r.stringToBytes(a) : a = e.stringToBytes(a) : t(a) ? a = Array.prototype.slice.call(a, 0) : !Array.isArray(a) && a.constructor !== Uint8Array && (a = a.toString());
    for (var s = i.bytesToWords(a), c = a.length * 8, l = 1732584193, u = -271733879, h = -1732584194, d = 271733878, v = 0; v < s.length; v++)
      s[v] = (s[v] << 8 | s[v] >>> 24) & 16711935 | (s[v] << 24 | s[v] >>> 8) & 4278255360;
    s[c >>> 5] |= 128 << c % 32, s[(c + 64 >>> 9 << 4) + 14] = c;
    for (var M = n._ff, m = n._gg, g = n._hh, I = n._ii, v = 0; v < s.length; v += 16) {
      var A = l, L = u, y = h, D = d;
      l = M(l, u, h, d, s[v + 0], 7, -680876936), d = M(d, l, u, h, s[v + 1], 12, -389564586), h = M(h, d, l, u, s[v + 2], 17, 606105819), u = M(u, h, d, l, s[v + 3], 22, -1044525330), l = M(l, u, h, d, s[v + 4], 7, -176418897), d = M(d, l, u, h, s[v + 5], 12, 1200080426), h = M(h, d, l, u, s[v + 6], 17, -1473231341), u = M(u, h, d, l, s[v + 7], 22, -45705983), l = M(l, u, h, d, s[v + 8], 7, 1770035416), d = M(d, l, u, h, s[v + 9], 12, -1958414417), h = M(h, d, l, u, s[v + 10], 17, -42063), u = M(u, h, d, l, s[v + 11], 22, -1990404162), l = M(l, u, h, d, s[v + 12], 7, 1804603682), d = M(d, l, u, h, s[v + 13], 12, -40341101), h = M(h, d, l, u, s[v + 14], 17, -1502002290), u = M(u, h, d, l, s[v + 15], 22, 1236535329), l = m(l, u, h, d, s[v + 1], 5, -165796510), d = m(d, l, u, h, s[v + 6], 9, -1069501632), h = m(h, d, l, u, s[v + 11], 14, 643717713), u = m(u, h, d, l, s[v + 0], 20, -373897302), l = m(l, u, h, d, s[v + 5], 5, -701558691), d = m(d, l, u, h, s[v + 10], 9, 38016083), h = m(h, d, l, u, s[v + 15], 14, -660478335), u = m(u, h, d, l, s[v + 4], 20, -405537848), l = m(l, u, h, d, s[v + 9], 5, 568446438), d = m(d, l, u, h, s[v + 14], 9, -1019803690), h = m(h, d, l, u, s[v + 3], 14, -187363961), u = m(u, h, d, l, s[v + 8], 20, 1163531501), l = m(l, u, h, d, s[v + 13], 5, -1444681467), d = m(d, l, u, h, s[v + 2], 9, -51403784), h = m(h, d, l, u, s[v + 7], 14, 1735328473), u = m(u, h, d, l, s[v + 12], 20, -1926607734), l = g(l, u, h, d, s[v + 5], 4, -378558), d = g(d, l, u, h, s[v + 8], 11, -2022574463), h = g(h, d, l, u, s[v + 11], 16, 1839030562), u = g(u, h, d, l, s[v + 14], 23, -35309556), l = g(l, u, h, d, s[v + 1], 4, -1530992060), d = g(d, l, u, h, s[v + 4], 11, 1272893353), h = g(h, d, l, u, s[v + 7], 16, -155497632), u = g(u, h, d, l, s[v + 10], 23, -1094730640), l = g(l, u, h, d, s[v + 13], 4, 681279174), d = g(d, l, u, h, s[v + 0], 11, -358537222), h = g(h, d, l, u, s[v + 3], 16, -722521979), u = g(u, h, d, l, s[v + 6], 23, 76029189), l = g(l, u, h, d, s[v + 9], 4, -640364487), d = g(d, l, u, h, s[v + 12], 11, -421815835), h = g(h, d, l, u, s[v + 15], 16, 530742520), u = g(u, h, d, l, s[v + 2], 23, -995338651), l = I(l, u, h, d, s[v + 0], 6, -198630844), d = I(d, l, u, h, s[v + 7], 10, 1126891415), h = I(h, d, l, u, s[v + 14], 15, -1416354905), u = I(u, h, d, l, s[v + 5], 21, -57434055), l = I(l, u, h, d, s[v + 12], 6, 1700485571), d = I(d, l, u, h, s[v + 3], 10, -1894986606), h = I(h, d, l, u, s[v + 10], 15, -1051523), u = I(u, h, d, l, s[v + 1], 21, -2054922799), l = I(l, u, h, d, s[v + 8], 6, 1873313359), d = I(d, l, u, h, s[v + 15], 10, -30611744), h = I(h, d, l, u, s[v + 6], 15, -1560198380), u = I(u, h, d, l, s[v + 13], 21, 1309151649), l = I(l, u, h, d, s[v + 4], 6, -145523070), d = I(d, l, u, h, s[v + 11], 10, -1120210379), h = I(h, d, l, u, s[v + 2], 15, 718787259), u = I(u, h, d, l, s[v + 9], 21, -343485551), l = l + A >>> 0, u = u + L >>> 0, h = h + y >>> 0, d = d + D >>> 0;
    }
    return i.endian([l, u, h, d]);
  };
  n._ff = function(a, o, s, c, l, u, h) {
    var d = a + (o & s | ~o & c) + (l >>> 0) + h;
    return (d << u | d >>> 32 - u) + o;
  }, n._gg = function(a, o, s, c, l, u, h) {
    var d = a + (o & c | s & ~c) + (l >>> 0) + h;
    return (d << u | d >>> 32 - u) + o;
  }, n._hh = function(a, o, s, c, l, u, h) {
    var d = a + (o ^ s ^ c) + (l >>> 0) + h;
    return (d << u | d >>> 32 - u) + o;
  }, n._ii = function(a, o, s, c, l, u, h) {
    var d = a + (s ^ (o | ~c)) + (l >>> 0) + h;
    return (d << u | d >>> 32 - u) + o;
  }, n._blocksize = 16, n._digestsize = 16, As.exports = function(a, o) {
    if (a == null)
      throw new Error("Illegal argument " + a);
    var s = i.wordsToBytes(n(a, o));
    return o && o.asBytes ? s : o && o.asString ? r.bytesToString(s) : i.bytesToHex(s);
  };
})();
class Th {
  constructor() {
    this.items = [];
  }
  register(e, t = !1) {
    !e || this.has(e) || this.items.push({
      key: As.exports(e),
      isCollapsed: t
    });
  }
  has(e) {
    if (!e)
      return;
    const t = As.exports(e);
    return this.items.find((r) => r.key === t);
  }
  get(e) {
    return this.has(e);
  }
  update(e, t) {
    const r = this.has(e);
    !r || (r.isCollapsed = t);
  }
}
const wn = new Th(), Ch = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    showOnInit: { type: Boolean, default: !0 },
    tag: { default: "div" },
    reference: { default: null }
  },
  setup(i, { expose: e }) {
    const t = i, r = R(!1), n = () => {
      r.value = !r.value, wn.update(t.reference, r.value);
    };
    return Ht(() => {
      if (!wn.has(t.reference))
        r.value = !t.showOnInit, wn.register(t.reference, r.value);
      else {
        const a = wn.get(t.reference);
        r.value = a ? a.isCollapsed : r.value;
      }
    }), e({ isCollapsed: r, toggle: n }), { __sfc: !0, props: t, isCollapsed: r, toggle: n };
  }
});
var Eh = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t(e.tag, e._b({ tag: "component", staticClass: "v-collapse" }, "component", e.$attrs, !1), [e._t("trigger", null, null, { isCollapsed: r.isCollapsed, toggle: r.toggle }), r.isCollapsed ? e._e() : e._t("default", null, null, { isCollapsed: r.isCollapsed, toggle: r.toggle })], 2);
}, Nh = [], Lh = /* @__PURE__ */ Ge(
  Ch,
  Eh,
  Nh,
  !1,
  null,
  null,
  null,
  null
);
const Ph = Lh.exports, jh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ph
}, Symbol.toStringTag, { value: "Module" })), Bh = {};
var Oh = function() {
  var e = this, t = e._self._c;
  return t("div", e._g(e._b({ staticClass: "v-contextmenu" }, "div", e.$attrs, !1), e.$listeners), [e._t("default")], 2);
}, zh = [], Rh = /* @__PURE__ */ Ge(
  Bh,
  Oh,
  zh,
  !1,
  null,
  null,
  null,
  null
);
const vu = Rh.exports, kh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vu
}, Symbol.toStringTag, { value: "Module" })), Wh = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    name: null
  },
  setup(i) {
    return { __sfc: !0 };
  }
});
var Gh = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("svg", { staticClass: "v-icon" }, [t("use", { attrs: { "xlink:href": "#" + e.name } })]);
}, Uh = [], Hh = /* @__PURE__ */ Ge(
  Wh,
  Gh,
  Uh,
  !1,
  null,
  null,
  null,
  null
);
const pn = Hh.exports, Fh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pn
}, Symbol.toStringTag, { value: "Module" })), Vh = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    value: null
  },
  setup(i) {
    const e = R(null);
    return { __sfc: !0, fileRef: e, trigger: () => {
      e.value && e.value.click();
    } };
  }
});
var Yh = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("button", { staticClass: "v-file", on: { click: r.trigger } }, [t("input", e._g(e._b({ ref: "fileRef", attrs: { type: "file" }, domProps: { value: e.value } }, "input", e.$attrs, !1), e.$listeners)), e._t("default", function() {
    return [t("v-icon", { attrs: { name: "upload-cloud" } }), e._v(" Select a file ")];
  })], 2);
}, Zh = [], Qh = /* @__PURE__ */ Ge(
  Vh,
  Yh,
  Zh,
  !1,
  null,
  null,
  null,
  null
);
const Jh = Qh.exports, Xh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jh
}, Symbol.toStringTag, { value: "Module" }));
var vo;
const ti = typeof window < "u", Mu = (i) => typeof i == "function", yu = (i) => typeof i == "string", aa = () => +Date.now(), Mo = (i, e, t) => Math.min(t, Math.max(e, i)), yt = () => {
}, yo = ti && ((vo = window == null ? void 0 : window.navigator) == null ? void 0 : vo.userAgent) && /iP(ad|hone|od)/.test(window.navigator.userAgent);
function We(i) {
  return typeof i == "function" ? i() : wr(i);
}
function ya(i, e) {
  function t(...r) {
    i(() => e.apply(this, r), { fn: e, thisArg: this, args: r });
  }
  return t;
}
const Qs = (i) => i();
function $h(i, e = {}) {
  let t, r;
  return (a) => {
    const o = We(i), s = We(e.maxWait);
    if (t && clearTimeout(t), o <= 0 || s !== void 0 && s <= 0)
      return r && (clearTimeout(r), r = null), a();
    s && !r && (r = setTimeout(() => {
      t && clearTimeout(t), r = null, a();
    }, s)), t = setTimeout(() => {
      r && clearTimeout(r), r = null, a();
    }, o);
  };
}
function qh(i, e = !0, t = !0) {
  let r = 0, n, a = !0;
  const o = () => {
    n && (clearTimeout(n), n = void 0);
  };
  return (c) => {
    const l = We(i), u = Date.now() - r;
    if (o(), l <= 0)
      return r = Date.now(), c();
    u > l && (t || !a) ? (r = Date.now(), c()) : e && (n = setTimeout(() => {
      r = Date.now(), a = !0, o(), c();
    }, l)), !t && !n && (n = setTimeout(() => a = !0, l)), a = !1;
  };
}
function Kh(i = Qs) {
  const e = R(!0);
  function t() {
    e.value = !1;
  }
  function r() {
    e.value = !0;
  }
  return { isActive: e, pause: t, resume: r, eventFilter: (...a) => {
    e.value && i(...a);
  } };
}
const ep = {
  mounted: "inserted",
  updated: "componentUpdated",
  unmounted: "unbind"
};
function tp(i, e = !1, t = "Timeout") {
  return new Promise((r, n) => {
    setTimeout(e ? () => n(t) : r, i);
  });
}
function ip(i) {
  return i;
}
function rp(i) {
  let e;
  function t() {
    return e || (e = i()), e;
  }
  return t.reset = async () => {
    const r = e;
    e = void 0, r && await r;
  }, t;
}
function np(i, e, t = !1) {
  return e.reduce((r, n) => (n in i && (!t || i[n] !== void 0) && (r[n] = i[n]), r), {});
}
function xt(i) {
  return fh() ? (mh(i), !0) : !1;
}
function xa(i, e = 200, t = {}) {
  return ya($h(e, t), i);
}
function ap(i) {
  return typeof i == "function" ? me(i) : R(i);
}
function xo(i, e, t = {}) {
  var r, n;
  const {
    flush: a = "sync",
    deep: o = !1,
    immediate: s = !0,
    direction: c = "both",
    transform: l = {}
  } = t;
  let u, h;
  const d = (r = l.ltr) != null ? r : (M) => M, v = (n = l.rtl) != null ? n : (M) => M;
  return (c === "both" || c === "ltr") && (u = ze(i, (M) => e.value = d(M), { flush: a, deep: o, immediate: s })), (c === "both" || c === "rtl") && (h = ze(e, (M) => i.value = v(M), { flush: a, deep: o, immediate: s })), () => {
    u == null || u(), h == null || h();
  };
}
var sp = Object.defineProperty, op = Object.defineProperties, lp = Object.getOwnPropertyDescriptors, Io = Object.getOwnPropertySymbols, cp = Object.prototype.hasOwnProperty, up = Object.prototype.propertyIsEnumerable, bo = (i, e, t) => e in i ? sp(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, dp = (i, e) => {
  for (var t in e || (e = {}))
    cp.call(e, t) && bo(i, t, e[t]);
  if (Io)
    for (var t of Io(e))
      up.call(e, t) && bo(i, t, e[t]);
  return i;
}, hp = (i, e) => op(i, lp(e));
function xu(i) {
  if (!Kr(i))
    return pu(i);
  const e = Array.isArray(i.value) ? new Array(i.value.length) : {};
  for (const t in i.value)
    e[t] = gh(() => ({
      get() {
        return i.value[t];
      },
      set(r) {
        if (Array.isArray(i.value)) {
          const n = [...i.value];
          n[t] = r, i.value = n;
        } else {
          const n = hp(dp({}, i.value), { [t]: r });
          Object.setPrototypeOf(n, i.value), i.value = n;
        }
      }
    }));
  return e;
}
function Iu(i, e = !0) {
  fi() ? vh(i) : e ? i() : ga(i);
}
function Ni(i, e = !0) {
  fi() ? Ht(i) : e ? i() : ga(i);
}
function bu(i, e = 1e3, t = {}) {
  const {
    immediate: r = !0,
    immediateCallback: n = !1
  } = t;
  let a = null;
  const o = R(!1);
  function s() {
    a && (clearInterval(a), a = null);
  }
  function c() {
    o.value = !1, s();
  }
  function l() {
    wr(e) <= 0 || (o.value = !0, n && i(), s(), a = setInterval(i, We(e)));
  }
  if (r && ti && l(), Kr(e)) {
    const u = ze(e, () => {
      o.value && ti && l();
    });
    xt(u);
  }
  return xt(c), {
    isActive: o,
    pause: c,
    resume: l
  };
}
function wu(i = !1, e = {}) {
  const {
    truthyValue: t = !0,
    falsyValue: r = !1
  } = e, n = Kr(i), a = R(i);
  function o(s) {
    if (arguments.length)
      return a.value = s, a.value;
    {
      const c = We(t);
      return a.value = a.value === c ? We(r) : c, a.value;
    }
  }
  return n ? o : [a, o];
}
var wo = Object.getOwnPropertySymbols, pp = Object.prototype.hasOwnProperty, fp = Object.prototype.propertyIsEnumerable, mp = (i, e) => {
  var t = {};
  for (var r in i)
    pp.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  if (i != null && wo)
    for (var r of wo(i))
      e.indexOf(r) < 0 && fp.call(i, r) && (t[r] = i[r]);
  return t;
};
function gp(i, e, t = {}) {
  const r = t, {
    eventFilter: n = Qs
  } = r, a = mp(r, [
    "eventFilter"
  ]);
  return ze(i, ya(n, e), a);
}
var vp = Object.defineProperty, Mp = Object.defineProperties, yp = Object.getOwnPropertyDescriptors, sa = Object.getOwnPropertySymbols, _u = Object.prototype.hasOwnProperty, Au = Object.prototype.propertyIsEnumerable, _o = (i, e, t) => e in i ? vp(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, xp = (i, e) => {
  for (var t in e || (e = {}))
    _u.call(e, t) && _o(i, t, e[t]);
  if (sa)
    for (var t of sa(e))
      Au.call(e, t) && _o(i, t, e[t]);
  return i;
}, Ip = (i, e) => Mp(i, yp(e)), bp = (i, e) => {
  var t = {};
  for (var r in i)
    _u.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  if (i != null && sa)
    for (var r of sa(i))
      e.indexOf(r) < 0 && Au.call(i, r) && (t[r] = i[r]);
  return t;
};
function Su(i, e, t = {}) {
  const r = t, {
    eventFilter: n
  } = r, a = bp(r, [
    "eventFilter"
  ]), { eventFilter: o, pause: s, resume: c, isActive: l } = Kh(n);
  return { stop: gp(i, e, Ip(xp({}, a), {
    eventFilter: o
  })), pause: s, resume: c, isActive: l };
}
function _t(i) {
  var e;
  const t = We(i);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const He = ti ? window : void 0, Du = ti ? window.document : void 0, Ia = ti ? window.navigator : void 0;
function Ie(...i) {
  let e, t, r, n;
  if (yu(i[0]) ? ([t, r, n] = i, e = He) : [e, t, r, n] = i, !e)
    return yt;
  let a = yt;
  const o = ze(() => _t(e), (c) => {
    a(), c && (c.addEventListener(t, r, n), a = () => {
      c.removeEventListener(t, r, n), a = yt;
    });
  }, { immediate: !0, flush: "post" }), s = () => {
    o(), a();
  };
  return xt(s), s;
}
function wp(i, e, t = {}) {
  const { window: r = He, ignore: n, capture: a = !0, detectIframe: o = !1 } = t;
  if (!r)
    return;
  const s = R(!0);
  let c;
  const l = (d) => {
    r.clearTimeout(c);
    const v = _t(i), M = d.composedPath();
    !v || v === d.target || M.includes(v) || !s.value || n && n.length > 0 && n.some((m) => {
      const g = _t(m);
      return g && (d.target === g || M.includes(g));
    }) || e(d);
  }, u = [
    Ie(r, "click", l, { passive: !0, capture: a }),
    Ie(r, "pointerdown", (d) => {
      const v = _t(i);
      s.value = !!v && !d.composedPath().includes(v);
    }, { passive: !0 }),
    Ie(r, "pointerup", (d) => {
      if (d.button === 0) {
        const v = d.composedPath();
        d.composedPath = () => v, c = r.setTimeout(() => l(d), 50);
      }
    }, { passive: !0 }),
    o && Ie(r, "blur", (d) => {
      var v;
      const M = _t(i);
      ((v = document.activeElement) == null ? void 0 : v.tagName) === "IFRAME" && !(M != null && M.contains(document.activeElement)) && e(d);
    })
  ].filter(Boolean);
  return () => u.forEach((d) => d());
}
function _p(i = {}) {
  const { window: e = He } = i, t = R(0);
  return e && (Ie(e, "blur", () => t.value += 1, !0), Ie(e, "focus", () => t.value += 1, !0)), me(() => (t.value, e == null ? void 0 : e.document.activeElement));
}
function ii(i, e = !1) {
  const t = R(), r = () => t.value = Boolean(i());
  return r(), Ni(r, e), t;
}
function Ap({ navigator: i = Ia } = {}) {
  const e = ["chargingchange", "chargingtimechange", "dischargingtimechange", "levelchange"], t = ii(() => i && "getBattery" in i), r = R(!1), n = R(0), a = R(0), o = R(1);
  let s;
  function c() {
    r.value = this.charging, n.value = this.chargingTime || 0, a.value = this.dischargingTime || 0, o.value = this.level;
  }
  return t.value && i.getBattery().then((l) => {
    s = l, c.call(s);
    for (const u of e)
      Ie(s, u, c, { passive: !0 });
  }), {
    isSupported: t,
    charging: r,
    chargingTime: n,
    dischargingTime: a,
    level: o
  };
}
function _r(i, e = {}) {
  const { window: t = He } = e, r = ii(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let n;
  const a = R(!1), o = () => {
    !r.value || (n || (n = t.matchMedia(i)), a.value = n.matches);
  };
  return Iu(() => {
    o(), n && ("addEventListener" in n ? n.addEventListener("change", o) : n.addListener(o), xt(() => {
      "removeEventListener" in n ? n.removeEventListener("change", o) : n.removeListener(o);
    }));
  }), a;
}
function Sp({ window: i = He } = {}) {
  const e = (r) => {
    const { state: n, length: a } = (i == null ? void 0 : i.history) || {}, { hash: o, host: s, hostname: c, href: l, origin: u, pathname: h, port: d, protocol: v, search: M } = (i == null ? void 0 : i.location) || {};
    return {
      trigger: r,
      state: n,
      length: a,
      hash: o,
      host: s,
      hostname: c,
      href: l,
      origin: u,
      pathname: h,
      port: d,
      protocol: v,
      search: M
    };
  }, t = R(e("load"));
  return i && (Ie(i, "popstate", () => t.value = e("popstate"), { passive: !0 }), Ie(i, "hashchange", () => t.value = e("hashchange"), { passive: !0 })), t;
}
const Ds = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Ts = "__vueuse_ssr_handlers__";
Ds[Ts] = Ds[Ts] || {};
const Dp = Ds[Ts];
function Tu(i, e) {
  return Dp[i] || e;
}
function Tp(i) {
  return i == null ? "any" : i instanceof Set ? "set" : i instanceof Map ? "map" : i instanceof Date ? "date" : typeof i == "boolean" ? "boolean" : typeof i == "string" ? "string" : typeof i == "object" || Array.isArray(i) ? "object" : Number.isNaN(i) ? "any" : "number";
}
var Cp = Object.defineProperty, Ao = Object.getOwnPropertySymbols, Ep = Object.prototype.hasOwnProperty, Np = Object.prototype.propertyIsEnumerable, So = (i, e, t) => e in i ? Cp(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Do = (i, e) => {
  for (var t in e || (e = {}))
    Ep.call(e, t) && So(i, t, e[t]);
  if (Ao)
    for (var t of Ao(e))
      Np.call(e, t) && So(i, t, e[t]);
  return i;
};
const Lp = {
  boolean: {
    read: (i) => i === "true",
    write: (i) => String(i)
  },
  object: {
    read: (i) => JSON.parse(i),
    write: (i) => JSON.stringify(i)
  },
  number: {
    read: (i) => Number.parseFloat(i),
    write: (i) => String(i)
  },
  any: {
    read: (i) => i,
    write: (i) => String(i)
  },
  string: {
    read: (i) => i,
    write: (i) => String(i)
  },
  map: {
    read: (i) => new Map(JSON.parse(i)),
    write: (i) => JSON.stringify(Array.from(i.entries()))
  },
  set: {
    read: (i) => new Set(JSON.parse(i)),
    write: (i) => JSON.stringify(Array.from(i))
  },
  date: {
    read: (i) => new Date(i),
    write: (i) => i.toISOString()
  }
};
function Cu(i, e, t, r = {}) {
  var n;
  const {
    flush: a = "pre",
    deep: o = !0,
    listenToStorageChanges: s = !0,
    writeDefaults: c = !0,
    mergeDefaults: l = !1,
    shallow: u,
    window: h = He,
    eventFilter: d,
    onError: v = (B) => {
      console.error(B);
    }
  } = r, M = (u ? va : R)(e);
  if (!t)
    try {
      t = Tu("getDefaultStorage", () => {
        var B;
        return (B = He) == null ? void 0 : B.localStorage;
      })();
    } catch (B) {
      v(B);
    }
  if (!t)
    return M;
  const m = We(e), g = Tp(m), I = (n = r.serializer) != null ? n : Lp[g], { pause: A, resume: L } = Su(M, () => y(M.value), { flush: a, deep: o, eventFilter: d });
  return h && s && Ie(h, "storage", T), T(), M;
  function y(B) {
    try {
      B == null ? t.removeItem(i) : t.setItem(i, I.write(B));
    } catch (S) {
      v(S);
    }
  }
  function D(B) {
    if (!(B && B.key !== i)) {
      A();
      try {
        const S = B ? B.newValue : t.getItem(i);
        if (S == null)
          return c && m !== null && t.setItem(i, I.write(m)), m;
        if (!B && l) {
          const P = I.read(S);
          return Mu(l) ? l(P, m) : g === "object" && !Array.isArray(P) ? Do(Do({}, m), P) : P;
        } else
          return typeof S != "string" ? S : I.read(S);
      } catch (S) {
        v(S);
      } finally {
        L();
      }
    }
  }
  function T(B) {
    B && B.key !== i || (M.value = D(B));
  }
}
function Js(i) {
  return _r("(prefers-color-scheme: dark)", i);
}
var Pp = Object.defineProperty, To = Object.getOwnPropertySymbols, jp = Object.prototype.hasOwnProperty, Bp = Object.prototype.propertyIsEnumerable, Co = (i, e, t) => e in i ? Pp(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Op = (i, e) => {
  for (var t in e || (e = {}))
    jp.call(e, t) && Co(i, t, e[t]);
  if (To)
    for (var t of To(e))
      Bp.call(e, t) && Co(i, t, e[t]);
  return i;
};
function zp(i = {}) {
  const {
    selector: e = "html",
    attribute: t = "class",
    initialValue: r = "auto",
    window: n = He,
    storage: a,
    storageKey: o = "vueuse-color-scheme",
    listenToStorageChanges: s = !0,
    storageRef: c,
    emitAuto: l
  } = i, u = Op({
    auto: "",
    light: "light",
    dark: "dark"
  }, i.modes || {}), h = Js({ window: n }), d = me(() => h.value ? "dark" : "light"), v = c || (o == null ? R(r) : Cu(o, r, a, { window: n, listenToStorageChanges: s })), M = me({
    get() {
      return v.value === "auto" && !l ? d.value : v.value;
    },
    set(A) {
      v.value = A;
    }
  }), m = Tu("updateHTMLAttrs", (A, L, y) => {
    const D = n == null ? void 0 : n.document.querySelector(A);
    if (!!D)
      if (L === "class") {
        const T = y.split(/\s/g);
        Object.values(u).flatMap((B) => (B || "").split(/\s/g)).filter(Boolean).forEach((B) => {
          T.includes(B) ? D.classList.add(B) : D.classList.remove(B);
        });
      } else
        D.setAttribute(L, y);
  });
  function g(A) {
    var L;
    const y = A === "auto" ? d.value : A;
    m(e, t, (L = u[y]) != null ? L : y);
  }
  function I(A) {
    i.onChanged ? i.onChanged(A, g) : g(A);
  }
  return ze(M, I, { flush: "post", immediate: !0 }), l && ze(d, () => I(M.value), { flush: "post" }), Ni(() => I(M.value)), M;
}
var Rp = Object.defineProperty, kp = Object.defineProperties, Wp = Object.getOwnPropertyDescriptors, Eo = Object.getOwnPropertySymbols, Gp = Object.prototype.hasOwnProperty, Up = Object.prototype.propertyIsEnumerable, No = (i, e, t) => e in i ? Rp(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Hp = (i, e) => {
  for (var t in e || (e = {}))
    Gp.call(e, t) && No(i, t, e[t]);
  if (Eo)
    for (var t of Eo(e))
      Up.call(e, t) && No(i, t, e[t]);
  return i;
}, Fp = (i, e) => kp(i, Wp(e));
function Eu(i = {}) {
  const {
    valueDark: e = "dark",
    valueLight: t = "",
    window: r = He
  } = i, n = zp(Fp(Hp({}, i), {
    onChanged: (s, c) => {
      var l;
      i.onChanged ? (l = i.onChanged) == null || l.call(i, s === "dark") : c(s);
    },
    modes: {
      dark: e,
      light: t
    }
  })), a = Js({ window: r });
  return me({
    get() {
      return n.value === "dark";
    },
    set(s) {
      s === a.value ? n.value = "auto" : n.value = s ? "dark" : "light";
    }
  });
}
function Vp(i = {}) {
  const {
    window: e = He,
    eventFilter: t = Qs
  } = i, r = R({ x: null, y: null, z: null }), n = R({ alpha: null, beta: null, gamma: null }), a = R(0), o = R({
    x: null,
    y: null,
    z: null
  });
  if (e) {
    const s = ya(t, (c) => {
      r.value = c.acceleration, o.value = c.accelerationIncludingGravity, n.value = c.rotationRate, a.value = c.interval;
    });
    Ie(e, "devicemotion", s);
  }
  return {
    acceleration: r,
    accelerationIncludingGravity: o,
    rotationRate: n,
    interval: a
  };
}
function Yp(i = {}) {
  const { window: e = He } = i, t = ii(() => e && "DeviceOrientationEvent" in e), r = R(!1), n = R(null), a = R(null), o = R(null);
  return e && t.value && Ie(e, "deviceorientation", (s) => {
    r.value = s.absolute, n.value = s.alpha, a.value = s.beta, o.value = s.gamma;
  }), {
    isSupported: t,
    isAbsolute: r,
    alpha: n,
    beta: a,
    gamma: o
  };
}
const Zp = [
  1,
  1.325,
  1.4,
  1.5,
  1.8,
  2,
  2.4,
  2.5,
  2.75,
  3,
  3.5,
  4
];
function Qp({
  window: i = He
} = {}) {
  if (!i)
    return {
      pixelRatio: R(1)
    };
  const e = R(i.devicePixelRatio), t = () => {
    e.value = i.devicePixelRatio;
  };
  return Ie(i, "resize", t, { passive: !0 }), Zp.forEach((r) => {
    const n = _r(`screen and (min-resolution: ${r}dppx)`), a = _r(`screen and (max-resolution: ${r}dppx)`);
    ze([n, a], t);
  }), { pixelRatio: e };
}
function Jp(i, e = {}) {
  const {
    controls: t = !1,
    navigator: r = Ia
  } = e, n = ii(() => r && "permissions" in r);
  let a;
  const o = typeof i == "string" ? { name: i } : i, s = R(), c = () => {
    a && (s.value = a.state);
  }, l = rp(async () => {
    if (!!n.value) {
      if (!a)
        try {
          a = await r.permissions.query(o), Ie(a, "change", c), c();
        } catch {
          s.value = "prompt";
        }
      return a;
    }
  });
  return l(), t ? {
    state: s,
    isSupported: n,
    query: l
  } : s;
}
function Xp(i = {}) {
  const {
    navigator: e = Ia,
    requestPermissions: t = !1,
    constraints: r = { audio: !0, video: !0 },
    onUpdated: n
  } = i, a = R([]), o = me(() => a.value.filter((v) => v.kind === "videoinput")), s = me(() => a.value.filter((v) => v.kind === "audioinput")), c = me(() => a.value.filter((v) => v.kind === "audiooutput")), l = ii(() => e && e.mediaDevices && e.mediaDevices.enumerateDevices), u = R(!1);
  async function h() {
    !l.value || (a.value = await e.mediaDevices.enumerateDevices(), n == null || n(a.value));
  }
  async function d() {
    if (!l.value)
      return !1;
    if (u.value)
      return !0;
    const { state: v, query: M } = Jp("camera", { controls: !0 });
    return await M(), v.value !== "granted" && ((await e.mediaDevices.getUserMedia(r)).getTracks().forEach((g) => g.stop()), h()), u.value = !0, u.value;
  }
  return l.value && (t && d(), Ie(e.mediaDevices, "devicechange", h), h()), {
    devices: a,
    ensurePermissions: d,
    permissionGranted: u,
    videoInputs: o,
    audioInputs: s,
    audioOutputs: c,
    isSupported: l
  };
}
function $p({ document: i = Du } = {}) {
  if (!i)
    return R("visible");
  const e = R(i.visibilityState);
  return Ie(i, "visibilitychange", () => {
    e.value = i.visibilityState;
  }), e;
}
var qp = Object.defineProperty, Kp = Object.defineProperties, ef = Object.getOwnPropertyDescriptors, Lo = Object.getOwnPropertySymbols, tf = Object.prototype.hasOwnProperty, rf = Object.prototype.propertyIsEnumerable, Po = (i, e, t) => e in i ? qp(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, nf = (i, e) => {
  for (var t in e || (e = {}))
    tf.call(e, t) && Po(i, t, e[t]);
  if (Lo)
    for (var t of Lo(e))
      rf.call(e, t) && Po(i, t, e[t]);
  return i;
}, af = (i, e) => Kp(i, ef(e));
function sf(i, e = {}) {
  var t, r;
  const n = (t = e.draggingElement) != null ? t : He, a = R((r = We(e.initialValue)) != null ? r : { x: 0, y: 0 }), o = R(), s = (d) => e.pointerTypes ? e.pointerTypes.includes(d.pointerType) : !0, c = (d) => {
    We(e.preventDefault) && d.preventDefault(), We(e.stopPropagation) && d.stopPropagation();
  }, l = (d) => {
    var v;
    if (!s(d) || We(e.exact) && d.target !== We(i))
      return;
    const M = We(i).getBoundingClientRect(), m = {
      x: d.pageX - M.left,
      y: d.pageY - M.top
    };
    ((v = e.onStart) == null ? void 0 : v.call(e, m, d)) !== !1 && (o.value = m, c(d));
  }, u = (d) => {
    var v;
    !s(d) || !o.value || (a.value = {
      x: d.pageX - o.value.x,
      y: d.pageY - o.value.y
    }, (v = e.onMove) == null || v.call(e, a.value, d), c(d));
  }, h = (d) => {
    var v;
    !s(d) || !o.value || (o.value = void 0, (v = e.onEnd) == null || v.call(e, a.value, d), c(d));
  };
  return ti && (Ie(i, "pointerdown", l, !0), Ie(n, "pointermove", u, !0), Ie(n, "pointerup", h, !0)), af(nf({}, xu(a)), {
    position: a,
    isDragging: me(() => !!o.value),
    style: me(() => `left:${a.value.x}px;top:${a.value.y}px;`)
  });
}
var jo = Object.getOwnPropertySymbols, of = Object.prototype.hasOwnProperty, lf = Object.prototype.propertyIsEnumerable, cf = (i, e) => {
  var t = {};
  for (var r in i)
    of.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  if (i != null && jo)
    for (var r of jo(i))
      e.indexOf(r) < 0 && lf.call(i, r) && (t[r] = i[r]);
  return t;
};
function Nu(i, e, t = {}) {
  const r = t, { window: n = He } = r, a = cf(r, ["window"]);
  let o;
  const s = ii(() => n && "ResizeObserver" in n), c = () => {
    o && (o.disconnect(), o = void 0);
  }, l = ze(() => _t(i), (h) => {
    c(), s.value && n && h && (o = new ResizeObserver(e), o.observe(h, a));
  }, { immediate: !0, flush: "post" }), u = () => {
    c(), l();
  };
  return xt(u), {
    isSupported: s,
    stop: u
  };
}
function uf(i, e = {}) {
  const {
    reset: t = !0,
    windowResize: r = !0,
    windowScroll: n = !0,
    immediate: a = !0
  } = e, o = R(0), s = R(0), c = R(0), l = R(0), u = R(0), h = R(0), d = R(0), v = R(0);
  function M() {
    const m = _t(i);
    if (!m) {
      t && (o.value = 0, s.value = 0, c.value = 0, l.value = 0, u.value = 0, h.value = 0, d.value = 0, v.value = 0);
      return;
    }
    const g = m.getBoundingClientRect();
    o.value = g.height, s.value = g.bottom, c.value = g.left, l.value = g.right, u.value = g.top, h.value = g.width, d.value = g.x, v.value = g.y;
  }
  return Nu(i, M), ze(() => _t(i), (m) => !m && M()), n && Ie("scroll", M, { passive: !0 }), r && Ie("resize", M, { passive: !0 }), Ni(() => {
    a && M();
  }), {
    height: o,
    bottom: s,
    left: c,
    right: l,
    top: u,
    width: h,
    x: d,
    y: v,
    update: M
  };
}
function Lu(i, e = {}) {
  const {
    immediate: t = !0,
    window: r = He
  } = e, n = R(!1);
  let a = null;
  function o() {
    !n.value || !r || (i(), a = r.requestAnimationFrame(o));
  }
  function s() {
    !n.value && r && (n.value = !0, o());
  }
  function c() {
    n.value = !1, a != null && r && (r.cancelAnimationFrame(a), a = null);
  }
  return t && s(), xt(c), {
    isActive: n,
    pause: c,
    resume: s
  };
}
function Pu(i, e = { width: 0, height: 0 }, t = {}) {
  const r = R(e.width), n = R(e.height);
  return Nu(i, ([a]) => {
    r.value = a.contentRect.width, n.value = a.contentRect.height;
  }, t), ze(() => _t(i), (a) => {
    r.value = a ? e.width : 0, n.value = a ? e.height : 0;
  }), {
    width: r,
    height: n
  };
}
function df(i, { window: e = He, scrollTarget: t } = {}) {
  const r = R(!1), n = () => {
    if (!e)
      return;
    const a = e.document, o = We(i);
    if (!o)
      r.value = !1;
    else {
      const s = o.getBoundingClientRect();
      r.value = s.top <= (e.innerHeight || a.documentElement.clientHeight) && s.left <= (e.innerWidth || a.documentElement.clientWidth) && s.bottom >= 0 && s.right >= 0;
    }
  };
  return Ni(n), e && Ni(() => Ie(() => We(t) || e, "scroll", n, { capture: !1, passive: !0 })), r;
}
function hf(i = {}) {
  const { initialValue: e = "" } = i, t = ii(() => typeof window < "u" && "EyeDropper" in window), r = R(e);
  async function n(a) {
    if (!t.value)
      return;
    const s = await new window.EyeDropper().open(a);
    return r.value = s.sRGBHex, s;
  }
  return { isSupported: t, sRGBHex: r, open: n };
}
const Bo = [
  [
    "requestFullscreen",
    "exitFullscreen",
    "fullscreenElement",
    "fullscreenEnabled",
    "fullscreenchange",
    "fullscreenerror"
  ],
  [
    "webkitRequestFullscreen",
    "webkitExitFullscreen",
    "webkitFullscreenElement",
    "webkitFullscreenEnabled",
    "webkitfullscreenchange",
    "webkitfullscreenerror"
  ],
  [
    "webkitRequestFullScreen",
    "webkitCancelFullScreen",
    "webkitCurrentFullScreenElement",
    "webkitCancelFullScreen",
    "webkitfullscreenchange",
    "webkitfullscreenerror"
  ],
  [
    "mozRequestFullScreen",
    "mozCancelFullScreen",
    "mozFullScreenElement",
    "mozFullScreenEnabled",
    "mozfullscreenchange",
    "mozfullscreenerror"
  ],
  [
    "msRequestFullscreen",
    "msExitFullscreen",
    "msFullscreenElement",
    "msFullscreenEnabled",
    "MSFullscreenChange",
    "MSFullscreenError"
  ]
];
function pf(i, e = {}) {
  const { document: t = Du, autoExit: r = !1 } = e, n = i || (t == null ? void 0 : t.querySelector("html")), a = R(!1);
  let o = Bo[0];
  const s = ii(() => {
    if (t) {
      for (const m of Bo)
        if (m[1] in t)
          return o = m, !0;
    } else
      return !1;
    return !1;
  }), [c, l, u, , h] = o;
  async function d() {
    !s.value || (t != null && t[u] && await t[l](), a.value = !1);
  }
  async function v() {
    if (!s.value)
      return;
    await d();
    const m = _t(n);
    m && (await m[c](), a.value = !0);
  }
  async function M() {
    a.value ? await d() : await v();
  }
  return t && Ie(t, h, () => {
    a.value = !!(t != null && t[u]);
  }, !1), r && xt(d), {
    isSupported: s,
    isFullscreen: a,
    enter: v,
    exit: d,
    toggle: M
  };
}
function ff(i = {}) {
  const {
    enableHighAccuracy: e = !0,
    maximumAge: t = 3e4,
    timeout: r = 27e3,
    navigator: n = Ia
  } = i, a = ii(() => n && "geolocation" in n), o = R(null), s = R(null), c = R({
    accuracy: 0,
    latitude: 1 / 0,
    longitude: 1 / 0,
    altitude: null,
    altitudeAccuracy: null,
    heading: null,
    speed: null
  });
  function l(h) {
    o.value = h.timestamp, c.value = h.coords, s.value = null;
  }
  let u;
  return a.value && (u = n.geolocation.watchPosition(l, (h) => s.value = h, {
    enableHighAccuracy: e,
    maximumAge: t,
    timeout: r
  })), xt(() => {
    u && n && n.geolocation.clearWatch(u);
  }), {
    isSupported: a,
    coords: c,
    locatedAt: o,
    error: s
  };
}
const mf = ["mousemove", "mousedown", "resize", "keydown", "touchstart", "wheel"], gf = 6e4;
function vf(i = gf, e = {}) {
  const {
    initialState: t = !1,
    listenForVisibilityChange: r = !0,
    events: n = mf,
    window: a = He,
    eventFilter: o = qh(50)
  } = e, s = R(t), c = R(aa());
  let l;
  const u = ya(o, () => {
    s.value = !1, c.value = aa(), clearTimeout(l), l = setTimeout(() => s.value = !0, i);
  });
  if (a) {
    const h = a.document;
    for (const d of n)
      Ie(a, d, u, { passive: !0 });
    r && Ie(h, "visibilitychange", () => {
      h.hidden || u();
    });
  }
  return l = setTimeout(() => s.value = !0, i), { idle: s, lastActive: c };
}
function ju(i = {}) {
  const {
    type: e = "page",
    touch: t = !0,
    resetOnTouchEnds: r = !1,
    initialValue: n = { x: 0, y: 0 },
    window: a = He,
    eventFilter: o
  } = i, s = R(n.x), c = R(n.y), l = R(null), u = (m) => {
    e === "page" ? (s.value = m.pageX, c.value = m.pageY) : e === "client" && (s.value = m.clientX, c.value = m.clientY), l.value = "mouse";
  }, h = () => {
    s.value = n.x, c.value = n.y;
  }, d = (m) => {
    if (m.touches.length > 0) {
      const g = m.touches[0];
      e === "page" ? (s.value = g.pageX, c.value = g.pageY) : e === "client" && (s.value = g.clientX, c.value = g.clientY), l.value = "touch";
    }
  }, v = (m) => o === void 0 ? u(m) : o(() => u(m), {}), M = (m) => o === void 0 ? d(m) : o(() => d(m), {});
  return a && (Ie(a, "mousemove", v, { passive: !0 }), Ie(a, "dragover", v, { passive: !0 }), t && (Ie(a, "touchstart", M, { passive: !0 }), Ie(a, "touchmove", M, { passive: !0 }), r && Ie(a, "touchend", h, { passive: !0 }))), {
    x: s,
    y: c,
    sourceType: l
  };
}
function Mf(i, e = {}) {
  const {
    handleOutside: t = !0,
    window: r = He
  } = e, { x: n, y: a, sourceType: o } = ju(e), s = R(i != null ? i : r == null ? void 0 : r.document.body), c = R(0), l = R(0), u = R(0), h = R(0), d = R(0), v = R(0), M = R(!0);
  let m = () => {
  };
  return r && (m = ze([s, n, a], () => {
    const g = _t(s);
    if (!g)
      return;
    const {
      left: I,
      top: A,
      width: L,
      height: y
    } = g.getBoundingClientRect();
    u.value = I + r.pageXOffset, h.value = A + r.pageYOffset, d.value = y, v.value = L;
    const D = n.value - u.value, T = a.value - h.value;
    M.value = L === 0 || y === 0 || D < 0 || T < 0 || D > L || T > y, (t || !M.value) && (c.value = D, l.value = T);
  }, { immediate: !0 })), {
    x: n,
    y: a,
    sourceType: o,
    elementX: c,
    elementY: l,
    elementPositionX: u,
    elementPositionY: h,
    elementHeight: d,
    elementWidth: v,
    isOutside: M,
    stop: m
  };
}
function yf(i = {}) {
  const {
    touch: e = !0,
    drag: t = !0,
    initialValue: r = !1,
    window: n = He
  } = i, a = R(r), o = R(null);
  if (!n)
    return {
      pressed: a,
      sourceType: o
    };
  const s = (u) => () => {
    a.value = !0, o.value = u;
  }, c = () => {
    a.value = !1, o.value = null;
  }, l = me(() => _t(i.target) || n);
  return Ie(l, "mousedown", s("mouse"), { passive: !0 }), Ie(n, "mouseleave", c, { passive: !0 }), Ie(n, "mouseup", c, { passive: !0 }), t && (Ie(l, "dragstart", s("mouse"), { passive: !0 }), Ie(n, "drop", c, { passive: !0 }), Ie(n, "dragend", c, { passive: !0 })), e && (Ie(l, "touchstart", s("touch"), { passive: !0 }), Ie(n, "touchend", c, { passive: !0 }), Ie(n, "touchcancel", c, { passive: !0 })), {
    pressed: a,
    sourceType: o
  };
}
function Bu(i = {}) {
  const { window: e = He } = i, t = e == null ? void 0 : e.navigator, r = ii(() => t && "connection" in t), n = R(!0), a = R(!1), o = R(void 0), s = R(void 0), c = R(void 0), l = R(void 0), u = R(void 0), h = R(void 0), d = R("unknown"), v = r.value && t.connection;
  function M() {
    !t || (n.value = t.onLine, o.value = n.value ? void 0 : Date.now(), s.value = n.value ? Date.now() : void 0, v && (c.value = v.downlink, l.value = v.downlinkMax, h.value = v.effectiveType, u.value = v.rtt, a.value = v.saveData, d.value = v.type));
  }
  return e && (Ie(e, "offline", () => {
    n.value = !1, o.value = Date.now();
  }), Ie(e, "online", () => {
    n.value = !0, s.value = Date.now();
  })), v && Ie(v, "change", M, !1), M(), {
    isSupported: r,
    isOnline: n,
    saveData: a,
    offlineAt: o,
    onlineAt: s,
    downlink: c,
    downlinkMax: l,
    effectiveType: h,
    rtt: u,
    type: d
  };
}
var xf = Object.defineProperty, Oo = Object.getOwnPropertySymbols, If = Object.prototype.hasOwnProperty, bf = Object.prototype.propertyIsEnumerable, zo = (i, e, t) => e in i ? xf(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, wf = (i, e) => {
  for (var t in e || (e = {}))
    If.call(e, t) && zo(i, t, e[t]);
  if (Oo)
    for (var t of Oo(e))
      bf.call(e, t) && zo(i, t, e[t]);
  return i;
};
function Ou(i = {}) {
  const {
    controls: e = !1,
    interval: t = "requestAnimationFrame"
  } = i, r = R(new Date()), n = () => r.value = new Date(), a = t === "requestAnimationFrame" ? Lu(n, { immediate: !0 }) : bu(n, t, { immediate: !0 });
  return e ? wf({
    now: r
  }, a) : r;
}
function _f(i) {
  const e = R(), t = () => {
    e.value && URL.revokeObjectURL(e.value), e.value = void 0;
  };
  return ze(() => wr(i), (r) => {
    t(), r && (e.value = URL.createObjectURL(r));
  }, { immediate: !0 }), xt(t), Mh(e);
}
function Ro(i, e, t) {
  const r = R(i);
  return me({
    get() {
      return r.value = Mo(r.value, We(e), We(t));
    },
    set(n) {
      r.value = Mo(n, We(e), We(t));
    }
  });
}
function Af(i) {
  const {
    total: e = 1 / 0,
    pageSize: t = 10,
    page: r = 1,
    onPageChange: n = yt,
    onPageSizeChange: a = yt,
    onPageCountChange: o = yt
  } = i, s = Ro(t, 1, 1 / 0), c = me(() => Math.max(1, Math.ceil(wr(e) / wr(s)))), l = Ro(r, 1, c), u = me(() => l.value === 1), h = me(() => l.value === c.value);
  Kr(r) && xo(r, l), Kr(t) && xo(t, s);
  function d() {
    l.value--;
  }
  function v() {
    l.value++;
  }
  const M = {
    currentPage: l,
    currentPageSize: s,
    pageCount: c,
    isFirstPage: u,
    isLastPage: h,
    prev: d,
    next: v
  };
  return ze(l, () => {
    n(Se(M));
  }), ze(s, () => {
    a(Se(M));
  }), ze(c, () => {
    o(Se(M));
  }), M;
}
function Sf(i = {}) {
  const { isOnline: e } = Bu(i);
  return e;
}
function Df(i = {}) {
  const { window: e = He } = i, t = R(!1), r = (n) => {
    if (!e)
      return;
    n = n || e.event;
    const a = n.relatedTarget || n.toElement;
    t.value = !a;
  };
  return e && (Ie(e, "mouseout", r, { passive: !0 }), Ie(e.document, "mouseleave", r, { passive: !0 }), Ie(e.document, "mouseenter", r, { passive: !0 })), t;
}
var Tf = Object.defineProperty, Cf = Object.defineProperties, Ef = Object.getOwnPropertyDescriptors, ko = Object.getOwnPropertySymbols, Nf = Object.prototype.hasOwnProperty, Lf = Object.prototype.propertyIsEnumerable, Wo = (i, e, t) => e in i ? Tf(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Pf = (i, e) => {
  for (var t in e || (e = {}))
    Nf.call(e, t) && Wo(i, t, e[t]);
  if (ko)
    for (var t of ko(e))
      Lf.call(e, t) && Wo(i, t, e[t]);
  return i;
}, jf = (i, e) => Cf(i, Ef(e));
const zu = {
  x: 0,
  y: 0,
  pointerId: 0,
  pressure: 0,
  tiltX: 0,
  tiltY: 0,
  width: 0,
  height: 0,
  twist: 0,
  pointerType: null
}, Bf = /* @__PURE__ */ Object.keys(zu);
function Of(i = {}) {
  const {
    target: e = He
  } = i, t = R(!1), r = R(i.initialValue || {});
  Object.assign(r.value, zu, r.value);
  const n = (a) => {
    t.value = !0, !(i.pointerTypes && !i.pointerTypes.includes(a.pointerType)) && (r.value = np(a, Bf, !1));
  };
  return e && (Ie(e, "pointerdown", n, { passive: !0 }), Ie(e, "pointermove", n, { passive: !0 }), Ie(e, "pointerleave", () => t.value = !1, { passive: !0 })), jf(Pf({}, xu(r)), {
    isInside: t
  });
}
var Go;
(function(i) {
  i.UP = "UP", i.RIGHT = "RIGHT", i.DOWN = "DOWN", i.LEFT = "LEFT", i.NONE = "NONE";
})(Go || (Go = {}));
function zf(i) {
  const e = _r("(prefers-color-scheme: light)", i), t = _r("(prefers-color-scheme: dark)", i);
  return me(() => t.value ? "dark" : e.value ? "light" : "no-preference");
}
function Rf(i = {}) {
  const { window: e = He } = i;
  if (!e)
    return R(["en"]);
  const t = e.navigator, r = R(t.languages);
  return Ie(e, "languagechange", () => {
    r.value = t.languages;
  }), r;
}
function kf(i) {
  const e = _r("(prefers-reduced-motion: reduce)", i);
  return me(() => e.value ? "reduce" : "no-preference");
}
var Wf = Object.defineProperty, oa = Object.getOwnPropertySymbols, Ru = Object.prototype.hasOwnProperty, ku = Object.prototype.propertyIsEnumerable, Uo = (i, e, t) => e in i ? Wf(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Gf = (i, e) => {
  for (var t in e || (e = {}))
    Ru.call(e, t) && Uo(i, t, e[t]);
  if (oa)
    for (var t of oa(e))
      ku.call(e, t) && Uo(i, t, e[t]);
  return i;
}, Uf = (i, e) => {
  var t = {};
  for (var r in i)
    Ru.call(i, r) && e.indexOf(r) < 0 && (t[r] = i[r]);
  if (i != null && oa)
    for (var r of oa(i))
      e.indexOf(r) < 0 && ku.call(i, r) && (t[r] = i[r]);
  return t;
};
const Ho = [
  { max: 6e4, value: 1e3, name: "second" },
  { max: 276e4, value: 6e4, name: "minute" },
  { max: 72e6, value: 36e5, name: "hour" },
  { max: 5184e5, value: 864e5, name: "day" },
  { max: 24192e5, value: 6048e5, name: "week" },
  { max: 28512e6, value: 2592e6, name: "month" },
  { max: 1 / 0, value: 31536e6, name: "year" }
], Hf = {
  justNow: "just now",
  past: (i) => i.match(/\d/) ? `${i} ago` : i,
  future: (i) => i.match(/\d/) ? `in ${i}` : i,
  month: (i, e) => i === 1 ? e ? "last month" : "next month" : `${i} month${i > 1 ? "s" : ""}`,
  year: (i, e) => i === 1 ? e ? "last year" : "next year" : `${i} year${i > 1 ? "s" : ""}`,
  day: (i, e) => i === 1 ? e ? "yesterday" : "tomorrow" : `${i} day${i > 1 ? "s" : ""}`,
  week: (i, e) => i === 1 ? e ? "last week" : "next week" : `${i} week${i > 1 ? "s" : ""}`,
  hour: (i) => `${i} hour${i > 1 ? "s" : ""}`,
  minute: (i) => `${i} minute${i > 1 ? "s" : ""}`,
  second: (i) => `${i} second${i > 1 ? "s" : ""}`
}, Ff = (i) => i.toISOString().slice(0, 10);
function Vf(i, e = {}) {
  const {
    controls: t = !1,
    max: r,
    updateInterval: n = 3e4,
    messages: a = Hf,
    fullDateFormatter: o = Ff
  } = e, { abs: s, round: c } = Math, l = Ou({ interval: n, controls: !0 }), { now: u } = l, h = Uf(l, ["now"]);
  function d(g, I) {
    var A;
    const L = +I - +g, y = s(L);
    if (y < 6e4)
      return a.justNow;
    if (typeof r == "number" && y > r)
      return o(new Date(g));
    if (typeof r == "string") {
      const D = (A = Ho.find((T) => T.name === r)) == null ? void 0 : A.max;
      if (D && y > D)
        return o(new Date(g));
    }
    for (const D of Ho)
      if (y < D.max)
        return M(L, D);
  }
  function v(g, I, A) {
    const L = a[g];
    return typeof L == "function" ? L(I, A) : L.replace("{0}", I.toString());
  }
  function M(g, I) {
    const A = c(s(g) / I.value), L = g > 0, y = v(I.name, A, L);
    return v(L ? "past" : "future", y, L);
  }
  const m = me(() => d(new Date(We(i)), wr(u.value)));
  return t ? Gf({
    timeAgo: m
  }, h) : m;
}
var Yf = Object.defineProperty, Fo = Object.getOwnPropertySymbols, Zf = Object.prototype.hasOwnProperty, Qf = Object.prototype.propertyIsEnumerable, Vo = (i, e, t) => e in i ? Yf(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Jf = (i, e) => {
  for (var t in e || (e = {}))
    Zf.call(e, t) && Vo(i, t, e[t]);
  if (Fo)
    for (var t of Fo(e))
      Qf.call(e, t) && Vo(i, t, e[t]);
  return i;
};
function Xf(i = {}) {
  const {
    controls: e = !1,
    offset: t = 0,
    immediate: r = !0,
    interval: n = "requestAnimationFrame"
  } = i, a = R(aa() + t), o = () => a.value = aa() + t, s = n === "requestAnimationFrame" ? Lu(o, { immediate: r }) : bu(o, n, { immediate: r });
  return e ? Jf({
    timestamp: a
  }, s) : a;
}
var $f = Object.defineProperty, Yo = Object.getOwnPropertySymbols, qf = Object.prototype.hasOwnProperty, Kf = Object.prototype.propertyIsEnumerable, Zo = (i, e, t) => e in i ? $f(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, em = (i, e) => {
  for (var t in e || (e = {}))
    qf.call(e, t) && Zo(i, t, e[t]);
  if (Yo)
    for (var t of Yo(e))
      Kf.call(e, t) && Zo(i, t, e[t]);
  return i;
};
const tm = {
  easeInSine: [0.12, 0, 0.39, 0],
  easeOutSine: [0.61, 1, 0.88, 1],
  easeInOutSine: [0.37, 0, 0.63, 1],
  easeInQuad: [0.11, 0, 0.5, 0],
  easeOutQuad: [0.5, 1, 0.89, 1],
  easeInOutQuad: [0.45, 0, 0.55, 1],
  easeInCubic: [0.32, 0, 0.67, 0],
  easeOutCubic: [0.33, 1, 0.68, 1],
  easeInOutCubic: [0.65, 0, 0.35, 1],
  easeInQuart: [0.5, 0, 0.75, 0],
  easeOutQuart: [0.25, 1, 0.5, 1],
  easeInOutQuart: [0.76, 0, 0.24, 1],
  easeInQuint: [0.64, 0, 0.78, 0],
  easeOutQuint: [0.22, 1, 0.36, 1],
  easeInOutQuint: [0.83, 0, 0.17, 1],
  easeInExpo: [0.7, 0, 0.84, 0],
  easeOutExpo: [0.16, 1, 0.3, 1],
  easeInOutExpo: [0.87, 0, 0.13, 1],
  easeInCirc: [0.55, 0, 1, 0.45],
  easeOutCirc: [0, 0.55, 0.45, 1],
  easeInOutCirc: [0.85, 0, 0.15, 1],
  easeInBack: [0.36, 0, 0.66, -0.56],
  easeOutBack: [0.34, 1.56, 0.64, 1],
  easeInOutBack: [0.68, -0.6, 0.32, 1.6]
};
em({
  linear: ip
}, tm);
function im(i, e) {
  const t = R(), r = Pu(t), n = R([]), a = va(i), o = R({ start: 0, end: 10 }), { itemHeight: s, overscan: c = 5 } = e, l = (A) => {
    if (typeof s == "number")
      return Math.ceil(A / s);
    const { start: L = 0 } = o.value;
    let y = 0, D = 0;
    for (let T = L; T < a.value.length; T++)
      if (y += s(T), y >= A) {
        D = T;
        break;
      }
    return D - L;
  }, u = (A) => {
    if (typeof s == "number")
      return Math.floor(A / s) + 1;
    let L = 0, y = 0;
    for (let D = 0; D < a.value.length; D++)
      if (L += s(D), L >= A) {
        y = D;
        break;
      }
    return y + 1;
  }, h = () => {
    const A = t.value;
    if (A) {
      const L = u(A.scrollTop), y = l(A.clientHeight), D = L - c, T = L + y + c;
      o.value = {
        start: D < 0 ? 0 : D,
        end: T > a.value.length ? a.value.length : T
      }, n.value = a.value.slice(o.value.start, o.value.end).map((B, S) => ({
        data: B,
        index: S + o.value.start
      }));
    }
  };
  ze([r.width, r.height, i], () => {
    h();
  });
  const d = me(() => typeof s == "number" ? a.value.length * s : a.value.reduce((A, L, y) => A + s(y), 0)), v = (A) => typeof s == "number" ? A * s : a.value.slice(0, A).reduce((y, D, T) => y + s(T), 0), M = (A) => {
    t.value && (t.value.scrollTop = v(A), h());
  }, m = me(() => v(o.value.start)), g = me(() => ({
    style: {
      width: "100%",
      height: `${d.value - m.value}px`,
      marginTop: `${m.value}px`
    }
  }));
  return {
    list: n,
    scrollTo: M,
    containerProps: {
      ref: t,
      onScroll: () => {
        h();
      },
      style: { overflowY: "auto" }
    },
    wrapperProps: g
  };
}
function rm({ window: i = He } = {}) {
  if (!i)
    return R(!1);
  const e = R(i.document.hasFocus());
  return Ie(i, "blur", () => {
    e.value = !1;
  }), Ie(i, "focus", () => {
    e.value = !0;
  }), e;
}
function nm(i = {}) {
  const {
    window: e = He,
    initialWidth: t = 1 / 0,
    initialHeight: r = 1 / 0,
    listenOrientation: n = !0
  } = i, a = R(t), o = R(r), s = () => {
    e && (a.value = e.innerWidth, o.value = e.innerHeight);
  };
  return s(), Ni(s), Ie("resize", s, { passive: !0 }), n && Ie("orientationchange", s, { passive: !0 }), { width: a, height: o };
}
const am = {
  inheritAttrs: !1
}, sm = /* @__PURE__ */ ge({
  ...am,
  __name: "index",
  props: {
    value: { default: null },
    delay: null,
    lazy: { type: Boolean }
  },
  emits: ["input"],
  setup(i, { expose: e, emit: t }) {
    const r = i, n = ["icon", "icon-position", "value"], a = Zs(), o = ma(), s = R(), c = me(() => !!o.default), l = me(() => !!o["group-element"]), u = me(() => {
      var g;
      return (g = a.icon) != null ? g : null;
    }), h = me(() => {
      var g;
      return u.value ? (g = a["icon-position"]) != null ? g : "left" : null;
    }), d = me(() => {
      const g = structuredClone({ type: "text", ...a });
      return n.forEach((I) => {
        delete g[I];
      }), g;
    }), { listeners: v, setEmitter: M, emitValue: m } = Lr(t, r.lazy);
    return r.delay && M(xa(m, r.delay)), e({
      focus: () => {
        s.value && s.value.focus();
      }
    }), { __sfc: !0, attributeBlackList: n, props: r, attrs: a, slots: o, inputRef: s, hasLabel: c, isGroup: l, icon: u, iconPosition: h, filteredAttributes: d, emit: t, listeners: v, setEmitter: M, emitValue: m, vIcon: pn };
  }
});
var om = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("label", { staticClass: "v-input" }, [r.hasLabel ? t("span", { staticClass: "label" }, [e._t("default")], 2) : e._e(), t("div", { staticClass: "input", class: { group: r.isGroup }, attrs: { icon: r.iconPosition } }, [r.icon ? t(r.vIcon, { attrs: { name: r.icon } }) : e._e(), t("input", e._g(e._b({ ref: "inputRef", domProps: { value: e.value } }, "input", r.filteredAttributes, !1), r.listeners)), e._t("group-element")], 2), e._t("info")], 2);
}, lm = [], cm = /* @__PURE__ */ Ge(
  sm,
  om,
  lm,
  !1,
  null,
  null,
  null,
  null
);
const um = cm.exports, dm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: um
}, Symbol.toStringTag, { value: "Module" })), hm = {};
var pm = function() {
  var e = this, t = e._self._c;
  return t("v-icon", { staticClass: "v-loader", attrs: { name: "loader" } });
}, fm = [], mm = /* @__PURE__ */ Ge(
  hm,
  pm,
  fm,
  !1,
  null,
  null,
  null,
  null
);
const gm = mm.exports, vm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gm
}, Symbol.toStringTag, { value: "Module" }));
var Si = qr;
Si = "default" in Si ? Si.default : Si;
var Mm = "2.2.2", ym = /^2\./.test(Si.version);
ym || Si.util.warn("VueClickaway " + Mm + " only supports Vue 2.x, and does not support Vue " + Si.version);
var la = "_vue_clickaway_handler";
function Qo(i, e, t) {
  Wu(i);
  var r = t.context, n = e.value;
  if (typeof n != "function") {
    process.env.NODE_ENV !== "production" && Si.util.warn(
      "v-" + e.name + '="' + e.expression + '" expects a function value, got ' + n
    );
    return;
  }
  var a = !1;
  setTimeout(function() {
    a = !0;
  }, 0), i[la] = function(o) {
    var s = o.path || (o.composedPath ? o.composedPath() : void 0);
    if (a && (s ? s.indexOf(i) < 0 : !i.contains(o.target)))
      return n.call(r, o);
  }, document.documentElement.addEventListener("click", i[la], !1);
}
function Wu(i) {
  document.documentElement.removeEventListener("click", i[la], !1), delete i[la];
}
var xm = {
  bind: Qo,
  update: function(i, e) {
    e.value !== e.oldValue && Qo(i, e);
  },
  unbind: Wu
}, Gu = xm;
let Im = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", bm = (i = 21) => {
  let e = "", t = i;
  for (; t--; )
    e += Im[Math.random() * 64 | 0];
  return e;
};
function $n(i) {
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? $n = function(e) {
    return typeof e;
  } : $n = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $n(i);
}
var Uu = {
  selector: "vue-portal-target-".concat(bm())
}, wm = function(e) {
  return Uu.selector = e;
}, ja = typeof window < "u" && (typeof document > "u" ? "undefined" : $n(document)) !== void 0, _m = qr.extend({
  abstract: !0,
  name: "PortalOutlet",
  props: ["nodes", "tag"],
  data: function(e) {
    return {
      updatedNodes: e.nodes
    };
  },
  render: function(e) {
    var t = this.updatedNodes && this.updatedNodes();
    return t ? t.length === 1 && !t[0].text ? t : e(this.tag || "DIV", t) : e();
  },
  destroyed: function() {
    var e = this.$el;
    e && e.parentNode.removeChild(e);
  }
}), ba = qr.extend({
  name: "VueSimplePortal",
  props: {
    disabled: {
      type: Boolean
    },
    prepend: {
      type: Boolean
    },
    selector: {
      type: String,
      default: function() {
        return "#".concat(Uu.selector);
      }
    },
    tag: {
      type: String,
      default: "DIV"
    }
  },
  render: function(e) {
    if (this.disabled) {
      var t = this.$scopedSlots && this.$scopedSlots.default();
      return t ? t.length < 2 && !t[0].text ? t : e(this.tag, t) : e();
    }
    return e();
  },
  created: function() {
    this.getTargetEl() || this.insertTargetEl();
  },
  updated: function() {
    var e = this;
    this.$nextTick(function() {
      !e.disabled && e.slotFn !== e.$scopedSlots.default && (e.container.updatedNodes = e.$scopedSlots.default), e.slotFn = e.$scopedSlots.default;
    });
  },
  beforeDestroy: function() {
    this.unmount();
  },
  watch: {
    disabled: {
      immediate: !0,
      handler: function(e) {
        e ? this.unmount() : this.$nextTick(this.mount);
      }
    }
  },
  methods: {
    getTargetEl: function() {
      if (!!ja)
        return document.querySelector(this.selector);
    },
    insertTargetEl: function() {
      if (!!ja) {
        var e = document.querySelector("body"), t = document.createElement(this.tag);
        t.id = this.selector.substring(1), e.appendChild(t);
      }
    },
    mount: function() {
      if (!!ja) {
        var e = this.getTargetEl(), t = document.createElement("DIV");
        this.prepend && e.firstChild ? e.insertBefore(t, e.firstChild) : e.appendChild(t), this.container = new _m({
          el: t,
          parent: this,
          propsData: {
            tag: this.tag,
            nodes: this.$scopedSlots.default
          }
        });
      }
    },
    unmount: function() {
      this.container && (this.container.$destroy(), delete this.container);
    }
  }
});
function Am(i) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  i.component(e.name || "portal", ba), e.defaultSelector && wm(e.defaultSelector);
}
typeof window < "u" && window.Vue && window.Vue === qr && qr.use(Am);
const _n = R([]);
function Sm() {
  return {
    addItem: (r) => {
      _n.value.push(r);
    },
    removeItem: (r) => {
      const n = _n.value.findIndex((a) => a === r);
      _n.value.splice(n, 1);
    },
    hideAllItems: () => {
      _n.value.forEach((r) => {
        r.hide();
      });
    }
  };
}
const Dm = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    hideOnClick: { type: Boolean, default: !0 }
  },
  setup(i, { expose: e }) {
    var D;
    const t = i, { addItem: r, removeItem: n, hideAllItems: a } = Sm(), o = R(null), s = R(!1), c = R(!1), l = R({}), u = (D = fi()) == null ? void 0 : D.proxy.$parent, h = me(() => {
      if (u && u.$el)
        return u.$el;
    }), d = () => {
      l.value = {}, c.value = !1;
    }, v = () => {
      h.value && h.value.classList.toggle("more-visible", s.value);
    }, M = (T) => {
      T.preventDefault(), T.stopPropagation(), a(), c.value = !0, l.value = {
        top: T.y + "px",
        left: T.x + "px",
        right: "auto",
        position: "fixed",
        transform: "none",
        zIndex: 1e3
      }, m();
    }, m = () => {
      s.value = !s.value, v(), s.value || d();
    }, g = () => {
      t.hideOnClick && I();
    }, I = () => {
      s.value = !1, v(), d();
    }, A = () => {
      h.value && h.value.addEventListener("contextmenu", M);
    }, L = () => {
      h.value && h.value.removeEventListener("contextmenu", M);
    }, y = {
      ref: o.value,
      hide: I
    };
    return Ht(() => {
      A(), r(y);
    }), Ma(() => {
      L(), n(y);
    }), e({
      hide: I
    }), { __sfc: !0, props: t, addItem: r, removeItem: n, hideAllItems: a, moreRef: o, isVisible: s, followCursor: c, styleObject: l, parentComponent: u, parentElement: h, reset: d, toggleParentClass: v, onContextMenu: M, toggle: m, clickListener: g, hide: I, bindListeners: A, unbindListeners: L, item: y, vOnClickaway: Gu, Portal: ba, vContextmenu: vu };
  }
});
var Tm = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", e._b({ ref: "moreRef", staticClass: "v-more" }, "div", e.$attrs, !1), [t("div", { staticClass: "trigger", on: { click: r.toggle } }, [e._t("default")], 2), r.followCursor ? t(r.Portal, [r.isVisible ? t(r.vContextmenu, { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: r.hide, expression: "hide" }], staticClass: "more", style: r.styleObject }, [e._t("more", null, { toggle: r.toggle, hide: r.hide })], 2) : e._e()], 1) : [r.isVisible ? t(r.vContextmenu, { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: r.hide, expression: "hide" }], staticClass: "more", style: r.styleObject, on: { click: r.clickListener } }, [e._t("more", null, { toggle: r.toggle, hide: r.hide })], 2) : e._e()]], 2);
}, Cm = [], Em = /* @__PURE__ */ Ge(
  Dm,
  Tm,
  Cm,
  !1,
  null,
  null,
  null,
  null
);
const Nm = Em.exports, Lm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Nm
}, Symbol.toStringTag, { value: "Module" })), Pm = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    collapsible: { type: Boolean }
  },
  setup(i) {
    const e = ma(), t = R(!1), r = me(() => !!e.header), n = me(() => !!e.footer);
    return { __sfc: !0, slots: e, isCollapsed: t, hasHeader: r, hasFooter: n, toggle: () => {
      t.value = !t.value;
    }, vIcon: pn };
  }
});
var jm = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", e._g({ staticClass: "panel" }, e.$listeners), [r.hasHeader ? t("header", { class: { collapsible: e.collapsible } }, [e._t("header"), e.collapsible ? t("aside", { staticClass: "toggle", class: { collapsed: r.isCollapsed }, on: { click: r.toggle } }, [t(r.vIcon, { attrs: { name: "chevron-down" } })], 1) : e._e()], 2) : e._e(), r.isCollapsed ? e._e() : [t("section", [e._t("default")], 2), r.hasFooter ? t("footer", [e._t("footer")], 2) : e._e()]], 2);
}, Bm = [], Om = /* @__PURE__ */ Ge(
  Pm,
  jm,
  Bm,
  !1,
  null,
  null,
  null,
  null
);
const zm = Om.exports, Rm = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zm
}, Symbol.toStringTag, { value: "Module" }));
function en(i) {
  var e = i.getBoundingClientRect();
  return {
    width: e.width,
    height: e.height,
    top: e.top,
    right: e.right,
    bottom: e.bottom,
    left: e.left,
    x: e.left,
    y: e.top
  };
}
function ri(i) {
  if (i.toString() !== "[object Window]") {
    var e = i.ownerDocument;
    return e ? e.defaultView : window;
  }
  return i;
}
function Xs(i) {
  var e = ri(i), t = e.pageXOffset, r = e.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: r
  };
}
function tn(i) {
  var e = ri(i).Element;
  return i instanceof e || i instanceof Element;
}
function Rt(i) {
  var e = ri(i).HTMLElement;
  return i instanceof e || i instanceof HTMLElement;
}
function km(i) {
  return {
    scrollLeft: i.scrollLeft,
    scrollTop: i.scrollTop
  };
}
function Wm(i) {
  return i === ri(i) || !Rt(i) ? Xs(i) : km(i);
}
function Ft(i) {
  return i ? (i.nodeName || "").toLowerCase() : null;
}
function mi(i) {
  return (tn(i) ? i.ownerDocument : i.document).documentElement;
}
function $s(i) {
  return en(mi(i)).left + Xs(i).scrollLeft;
}
function Bt(i) {
  return ri(i).getComputedStyle(i);
}
function qs(i) {
  var e = Bt(i), t = e.overflow, r = e.overflowX, n = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + n + r);
}
function Gm(i, e, t) {
  t === void 0 && (t = !1);
  var r = mi(e), n = en(i), a = Rt(e), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, s = {
    x: 0,
    y: 0
  };
  return (a || !a && !t) && ((Ft(e) !== "body" || qs(r)) && (o = Wm(e)), Rt(e) ? (s = en(e), s.x += e.clientLeft, s.y += e.clientTop) : r && (s.x = $s(r))), {
    x: n.left + o.scrollLeft - s.x,
    y: n.top + o.scrollTop - s.y,
    width: n.width,
    height: n.height
  };
}
function Ks(i) {
  return {
    x: i.offsetLeft,
    y: i.offsetTop,
    width: i.offsetWidth,
    height: i.offsetHeight
  };
}
function wa(i) {
  return Ft(i) === "html" ? i : i.assignedSlot || i.parentNode || i.host || mi(i);
}
function Hu(i) {
  return ["html", "body", "#document"].indexOf(Ft(i)) >= 0 ? i.ownerDocument.body : Rt(i) && qs(i) ? i : Hu(wa(i));
}
function Xr(i, e) {
  e === void 0 && (e = []);
  var t = Hu(i), r = Ft(t) === "body", n = ri(t), a = r ? [n].concat(n.visualViewport || [], qs(t) ? t : []) : t, o = e.concat(a);
  return r ? o : o.concat(Xr(wa(a)));
}
function Um(i) {
  return ["table", "td", "th"].indexOf(Ft(i)) >= 0;
}
function Jo(i) {
  if (!Rt(i) || Bt(i).position === "fixed")
    return null;
  var e = i.offsetParent;
  if (e) {
    var t = mi(e);
    if (Ft(e) === "body" && Bt(e).position === "static" && Bt(t).position !== "static")
      return t;
  }
  return e;
}
function Hm(i) {
  for (var e = wa(i); Rt(e) && ["html", "body"].indexOf(Ft(e)) < 0; ) {
    var t = Bt(e);
    if (t.transform !== "none" || t.perspective !== "none" || t.willChange && t.willChange !== "auto")
      return e;
    e = e.parentNode;
  }
  return null;
}
function fn(i) {
  for (var e = ri(i), t = Jo(i); t && Um(t) && Bt(t).position === "static"; )
    t = Jo(t);
  return t && Ft(t) === "body" && Bt(t).position === "static" ? e : t || Hm(i) || e;
}
var St = "top", kt = "bottom", Wt = "right", Dt = "left", _a = "auto", mn = [St, kt, Wt, Dt], Ar = "start", eo = "end", Fm = "clippingParents", Fu = "viewport", Gr = "popper", Vm = "reference", Xo = /* @__PURE__ */ mn.reduce(function(i, e) {
  return i.concat([e + "-" + Ar, e + "-" + eo]);
}, []), Vu = /* @__PURE__ */ [].concat(mn, [_a]).reduce(function(i, e) {
  return i.concat([e, e + "-" + Ar, e + "-" + eo]);
}, []), Ym = "beforeRead", Zm = "read", Qm = "afterRead", Jm = "beforeMain", Xm = "main", $m = "afterMain", qm = "beforeWrite", Km = "write", e0 = "afterWrite", Cs = [Ym, Zm, Qm, Jm, Xm, $m, qm, Km, e0];
function t0(i) {
  var e = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), r = [];
  i.forEach(function(a) {
    e.set(a.name, a);
  });
  function n(a) {
    t.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(s) {
      if (!t.has(s)) {
        var c = e.get(s);
        c && n(c);
      }
    }), r.push(a);
  }
  return i.forEach(function(a) {
    t.has(a.name) || n(a);
  }), r;
}
function i0(i) {
  var e = t0(i);
  return Cs.reduce(function(t, r) {
    return t.concat(e.filter(function(n) {
      return n.phase === r;
    }));
  }, []);
}
function r0(i) {
  var e;
  return function() {
    return e || (e = new Promise(function(t) {
      Promise.resolve().then(function() {
        e = void 0, t(i());
      });
    })), e;
  };
}
function Mi(i) {
  for (var e = arguments.length, t = new Array(e > 1 ? e - 1 : 0), r = 1; r < e; r++)
    t[r - 1] = arguments[r];
  return [].concat(t).reduce(function(n, a) {
    return n.replace(/%s/, a);
  }, i);
}
var Bi = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', n0 = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', a0 = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function s0(i) {
  i.forEach(function(e) {
    Object.keys(e).forEach(function(t) {
      switch (t) {
        case "name":
          typeof e.name != "string" && console.error(Mi(Bi, String(e.name), '"name"', '"string"', '"' + String(e.name) + '"'));
          break;
        case "enabled":
          typeof e.enabled != "boolean" && console.error(Mi(Bi, e.name, '"enabled"', '"boolean"', '"' + String(e.enabled) + '"'));
        case "phase":
          Cs.indexOf(e.phase) < 0 && console.error(Mi(Bi, e.name, '"phase"', "either " + Cs.join(", "), '"' + String(e.phase) + '"'));
          break;
        case "fn":
          typeof e.fn != "function" && console.error(Mi(Bi, e.name, '"fn"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "effect":
          typeof e.effect != "function" && console.error(Mi(Bi, e.name, '"effect"', '"function"', '"' + String(e.fn) + '"'));
          break;
        case "requires":
          Array.isArray(e.requires) || console.error(Mi(Bi, e.name, '"requires"', '"array"', '"' + String(e.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(e.requiresIfExists) || console.error(Mi(Bi, e.name, '"requiresIfExists"', '"array"', '"' + String(e.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + e.name + '" modifier, valid properties are ' + a0.map(function(r) {
            return '"' + r + '"';
          }).join(", ") + '; but "' + t + '" was provided.');
      }
      e.requires && e.requires.forEach(function(r) {
        i.find(function(n) {
          return n.name === r;
        }) == null && console.error(Mi(n0, String(e.name), r, r));
      });
    });
  });
}
function o0(i, e) {
  var t = /* @__PURE__ */ new Set();
  return i.filter(function(r) {
    var n = e(r);
    if (!t.has(n))
      return t.add(n), !0;
  });
}
function Ot(i) {
  return i.split("-")[0];
}
function l0(i) {
  var e = i.reduce(function(t, r) {
    var n = t[r.name];
    return t[r.name] = n ? Object.assign(Object.assign(Object.assign({}, n), r), {}, {
      options: Object.assign(Object.assign({}, n.options), r.options),
      data: Object.assign(Object.assign({}, n.data), r.data)
    }) : r, t;
  }, {});
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}
function c0(i) {
  var e = ri(i), t = mi(i), r = e.visualViewport, n = t.clientWidth, a = t.clientHeight, o = 0, s = 0;
  return r && (n = r.width, a = r.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (o = r.offsetLeft, s = r.offsetTop)), {
    width: n,
    height: a,
    x: o + $s(i),
    y: s
  };
}
function u0(i) {
  var e = mi(i), t = Xs(i), r = i.ownerDocument.body, n = Math.max(e.scrollWidth, e.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), a = Math.max(e.scrollHeight, e.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), o = -t.scrollLeft + $s(i), s = -t.scrollTop;
  return Bt(r || e).direction === "rtl" && (o += Math.max(e.clientWidth, r ? r.clientWidth : 0) - n), {
    width: n,
    height: a,
    x: o,
    y: s
  };
}
function Yu(i, e) {
  var t = Boolean(e.getRootNode && e.getRootNode().host);
  if (i.contains(e))
    return !0;
  if (t) {
    var r = e;
    do {
      if (r && i.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function Es(i) {
  return Object.assign(Object.assign({}, i), {}, {
    left: i.x,
    top: i.y,
    right: i.x + i.width,
    bottom: i.y + i.height
  });
}
function d0(i) {
  var e = en(i);
  return e.top = e.top + i.clientTop, e.left = e.left + i.clientLeft, e.bottom = e.top + i.clientHeight, e.right = e.left + i.clientWidth, e.width = i.clientWidth, e.height = i.clientHeight, e.x = e.left, e.y = e.top, e;
}
function $o(i, e) {
  return e === Fu ? Es(c0(i)) : Rt(e) ? d0(e) : Es(u0(mi(i)));
}
function h0(i) {
  var e = Xr(wa(i)), t = ["absolute", "fixed"].indexOf(Bt(i).position) >= 0, r = t && Rt(i) ? fn(i) : i;
  return tn(r) ? e.filter(function(n) {
    return tn(n) && Yu(n, r) && Ft(n) !== "body";
  }) : [];
}
function p0(i, e, t) {
  var r = e === "clippingParents" ? h0(i) : [].concat(e), n = [].concat(r, [t]), a = n[0], o = n.reduce(function(s, c) {
    var l = $o(i, c);
    return s.top = Math.max(l.top, s.top), s.right = Math.min(l.right, s.right), s.bottom = Math.min(l.bottom, s.bottom), s.left = Math.max(l.left, s.left), s;
  }, $o(i, a));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function rn(i) {
  return i.split("-")[1];
}
function to(i) {
  return ["top", "bottom"].indexOf(i) >= 0 ? "x" : "y";
}
function Zu(i) {
  var e = i.reference, t = i.element, r = i.placement, n = r ? Ot(r) : null, a = r ? rn(r) : null, o = e.x + e.width / 2 - t.width / 2, s = e.y + e.height / 2 - t.height / 2, c;
  switch (n) {
    case St:
      c = {
        x: o,
        y: e.y - t.height
      };
      break;
    case kt:
      c = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Wt:
      c = {
        x: e.x + e.width,
        y: s
      };
      break;
    case Dt:
      c = {
        x: e.x - t.width,
        y: s
      };
      break;
    default:
      c = {
        x: e.x,
        y: e.y
      };
  }
  var l = n ? to(n) : null;
  if (l != null) {
    var u = l === "y" ? "height" : "width";
    switch (a) {
      case Ar:
        c[l] = Math.floor(c[l]) - Math.floor(e[u] / 2 - t[u] / 2);
        break;
      case eo:
        c[l] = Math.floor(c[l]) + Math.ceil(e[u] / 2 - t[u] / 2);
        break;
    }
  }
  return c;
}
function Qu() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Ju(i) {
  return Object.assign(Object.assign({}, Qu()), i);
}
function Xu(i, e) {
  return e.reduce(function(t, r) {
    return t[r] = i, t;
  }, {});
}
function nn(i, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, n = r === void 0 ? i.placement : r, a = t.boundary, o = a === void 0 ? Fm : a, s = t.rootBoundary, c = s === void 0 ? Fu : s, l = t.elementContext, u = l === void 0 ? Gr : l, h = t.altBoundary, d = h === void 0 ? !1 : h, v = t.padding, M = v === void 0 ? 0 : v, m = Ju(typeof M != "number" ? M : Xu(M, mn)), g = u === Gr ? Vm : Gr, I = i.elements.reference, A = i.rects.popper, L = i.elements[d ? g : u], y = p0(tn(L) ? L : L.contextElement || mi(i.elements.popper), o, c), D = en(I), T = Zu({
    reference: D,
    element: A,
    strategy: "absolute",
    placement: n
  }), B = Es(Object.assign(Object.assign({}, A), T)), S = u === Gr ? B : D, P = {
    top: y.top - S.top + m.top,
    bottom: S.bottom - y.bottom + m.bottom,
    left: y.left - S.left + m.left,
    right: S.right - y.right + m.right
  }, G = i.modifiersData.offset;
  if (u === Gr && G) {
    var U = G[n];
    Object.keys(P).forEach(function(le) {
      var ne = [Wt, kt].indexOf(le) >= 0 ? 1 : -1, z = [St, kt].indexOf(le) >= 0 ? "y" : "x";
      P[le] += U[z] * ne;
    });
  }
  return P;
}
var qo = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", f0 = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", Ko = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function el() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++)
    e[t] = arguments[t];
  return !e.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function m0(i) {
  i === void 0 && (i = {});
  var e = i, t = e.defaultModifiers, r = t === void 0 ? [] : t, n = e.defaultOptions, a = n === void 0 ? Ko : n;
  return function(s, c, l) {
    l === void 0 && (l = a);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign(Object.assign({}, Ko), a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: c
      },
      attributes: {},
      styles: {}
    }, h = [], d = !1, v = {
      state: u,
      setOptions: function(I) {
        m(), u.options = Object.assign(Object.assign(Object.assign({}, a), u.options), I), u.scrollParents = {
          reference: tn(s) ? Xr(s) : s.contextElement ? Xr(s.contextElement) : [],
          popper: Xr(c)
        };
        var A = i0(l0([].concat(r, u.options.modifiers)));
        if (u.orderedModifiers = A.filter(function(G) {
          return G.enabled;
        }), process.env.NODE_ENV !== "production") {
          var L = o0([].concat(A, u.options.modifiers), function(G) {
            var U = G.name;
            return U;
          });
          if (s0(L), Ot(u.options.placement) === _a) {
            var y = u.orderedModifiers.find(function(G) {
              var U = G.name;
              return U === "flip";
            });
            y || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var D = Bt(c), T = D.marginTop, B = D.marginRight, S = D.marginBottom, P = D.marginLeft;
          [T, B, S, P].some(function(G) {
            return parseFloat(G);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return M(), v.update();
      },
      forceUpdate: function() {
        if (!d) {
          var I = u.elements, A = I.reference, L = I.popper;
          if (!el(A, L)) {
            process.env.NODE_ENV !== "production" && console.error(qo);
            return;
          }
          u.rects = {
            reference: Gm(A, fn(L), u.options.strategy === "fixed"),
            popper: Ks(L)
          }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(U) {
            return u.modifiersData[U.name] = Object.assign({}, U.data);
          });
          for (var y = 0, D = 0; D < u.orderedModifiers.length; D++) {
            if (process.env.NODE_ENV !== "production" && (y += 1, y > 100)) {
              console.error(f0);
              break;
            }
            if (u.reset === !0) {
              u.reset = !1, D = -1;
              continue;
            }
            var T = u.orderedModifiers[D], B = T.fn, S = T.options, P = S === void 0 ? {} : S, G = T.name;
            typeof B == "function" && (u = B({
              state: u,
              options: P,
              name: G,
              instance: v
            }) || u);
          }
        }
      },
      update: r0(function() {
        return new Promise(function(g) {
          v.forceUpdate(), g(u);
        });
      }),
      destroy: function() {
        m(), d = !0;
      }
    };
    if (!el(s, c))
      return process.env.NODE_ENV !== "production" && console.error(qo), v;
    v.setOptions(l).then(function(g) {
      !d && l.onFirstUpdate && l.onFirstUpdate(g);
    });
    function M() {
      u.orderedModifiers.forEach(function(g) {
        var I = g.name, A = g.options, L = A === void 0 ? {} : A, y = g.effect;
        if (typeof y == "function") {
          var D = y({
            state: u,
            name: I,
            instance: v,
            options: L
          }), T = function() {
          };
          h.push(D || T);
        }
      });
    }
    function m() {
      h.forEach(function(g) {
        return g();
      }), h = [];
    }
    return v;
  };
}
var An = {
  passive: !0
};
function g0(i) {
  var e = i.state, t = i.instance, r = i.options, n = r.scroll, a = n === void 0 ? !0 : n, o = r.resize, s = o === void 0 ? !0 : o, c = ri(e.elements.popper), l = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return a && l.forEach(function(u) {
    u.addEventListener("scroll", t.update, An);
  }), s && c.addEventListener("resize", t.update, An), function() {
    a && l.forEach(function(u) {
      u.removeEventListener("scroll", t.update, An);
    }), s && c.removeEventListener("resize", t.update, An);
  };
}
const v0 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: g0,
  data: {}
};
function M0(i) {
  var e = i.state, t = i.name;
  e.modifiersData[t] = Zu({
    reference: e.rects.reference,
    element: e.rects.popper,
    strategy: "absolute",
    placement: e.placement
  });
}
const y0 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: M0,
  data: {}
};
var x0 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function I0(i) {
  var e = i.x, t = i.y, r = window, n = r.devicePixelRatio || 1;
  return {
    x: Math.round(e * n) / n || 0,
    y: Math.round(t * n) / n || 0
  };
}
function tl(i) {
  var e, t = i.popper, r = i.popperRect, n = i.placement, a = i.offsets, o = i.position, s = i.gpuAcceleration, c = i.adaptive, l = I0(a), u = l.x, h = l.y, d = a.hasOwnProperty("x"), v = a.hasOwnProperty("y"), M = Dt, m = St, g = window;
  if (c) {
    var I = fn(t);
    I === ri(t) && (I = mi(t)), n === St && (m = kt, h -= I.clientHeight - r.height, h *= s ? 1 : -1), n === Dt && (M = Wt, u -= I.clientWidth - r.width, u *= s ? 1 : -1);
  }
  var A = Object.assign({
    position: o
  }, c && x0);
  if (s) {
    var L;
    return Object.assign(Object.assign({}, A), {}, (L = {}, L[m] = v ? "0" : "", L[M] = d ? "0" : "", L.transform = (g.devicePixelRatio || 1) < 2 ? "translate(" + u + "px, " + h + "px)" : "translate3d(" + u + "px, " + h + "px, 0)", L));
  }
  return Object.assign(Object.assign({}, A), {}, (e = {}, e[m] = v ? h + "px" : "", e[M] = d ? u + "px" : "", e.transform = "", e));
}
function b0(i) {
  var e = i.state, t = i.options, r = t.gpuAcceleration, n = r === void 0 ? !0 : r, a = t.adaptive, o = a === void 0 ? !0 : a;
  if (process.env.NODE_ENV !== "production") {
    var s = Bt(e.elements.popper).transitionProperty || "";
    o && ["transform", "top", "right", "bottom", "left"].some(function(l) {
      return s.indexOf(l) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var c = {
    placement: Ot(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: n
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign(Object.assign({}, e.styles.popper), tl(Object.assign(Object.assign({}, c), {}, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign(Object.assign({}, e.styles.arrow), tl(Object.assign(Object.assign({}, c), {}, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1
  })))), e.attributes.popper = Object.assign(Object.assign({}, e.attributes.popper), {}, {
    "data-popper-placement": e.placement
  });
}
const w0 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: b0,
  data: {}
};
function _0(i) {
  var e = i.state;
  Object.keys(e.elements).forEach(function(t) {
    var r = e.styles[t] || {}, n = e.attributes[t] || {}, a = e.elements[t];
    !Rt(a) || !Ft(a) || (Object.assign(a.style, r), Object.keys(n).forEach(function(o) {
      var s = n[o];
      s === !1 ? a.removeAttribute(o) : a.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function A0(i) {
  var e = i.state, t = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, t.popper), e.elements.arrow && Object.assign(e.elements.arrow.style, t.arrow), function() {
    Object.keys(e.elements).forEach(function(r) {
      var n = e.elements[r], a = e.attributes[r] || {}, o = Object.keys(e.styles.hasOwnProperty(r) ? e.styles[r] : t[r]), s = o.reduce(function(c, l) {
        return c[l] = "", c;
      }, {});
      !Rt(n) || !Ft(n) || (Object.assign(n.style, s), Object.keys(a).forEach(function(c) {
        n.removeAttribute(c);
      }));
    });
  };
}
const S0 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: _0,
  effect: A0,
  requires: ["computeStyles"]
};
function D0(i, e, t) {
  var r = Ot(i), n = [Dt, St].indexOf(r) >= 0 ? -1 : 1, a = typeof t == "function" ? t(Object.assign(Object.assign({}, e), {}, {
    placement: i
  })) : t, o = a[0], s = a[1];
  return o = o || 0, s = (s || 0) * n, [Dt, Wt].indexOf(r) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function T0(i) {
  var e = i.state, t = i.options, r = i.name, n = t.offset, a = n === void 0 ? [0, 0] : n, o = Vu.reduce(function(u, h) {
    return u[h] = D0(h, e.rects, a), u;
  }, {}), s = o[e.placement], c = s.x, l = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += c, e.modifiersData.popperOffsets.y += l), e.modifiersData[r] = o;
}
const C0 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: T0
};
var E0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function qn(i) {
  return i.replace(/left|right|bottom|top/g, function(e) {
    return E0[e];
  });
}
var N0 = {
  start: "end",
  end: "start"
};
function il(i) {
  return i.replace(/start|end/g, function(e) {
    return N0[e];
  });
}
function L0(i, e) {
  e === void 0 && (e = {});
  var t = e, r = t.placement, n = t.boundary, a = t.rootBoundary, o = t.padding, s = t.flipVariations, c = t.allowedAutoPlacements, l = c === void 0 ? Vu : c, u = rn(r), h = u ? s ? Xo : Xo.filter(function(M) {
    return rn(M) === u;
  }) : mn, d = h.filter(function(M) {
    return l.indexOf(M) >= 0;
  });
  d.length === 0 && (d = h, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var v = d.reduce(function(M, m) {
    return M[m] = nn(i, {
      placement: m,
      boundary: n,
      rootBoundary: a,
      padding: o
    })[Ot(m)], M;
  }, {});
  return Object.keys(v).sort(function(M, m) {
    return v[M] - v[m];
  });
}
function P0(i) {
  if (Ot(i) === _a)
    return [];
  var e = qn(i);
  return [il(i), e, il(e)];
}
function j0(i) {
  var e = i.state, t = i.options, r = i.name;
  if (!e.modifiersData[r]._skip) {
    for (var n = t.mainAxis, a = n === void 0 ? !0 : n, o = t.altAxis, s = o === void 0 ? !0 : o, c = t.fallbackPlacements, l = t.padding, u = t.boundary, h = t.rootBoundary, d = t.altBoundary, v = t.flipVariations, M = v === void 0 ? !0 : v, m = t.allowedAutoPlacements, g = e.options.placement, I = Ot(g), A = I === g, L = c || (A || !M ? [qn(g)] : P0(g)), y = [g].concat(L).reduce(function(fe, ye) {
      return fe.concat(Ot(ye) === _a ? L0(e, {
        placement: ye,
        boundary: u,
        rootBoundary: h,
        padding: l,
        flipVariations: M,
        allowedAutoPlacements: m
      }) : ye);
    }, []), D = e.rects.reference, T = e.rects.popper, B = /* @__PURE__ */ new Map(), S = !0, P = y[0], G = 0; G < y.length; G++) {
      var U = y[G], le = Ot(U), ne = rn(U) === Ar, z = [St, kt].indexOf(le) >= 0, q = z ? "width" : "height", V = nn(e, {
        placement: U,
        boundary: u,
        rootBoundary: h,
        altBoundary: d,
        padding: l
      }), ie = z ? ne ? Wt : Dt : ne ? kt : St;
      D[q] > T[q] && (ie = qn(ie));
      var K = qn(ie), Y = [];
      if (a && Y.push(V[le] <= 0), s && Y.push(V[ie] <= 0, V[K] <= 0), Y.every(function(fe) {
        return fe;
      })) {
        P = U, S = !1;
        break;
      }
      B.set(U, Y);
    }
    if (S)
      for (var Q = M ? 3 : 1, se = function(ye) {
        var $ = y.find(function(Le) {
          var Me = B.get(Le);
          if (Me)
            return Me.slice(0, ye).every(function(we) {
              return we;
            });
        });
        if ($)
          return P = $, "break";
      }, X = Q; X > 0; X--) {
        var ue = se(X);
        if (ue === "break")
          break;
      }
    e.placement !== P && (e.modifiersData[r]._skip = !0, e.placement = P, e.reset = !0);
  }
}
const B0 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: j0,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function O0(i) {
  return i === "x" ? "y" : "x";
}
function Kn(i, e, t) {
  return Math.max(i, Math.min(e, t));
}
function z0(i) {
  var e = i.state, t = i.options, r = i.name, n = t.mainAxis, a = n === void 0 ? !0 : n, o = t.altAxis, s = o === void 0 ? !1 : o, c = t.boundary, l = t.rootBoundary, u = t.altBoundary, h = t.padding, d = t.tether, v = d === void 0 ? !0 : d, M = t.tetherOffset, m = M === void 0 ? 0 : M, g = nn(e, {
    boundary: c,
    rootBoundary: l,
    padding: h,
    altBoundary: u
  }), I = Ot(e.placement), A = rn(e.placement), L = !A, y = to(I), D = O0(y), T = e.modifiersData.popperOffsets, B = e.rects.reference, S = e.rects.popper, P = typeof m == "function" ? m(Object.assign(Object.assign({}, e.rects), {}, {
    placement: e.placement
  })) : m, G = {
    x: 0,
    y: 0
  };
  if (!!T) {
    if (a) {
      var U = y === "y" ? St : Dt, le = y === "y" ? kt : Wt, ne = y === "y" ? "height" : "width", z = T[y], q = T[y] + g[U], V = T[y] - g[le], ie = v ? -S[ne] / 2 : 0, K = A === Ar ? B[ne] : S[ne], Y = A === Ar ? -S[ne] : -B[ne], Q = e.elements.arrow, se = v && Q ? Ks(Q) : {
        width: 0,
        height: 0
      }, X = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : Qu(), ue = X[U], fe = X[le], ye = Kn(0, B[ne], se[ne]), $ = L ? B[ne] / 2 - ie - ye - ue - P : K - ye - ue - P, Le = L ? -B[ne] / 2 + ie + ye + fe + P : Y + ye + fe + P, Me = e.elements.arrow && fn(e.elements.arrow), we = Me ? y === "y" ? Me.clientTop || 0 : Me.clientLeft || 0 : 0, de = e.modifiersData.offset ? e.modifiersData.offset[e.placement][y] : 0, Oe = T[y] + $ - de - we, _e = T[y] + Le - de, xe = Kn(v ? Math.min(q, Oe) : q, z, v ? Math.max(V, _e) : V);
      T[y] = xe, G[y] = xe - z;
    }
    if (s) {
      var Ue = y === "x" ? St : Dt, Xe = y === "x" ? kt : Wt, Ye = T[D], qe = Ye + g[Ue], Ve = Ye - g[Xe], Ne = Kn(qe, Ye, Ve);
      T[D] = Ne, G[D] = Ne - Ye;
    }
    e.modifiersData[r] = G;
  }
}
const R0 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: z0,
  requiresIfExists: ["offset"]
};
function k0(i) {
  var e, t = i.state, r = i.name, n = t.elements.arrow, a = t.modifiersData.popperOffsets, o = Ot(t.placement), s = to(o), c = [Dt, Wt].indexOf(o) >= 0, l = c ? "height" : "width";
  if (!(!n || !a)) {
    var u = t.modifiersData[r + "#persistent"].padding, h = Ks(n), d = s === "y" ? St : Dt, v = s === "y" ? kt : Wt, M = t.rects.reference[l] + t.rects.reference[s] - a[s] - t.rects.popper[l], m = a[s] - t.rects.reference[s], g = fn(n), I = g ? s === "y" ? g.clientHeight || 0 : g.clientWidth || 0 : 0, A = M / 2 - m / 2, L = u[d], y = I - h[l] - u[v], D = I / 2 - h[l] / 2 + A, T = Kn(L, D, y), B = s;
    t.modifiersData[r] = (e = {}, e[B] = T, e.centerOffset = T - D, e);
  }
}
function W0(i) {
  var e = i.state, t = i.options, r = i.name, n = t.element, a = n === void 0 ? "[data-popper-arrow]" : n, o = t.padding, s = o === void 0 ? 0 : o;
  if (a != null && !(typeof a == "string" && (a = e.elements.popper.querySelector(a), !a))) {
    if (process.env.NODE_ENV !== "production" && (Rt(a) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !Yu(e.elements.popper, a)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    e.elements.arrow = a, e.modifiersData[r + "#persistent"] = {
      padding: Ju(typeof s != "number" ? s : Xu(s, mn))
    };
  }
}
const G0 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: k0,
  effect: W0,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function rl(i, e, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: i.top - e.height - t.y,
    right: i.right - e.width + t.x,
    bottom: i.bottom - e.height + t.y,
    left: i.left - e.width - t.x
  };
}
function nl(i) {
  return [St, Wt, kt, Dt].some(function(e) {
    return i[e] >= 0;
  });
}
function U0(i) {
  var e = i.state, t = i.name, r = e.rects.reference, n = e.rects.popper, a = e.modifiersData.preventOverflow, o = nn(e, {
    elementContext: "reference"
  }), s = nn(e, {
    altBoundary: !0
  }), c = rl(o, r), l = rl(s, n, a), u = nl(c), h = nl(l);
  e.modifiersData[t] = {
    referenceClippingOffsets: c,
    popperEscapeOffsets: l,
    isReferenceHidden: u,
    hasPopperEscaped: h
  }, e.attributes.popper = Object.assign(Object.assign({}, e.attributes.popper), {}, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": h
  });
}
const H0 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: U0
};
var F0 = [v0, y0, w0, S0, C0, B0, R0, G0, H0], $u = /* @__PURE__ */ m0({
  defaultModifiers: F0
});
const V0 = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    placement: { default: "bottom" },
    keepAlive: { type: Boolean, default: !0 },
    autoclose: { type: Boolean, default: !0 },
    showCloseButton: { type: Boolean, default: !1 },
    strategy: { default: "absolute" },
    offset: { default: () => [0, 8] }
  },
  setup(i, { expose: e }) {
    const t = i, r = R(null), n = R(null), a = R(!1), o = R(null), s = async () => {
      a.value = !0, await ga(), r.value && n.value && (o.value = $u(r.value, n.value, {
        strategy: t.strategy,
        placement: t.placement,
        modifiers: [
          {
            name: "offset",
            options: {
              offset: t.offset
            }
          }
        ]
      }));
    }, c = () => {
      var d;
      a.value = !1, (d = o.value) == null || d.destroy(), o.value = null;
    }, l = () => {
      !t.autoclose && c();
    }, u = () => {
      (t.autoclose || !t.showCloseButton) && c();
    }, h = () => {
      a.value ? c() : s();
    };
    return e({
      toggle: h,
      hide: c,
      show: s
    }), { __sfc: !0, props: t, triggerRef: r, popperRef: n, isVisible: a, popperInstance: o, show: s, hide: c, close: l, clickAway: u, toggle: h, vOnClickaway: Gu, vIcon: pn };
  }
});
var Y0 = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", { directives: [{ name: "on-clickaway", rawName: "v-on-clickaway", value: r.clickAway, expression: "clickAway" }], staticClass: "v-popover" }, [t("span", { ref: "triggerRef", staticClass: "trigger", attrs: { "aria-describedby": "tooltip" }, on: { click: r.toggle } }, [e._t("default")], 2), e.keepAlive || r.isVisible ? t("div", e._g({ directives: [{ name: "show", rawName: "v-show", value: e.keepAlive ? r.isVisible : !0, expression: "!keepAlive ? true : isVisible" }], ref: "popperRef", staticClass: "popover", attrs: { role: "tooltip" } }, e.autoclose ? { click: r.toggle } : {}), [e.showCloseButton ? t("button", { staticClass: "close", on: { click: r.close } }, [t(r.vIcon, { attrs: { name: "x" } })], 1) : e._e(), e._t("popover", null, { hide: r.hide }), t("div", { staticClass: "arrow", attrs: { "data-popper-arrow": "" } })], 2) : e._e()]);
}, Z0 = [], Q0 = /* @__PURE__ */ Ge(
  V0,
  Y0,
  Z0,
  !1,
  null,
  null,
  null,
  null
);
const J0 = Q0.exports, X0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J0
}, Symbol.toStringTag, { value: "Module" })), $0 = () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(i) {
  const e = Math.random() * 16 | 0;
  return (i == "x" ? e : e & 3 | 8).toString(16);
}), qu = () => typeof __webpack_require__ == "function", q0 = (i) => new Promise((e) => setTimeout(e, i)), Ba = (i) => typeof i == "object" && i !== null, K0 = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    loading: { type: Boolean, default: !1 },
    minLoadDuration: { default: 1e3 }
  },
  setup(i, { expose: e }) {
    var M;
    const t = i, r = (M = fi()) == null ? void 0 : M.proxy.$listeners, n = R(!1), a = R(!1), o = R(!1), s = R(!1), c = me(() => t.loading ? !0 : a.value), l = me(() => ({ ...r, click: u })), u = async (m) => {
      if (!a.value)
        try {
          a.value = !0;
          const g = r == null ? void 0 : r.click;
          await Promise.all([q0(t.minLoadDuration), g(m)]), h(o);
        } catch (g) {
          throw h(s), g;
        } finally {
          a.value = !1;
        }
    }, h = (m) => {
      if (n.value)
        return n.value = !1;
      m.value = !0, setTimeout(() => {
        m.value = !1;
      }, t.minLoadDuration);
    }, d = () => {
      a.value = !1, s.value = !1, o.value = !1;
    }, v = () => {
      n.value = !0, d();
    };
    return e({ cancel: v }), { __sfc: !0, props: t, instanceListeners: r, isCanceled: n, isLoading: a, isSuccess: o, hasError: s, loadingState: c, listeners: l, handleClick: u, resetDelayed: h, reset: d, cancel: v };
  }
});
var eg = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("button", e._g({ staticClass: "promise v-promise-button", class: { success: r.isSuccess, danger: r.hasError, loading: r.loadingState }, attrs: { disabled: r.loadingState } }, r.listeners), [r.loadingState ? e._t("loading", function() {
    return [e._v("Loading...")];
  }) : r.isSuccess ? e._t("success", function() {
    return [e._v("Sucess!")];
  }) : r.hasError ? e._t("error", function() {
    return [e._v("Errored")];
  }) : e._t("default")], 2);
}, tg = [], ig = /* @__PURE__ */ Ge(
  K0,
  eg,
  tg,
  !1,
  null,
  null,
  null,
  null
);
const rg = ig.exports, ng = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rg
}, Symbol.toStringTag, { value: "Module" })), ag = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    value: null,
    innerValue: { default: null }
  },
  emits: ["input"],
  setup(i, { emit: e }) {
    const t = i, r = me(() => t.value === t.innerValue), n = (s) => {
      e("input", t.innerValue);
    }, { hasLabel: a, listeners: o } = Lr(e, !1, n);
    return { __sfc: !0, props: t, emit: e, isChecked: r, emitValue: n, hasLabel: a, listeners: o };
  }
});
var sg = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("label", { staticClass: "radio", class: { "no-text": !r.hasLabel } }, [t("div", { staticClass: "input" }, [t("input", e._g(e._b({ attrs: { type: "radio" }, domProps: { value: e.value, checked: r.isChecked } }, "input", e.$attrs, !1), r.listeners)), t("span", { staticClass: "label" }, [e._t("default")], 2)])]);
}, og = [], lg = /* @__PURE__ */ Ge(
  ag,
  sg,
  og,
  !1,
  null,
  null,
  null,
  null
);
const cg = lg.exports, ug = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cg
}, Symbol.toStringTag, { value: "Module" })), dg = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    value: { default: null },
    options: { default: () => [] },
    labelAttribute: { default: "label" },
    valueAttribute: null
  },
  emits: ["input"],
  setup(i, { emit: e }) {
    const t = i, r = ma(), n = Zs(), a = me(() => Ba(t.options[0])), o = me(() => a.value && !t.valueAttribute), s = me(() => !!r.default), c = me(() => n.placeholder), l = me(() => (M) => {
      var m;
      return Ba(M) ? M[(m = t.valueAttribute) != null ? m : "value"] : M;
    }), u = me(() => (M) => {
      var m;
      return Ba(M) ? M[(m = t.labelAttribute) != null ? m : "label"] : M;
    }), h = (M) => {
      const m = M.target;
      if (m) {
        let g = m.value;
        o.value && (g = t.options[m.selectedIndex]), e("input", g);
      }
    }, { listeners: d } = Lr(e, !1, h), v = fi();
    return ze(
      () => t.options,
      (M) => {
        ga(() => {
          v == null || v.proxy.$forceUpdate();
        });
      }
    ), { __sfc: !0, props: t, emit: e, slots: r, attrs: n, hasComplexOptions: a, shouldEmitObject: o, hasLabel: s, placeholder: c, valueFor: l, labelFor: u, emitValue: h, listeners: d, instance: v };
  }
});
var hg = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("label", { staticClass: "select v-select" }, [r.hasLabel ? t("span", { staticClass: "label" }, [e._t("default")], 2) : e._e(), t("div", { staticClass: "input" }, [t("select", e._g(e._b({ domProps: { value: r.valueFor(e.value) } }, "select", e.$attrs, !1), r.listeners), [r.placeholder ? t("option", { attrs: { disabled: "" }, domProps: { value: null } }, [e._v(e._s(r.placeholder))]) : e._e(), e._l(e.options, function(n, a) {
    return t("option", { key: a, domProps: { value: r.valueFor(n) } }, [e._v(" " + e._s(r.labelFor(n)) + " ")]);
  })], 2)])]);
}, pg = [], fg = /* @__PURE__ */ Ge(
  dg,
  hg,
  pg,
  !1,
  null,
  null,
  null,
  null
);
const mg = fg.exports, gg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: mg
}, Symbol.toStringTag, { value: "Module" })), Ku = Symbol("Splitter"), vg = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    isHorizontal: { type: Boolean, default: !0 }
  },
  setup(i) {
    var o;
    const e = i, t = R([]), r = me(() => ({
      "flex-direction": e.isHorizontal ? "row" : "column"
    })), n = (o = fi()) == null ? void 0 : o.proxy, a = (s) => {
      t.value.push(s), t.value.length === (n == null ? void 0 : n.$children.length) && s.disableResizer();
    };
    return dn(Ku, {
      onAreaAdd: a,
      isHorizontal: e.isHorizontal
    }), { __sfc: !0, props: e, panes: t, styleObject: r, instance: n, onAreaAdd: a };
  }
});
var Mg = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", { staticClass: "v-splitter", class: { vertical: !e.isHorizontal }, style: r.styleObject }, [e._t("default")], 2);
}, yg = [], xg = /* @__PURE__ */ Ge(
  vg,
  Mg,
  yg,
  !1,
  null,
  null,
  null,
  null
);
const Ig = xg.exports, bg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ig
}, Symbol.toStringTag, { value: "Module" })), wg = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    value: { type: Boolean },
    labelOn: { default: "&nbsp" },
    labelOff: { default: "&nbsp" }
  },
  emits: ["input"],
  setup(i, { emit: e }) {
    const { listeners: t } = Lr(e);
    return { __sfc: !0, emit: e, listeners: t };
  }
});
var _g = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("label", { staticClass: "v-switch" }, [t("span", { staticClass: "label" }, [e._t("default")], 2), t("div", { staticClass: "input" }, [t("label", { staticClass: "switch" }, [t("input", e._g(e._b({ attrs: { type: "checkbox" }, domProps: { value: e.value, checked: e.value } }, "input", e.$attrs, !1), r.listeners)), t("div", { staticClass: "switch-handle" }), t("span", { staticClass: "value-on", domProps: { innerHTML: e._s(e.labelOn) } }), t("span", { staticClass: "value-off", domProps: { innerHTML: e._s(e.labelOff) } })])])]);
}, Ag = [], Sg = /* @__PURE__ */ Ge(
  wg,
  _g,
  Ag,
  !1,
  null,
  null,
  null,
  null
);
const Dg = Sg.exports, Tg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Dg
}, Symbol.toStringTag, { value: "Module" })), ed = Symbol("Tabs"), Cg = /* @__PURE__ */ ge({
  __name: "index",
  setup(i) {
    const e = R([]), t = (m) => {
      e.value.push(m), r();
    }, r = xa(() => {
      if (c(window.location.hash))
        return l();
      e.value.length && s(e.value.at(0));
    }, 10);
    dn(ed, {
      addTab: t
    });
    const n = me(() => e.value.findIndex((m) => m.isActive)), a = me(
      () => e.value.filter((m) => !m.isDisabled).map((m) => e.value.indexOf(m))
    ), o = (m) => document.documentElement.classList.contains("no-tab-switch") ? !1 : m.composedPath().slice(0, 8).some((g) => g instanceof HTMLInputElement || g instanceof HTMLTextAreaElement) === !1, s = (m, g) => {
      if (m.isDisabled && g) {
        g.preventDefault();
        return;
      }
      e.value.forEach((I) => I.deActivate()), m.activate();
    }, c = (m) => e.value.find((g) => g.hash === m), l = () => {
      const m = c(window.location.hash);
      m && s(m);
    }, u = () => {
      const m = a.value.indexOf(n.value);
      let g = a.value.at(m + 1);
      g === void 0 && (g = a.value.at(0)), s(e.value.at(g));
    }, h = () => {
      const m = a.value.indexOf(n.value);
      let g = a.value.at(m - 1);
      g === void 0 && (g = a.value.at(a.value.length - 1)), s(e.value.at(g));
    }, d = (m) => {
      !o(m) || (m.code.toLowerCase() === "arrowright" && u(), m.code.toLowerCase() === "arrowleft" && h());
    }, v = () => {
      window.addEventListener("hashchange", l), window.addEventListener("keydown", d);
    }, M = () => {
      window.removeEventListener("hashchange", l), window.removeEventListener("keydown", d);
    };
    return Ma(() => {
      M();
    }), Ht(() => {
      v();
    }), { __sfc: !0, tabs: e, addTab: t, activate: r, currentTabIndex: n, enabledTabIndices: a, shouldSwitch: o, selectTab: s, findTab: c, selectTabFromHash: l, selectNextTab: u, selectPreviousTab: h, onKeyPress: d, bindListeners: v, unbindListeners: M };
  }
});
var Eg = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", { staticClass: "v-tabs" }, [t("ul", { attrs: { role: "tablist" } }, e._l(r.tabs, function(n) {
    return t("li", { key: n.hash, class: { "is-active": n.isActive, "is-disabled": n.isDisabled }, attrs: { role: "presentation" } }, [t("a", { attrs: { href: n.hash, "aria-controls": n.hash, "aria-selected": n.isActive, role: "tab" }, domProps: { innerHTML: e._s(n.header) }, on: { click: function(a) {
      return r.selectTab(n, a);
    } } })]);
  }), 0), t("div", { ref: "panelRef", staticClass: "tab-panels" }, [e._t("default")], 2)]);
}, Ng = [], Lg = /* @__PURE__ */ Ge(
  Cg,
  Eg,
  Ng,
  !1,
  null,
  null,
  null,
  null
);
const Pg = Lg.exports, jg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pg
}, Symbol.toStringTag, { value: "Module" })), Bg = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    value: null,
    lazy: { type: Boolean }
  },
  emits: ["input"],
  setup(i, { emit: e }) {
    const t = i, { listeners: r, hasLabel: n } = Lr(e, t.lazy);
    return { __sfc: !0, props: t, emit: e, listeners: r, hasLabel: n };
  }
});
var Og = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("label", { staticClass: "v-textarea" }, [r.hasLabel ? t("span", { staticClass: "label" }, [e._t("default")], 2) : e._e(), t("div", { staticClass: "input" }, [t("textarea", e._g(e._b({ domProps: { value: e.value } }, "textarea", e.$attrs, !1), r.listeners))])]);
}, zg = [], Rg = /* @__PURE__ */ Ge(
  Bg,
  Og,
  zg,
  !1,
  null,
  null,
  null,
  null
);
const kg = Rg.exports, Wg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kg
}, Symbol.toStringTag, { value: "Module" }));
var Gg = "tippy-box", td = "tippy-content", Ug = "tippy-backdrop", id = "tippy-arrow", rd = "tippy-svg-arrow", ki = {
  passive: !0,
  capture: !0
};
function Hg(i, e) {
  return {}.hasOwnProperty.call(i, e);
}
function Oa(i, e, t) {
  if (Array.isArray(i)) {
    var r = i[e];
    return r == null ? Array.isArray(t) ? t[e] : t : r;
  }
  return i;
}
function io(i, e) {
  var t = {}.toString.call(i);
  return t.indexOf("[object") === 0 && t.indexOf(e + "]") > -1;
}
function nd(i, e) {
  return typeof i == "function" ? i.apply(void 0, e) : i;
}
function al(i, e) {
  if (e === 0)
    return i;
  var t;
  return function(r) {
    clearTimeout(t), t = setTimeout(function() {
      i(r);
    }, e);
  };
}
function Fg(i, e) {
  var t = Object.assign({}, i);
  return e.forEach(function(r) {
    delete t[r];
  }), t;
}
function Vg(i) {
  return i.split(/\s+/).filter(Boolean);
}
function Yr(i) {
  return [].concat(i);
}
function sl(i, e) {
  i.indexOf(e) === -1 && i.push(e);
}
function Yg(i) {
  return i.filter(function(e, t) {
    return i.indexOf(e) === t;
  });
}
function Zg(i) {
  return i.split("-")[0];
}
function ca(i) {
  return [].slice.call(i);
}
function Qg(i) {
  return Object.keys(i).reduce(function(e, t) {
    return i[t] !== void 0 && (e[t] = i[t]), e;
  }, {});
}
function $r() {
  return document.createElement("div");
}
function an(i) {
  return ["Element", "Fragment"].some(function(e) {
    return io(i, e);
  });
}
function Jg(i) {
  return io(i, "NodeList");
}
function Xg(i) {
  return io(i, "MouseEvent");
}
function $g(i) {
  return !!(i && i._tippy && i._tippy.reference === i);
}
function qg(i) {
  return an(i) ? [i] : Jg(i) ? ca(i) : Array.isArray(i) ? i : ca(document.querySelectorAll(i));
}
function za(i, e) {
  i.forEach(function(t) {
    t && (t.style.transitionDuration = e + "ms");
  });
}
function ol(i, e) {
  i.forEach(function(t) {
    t && t.setAttribute("data-state", e);
  });
}
function Kg(i) {
  var e = Yr(i), t = e[0];
  return t && t.ownerDocument || document;
}
function ev(i, e) {
  var t = e.clientX, r = e.clientY;
  return i.every(function(n) {
    var a = n.popperRect, o = n.popperState, s = n.props, c = s.interactiveBorder, l = Zg(o.placement), u = o.modifiersData.offset;
    if (!u)
      return !0;
    var h = l === "bottom" ? u.top.y : 0, d = l === "top" ? u.bottom.y : 0, v = l === "right" ? u.left.x : 0, M = l === "left" ? u.right.x : 0, m = a.top - r + h > c, g = r - a.bottom - d > c, I = a.left - t + v > c, A = t - a.right - M > c;
    return m || g || I || A;
  });
}
function Ra(i, e, t) {
  var r = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(n) {
    i[r](n, t);
  });
}
var Xt = {
  isTouch: !1
}, ll = 0;
function tv() {
  Xt.isTouch || (Xt.isTouch = !0, window.performance && document.addEventListener("mousemove", ad));
}
function ad() {
  var i = performance.now();
  i - ll < 20 && (Xt.isTouch = !1, document.removeEventListener("mousemove", ad)), ll = i;
}
function iv() {
  var i = document.activeElement;
  if ($g(i)) {
    var e = i._tippy;
    i.blur && !e.state.isVisible && i.blur();
  }
}
function rv() {
  document.addEventListener("touchstart", tv, ki), window.addEventListener("blur", iv);
}
var nv = typeof window < "u" && typeof document < "u", av = nv ? navigator.userAgent : "", sv = /MSIE |Trident\//.test(av);
function tr(i) {
  var e = i === "destroy" ? "n already-" : " ";
  return [i + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function cl(i) {
  var e = /[ \t]{2,}/g, t = /^[ \t]*/gm;
  return i.replace(e, " ").replace(t, "").trim();
}
function ov(i) {
  return cl(`
  %ctippy.js

  %c` + cl(i) + `

  %c\u{1F477}\u200D This is a development-only message. It will be removed in production.
  `);
}
function sd(i) {
  return [
    ov(i),
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    "line-height: 1.5",
    "color: #a6a095;"
  ];
}
var sn;
process.env.NODE_ENV !== "production" && lv();
function lv() {
  sn = /* @__PURE__ */ new Set();
}
function ui(i, e) {
  if (i && !sn.has(e)) {
    var t;
    sn.add(e), (t = console).warn.apply(t, sd(e));
  }
}
function Ns(i, e) {
  if (i && !sn.has(e)) {
    var t;
    sn.add(e), (t = console).error.apply(t, sd(e));
  }
}
function cv(i) {
  var e = !i, t = Object.prototype.toString.call(i) === "[object Object]" && !i.addEventListener;
  Ns(e, ["tippy() was passed", "`" + String(i) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Ns(t, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var od = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, uv = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Mt = Object.assign({
  appendTo: function() {
    return document.body;
  },
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, od, {}, uv), dv = Object.keys(Mt), hv = function(e) {
  process.env.NODE_ENV !== "production" && cd(e, []);
  var t = Object.keys(e);
  t.forEach(function(r) {
    Mt[r] = e[r];
  });
};
function ld(i) {
  var e = i.plugins || [], t = e.reduce(function(r, n) {
    var a = n.name, o = n.defaultValue;
    return a && (r[a] = i[a] !== void 0 ? i[a] : o), r;
  }, {});
  return Object.assign({}, i, {}, t);
}
function pv(i, e) {
  var t = e ? Object.keys(ld(Object.assign({}, Mt, {
    plugins: e
  }))) : dv, r = t.reduce(function(n, a) {
    var o = (i.getAttribute("data-tippy-" + a) || "").trim();
    if (!o)
      return n;
    if (a === "content")
      n[a] = o;
    else
      try {
        n[a] = JSON.parse(o);
      } catch {
        n[a] = o;
      }
    return n;
  }, {});
  return r;
}
function ul(i, e) {
  var t = Object.assign({}, e, {
    content: nd(e.content, [i])
  }, e.ignoreAttributes ? {} : pv(i, e.plugins));
  return t.aria = Object.assign({}, Mt.aria, {}, t.aria), t.aria = {
    expanded: t.aria.expanded === "auto" ? e.interactive : t.aria.expanded,
    content: t.aria.content === "auto" ? e.interactive ? null : "describedby" : t.aria.content
  }, t;
}
function cd(i, e) {
  i === void 0 && (i = {}), e === void 0 && (e = []);
  var t = Object.keys(i);
  t.forEach(function(r) {
    var n = Fg(Mt, Object.keys(od)), a = !Hg(n, r);
    a && (a = e.filter(function(o) {
      return o.name === r;
    }).length === 0), ui(a, ["`" + r + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var fv = function() {
  return "innerHTML";
};
function Ls(i, e) {
  i[fv()] = e;
}
function dl(i) {
  var e = $r();
  return i === !0 ? e.className = id : (e.className = rd, an(i) ? e.appendChild(i) : Ls(e, i)), e;
}
function hl(i, e) {
  an(e.content) ? (Ls(i, ""), i.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? Ls(i, e.content) : i.textContent = e.content);
}
function Ps(i) {
  var e = i.firstElementChild, t = ca(e.children);
  return {
    box: e,
    content: t.find(function(r) {
      return r.classList.contains(td);
    }),
    arrow: t.find(function(r) {
      return r.classList.contains(id) || r.classList.contains(rd);
    }),
    backdrop: t.find(function(r) {
      return r.classList.contains(Ug);
    })
  };
}
function ud(i) {
  var e = $r(), t = $r();
  t.className = Gg, t.setAttribute("data-state", "hidden"), t.setAttribute("tabindex", "-1");
  var r = $r();
  r.className = td, r.setAttribute("data-state", "hidden"), hl(r, i.props), e.appendChild(t), t.appendChild(r), n(i.props, i.props);
  function n(a, o) {
    var s = Ps(e), c = s.box, l = s.content, u = s.arrow;
    o.theme ? c.setAttribute("data-theme", o.theme) : c.removeAttribute("data-theme"), typeof o.animation == "string" ? c.setAttribute("data-animation", o.animation) : c.removeAttribute("data-animation"), o.inertia ? c.setAttribute("data-inertia", "") : c.removeAttribute("data-inertia"), c.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? c.setAttribute("role", o.role) : c.removeAttribute("role"), (a.content !== o.content || a.allowHTML !== o.allowHTML) && hl(l, i.props), o.arrow ? u ? a.arrow !== o.arrow && (c.removeChild(u), c.appendChild(dl(o.arrow))) : c.appendChild(dl(o.arrow)) : u && c.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: n
  };
}
ud.$$tippy = !0;
var mv = 1, Sn = [], ka = [];
function gv(i, e) {
  var t = ul(i, Object.assign({}, Mt, {}, ld(Qg(e)))), r, n, a, o = !1, s = !1, c = !1, l = !1, u, h, d, v = [], M = al(Ue, t.interactiveDebounce), m, g = mv++, I = null, A = Yg(t.plugins), L = {
    isEnabled: !0,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }, y = {
    id: g,
    reference: i,
    popper: $r(),
    popperInstance: I,
    props: t,
    state: L,
    plugins: A,
    clearDelayTimeouts: he,
    setProps: x,
    setContent: f,
    show: p,
    hide: b,
    hideWithInteractivity: N,
    enable: J,
    disable: ce,
    unmount: O,
    destroy: w
  };
  if (!t.render)
    return process.env.NODE_ENV !== "production" && Ns(!0, "render() function has not been supplied."), y;
  var D = t.render(y), T = D.popper, B = D.onUpdate;
  T.setAttribute("data-tippy-root", ""), T.id = "tippy-" + y.id, y.popper = T, i._tippy = y, T._tippy = y;
  var S = A.map(function(j) {
    return j.fn(y);
  }), P = i.hasAttribute("aria-expanded");
  return Oe(), Q(), ie(), K("onCreate", [y]), t.showOnCreate && E(), T.addEventListener("mouseenter", function() {
    y.props.interactive && y.state.isVisible && y.clearDelayTimeouts();
  }), T.addEventListener("mouseleave", function(j) {
    y.props.interactive && y.props.trigger.indexOf("mouseenter") >= 0 && (z().addEventListener("mousemove", M), M(j));
  }), y;
  function G() {
    var j = y.props.touch;
    return Array.isArray(j) ? j : [j, 0];
  }
  function U() {
    return G()[0] === "hold";
  }
  function le() {
    var j;
    return !!((j = y.props.render) != null && j.$$tippy);
  }
  function ne() {
    return m || i;
  }
  function z() {
    var j = ne().parentNode;
    return j ? Kg(j) : document;
  }
  function q() {
    return Ps(T);
  }
  function V(j) {
    return y.state.isMounted && !y.state.isVisible || Xt.isTouch || u && u.type === "focus" ? 0 : Oa(y.props.delay, j ? 0 : 1, Mt.delay);
  }
  function ie() {
    T.style.pointerEvents = y.props.interactive && y.state.isVisible ? "" : "none", T.style.zIndex = "" + y.props.zIndex;
  }
  function K(j, k, ee) {
    if (ee === void 0 && (ee = !0), S.forEach(function(ae) {
      ae[j] && ae[j].apply(void 0, k);
    }), ee) {
      var te;
      (te = y.props)[j].apply(te, k);
    }
  }
  function Y() {
    var j = y.props.aria;
    if (!!j.content) {
      var k = "aria-" + j.content, ee = T.id, te = Yr(y.props.triggerTarget || i);
      te.forEach(function(ae) {
        var oe = ae.getAttribute(k);
        if (y.state.isVisible)
          ae.setAttribute(k, oe ? oe + " " + ee : ee);
        else {
          var ve = oe && oe.replace(ee, "").trim();
          ve ? ae.setAttribute(k, ve) : ae.removeAttribute(k);
        }
      });
    }
  }
  function Q() {
    if (!(P || !y.props.aria.expanded)) {
      var j = Yr(y.props.triggerTarget || i);
      j.forEach(function(k) {
        y.props.interactive ? k.setAttribute("aria-expanded", y.state.isVisible && k === ne() ? "true" : "false") : k.removeAttribute("aria-expanded");
      });
    }
  }
  function se() {
    z().removeEventListener("mousemove", M), Sn = Sn.filter(function(j) {
      return j !== M;
    });
  }
  function X(j) {
    if (!(Xt.isTouch && (c || j.type === "mousedown")) && !(y.props.interactive && T.contains(j.target))) {
      if (ne().contains(j.target)) {
        if (Xt.isTouch || y.state.isVisible && y.props.trigger.indexOf("click") >= 0)
          return;
      } else
        K("onClickOutside", [y, j]);
      y.props.hideOnClick === !0 && (y.clearDelayTimeouts(), y.hide(), s = !0, setTimeout(function() {
        s = !1;
      }), y.state.isMounted || $());
    }
  }
  function ue() {
    c = !0;
  }
  function fe() {
    c = !1;
  }
  function ye() {
    var j = z();
    j.addEventListener("mousedown", X, !0), j.addEventListener("touchend", X, ki), j.addEventListener("touchstart", fe, ki), j.addEventListener("touchmove", ue, ki);
  }
  function $() {
    var j = z();
    j.removeEventListener("mousedown", X, !0), j.removeEventListener("touchend", X, ki), j.removeEventListener("touchstart", fe, ki), j.removeEventListener("touchmove", ue, ki);
  }
  function Le(j, k) {
    we(j, function() {
      !y.state.isVisible && T.parentNode && T.parentNode.contains(T) && k();
    });
  }
  function Me(j, k) {
    we(j, k);
  }
  function we(j, k) {
    var ee = q().box;
    function te(ae) {
      ae.target === ee && (Ra(ee, "remove", te), k());
    }
    if (j === 0)
      return k();
    Ra(ee, "remove", h), Ra(ee, "add", te), h = te;
  }
  function de(j, k, ee) {
    ee === void 0 && (ee = !1);
    var te = Yr(y.props.triggerTarget || i);
    te.forEach(function(ae) {
      ae.addEventListener(j, k, ee), v.push({
        node: ae,
        eventType: j,
        handler: k,
        options: ee
      });
    });
  }
  function Oe() {
    U() && (de("touchstart", xe, {
      passive: !0
    }), de("touchend", Xe, {
      passive: !0
    })), Vg(y.props.trigger).forEach(function(j) {
      if (j !== "manual")
        switch (de(j, xe), j) {
          case "mouseenter":
            de("mouseleave", Xe);
            break;
          case "focus":
            de(sv ? "focusout" : "blur", Ye);
            break;
          case "focusin":
            de("focusout", Ye);
            break;
        }
    });
  }
  function _e() {
    v.forEach(function(j) {
      var k = j.node, ee = j.eventType, te = j.handler, ae = j.options;
      k.removeEventListener(ee, te, ae);
    }), v = [];
  }
  function xe(j) {
    var k, ee = !1;
    if (!(!y.state.isEnabled || qe(j) || s)) {
      var te = ((k = u) == null ? void 0 : k.type) === "focus";
      u = j, m = j.currentTarget, Q(), !y.state.isVisible && Xg(j) && Sn.forEach(function(ae) {
        return ae(j);
      }), j.type === "click" && (y.props.trigger.indexOf("mouseenter") < 0 || o) && y.props.hideOnClick !== !1 && y.state.isVisible ? ee = !0 : E(j), j.type === "click" && (o = !ee), ee && !te && _(j);
    }
  }
  function Ue(j) {
    var k = j.target, ee = ne().contains(k) || T.contains(k);
    if (!(j.type === "mousemove" && ee)) {
      var te = it().concat(T).map(function(ae) {
        var oe, ve = ae._tippy, Ae = (oe = ve.popperInstance) == null ? void 0 : oe.state;
        return Ae ? {
          popperRect: ae.getBoundingClientRect(),
          popperState: Ae,
          props: t
        } : null;
      }).filter(Boolean);
      ev(te, j) && (se(), _(j));
    }
  }
  function Xe(j) {
    var k = qe(j) || y.props.trigger.indexOf("click") >= 0 && o;
    if (!k) {
      if (y.props.interactive) {
        y.hideWithInteractivity(j);
        return;
      }
      _(j);
    }
  }
  function Ye(j) {
    y.props.trigger.indexOf("focusin") < 0 && j.target !== ne() || y.props.interactive && j.relatedTarget && T.contains(j.relatedTarget) || _(j);
  }
  function qe(j) {
    return Xt.isTouch ? U() !== j.type.indexOf("touch") >= 0 : !1;
  }
  function Ve() {
    Ne();
    var j = y.props, k = j.popperOptions, ee = j.placement, te = j.offset, ae = j.getReferenceClientRect, oe = j.moveTransition, ve = le() ? Ps(T).arrow : null, Ae = ae ? {
      getBoundingClientRect: ae,
      contextElement: ae.contextElement || ne()
    } : i, Fe = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Pi) {
        var Or = Pi.state;
        if (le()) {
          var $i = q(), zr = $i.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(gi) {
            gi === "placement" ? zr.setAttribute("data-placement", Or.placement) : Or.attributes.popper["data-popper-" + gi] ? zr.setAttribute("data-" + gi, "") : zr.removeAttribute("data-" + gi);
          }), Or.attributes.popper = {};
        }
      }
    }, Ze = [{
      name: "offset",
      options: {
        offset: te
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !oe
      }
    }, Fe];
    le() && ve && Ze.push({
      name: "arrow",
      options: {
        element: ve,
        padding: 3
      }
    }), Ze.push.apply(Ze, (k == null ? void 0 : k.modifiers) || []), y.popperInstance = $u(Ae, T, Object.assign({}, k, {
      placement: ee,
      onFirstUpdate: d,
      modifiers: Ze
    }));
  }
  function Ne() {
    y.popperInstance && (y.popperInstance.destroy(), y.popperInstance = null);
  }
  function dt() {
    var j = y.props.appendTo, k, ee = ne();
    y.props.interactive && j === Mt.appendTo || j === "parent" ? k = ee.parentNode : k = nd(j, [ee]), k.contains(T) || k.appendChild(T), Ve(), process.env.NODE_ENV !== "production" && ui(y.props.interactive && j === Mt.appendTo && ee.nextElementSibling !== T, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function it() {
    return ca(T.querySelectorAll("[data-tippy-root]"));
  }
  function E(j) {
    y.clearDelayTimeouts(), j && K("onTrigger", [y, j]), ye();
    var k = V(!0), ee = G(), te = ee[0], ae = ee[1];
    Xt.isTouch && te === "hold" && ae && (k = ae), k ? r = setTimeout(function() {
      y.show();
    }, k) : y.show();
  }
  function _(j) {
    if (y.clearDelayTimeouts(), K("onUntrigger", [y, j]), !y.state.isVisible) {
      $();
      return;
    }
    if (!(y.props.trigger.indexOf("mouseenter") >= 0 && y.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(j.type) >= 0 && o)) {
      var k = V(!1);
      k ? n = setTimeout(function() {
        y.state.isVisible && y.hide();
      }, k) : a = requestAnimationFrame(function() {
        y.hide();
      });
    }
  }
  function J() {
    y.state.isEnabled = !0;
  }
  function ce() {
    y.hide(), y.state.isEnabled = !1;
  }
  function he() {
    clearTimeout(r), clearTimeout(n), cancelAnimationFrame(a);
  }
  function x(j) {
    if (process.env.NODE_ENV !== "production" && ui(y.state.isDestroyed, tr("setProps")), !y.state.isDestroyed) {
      K("onBeforeUpdate", [y, j]), _e();
      var k = y.props, ee = ul(i, Object.assign({}, y.props, {}, j, {
        ignoreAttributes: !0
      }));
      y.props = ee, Oe(), k.interactiveDebounce !== ee.interactiveDebounce && (se(), M = al(Ue, ee.interactiveDebounce)), k.triggerTarget && !ee.triggerTarget ? Yr(k.triggerTarget).forEach(function(te) {
        te.removeAttribute("aria-expanded");
      }) : ee.triggerTarget && i.removeAttribute("aria-expanded"), Q(), ie(), B && B(k, ee), y.popperInstance && (Ve(), it().forEach(function(te) {
        requestAnimationFrame(te._tippy.popperInstance.forceUpdate);
      })), K("onAfterUpdate", [y, j]);
    }
  }
  function f(j) {
    y.setProps({
      content: j
    });
  }
  function p() {
    process.env.NODE_ENV !== "production" && ui(y.state.isDestroyed, tr("show"));
    var j = y.state.isVisible, k = y.state.isDestroyed, ee = !y.state.isEnabled, te = Xt.isTouch && !y.props.touch, ae = Oa(y.props.duration, 0, Mt.duration);
    if (!(j || k || ee || te) && !ne().hasAttribute("disabled") && (K("onShow", [y], !1), y.props.onShow(y) !== !1)) {
      if (y.state.isVisible = !0, le() && (T.style.visibility = "visible"), ie(), ye(), y.state.isMounted || (T.style.transition = "none"), le()) {
        var oe = q(), ve = oe.box, Ae = oe.content;
        za([ve, Ae], 0);
      }
      d = function() {
        if (!(!y.state.isVisible || l)) {
          if (l = !0, T.offsetHeight, T.style.transition = y.props.moveTransition, le() && y.props.animation) {
            var Ze = q(), ht = Ze.box, Pi = Ze.content;
            za([ht, Pi], ae), ol([ht, Pi], "visible");
          }
          Y(), Q(), sl(ka, y), y.state.isMounted = !0, K("onMount", [y]), y.props.animation && le() && Me(ae, function() {
            y.state.isShown = !0, K("onShown", [y]);
          });
        }
      }, dt();
    }
  }
  function b() {
    process.env.NODE_ENV !== "production" && ui(y.state.isDestroyed, tr("hide"));
    var j = !y.state.isVisible, k = y.state.isDestroyed, ee = !y.state.isEnabled, te = Oa(y.props.duration, 1, Mt.duration);
    if (!(j || k || ee) && (K("onHide", [y], !1), y.props.onHide(y) !== !1)) {
      if (y.state.isVisible = !1, y.state.isShown = !1, l = !1, o = !1, le() && (T.style.visibility = "hidden"), se(), $(), ie(), le()) {
        var ae = q(), oe = ae.box, ve = ae.content;
        y.props.animation && (za([oe, ve], te), ol([oe, ve], "hidden"));
      }
      Y(), Q(), y.props.animation ? le() && Le(te, y.unmount) : y.unmount();
    }
  }
  function N(j) {
    process.env.NODE_ENV !== "production" && ui(y.state.isDestroyed, tr("hideWithInteractivity")), z().addEventListener("mousemove", M), sl(Sn, M), M(j);
  }
  function O() {
    process.env.NODE_ENV !== "production" && ui(y.state.isDestroyed, tr("unmount")), y.state.isVisible && y.hide(), y.state.isMounted && (Ne(), it().forEach(function(j) {
      j._tippy.unmount();
    }), T.parentNode && T.parentNode.removeChild(T), ka = ka.filter(function(j) {
      return j !== y;
    }), y.state.isMounted = !1, K("onHidden", [y]));
  }
  function w() {
    process.env.NODE_ENV !== "production" && ui(y.state.isDestroyed, tr("destroy")), !y.state.isDestroyed && (y.clearDelayTimeouts(), y.unmount(), _e(), delete i._tippy, y.state.isDestroyed = !0, K("onDestroy", [y]));
  }
}
function gn(i, e) {
  e === void 0 && (e = {});
  var t = Mt.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (cv(i), cd(e, t)), rv();
  var r = Object.assign({}, e, {
    plugins: t
  }), n = qg(i);
  if (process.env.NODE_ENV !== "production") {
    var a = an(r.content), o = n.length > 1;
    ui(a && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = n.reduce(function(c, l) {
    var u = l && gv(l, r);
    return u && c.push(u), c;
  }, []);
  return an(i) ? s[0] : s;
}
gn.defaultProps = Mt;
gn.setDefaultProps = hv;
gn.currentInput = Xt;
gn.setDefaultProps({
  render: ud
});
const vv = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    content: null
  },
  setup(i) {
    const e = i, t = R(), r = R();
    return Ht(() => {
      t.value && (r.value = gn(t.value, {
        content: e.content,
        allowHTML: !0
      }));
    }), { __sfc: !0, props: e, tooltipRef: t, tippyInstance: r };
  }
});
var Mv = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("span", { ref: "tooltipRef", staticClass: "v-tooltip" }, [e._t("default")], 2);
}, yv = [], xv = /* @__PURE__ */ Ge(
  vv,
  Mv,
  yv,
  !1,
  null,
  null,
  null,
  null
);
const Iv = xv.exports, bv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Iv
}, Symbol.toStringTag, { value: "Module" }));
var ro = Symbol(), Wa = Symbol(), pl = Symbol(), fl = Symbol(), no = function(e) {
  return "frag" in e;
};
function on(i, e) {
  Wa in i || (i[Wa] = e, Object.defineProperty(i, "parentNode", {
    get: function() {
      return this[Wa] || this.parentElement;
    }
  }));
}
function ea(i) {
  pl in i || (i[pl] = !0, Object.defineProperty(i, "nextSibling", {
    get: function() {
      var t = this.parentNode.childNodes, r = t.indexOf(this);
      return r > -1 && t[r + 1] || null;
    }
  }));
}
function wv(i, e) {
  for (; i.parentNode !== e; ) {
    var t = i, r = t.parentNode;
    r && (i = r);
  }
  return i;
}
var Ga;
function dd(i) {
  if (!Ga) {
    var e = Object.getOwnPropertyDescriptor(Node.prototype, "childNodes");
    Ga = e.get;
  }
  var t = Ga.apply(i), r = Array.from(t).map(function(n) {
    return wv(n, i);
  });
  return r.filter(function(n, a) {
    return n !== r[a - 1];
  });
}
function ml(i) {
  fl in i || (i[fl] = !0, Object.defineProperties(i, {
    childNodes: {
      get: function() {
        return this.frag || dd(this);
      }
    },
    firstChild: {
      get: function() {
        return this.childNodes[0] || null;
      }
    }
  }), i.hasChildNodes = function() {
    return this.childNodes.length > 0;
  });
}
function _v() {
  var i;
  (i = this.frag[0]).before.apply(i, arguments);
}
function Av() {
  var i = this.frag, e = i.splice(0, i.length);
  e.forEach(function(t) {
    t.remove();
  });
}
var Sv = function i(e) {
  var t;
  return (t = Array.prototype).concat.apply(t, e.map(function(r) {
    return no(r) ? i(r.frag) : r;
  }));
};
function Dv(i, e) {
  var t = i[ro];
  e.before(t), on(t, i), i.frag.unshift(t);
}
function gl(i) {
  if (no(this)) {
    var e = this.frag.indexOf(i);
    if (e > -1) {
      var t = this.frag.splice(e, 1), r = t[0];
      this.frag.length === 0 && Dv(this, r), i.remove();
    }
  } else {
    var n = dd(this), a = n.indexOf(i);
    a > -1 && i.remove();
  }
  return i;
}
function vl(i, e) {
  var t = this, r = i.frag || [i];
  if (no(this)) {
    var n = this.frag;
    if (e) {
      var a = n.indexOf(e);
      a > -1 && (n.splice.apply(n, [a, 0].concat(r)), e.before.apply(e, r));
    } else {
      var o = n[n.length - 1];
      n.push.apply(n, r), o.after.apply(o, r);
    }
    hd(this);
  } else
    e ? this.childNodes.includes(e) && e.before.apply(e, r) : this.append.apply(this, r);
  r.forEach(function(c) {
    on(c, t);
  });
  var s = r[r.length - 1];
  return ea(s), i;
}
function Tv(i) {
  var e = this.frag, t = e[e.length - 1];
  return t.after(i), on(i, this), hd(this), e.push(i), i;
}
function hd(i) {
  var e = i[ro];
  i.frag[0] === e && (i.frag.shift(), e.remove());
}
var Cv = {
  inserted: function(e) {
    var t = e.parentNode, r = e.nextSibling, n = e.previousSibling, a = Array.from(e.childNodes), o = document.createComment("");
    a.length === 0 && a.push(o), e.frag = a, e[ro] = o;
    var s = document.createDocumentFragment();
    s.append.apply(s, Sv(a)), e.replaceWith(s), a.forEach(function(c) {
      on(c, e), ea(c);
    }), ml(e), Object.assign(e, {
      remove: Av,
      appendChild: Tv,
      insertBefore: vl,
      removeChild: gl,
      before: _v
    }), Object.defineProperty(e, "innerHTML", {
      set: function(l) {
        var u = this, h = document.createElement("div");
        h.innerHTML = l;
        var d = this.frag.length;
        Array.from(h.childNodes).forEach(function(v) {
          u.appendChild(v);
        }), h.append.apply(h, this.frag.splice(0, d));
      },
      get: function() {
        return "";
      }
    }), t && (Object.assign(t, {
      removeChild: gl,
      insertBefore: vl
    }), on(e, t), ml(t)), r && ea(e), n && ea(n);
  },
  unbind: function(e) {
    e.remove();
  }
}, Ev = {
  name: "Fragment",
  directives: {
    frag: Cv
  },
  render: function(e) {
    return e("div", {
      directives: [{
        name: "frag"
      }]
    }, this.$slots.default);
  }
};
ge({
  name: "OnClickOutside",
  props: ["as"],
  emits: ["trigger"],
  setup(i, { slots: e, emit: t }) {
    const r = R();
    return wp(r, (n) => {
      t("trigger", n);
    }), () => {
      if (e.default)
        return mt(i.as || "div", { ref: r }, e.default());
    };
  }
});
function ln(i) {
  var e;
  const t = We(i);
  return (e = t == null ? void 0 : t.$el) != null ? e : t;
}
const Li = ti ? window : void 0;
function xr(...i) {
  let e, t, r, n;
  if (yu(i[0]) ? ([t, r, n] = i, e = Li) : [e, t, r, n] = i, !e)
    return yt;
  let a = yt;
  const o = ze(() => ln(e), (c) => {
    a(), c && (c.addEventListener(t, r, n), a = () => {
      c.removeEventListener(t, r, n), a = yt;
    });
  }, { immediate: !0, flush: "post" }), s = () => {
    o(), a();
  };
  return xt(s), s;
}
const Nv = 500;
function Lv(i, e, t) {
  var r, n;
  const a = me(() => ln(i));
  let o = null;
  function s() {
    o != null && (clearTimeout(o), o = null);
  }
  function c(u) {
    var h, d, v, M;
    ((h = t == null ? void 0 : t.modifiers) == null ? void 0 : h.self) && u.target !== a.value || (s(), (d = t == null ? void 0 : t.modifiers) != null && d.prevent && u.preventDefault(), (v = t == null ? void 0 : t.modifiers) != null && v.stop && u.stopPropagation(), o = setTimeout(() => e(u), (M = t == null ? void 0 : t.delay) != null ? M : Nv));
  }
  const l = {
    capture: (r = t == null ? void 0 : t.modifiers) == null ? void 0 : r.capture,
    once: (n = t == null ? void 0 : t.modifiers) == null ? void 0 : n.once
  };
  xr(a, "pointerdown", c, l), xr(a, "pointerup", s, l), xr(a, "pointerleave", s, l);
}
ge({
  name: "OnLongPress",
  props: ["as", "options"],
  emits: ["trigger"],
  setup(i, { slots: e, emit: t }) {
    const r = R();
    return Lv(r, (n) => {
      t("trigger", n);
    }, i.options), () => {
      if (e.default)
        return mt(i.as || "div", { ref: r }, e.default());
    };
  }
});
ge({
  name: "UseActiveElement",
  setup(i, { slots: e }) {
    const t = Se({
      element: _p()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseBattery",
  setup(i, { slots: e }) {
    const t = Se(Ap(i));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseBrowserLocation",
  setup(i, { slots: e }) {
    const t = Se(Sp());
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
const js = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Bs = "__vueuse_ssr_handlers__";
js[Bs] = js[Bs] || {};
const Pv = js[Bs];
function pd(i, e) {
  return Pv[i] || e;
}
function jv(i) {
  return i == null ? "any" : i instanceof Set ? "set" : i instanceof Map ? "map" : i instanceof Date ? "date" : typeof i == "boolean" ? "boolean" : typeof i == "string" ? "string" : typeof i == "object" || Array.isArray(i) ? "object" : Number.isNaN(i) ? "any" : "number";
}
var Bv = Object.defineProperty, Ml = Object.getOwnPropertySymbols, Ov = Object.prototype.hasOwnProperty, zv = Object.prototype.propertyIsEnumerable, yl = (i, e, t) => e in i ? Bv(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, xl = (i, e) => {
  for (var t in e || (e = {}))
    Ov.call(e, t) && yl(i, t, e[t]);
  if (Ml)
    for (var t of Ml(e))
      zv.call(e, t) && yl(i, t, e[t]);
  return i;
};
const Rv = {
  boolean: {
    read: (i) => i === "true",
    write: (i) => String(i)
  },
  object: {
    read: (i) => JSON.parse(i),
    write: (i) => JSON.stringify(i)
  },
  number: {
    read: (i) => Number.parseFloat(i),
    write: (i) => String(i)
  },
  any: {
    read: (i) => i,
    write: (i) => String(i)
  },
  string: {
    read: (i) => i,
    write: (i) => String(i)
  },
  map: {
    read: (i) => new Map(JSON.parse(i)),
    write: (i) => JSON.stringify(Array.from(i.entries()))
  },
  set: {
    read: (i) => new Set(JSON.parse(i)),
    write: (i) => JSON.stringify(Array.from(i))
  },
  date: {
    read: (i) => new Date(i),
    write: (i) => i.toISOString()
  }
};
function kv(i, e, t, r = {}) {
  var n;
  const {
    flush: a = "pre",
    deep: o = !0,
    listenToStorageChanges: s = !0,
    writeDefaults: c = !0,
    mergeDefaults: l = !1,
    shallow: u,
    window: h = Li,
    eventFilter: d,
    onError: v = (B) => {
      console.error(B);
    }
  } = r, M = (u ? va : R)(e);
  if (!t)
    try {
      t = pd("getDefaultStorage", () => {
        var B;
        return (B = Li) == null ? void 0 : B.localStorage;
      })();
    } catch (B) {
      v(B);
    }
  if (!t)
    return M;
  const m = We(e), g = jv(m), I = (n = r.serializer) != null ? n : Rv[g], { pause: A, resume: L } = Su(M, () => y(M.value), { flush: a, deep: o, eventFilter: d });
  return h && s && xr(h, "storage", T), T(), M;
  function y(B) {
    try {
      B == null ? t.removeItem(i) : t.setItem(i, I.write(B));
    } catch (S) {
      v(S);
    }
  }
  function D(B) {
    if (!(B && B.key !== i)) {
      A();
      try {
        const S = B ? B.newValue : t.getItem(i);
        if (S == null)
          return c && m !== null && t.setItem(i, I.write(m)), m;
        if (!B && l) {
          const P = I.read(S);
          return Mu(l) ? l(P, m) : g === "object" && !Array.isArray(P) ? xl(xl({}, m), P) : P;
        } else
          return typeof S != "string" ? S : I.read(S);
      } catch (S) {
        v(S);
      } finally {
        L();
      }
    }
  }
  function T(B) {
    B && B.key !== i || (M.value = D(B));
  }
}
function fd(i, e = !1) {
  const t = R(), r = () => t.value = Boolean(i());
  return r(), Ni(r, e), t;
}
function Wv(i, e = {}) {
  const { window: t = Li } = e, r = fd(() => t && "matchMedia" in t && typeof t.matchMedia == "function");
  let n;
  const a = R(!1), o = () => {
    !r.value || (n || (n = t.matchMedia(i)), a.value = n.matches);
  };
  return Iu(() => {
    o(), n && ("addEventListener" in n ? n.addEventListener("change", o) : n.addListener(o), xt(() => {
      "removeEventListener" in n ? n.removeEventListener("change", o) : n.removeListener(o);
    }));
  }), a;
}
function Gv(i) {
  return Wv("(prefers-color-scheme: dark)", i);
}
var Uv = Object.defineProperty, Il = Object.getOwnPropertySymbols, Hv = Object.prototype.hasOwnProperty, Fv = Object.prototype.propertyIsEnumerable, bl = (i, e, t) => e in i ? Uv(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Vv = (i, e) => {
  for (var t in e || (e = {}))
    Hv.call(e, t) && bl(i, t, e[t]);
  if (Il)
    for (var t of Il(e))
      Fv.call(e, t) && bl(i, t, e[t]);
  return i;
};
function Yv(i = {}) {
  const {
    selector: e = "html",
    attribute: t = "class",
    initialValue: r = "auto",
    window: n = Li,
    storage: a,
    storageKey: o = "vueuse-color-scheme",
    listenToStorageChanges: s = !0,
    storageRef: c,
    emitAuto: l
  } = i, u = Vv({
    auto: "",
    light: "light",
    dark: "dark"
  }, i.modes || {}), h = Gv({ window: n }), d = me(() => h.value ? "dark" : "light"), v = c || (o == null ? R(r) : kv(o, r, a, { window: n, listenToStorageChanges: s })), M = me({
    get() {
      return v.value === "auto" && !l ? d.value : v.value;
    },
    set(A) {
      v.value = A;
    }
  }), m = pd("updateHTMLAttrs", (A, L, y) => {
    const D = n == null ? void 0 : n.document.querySelector(A);
    if (!!D)
      if (L === "class") {
        const T = y.split(/\s/g);
        Object.values(u).flatMap((B) => (B || "").split(/\s/g)).filter(Boolean).forEach((B) => {
          T.includes(B) ? D.classList.add(B) : D.classList.remove(B);
        });
      } else
        D.setAttribute(L, y);
  });
  function g(A) {
    var L;
    const y = A === "auto" ? d.value : A;
    m(e, t, (L = u[y]) != null ? L : y);
  }
  function I(A) {
    i.onChanged ? i.onChanged(A, g) : g(A);
  }
  return ze(M, I, { flush: "post", immediate: !0 }), l && ze(d, () => I(M.value), { flush: "post" }), Ni(() => I(M.value)), M;
}
ge({
  name: "UseColorMode",
  props: ["selector", "attribute", "modes", "onChanged", "storageKey", "storage", "emitAuto"],
  setup(i, { slots: e }) {
    const t = Yv(i), r = Se({
      mode: t
    });
    return () => {
      if (e.default)
        return e.default(r);
    };
  }
});
ge({
  name: "UseDark",
  props: ["selector", "attribute", "valueDark", "valueLight", "onChanged", "storageKey", "storage"],
  setup(i, { slots: e }) {
    const t = Eu(i), r = Se({
      isDark: t,
      toggleDark: wu(t)
    });
    return () => {
      if (e.default)
        return e.default(r);
    };
  }
});
ge({
  name: "UseDeviceMotion",
  setup(i, { slots: e }) {
    const t = Se(Vp());
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseDeviceOrientation",
  setup(i, { slots: e }) {
    const t = Se(Yp());
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseDevicePixelRatio",
  setup(i, { slots: e }) {
    const t = Se({
      pixelRatio: Qp()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseDevicesList",
  props: ["onUpdated", "requestPermissions", "constraints"],
  setup(i, { slots: e }) {
    const t = Se(Xp(i));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseDocumentVisibility",
  setup(i, { slots: e }) {
    const t = Se({
      visibility: $p()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
var Zv = Object.defineProperty, Qv = Object.defineProperties, Jv = Object.getOwnPropertyDescriptors, wl = Object.getOwnPropertySymbols, Xv = Object.prototype.hasOwnProperty, $v = Object.prototype.propertyIsEnumerable, _l = (i, e, t) => e in i ? Zv(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, qv = (i, e) => {
  for (var t in e || (e = {}))
    Xv.call(e, t) && _l(i, t, e[t]);
  if (wl)
    for (var t of wl(e))
      $v.call(e, t) && _l(i, t, e[t]);
  return i;
}, Kv = (i, e) => Qv(i, Jv(e));
ge({
  name: "UseDraggable",
  props: [
    "storageKey",
    "storageType",
    "initialValue",
    "exact",
    "preventDefault",
    "stopPropagation",
    "pointerTypes",
    "as"
  ],
  setup(i, { slots: e }) {
    const t = R(), r = i.storageKey ? Cu(i.storageKey, We(i.initialValue) || { x: 0, y: 0 }, ti ? i.storageType === "session" ? sessionStorage : localStorage : void 0) : i.initialValue || { x: 0, y: 0 }, n = Se(sf(t, Kv(qv({}, i), {
      initialValue: r
    })));
    return () => {
      if (e.default)
        return mt(i.as || "div", { ref: t, style: `touch-action:none;${n.style}` }, e.default(n));
    };
  }
});
ge({
  name: "UseElementBounding",
  props: ["box", "as"],
  setup(i, { slots: e }) {
    const t = R(), r = Se(uf(t));
    return () => {
      if (e.default)
        return mt(i.as || "div", { ref: t }, e.default(r));
    };
  }
});
ge({
  name: "UseElementSize",
  props: ["width", "height", "box"],
  setup(i, { slots: e }) {
    const t = R(), r = Se(Pu(t, { width: i.width, height: i.height }, { box: i.box }));
    return () => {
      if (e.default)
        return mt(i.as || "div", { ref: t }, e.default(r));
    };
  }
});
ge({
  name: "UseElementVisibility",
  props: ["as"],
  setup(i, { slots: e }) {
    const t = R(), r = Se({
      isVisible: df(t)
    });
    return () => {
      if (e.default)
        return mt(i.as || "div", { ref: t }, e.default(r));
    };
  }
});
ge({
  name: "UseEyeDropper",
  props: {
    sRGBHex: String
  },
  setup(i, { slots: e }) {
    const t = Se(hf());
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseFullscreen",
  props: ["as"],
  setup(i, { slots: e }) {
    const t = R(), r = Se(pf(t));
    return () => {
      if (e.default)
        return mt(i.as || "div", { ref: t }, e.default(r));
    };
  }
});
ge({
  name: "UseGeolocation",
  props: ["enableHighAccuracy", "maximumAge", "timeout", "navigator"],
  setup(i, { slots: e }) {
    const t = Se(ff(i));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseIdle",
  props: ["timeout", "events", "listenForVisibilityChange", "initialState"],
  setup(i, { slots: e }) {
    const t = Se(vf(i.timeout, i));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
function eM(i, e, t) {
  const {
    immediate: r = !0,
    delay: n = 0,
    onError: a = yt,
    resetOnExecute: o = !0,
    shallow: s = !0,
    throwError: c
  } = t != null ? t : {}, l = s ? va(e) : R(e), u = R(!1), h = R(!1), d = R(void 0);
  async function v(M = 0, ...m) {
    o && (l.value = e), d.value = void 0, u.value = !1, h.value = !0, M > 0 && await tp(M);
    const g = typeof i == "function" ? i(...m) : i;
    try {
      const I = await g;
      l.value = I, u.value = !0;
    } catch (I) {
      if (d.value = I, a(I), c)
        throw d;
    } finally {
      h.value = !1;
    }
    return l.value;
  }
  return r && v(n), {
    state: l,
    isReady: u,
    isLoading: h,
    error: d,
    execute: v
  };
}
var tM = Object.defineProperty, Al = Object.getOwnPropertySymbols, iM = Object.prototype.hasOwnProperty, rM = Object.prototype.propertyIsEnumerable, Sl = (i, e, t) => e in i ? tM(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, nM = (i, e) => {
  for (var t in e || (e = {}))
    iM.call(e, t) && Sl(i, t, e[t]);
  if (Al)
    for (var t of Al(e))
      rM.call(e, t) && Sl(i, t, e[t]);
  return i;
};
async function aM(i) {
  return new Promise((e, t) => {
    const r = new Image(), { src: n, srcset: a, sizes: o } = i;
    r.src = n, a && (r.srcset = a), o && (r.sizes = o), r.onload = () => e(r), r.onerror = t;
  });
}
const sM = (i, e = {}) => {
  const t = eM(() => aM(We(i)), void 0, nM({
    resetOnExecute: !0
  }, e));
  return ze(() => We(i), () => t.execute(e.delay), { deep: !0 }), t;
};
ge({
  name: "UseImage",
  props: [
    "src",
    "srcset",
    "sizes",
    "as"
  ],
  setup(i, { slots: e }) {
    const t = Se(sM(i));
    return () => t.isLoading && e.loading ? e.loading(t) : t.error && e.error ? e.error(t.error) : e.default ? e.default(t) : mt(i.as || "img", i);
  }
});
function Dl(i, e, t = {}) {
  const {
    root: r,
    rootMargin: n = "0px",
    threshold: a = 0.1,
    window: o = Li
  } = t, s = fd(() => o && "IntersectionObserver" in o);
  let c = yt;
  const l = s.value ? ze(() => ({
    el: ln(i),
    root: ln(r)
  }), ({ el: h, root: d }) => {
    if (c(), !h)
      return;
    const v = new IntersectionObserver(e, {
      root: d,
      rootMargin: n,
      threshold: a
    });
    v.observe(h), c = () => {
      v.disconnect(), c = yt;
    };
  }, { immediate: !0, flush: "post" }) : yt, u = () => {
    c(), l();
  };
  return xt(u), {
    isSupported: s,
    stop: u
  };
}
const oM = {
  [ep.mounted](i, e) {
    typeof e.value == "function" ? Dl(i, e.value) : Dl(i, ...e.value);
  }
};
ge({
  name: "UseMouse",
  props: ["touch", "resetOnTouchEnds", "initialValue"],
  setup(i, { slots: e }) {
    const t = Se(ju(i));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseMouseElement",
  props: ["handleOutside", "as"],
  setup(i, { slots: e }) {
    const t = R(), r = Se(Mf(t, i));
    return () => {
      if (e.default)
        return mt(i.as || "div", { ref: t }, e.default(r));
    };
  }
});
var lM = Object.defineProperty, cM = Object.defineProperties, uM = Object.getOwnPropertyDescriptors, Tl = Object.getOwnPropertySymbols, dM = Object.prototype.hasOwnProperty, hM = Object.prototype.propertyIsEnumerable, Cl = (i, e, t) => e in i ? lM(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, pM = (i, e) => {
  for (var t in e || (e = {}))
    dM.call(e, t) && Cl(i, t, e[t]);
  if (Tl)
    for (var t of Tl(e))
      hM.call(e, t) && Cl(i, t, e[t]);
  return i;
}, fM = (i, e) => cM(i, uM(e));
ge({
  name: "UseMousePressed",
  props: ["touch", "initialValue", "as"],
  setup(i, { slots: e }) {
    const t = R(), r = Se(yf(fM(pM({}, i), { target: t })));
    return () => {
      if (e.default)
        return mt(i.as || "div", { ref: t }, e.default(r));
    };
  }
});
ge({
  name: "UseNetwork",
  setup(i, { slots: e }) {
    const t = Se(Bu());
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
var mM = Object.defineProperty, gM = Object.defineProperties, vM = Object.getOwnPropertyDescriptors, El = Object.getOwnPropertySymbols, MM = Object.prototype.hasOwnProperty, yM = Object.prototype.propertyIsEnumerable, Nl = (i, e, t) => e in i ? mM(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, xM = (i, e) => {
  for (var t in e || (e = {}))
    MM.call(e, t) && Nl(i, t, e[t]);
  if (El)
    for (var t of El(e))
      yM.call(e, t) && Nl(i, t, e[t]);
  return i;
}, IM = (i, e) => gM(i, vM(e));
ge({
  name: "UseNow",
  props: ["interval"],
  setup(i, { slots: e }) {
    const t = Se(Ou(IM(xM({}, i), { controls: !0 })));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseObjectUrl",
  props: [
    "object"
  ],
  setup(i, { slots: e }) {
    const t = yh(i, "object"), r = _f(t);
    return () => {
      if (e.default && r.value)
        return e.default(r);
    };
  }
});
var bM = Object.defineProperty, wM = Object.defineProperties, _M = Object.getOwnPropertyDescriptors, Ll = Object.getOwnPropertySymbols, AM = Object.prototype.hasOwnProperty, SM = Object.prototype.propertyIsEnumerable, Pl = (i, e, t) => e in i ? bM(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, DM = (i, e) => {
  for (var t in e || (e = {}))
    AM.call(e, t) && Pl(i, t, e[t]);
  if (Ll)
    for (var t of Ll(e))
      SM.call(e, t) && Pl(i, t, e[t]);
  return i;
}, TM = (i, e) => wM(i, _M(e));
ge({
  name: "UseOffsetPagination",
  props: [
    "total",
    "page",
    "pageSize",
    "onPageChange",
    "onPageSizeChange",
    "onPageCountChange"
  ],
  emits: [
    "page-change",
    "page-size-change",
    "page-count-change"
  ],
  setup(i, { slots: e, emit: t }) {
    const r = Se(Af(TM(DM({}, i), {
      onPageChange(...n) {
        var a;
        (a = i.onPageChange) == null || a.call(i, ...n), t("page-change", ...n);
      },
      onPageSizeChange(...n) {
        var a;
        (a = i.onPageSizeChange) == null || a.call(i, ...n), t("page-size-change", ...n);
      },
      onPageCountChange(...n) {
        var a;
        (a = i.onPageCountChange) == null || a.call(i, ...n), t("page-count-change", ...n);
      }
    })));
    return () => {
      if (e.default)
        return e.default(r);
    };
  }
});
ge({
  name: "UseOnline",
  setup(i, { slots: e }) {
    const t = Se({
      isOnline: Sf()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UsePageLeave",
  setup(i, { slots: e }) {
    const t = Se({
      isLeft: Df()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
var CM = Object.defineProperty, EM = Object.defineProperties, NM = Object.getOwnPropertyDescriptors, jl = Object.getOwnPropertySymbols, LM = Object.prototype.hasOwnProperty, PM = Object.prototype.propertyIsEnumerable, Bl = (i, e, t) => e in i ? CM(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, jM = (i, e) => {
  for (var t in e || (e = {}))
    LM.call(e, t) && Bl(i, t, e[t]);
  if (jl)
    for (var t of jl(e))
      PM.call(e, t) && Bl(i, t, e[t]);
  return i;
}, BM = (i, e) => EM(i, NM(e));
ge({
  name: "UsePointer",
  props: [
    "pointerTypes",
    "initialValue",
    "target"
  ],
  setup(i, { slots: e }) {
    const t = R(null), r = Se(Of(BM(jM({}, i), {
      target: i.target === "self" ? t : Li
    })));
    return () => {
      if (e.default)
        return e.default(r, { ref: t });
    };
  }
});
ge({
  name: "UsePreferredColorScheme",
  setup(i, { slots: e }) {
    const t = Se({
      colorScheme: zf()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UsePreferredDark",
  setup(i, { slots: e }) {
    const t = Se({
      prefersDark: Js()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UsePreferredLanguages",
  setup(i, { slots: e }) {
    const t = Se({
      languages: Rf()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UsePreferredReducedMotion",
  setup(i, { slots: e }) {
    const t = Se({
      motion: kf()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
function Dn(i, e, { window: t = Li, initialValue: r = "" } = {}) {
  const n = R(r), a = me(() => {
    var o;
    return ln(e) || ((o = t == null ? void 0 : t.document) == null ? void 0 : o.documentElement);
  });
  return ze([a, () => We(i)], ([o, s]) => {
    var c;
    if (o && t) {
      const l = (c = t.getComputedStyle(o).getPropertyValue(s)) == null ? void 0 : c.trim();
      n.value = l || r;
    }
  }, { immediate: !0 }), ze(n, (o) => {
    var s;
    (s = a.value) != null && s.style && a.value.style.setProperty(We(i), o);
  }), n;
}
const Ol = "--vueuse-safe-area-top", zl = "--vueuse-safe-area-right", Rl = "--vueuse-safe-area-bottom", kl = "--vueuse-safe-area-left";
function OM() {
  const i = R(""), e = R(""), t = R(""), r = R("");
  if (ti) {
    const a = Dn(Ol), o = Dn(zl), s = Dn(Rl), c = Dn(kl);
    a.value = "env(safe-area-inset-top, 0px)", o.value = "env(safe-area-inset-right, 0px)", s.value = "env(safe-area-inset-bottom, 0px)", c.value = "env(safe-area-inset-left, 0px)", n(), xr("resize", xa(n));
  }
  function n() {
    i.value = Tn(Ol), e.value = Tn(zl), t.value = Tn(Rl), r.value = Tn(kl);
  }
  return {
    top: i,
    right: e,
    bottom: t,
    left: r,
    update: n
  };
}
function Tn(i) {
  return getComputedStyle(document.documentElement).getPropertyValue(i);
}
ge({
  name: "UseScreenSafeArea",
  props: {
    top: Boolean,
    right: Boolean,
    bottom: Boolean,
    left: Boolean
  },
  setup(i, { slots: e }) {
    const {
      top: t,
      right: r,
      bottom: n,
      left: a
    } = OM();
    return () => {
      if (e.default)
        return mt("div", {
          style: {
            paddingTop: i.top ? t.value : "",
            paddingRight: i.right ? r.value : "",
            paddingBottom: i.bottom ? n.value : "",
            paddingLeft: i.left ? a.value : "",
            boxSizing: "border-box",
            maxHeight: "100vh",
            maxWidth: "100vw",
            overflow: "auto"
          }
        }, e.default());
    };
  }
});
function zM(i) {
  const e = i || window.event;
  return e.touches.length > 1 ? !0 : (e.preventDefault && e.preventDefault(), !1);
}
function RM(i, e = !1) {
  const t = R(e);
  let r = null, n;
  ze(ap(i), (s) => {
    if (s) {
      const c = s;
      n = c.style.overflow, t.value && (c.style.overflow = "hidden");
    }
  }, {
    immediate: !0
  });
  const a = () => {
    const s = We(i);
    !s || t.value || (yo && (r = xr(s, "touchmove", zM, { passive: !1 })), s.style.overflow = "hidden", t.value = !0);
  }, o = () => {
    const s = We(i);
    !s || !t.value || (yo && (r == null || r()), s.style.overflow = n, t.value = !1);
  };
  return xt(o), me({
    get() {
      return t.value;
    },
    set(s) {
      s ? a() : o();
    }
  });
}
const kM = () => {
  let i = !1;
  const e = R(!1);
  return (t, r) => {
    if (e.value = r.value, i)
      return;
    i = !0;
    const n = RM(t, r.value);
    ze(e, (a) => n.value = a);
  };
};
kM();
var WM = Object.defineProperty, GM = Object.defineProperties, UM = Object.getOwnPropertyDescriptors, Wl = Object.getOwnPropertySymbols, HM = Object.prototype.hasOwnProperty, FM = Object.prototype.propertyIsEnumerable, Gl = (i, e, t) => e in i ? WM(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, VM = (i, e) => {
  for (var t in e || (e = {}))
    HM.call(e, t) && Gl(i, t, e[t]);
  if (Wl)
    for (var t of Wl(e))
      FM.call(e, t) && Gl(i, t, e[t]);
  return i;
}, YM = (i, e) => GM(i, UM(e));
ge({
  name: "UseTimeAgo",
  props: ["time", "updateInterval", "max", "fullDateFormatter", "messages"],
  setup(i, { slots: e }) {
    const t = Se(Vf(() => i.time, YM(VM({}, i), { controls: !0 })));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
var ZM = Object.defineProperty, QM = Object.defineProperties, JM = Object.getOwnPropertyDescriptors, Ul = Object.getOwnPropertySymbols, XM = Object.prototype.hasOwnProperty, $M = Object.prototype.propertyIsEnumerable, Hl = (i, e, t) => e in i ? ZM(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, qM = (i, e) => {
  for (var t in e || (e = {}))
    XM.call(e, t) && Hl(i, t, e[t]);
  if (Ul)
    for (var t of Ul(e))
      $M.call(e, t) && Hl(i, t, e[t]);
  return i;
}, KM = (i, e) => QM(i, JM(e));
ge({
  name: "UseTimestamp",
  props: ["immediate", "interval", "offset"],
  setup(i, { slots: e }) {
    const t = Se(Xf(KM(qM({}, i), { controls: !0 })));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
var e1 = Object.defineProperty, Fl = Object.getOwnPropertySymbols, t1 = Object.prototype.hasOwnProperty, i1 = Object.prototype.propertyIsEnumerable, Vl = (i, e, t) => e in i ? e1(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : i[e] = t, Yl = (i, e) => {
  for (var t in e || (e = {}))
    t1.call(e, t) && Vl(i, t, e[t]);
  if (Fl)
    for (var t of Fl(e))
      i1.call(e, t) && Vl(i, t, e[t]);
  return i;
};
ge({
  name: "UseVirtualList",
  props: [
    "list",
    "options",
    "height"
  ],
  setup(i, { slots: e }) {
    const { list: t } = pu(i), { list: r, containerProps: n, wrapperProps: a } = im(t, i.options);
    return n.style.height = i.height || "300px", () => mt("div", Yl({}, n), [
      mt("div", Yl({}, a.value), r.value.map((o) => mt("div", { style: { overFlow: "hidden", height: o.height } }, e.default ? e.default(o) : "Please set content!")))
    ]);
  }
});
ge({
  name: "UseWindowFocus",
  setup(i, { slots: e }) {
    const t = Se({
      focused: rm()
    });
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
ge({
  name: "UseWindowSize",
  props: ["initialWidth", "initialHeight"],
  setup(i, { slots: e }) {
    const t = Se(nm(i));
    return () => {
      if (e.default)
        return e.default(t);
    };
  }
});
const Ua = R(/* @__PURE__ */ new Map());
let md = () => {
};
const r1 = xa(() => {
  md();
}, 10);
function n1() {
  return {
    setVisibleNodes: (t, r, n, a) => {
      const o = r !== void 0 ? `${t}-[${r}]` : t;
      return n ? Ua.value.set(o, a) : Ua.value.delete(o), r1();
    },
    visibleNodes: Ua,
    setCallbackFunction: (t) => {
      md = t;
    }
  };
}
const a1 = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    nodes: null,
    hasParent: { type: Boolean },
    showNodeValue: { type: Boolean },
    channelIndex: null,
    isDraggable: { type: Boolean },
    emitOnClick: { type: Boolean }
  },
  emits: ["node-selected", "node-value-selected", "update-nodes"],
  setup(i, { emit: e }) {
    const t = i, { setVisibleNodes: r, setCallbackFunction: n, visibleNodes: a } = n1(), o = me(() => t.hasParent === !1), s = me(() => t.nodes.children.length > 0), c = me(() => m.value ? "folder-open" : "folder-closed"), l = me(() => {
      var P, G;
      return (G = (P = t.nodes.info) == null ? void 0 : P.paramType) != null ? G : "unknown";
    }), u = me(() => `tree-${l.value}`.toLowerCase()), h = me(() => s.value ? t.nodes.children : I.value.map(() => t.nodes)), d = me(() => h.value.length > 0), v = me(() => {
      var P, G, U, le, ne, z;
      return {
        name: t.nodes.name,
        path: (G = (P = t.nodes.info) == null ? void 0 : P.path) != null ? G : "",
        type: (le = (U = t.nodes.info) == null ? void 0 : U.paramType) != null ? le : "unknown",
        numberOfElements: (z = (ne = t.nodes.info) == null ? void 0 : ne.numberOfElements) != null ? z : 1,
        icon: u.value
      };
    }), M = me(() => ({
      "data-info": JSON.stringify(v.value),
      title: v.value.path
    })), m = R(!1), g = R(null), I = R([]), A = () => {
      e("node-value-selected", t.nodes);
    }, L = () => {
      if (h.value.length) {
        m.value = !m.value;
        return;
      }
      t.emitOnClick && S();
    }, y = () => {
      !t.emitOnClick && !h.value.length && S();
    }, D = (P) => {
      if (Array.isArray(P)) {
        t.channelIndex ? g.value = P[t.channelIndex] : (I.value = P, g.value = `[${P.length}chs]`);
        return;
      }
      ArrayBuffer.isView(P) || (g.value = P);
    }, T = (P) => {
      const G = P.some(
        ({ isIntersecting: U, intersectionRatio: le }) => U && le > 0.5
      );
      r(v.value.path, t.channelIndex, G, D);
    }, B = () => {
      e("update-nodes", a.value);
    }, S = () => {
      var P;
      e("node-selected", {
        node: t.nodes,
        info: v.value,
        channel: (P = t.channelIndex) != null ? P : null,
        setValue: D
      });
    };
    return Ht(() => {
      o.value && (m.value = !0, n(B));
    }), { __sfc: !0, setVisibleNodes: r, setCallbackFunction: n, visibleNodes: a, props: t, emit: e, isRoot: o, isFolder: s, folderIcon: c, itemType: l, itemIcon: u, children: h, hasChildren: d, info: v, nodeAttrs: M, isOpen: m, nodeValue: g, channelValues: I, onValueClick: A, onClick: L, onDblclick: y, setValue: D, onIntersectionObserver: T, emitVisibleNodes: B, emitValue: S, Fragment: Ev, vIntersectionObserver: oM, vIcon: pn };
  }
});
var s1 = function() {
  var n;
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t(r.isRoot ? "ul" : r.Fragment, { tag: "component", class: { "v-tree": r.isRoot } }, [t("li", e._b({}, "li", e.$attrs, !1), [t("div", e._g(e._b({ class: { "is-folder": r.isFolder, "has-children": r.hasChildren, "is-open": r.isOpen }, attrs: { draggable: e.isDraggable && !r.isFolder }, on: { click: r.onClick, dblclick: r.onDblclick } }, "div", r.nodeAttrs, !1), e.$listeners), [t(r.vIcon, { class: [!r.isFolder && r.itemIcon], attrs: { name: r.isFolder ? r.folderIcon : r.itemIcon } }), t("span", [e._v(e._s(e.nodes.name))]), r.isFolder ? e._e() : t("aside", { staticClass: "value" }, [e.showNodeValue ? t("output", { directives: [{ name: "intersection-observer", rawName: "v-intersection-observer", value: r.onIntersectionObserver, expression: "onIntersectionObserver" }], class: { "no-hover": r.hasChildren }, on: { click: r.onValueClick } }, [e._t("default", function() {
    return [e._v(e._s(r.nodeValue))];
  }, null, { node: e.nodes, nodeValue: r.nodeValue, hasChildren: r.hasChildren })], 2) : e._e(), r.children.length ? t("v-tooltip", { attrs: { content: (n = e.$attrs["add-all-channels-label"]) != null ? n : "add all channels" } }, [t("button", { staticClass: "stripped icon-only emit-all", on: { click: function(a) {
    return a.stopPropagation(), r.emitValue.apply(null, arguments);
  } } }, [t(r.vIcon, { attrs: { name: "file-plus" } })], 1)]) : e._e()], 1)], 1), r.isOpen ? t("ul", e._l(r.children, function(a, o) {
    return t("v-tree", e._g(e._b({ key: o, attrs: { "channel-index": r.isFolder ? void 0 : o, nodes: a, "has-parent": !0, "show-node-value": e.showNodeValue, "is-draggable": e.isDraggable, "emit-on-click": e.emitOnClick }, scopedSlots: e._u([e._l(Object.keys(e.$scopedSlots), function(s) {
      return { key: s, fn: function(c) {
        return [e._t(s, null, null, c)];
      } };
    })], null, !0) }, "v-tree", e.$attrs, !1), e.$listeners));
  }), 1) : e._e()])]);
}, o1 = [], l1 = /* @__PURE__ */ Ge(
  a1,
  s1,
  o1,
  !1,
  null,
  null,
  null,
  null
);
const c1 = l1.exports, u1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: c1
}, Symbol.toStringTag, { value: "Module" })), d1 = {};
var h1 = function() {
  var e = this, t = e._self._c;
  return t("a", e._g(e._b({ staticClass: "v-logo" }, "a", e.$attrs, !1), e.$listeners), [t("svg", { attrs: { width: "100%", height: "100%", viewBox: "0 0 120 20", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "xmlns:xlink": "http://www.w3.org/1999/xlink" } }, [t("title", [e._t("default", function() {
    return [e._v("Motorcortex")];
  })], 2), t("g", [t("path", { staticClass: "logo-symbol", attrs: { d: "M12.6213,15.591 C12.6213,15.622 12.6013,15.65 12.5733,15.662 C12.5633,15.667 12.5543,15.669 12.5433,15.669 C12.5233,15.669 12.5043,15.661 12.4893,15.647 L10.0523,13.284 C10.0323,13.265 10.0243,13.237 10.0303,13.21 L14.9183,2.469 C14.9263,2.434 14.9583,2.409 14.9933,2.409 C14.9963,2.409 14.9993,2.41 15.0023,2.41 C15.0413,2.415 15.0713,2.448 15.0713,2.487 L12.6213,15.591 Z M12.0143,16.222 L12.0123,16.222 L12.0093,16.222 L10.0043,16.147 C9.9873,16.147 9.9723,16.141 9.9593,16.131 L5.6753,12.419 C5.6653,12.411 5.6573,12.402 5.6523,12.391 L3.2933,7.596 C3.2773,7.563 3.2873,7.522 3.3173,7.5 C3.3313,7.49 3.3483,7.486 3.3633,7.486 C3.3833,7.486 3.4013,7.493 3.4163,7.507 L12.0603,16.084 C12.0793,16.098 12.0913,16.12 12.0913,16.144 C12.0913,16.187 12.0573,16.222 12.0143,16.222 L12.0143,16.222 Z M0.0003,0.747 L0.0003,19 L2.4783,19 L2.4463,7.576 C2.4393,7.538 2.4623,7.501 2.4993,7.489 C2.5073,7.487 2.5153,7.486 2.5223,7.486 C2.5523,7.486 2.5803,7.502 2.5933,7.53 C2.5973,7.535 2.6003,7.54 2.6023,7.545 L7.8463,19 L17.5173,19 L17.5173,0.747 L0.0003,0.747 Z", fill: "var(--red-500)" } }), t("path", { staticClass: "logo-type", attrs: { d: "M38.997,6.2452 C41.621,6.2452 43.729,8.2982 43.729,10.9592 C43.729,13.6202 41.621,15.6732 38.997,15.6732 C36.372,15.6732 34.265,13.6202 34.265,10.9592 C34.265,8.2982 36.372,6.2452 38.997,6.2452 Z M54.2373,6.2452 C56.8623,6.2452 58.9693,8.2982 58.9693,10.9592 C58.9693,13.6202 56.8623,15.6732 54.2373,15.6732 C51.6123,15.6732 49.5063,13.6202 49.5063,10.9592 C49.5063,8.2982 51.6123,6.2452 54.2373,6.2452 Z M70.3172,6.2452 C72.0502,6.2452 73.5852,7.1552 74.3532,8.5302 L72.0142,9.8882 C71.7102,9.2632 71.0672,8.8872 70.2812,8.8872 C69.1212,8.8872 68.2642,9.7272 68.2642,10.9592 C68.2642,12.1912 69.1212,13.0302 70.2812,13.0302 C71.0672,13.0302 71.7282,12.6552 72.0142,12.0302 L74.3532,13.3702 C73.5852,14.7622 72.0672,15.6732 70.3172,15.6732 C67.6042,15.6732 65.5862,13.6202 65.5862,10.9592 C65.5862,8.2982 67.6042,6.2452 70.3172,6.2452 Z M79.3916,6.2452 C82.0166,6.2452 84.1236,8.2982 84.1236,10.9592 C84.1236,13.6202 82.0166,15.6732 79.3916,15.6732 C76.7666,15.6732 74.6596,13.6202 74.6596,10.9592 C74.6596,8.2982 76.7666,6.2452 79.3916,6.2452 Z M101.801,6.2444 C104.408,6.2444 106.336,8.2624 106.336,10.9594 C106.336,11.3344 106.301,11.6914 106.229,12.0304 L99.89,12.0304 C100.23,12.9584 101.051,13.2804 102.033,13.2804 C102.765,13.2804 103.39,12.9944 103.747,12.6014 L105.89,13.8344 C105.015,15.0484 103.694,15.6734 101.997,15.6734 C98.944,15.6734 97.051,13.6194 97.051,10.9594 C97.051,8.2984 98.98,6.2444 101.801,6.2444 Z M44.4922,4.4881 L47.1702,4.4911 L47.1702,6.4951 L49.0102,6.4951 L49.0102,9.0661 L47.1702,9.0661 L47.1702,12.2271 C47.1702,12.9951 47.8312,13.0661 49.0102,12.9951 L49.0102,15.4231 C45.5102,15.7801 44.4922,14.7271 44.4922,12.2271 L44.4922,4.4881 Z M91.7705,4.4881 L94.4485,4.4911 L94.4485,6.4951 L96.2885,6.4951 L96.2885,9.0661 L94.4485,9.0661 L94.4485,12.2271 C94.4485,12.9951 95.1095,13.0661 96.2885,12.9951 L96.2885,15.4231 C92.7885,15.7801 91.7705,14.7271 91.7705,12.2271 L91.7705,4.4881 Z M65.0901,6.3166 L65.0901,9.3526 C63.9831,9.1736 62.4111,9.6196 62.4111,11.3876 L62.4111,15.4226 L59.7331,15.4226 L59.7331,6.4946 L62.4111,6.4946 L62.4111,8.0846 C62.7681,6.8876 63.9651,6.3166 65.0901,6.3166 Z M24.5861,4.543 L27.6811,9.087 L30.7761,4.543 L33.3821,4.543 L33.3821,15.423 L30.7761,15.423 L30.7761,8.794 L27.8271,13.631 L27.5341,13.631 L24.5861,8.794 L24.5861,15.423 L21.9811,15.423 L21.9811,4.543 L24.5861,4.543 Z M90.5002,6.3166 L90.5002,9.3526 C89.3932,9.1736 87.8212,9.6196 87.8212,11.3876 L87.8212,15.4226 L85.1432,15.4226 L85.1432,6.4946 L87.8212,6.4946 L87.8212,8.0846 C88.1782,6.8876 89.3752,6.3166 90.5002,6.3166 Z M115.3948,6.4948 L112.3058,10.8878 L115.5008,15.4228 L112.4308,15.4228 L110.7698,13.0658 L109.1098,15.4228 L106.0668,15.4228 L112.3518,6.4948 L115.3948,6.4948 Z M38.997,8.8522 C37.836,8.8522 36.944,9.6912 36.944,10.9592 C36.944,12.2272 37.836,13.0662 38.997,13.0662 C40.157,13.0662 41.05,12.2272 41.05,10.9592 C41.05,9.6912 40.157,8.8522 38.997,8.8522 Z M54.2373,8.8522 C53.0773,8.8522 52.1843,9.6912 52.1843,10.9592 C52.1843,12.2272 53.0773,13.0662 54.2373,13.0662 C55.3973,13.0662 56.2903,12.2272 56.2903,10.9592 C56.2903,9.6912 55.3973,8.8522 54.2373,8.8522 Z M79.3916,8.8522 C78.2306,8.8522 77.3386,9.6912 77.3386,10.9592 C77.3386,12.2272 78.2306,13.0662 79.3916,13.0662 C80.5516,13.0662 81.4446,12.2272 81.4446,10.9592 C81.4446,9.6912 80.5516,8.8522 79.3916,8.8522 Z M109.216,6.495 L110.176,7.863 L108.641,10.044 L106.145,6.495 L109.216,6.495 Z M101.783,8.6204 C100.766,8.6204 100.087,9.1204 99.837,10.0304 L103.676,10.0304 C103.39,8.9954 102.586,8.6204 101.783,8.6204 Z M117.7083,6.4352 L117.7083,6.8932 L117.1733,6.8932 L117.1733,8.5172 L116.6973,8.5172 L116.6973,6.8932 L116.1613,6.8932 L116.1613,6.4352 L117.7083,6.4352 Z M117.9172,8.5173 L117.9172,6.4353 L120.0002,6.4353 L120.0002,8.5173 L117.9172,8.5173 Z", fill: "currentColor" } })])])]);
}, p1 = [], f1 = /* @__PURE__ */ Ge(
  d1,
  h1,
  p1,
  !1,
  null,
  null,
  null,
  null
);
const m1 = f1.exports, g1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: m1
}, Symbol.toStringTag, { value: "Module" }));
class v1 {
  constructor() {
    this.buffer = [], this.index = 0, this.bufferMask = 0, this.visibleArray = [], this.cameraUpdateCounter = -1;
  }
  push(e) {
    this.buffer.push(e), this.bufferMask = this.buffer.length - 1;
  }
  validate() {
    const e = this.bufferMask + 1;
    return e && !(e & e - 1);
  }
  next() {
    return this.cameraUpdateCounter--, this.index++, this.getActive();
  }
  getActive() {
    return this.buffer[this.index & this.bufferMask];
  }
  length() {
    return this.bufferMask + 1;
  }
  get(e) {
    return this.buffer[e];
  }
  scanRigthToLeft(e) {
    const t = [], r = this.index;
    let n = this.index - (this.bufferMask + 1);
    n < 0 && (n = 0);
    for (let a = r; a >= n; a--) {
      const o = this.buffer[a & this.bufferMask];
      if (o.isVisible(e))
        t.push(o);
      else if (t.length > 0)
        break;
    }
    return t;
  }
  getVisibleArray(e) {
    const { isUpdated: t, counter: r } = e.isUpdated(this.cameraUpdateCounter);
    return t && (this.visibleArray = this.scanRigthToLeft(e.viewport()), this.visibleArray.length > 0 && (this.cameraUpdateCounter = r)), this.visibleArray;
  }
}
/**
 * @license
 * Copyright 2010-2022 Three.js Authors
 * SPDX-License-Identifier: MIT
 */
const ao = "141", M1 = 0, Zl = 1, y1 = 2, gd = 1, x1 = 2, Zr = 3, cn = 0, zt = 1, Sr = 2, I1 = 1, Ti = 0, Ir = 1, Ql = 2, Jl = 3, Xl = 4, b1 = 5, vr = 100, w1 = 101, _1 = 102, $l = 103, ql = 104, A1 = 200, S1 = 201, D1 = 202, T1 = 203, vd = 204, Md = 205, C1 = 206, E1 = 207, N1 = 208, L1 = 209, P1 = 210, j1 = 0, B1 = 1, O1 = 2, Os = 3, z1 = 4, R1 = 5, k1 = 6, W1 = 7, Aa = 0, G1 = 1, U1 = 2, hi = 0, H1 = 1, F1 = 2, V1 = 3, Y1 = 4, Z1 = 5, yd = 300, Dr = 301, Tr = 302, zs = 303, Rs = 304, Sa = 306, ks = 1e3, Pt = 1001, Ws = 1002, pt = 1003, Kl = 1004, ec = 1005, wt = 1006, Q1 = 1007, Da = 1008, Ji = 1009, J1 = 1010, X1 = 1011, xd = 1012, $1 = 1013, Fi = 1014, Vi = 1015, un = 1016, q1 = 1017, K1 = 1018, br = 1020, e2 = 1021, t2 = 1022, jt = 1023, i2 = 1024, r2 = 1025, Zi = 1026, Cr = 1027, n2 = 1028, a2 = 1029, s2 = 1030, o2 = 1031, l2 = 1033, Ha = 33776, Fa = 33777, Va = 33778, Ya = 33779, tc = 35840, ic = 35841, rc = 35842, nc = 35843, c2 = 36196, ac = 37492, sc = 37496, oc = 37808, lc = 37809, cc = 37810, uc = 37811, dc = 37812, hc = 37813, pc = 37814, fc = 37815, mc = 37816, gc = 37817, vc = 37818, Mc = 37819, yc = 37820, xc = 37821, Ic = 36492, Xi = 3e3, Qe = 3001, u2 = 3200, d2 = 3201, Pr = 0, h2 = 1, di = "srgb", Yi = "srgb-linear", Za = 7680, p2 = 519, bc = 35044, wc = "300 es", Gs = 1035;
class jr {
  addEventListener(e, t) {
    this._listeners === void 0 && (this._listeners = {});
    const r = this._listeners;
    r[e] === void 0 && (r[e] = []), r[e].indexOf(t) === -1 && r[e].push(t);
  }
  hasEventListener(e, t) {
    if (this._listeners === void 0)
      return !1;
    const r = this._listeners;
    return r[e] !== void 0 && r[e].indexOf(t) !== -1;
  }
  removeEventListener(e, t) {
    if (this._listeners === void 0)
      return;
    const r = this._listeners[e];
    if (r !== void 0) {
      const n = r.indexOf(t);
      n !== -1 && r.splice(n, 1);
    }
  }
  dispatchEvent(e) {
    if (this._listeners === void 0)
      return;
    const t = this._listeners[e.type];
    if (t !== void 0) {
      e.target = this;
      const r = t.slice(0);
      for (let n = 0, a = r.length; n < a; n++)
        r[n].call(this, e);
      e.target = null;
    }
  }
}
const at = [];
for (let i = 0; i < 256; i++)
  at[i] = (i < 16 ? "0" : "") + i.toString(16);
const Qa = Math.PI / 180, _c = 180 / Math.PI;
function vn() {
  const i = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, r = Math.random() * 4294967295 | 0;
  return (at[i & 255] + at[i >> 8 & 255] + at[i >> 16 & 255] + at[i >> 24 & 255] + "-" + at[e & 255] + at[e >> 8 & 255] + "-" + at[e >> 16 & 15 | 64] + at[e >> 24 & 255] + "-" + at[t & 63 | 128] + at[t >> 8 & 255] + "-" + at[t >> 16 & 255] + at[t >> 24 & 255] + at[r & 255] + at[r >> 8 & 255] + at[r >> 16 & 255] + at[r >> 24 & 255]).toLowerCase();
}
function ft(i, e, t) {
  return Math.max(e, Math.min(t, i));
}
function f2(i, e) {
  return (i % e + e) % e;
}
function Ja(i, e, t) {
  return (1 - t) * i + t * e;
}
function Ac(i) {
  return (i & i - 1) === 0 && i !== 0;
}
function Us(i) {
  return Math.pow(2, Math.floor(Math.log(i) / Math.LN2));
}
class Re {
  constructor(e = 0, t = 0) {
    this.isVector2 = !0, this.x = e, this.y = t;
  }
  get width() {
    return this.x;
  }
  set width(e) {
    this.x = e;
  }
  get height() {
    return this.y;
  }
  set height(e) {
    this.y = e;
  }
  set(e, t) {
    return this.x = e, this.y = t, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this;
  }
  add(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this);
  }
  addScalar(e) {
    return this.x += e, this.y += e, this;
  }
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this;
  }
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this;
  }
  sub(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this);
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this;
  }
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this;
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  applyMatrix3(e) {
    const t = this.x, r = this.y, n = e.elements;
    return this.x = n[0] * t + n[3] * r + n[6], this.y = n[1] * t + n[4] * r + n[7], this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this;
  }
  clamp(e, t) {
    return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this;
  }
  clampScalar(e, t) {
    return this.x = Math.max(e, Math.min(t, this.x)), this.y = Math.max(e, Math.min(t, this.y)), this;
  }
  clampLength(e, t) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(Math.max(e, Math.min(t, r)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y;
  }
  cross(e) {
    return this.x * e.y - this.y * e.x;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI;
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const t = this.x - e.x, r = this.y - e.y;
    return t * t + r * r;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this;
  }
  lerpVectors(e, t, r) {
    return this.x = e.x + (t.x - e.x) * r, this.y = e.y + (t.y - e.y) * r, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y;
  }
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e;
  }
  fromBufferAttribute(e, t, r) {
    return r !== void 0 && console.warn("THREE.Vector2: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this;
  }
  rotateAround(e, t) {
    const r = Math.cos(t), n = Math.sin(t), a = this.x - e.x, o = this.y - e.y;
    return this.x = a * r - o * n + e.x, this.y = a * n + o * r + e.y, this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y;
  }
}
class ei {
  constructor() {
    this.isMatrix3 = !0, this.elements = [
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ], arguments.length > 0 && console.error("THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.");
  }
  set(e, t, r, n, a, o, s, c, l) {
    const u = this.elements;
    return u[0] = e, u[1] = n, u[2] = s, u[3] = t, u[4] = a, u[5] = c, u[6] = r, u[7] = o, u[8] = l, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      1
    ), this;
  }
  copy(e) {
    const t = this.elements, r = e.elements;
    return t[0] = r[0], t[1] = r[1], t[2] = r[2], t[3] = r[3], t[4] = r[4], t[5] = r[5], t[6] = r[6], t[7] = r[7], t[8] = r[8], this;
  }
  extractBasis(e, t, r) {
    return e.setFromMatrix3Column(this, 0), t.setFromMatrix3Column(this, 1), r.setFromMatrix3Column(this, 2), this;
  }
  setFromMatrix4(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[4],
      t[8],
      t[1],
      t[5],
      t[9],
      t[2],
      t[6],
      t[10]
    ), this;
  }
  multiply(e) {
    return this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, t) {
    const r = e.elements, n = t.elements, a = this.elements, o = r[0], s = r[3], c = r[6], l = r[1], u = r[4], h = r[7], d = r[2], v = r[5], M = r[8], m = n[0], g = n[3], I = n[6], A = n[1], L = n[4], y = n[7], D = n[2], T = n[5], B = n[8];
    return a[0] = o * m + s * A + c * D, a[3] = o * g + s * L + c * T, a[6] = o * I + s * y + c * B, a[1] = l * m + u * A + h * D, a[4] = l * g + u * L + h * T, a[7] = l * I + u * y + h * B, a[2] = d * m + v * A + M * D, a[5] = d * g + v * L + M * T, a[8] = d * I + v * y + M * B, this;
  }
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[3] *= e, t[6] *= e, t[1] *= e, t[4] *= e, t[7] *= e, t[2] *= e, t[5] *= e, t[8] *= e, this;
  }
  determinant() {
    const e = this.elements, t = e[0], r = e[1], n = e[2], a = e[3], o = e[4], s = e[5], c = e[6], l = e[7], u = e[8];
    return t * o * u - t * s * l - r * a * u + r * s * c + n * a * l - n * o * c;
  }
  invert() {
    const e = this.elements, t = e[0], r = e[1], n = e[2], a = e[3], o = e[4], s = e[5], c = e[6], l = e[7], u = e[8], h = u * o - s * l, d = s * c - u * a, v = l * a - o * c, M = t * h + r * d + n * v;
    if (M === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
    const m = 1 / M;
    return e[0] = h * m, e[1] = (n * l - u * r) * m, e[2] = (s * r - n * o) * m, e[3] = d * m, e[4] = (u * t - n * c) * m, e[5] = (n * a - s * t) * m, e[6] = v * m, e[7] = (r * c - l * t) * m, e[8] = (o * t - r * a) * m, this;
  }
  transpose() {
    let e;
    const t = this.elements;
    return e = t[1], t[1] = t[3], t[3] = e, e = t[2], t[2] = t[6], t[6] = e, e = t[5], t[5] = t[7], t[7] = e, this;
  }
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose();
  }
  transposeIntoArray(e) {
    const t = this.elements;
    return e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8], this;
  }
  setUvTransform(e, t, r, n, a, o, s) {
    const c = Math.cos(a), l = Math.sin(a);
    return this.set(
      r * c,
      r * l,
      -r * (c * o + l * s) + o + e,
      -n * l,
      n * c,
      -n * (-l * o + c * s) + s + t,
      0,
      0,
      1
    ), this;
  }
  scale(e, t) {
    const r = this.elements;
    return r[0] *= e, r[3] *= e, r[6] *= e, r[1] *= t, r[4] *= t, r[7] *= t, this;
  }
  rotate(e) {
    const t = Math.cos(e), r = Math.sin(e), n = this.elements, a = n[0], o = n[3], s = n[6], c = n[1], l = n[4], u = n[7];
    return n[0] = t * a + r * c, n[3] = t * o + r * l, n[6] = t * s + r * u, n[1] = -r * a + t * c, n[4] = -r * o + t * l, n[7] = -r * s + t * u, this;
  }
  translate(e, t) {
    const r = this.elements;
    return r[0] += e * r[2], r[3] += e * r[5], r[6] += e * r[8], r[1] += t * r[2], r[4] += t * r[5], r[7] += t * r[8], this;
  }
  equals(e) {
    const t = this.elements, r = e.elements;
    for (let n = 0; n < 9; n++)
      if (t[n] !== r[n])
        return !1;
    return !0;
  }
  fromArray(e, t = 0) {
    for (let r = 0; r < 9; r++)
      this.elements[r] = e[r + t];
    return this;
  }
  toArray(e = [], t = 0) {
    const r = this.elements;
    return e[t] = r[0], e[t + 1] = r[1], e[t + 2] = r[2], e[t + 3] = r[3], e[t + 4] = r[4], e[t + 5] = r[5], e[t + 6] = r[6], e[t + 7] = r[7], e[t + 8] = r[8], e;
  }
  clone() {
    return new this.constructor().fromArray(this.elements);
  }
}
function Id(i) {
  for (let e = i.length - 1; e >= 0; --e)
    if (i[e] > 65535)
      return !0;
  return !1;
}
function ua(i) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", i);
}
function Qi(i) {
  return i < 0.04045 ? i * 0.0773993808 : Math.pow(i * 0.9478672986 + 0.0521327014, 2.4);
}
function ta(i) {
  return i < 31308e-7 ? i * 12.92 : 1.055 * Math.pow(i, 0.41666) - 0.055;
}
const Xa = {
  [di]: { [Yi]: Qi },
  [Yi]: { [di]: ta }
}, Tt = {
  legacyMode: !0,
  get workingColorSpace() {
    return Yi;
  },
  set workingColorSpace(i) {
    console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
  },
  convert: function(i, e, t) {
    if (this.legacyMode || e === t || !e || !t)
      return i;
    if (Xa[e] && Xa[e][t] !== void 0) {
      const r = Xa[e][t];
      return i.r = r(i.r), i.g = r(i.g), i.b = r(i.b), i;
    }
    throw new Error("Unsupported color space conversion.");
  },
  fromWorkingColorSpace: function(i, e) {
    return this.convert(i, this.workingColorSpace, e);
  },
  toWorkingColorSpace: function(i, e) {
    return this.convert(i, e, this.workingColorSpace);
  }
}, bd = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
}, Ke = { r: 0, g: 0, b: 0 }, Ct = { h: 0, s: 0, l: 0 }, Cn = { h: 0, s: 0, l: 0 };
function $a(i, e, t) {
  return t < 0 && (t += 1), t > 1 && (t -= 1), t < 1 / 6 ? i + (e - i) * 6 * t : t < 1 / 2 ? e : t < 2 / 3 ? i + (e - i) * 6 * (2 / 3 - t) : i;
}
function En(i, e) {
  return e.r = i.r, e.g = i.g, e.b = i.b, e;
}
class Ce {
  constructor(e, t, r) {
    return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, t === void 0 && r === void 0 ? this.set(e) : this.setRGB(e, t, r);
  }
  set(e) {
    return e && e.isColor ? this.copy(e) : typeof e == "number" ? this.setHex(e) : typeof e == "string" && this.setStyle(e), this;
  }
  setScalar(e) {
    return this.r = e, this.g = e, this.b = e, this;
  }
  setHex(e, t = di) {
    return e = Math.floor(e), this.r = (e >> 16 & 255) / 255, this.g = (e >> 8 & 255) / 255, this.b = (e & 255) / 255, Tt.toWorkingColorSpace(this, t), this;
  }
  setRGB(e, t, r, n = Yi) {
    return this.r = e, this.g = t, this.b = r, Tt.toWorkingColorSpace(this, n), this;
  }
  setHSL(e, t, r, n = Yi) {
    if (e = f2(e, 1), t = ft(t, 0, 1), r = ft(r, 0, 1), t === 0)
      this.r = this.g = this.b = r;
    else {
      const a = r <= 0.5 ? r * (1 + t) : r + t - r * t, o = 2 * r - a;
      this.r = $a(o, a, e + 1 / 3), this.g = $a(o, a, e), this.b = $a(o, a, e - 1 / 3);
    }
    return Tt.toWorkingColorSpace(this, n), this;
  }
  setStyle(e, t = di) {
    function r(a) {
      a !== void 0 && parseFloat(a) < 1 && console.warn("THREE.Color: Alpha component of " + e + " will be ignored.");
    }
    let n;
    if (n = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(e)) {
      let a;
      const o = n[1], s = n[2];
      switch (o) {
        case "rgb":
        case "rgba":
          if (a = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s))
            return this.r = Math.min(255, parseInt(a[1], 10)) / 255, this.g = Math.min(255, parseInt(a[2], 10)) / 255, this.b = Math.min(255, parseInt(a[3], 10)) / 255, Tt.toWorkingColorSpace(this, t), r(a[4]), this;
          if (a = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s))
            return this.r = Math.min(100, parseInt(a[1], 10)) / 100, this.g = Math.min(100, parseInt(a[2], 10)) / 100, this.b = Math.min(100, parseInt(a[3], 10)) / 100, Tt.toWorkingColorSpace(this, t), r(a[4]), this;
          break;
        case "hsl":
        case "hsla":
          if (a = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(s)) {
            const c = parseFloat(a[1]) / 360, l = parseInt(a[2], 10) / 100, u = parseInt(a[3], 10) / 100;
            return r(a[4]), this.setHSL(c, l, u, t);
          }
          break;
      }
    } else if (n = /^\#([A-Fa-f\d]+)$/.exec(e)) {
      const a = n[1], o = a.length;
      if (o === 3)
        return this.r = parseInt(a.charAt(0) + a.charAt(0), 16) / 255, this.g = parseInt(a.charAt(1) + a.charAt(1), 16) / 255, this.b = parseInt(a.charAt(2) + a.charAt(2), 16) / 255, Tt.toWorkingColorSpace(this, t), this;
      if (o === 6)
        return this.r = parseInt(a.charAt(0) + a.charAt(1), 16) / 255, this.g = parseInt(a.charAt(2) + a.charAt(3), 16) / 255, this.b = parseInt(a.charAt(4) + a.charAt(5), 16) / 255, Tt.toWorkingColorSpace(this, t), this;
    }
    return e && e.length > 0 ? this.setColorName(e, t) : this;
  }
  setColorName(e, t = di) {
    const r = bd[e.toLowerCase()];
    return r !== void 0 ? this.setHex(r, t) : console.warn("THREE.Color: Unknown color " + e), this;
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b);
  }
  copy(e) {
    return this.r = e.r, this.g = e.g, this.b = e.b, this;
  }
  copySRGBToLinear(e) {
    return this.r = Qi(e.r), this.g = Qi(e.g), this.b = Qi(e.b), this;
  }
  copyLinearToSRGB(e) {
    return this.r = ta(e.r), this.g = ta(e.g), this.b = ta(e.b), this;
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this;
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this;
  }
  getHex(e = di) {
    return Tt.fromWorkingColorSpace(En(this, Ke), e), ft(Ke.r * 255, 0, 255) << 16 ^ ft(Ke.g * 255, 0, 255) << 8 ^ ft(Ke.b * 255, 0, 255) << 0;
  }
  getHexString(e = di) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6);
  }
  getHSL(e, t = Yi) {
    Tt.fromWorkingColorSpace(En(this, Ke), t);
    const r = Ke.r, n = Ke.g, a = Ke.b, o = Math.max(r, n, a), s = Math.min(r, n, a);
    let c, l;
    const u = (s + o) / 2;
    if (s === o)
      c = 0, l = 0;
    else {
      const h = o - s;
      switch (l = u <= 0.5 ? h / (o + s) : h / (2 - o - s), o) {
        case r:
          c = (n - a) / h + (n < a ? 6 : 0);
          break;
        case n:
          c = (a - r) / h + 2;
          break;
        case a:
          c = (r - n) / h + 4;
          break;
      }
      c /= 6;
    }
    return e.h = c, e.s = l, e.l = u, e;
  }
  getRGB(e, t = Yi) {
    return Tt.fromWorkingColorSpace(En(this, Ke), t), e.r = Ke.r, e.g = Ke.g, e.b = Ke.b, e;
  }
  getStyle(e = di) {
    return Tt.fromWorkingColorSpace(En(this, Ke), e), e !== di ? `color(${e} ${Ke.r} ${Ke.g} ${Ke.b})` : `rgb(${Ke.r * 255 | 0},${Ke.g * 255 | 0},${Ke.b * 255 | 0})`;
  }
  offsetHSL(e, t, r) {
    return this.getHSL(Ct), Ct.h += e, Ct.s += t, Ct.l += r, this.setHSL(Ct.h, Ct.s, Ct.l), this;
  }
  add(e) {
    return this.r += e.r, this.g += e.g, this.b += e.b, this;
  }
  addColors(e, t) {
    return this.r = e.r + t.r, this.g = e.g + t.g, this.b = e.b + t.b, this;
  }
  addScalar(e) {
    return this.r += e, this.g += e, this.b += e, this;
  }
  sub(e) {
    return this.r = Math.max(0, this.r - e.r), this.g = Math.max(0, this.g - e.g), this.b = Math.max(0, this.b - e.b), this;
  }
  multiply(e) {
    return this.r *= e.r, this.g *= e.g, this.b *= e.b, this;
  }
  multiplyScalar(e) {
    return this.r *= e, this.g *= e, this.b *= e, this;
  }
  lerp(e, t) {
    return this.r += (e.r - this.r) * t, this.g += (e.g - this.g) * t, this.b += (e.b - this.b) * t, this;
  }
  lerpColors(e, t, r) {
    return this.r = e.r + (t.r - e.r) * r, this.g = e.g + (t.g - e.g) * r, this.b = e.b + (t.b - e.b) * r, this;
  }
  lerpHSL(e, t) {
    this.getHSL(Ct), e.getHSL(Cn);
    const r = Ja(Ct.h, Cn.h, t), n = Ja(Ct.s, Cn.s, t), a = Ja(Ct.l, Cn.l, t);
    return this.setHSL(r, n, a), this;
  }
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b;
  }
  fromArray(e, t = 0) {
    return this.r = e[t], this.g = e[t + 1], this.b = e[t + 2], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.r, e[t + 1] = this.g, e[t + 2] = this.b, e;
  }
  fromBufferAttribute(e, t) {
    return this.r = e.getX(t), this.g = e.getY(t), this.b = e.getZ(t), e.normalized === !0 && (this.r /= 255, this.g /= 255, this.b /= 255), this;
  }
  toJSON() {
    return this.getHex();
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b;
  }
}
Ce.NAMES = bd;
let ir;
class wd {
  static getDataURL(e) {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u")
      return e.src;
    let t;
    if (e instanceof HTMLCanvasElement)
      t = e;
    else {
      ir === void 0 && (ir = ua("canvas")), ir.width = e.width, ir.height = e.height;
      const r = ir.getContext("2d");
      e instanceof ImageData ? r.putImageData(e, 0, 0) : r.drawImage(e, 0, 0, e.width, e.height), t = ir;
    }
    return t.width > 2048 || t.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", e), t.toDataURL("image/jpeg", 0.6)) : t.toDataURL("image/png");
  }
  static sRGBToLinear(e) {
    if (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && e instanceof ImageBitmap) {
      const t = ua("canvas");
      t.width = e.width, t.height = e.height;
      const r = t.getContext("2d");
      r.drawImage(e, 0, 0, e.width, e.height);
      const n = r.getImageData(0, 0, e.width, e.height), a = n.data;
      for (let o = 0; o < a.length; o++)
        a[o] = Qi(a[o] / 255) * 255;
      return r.putImageData(n, 0, 0), t;
    } else if (e.data) {
      const t = e.data.slice(0);
      for (let r = 0; r < t.length; r++)
        t instanceof Uint8Array || t instanceof Uint8ClampedArray ? t[r] = Math.floor(Qi(t[r] / 255) * 255) : t[r] = Qi(t[r]);
      return {
        data: t,
        width: e.width,
        height: e.height
      };
    } else
      return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), e;
  }
}
class _d {
  constructor(e = null) {
    this.isSource = !0, this.uuid = vn(), this.data = e, this.version = 0;
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.images[this.uuid] !== void 0)
      return e.images[this.uuid];
    const r = {
      uuid: this.uuid,
      url: ""
    }, n = this.data;
    if (n !== null) {
      let a;
      if (Array.isArray(n)) {
        a = [];
        for (let o = 0, s = n.length; o < s; o++)
          n[o].isDataTexture ? a.push(qa(n[o].image)) : a.push(qa(n[o]));
      } else
        a = qa(n);
      r.url = a;
    }
    return t || (e.images[this.uuid] = r), r;
  }
}
function qa(i) {
  return typeof HTMLImageElement < "u" && i instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && i instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && i instanceof ImageBitmap ? wd.getDataURL(i) : i.data ? {
    data: Array.prototype.slice.call(i.data),
    width: i.width,
    height: i.height,
    type: i.data.constructor.name
  } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
let m2 = 0;
class Gt extends jr {
  constructor(e = Gt.DEFAULT_IMAGE, t = Gt.DEFAULT_MAPPING, r = Pt, n = Pt, a = wt, o = Da, s = jt, c = Ji, l = 1, u = Xi) {
    super(), this.isTexture = !0, Object.defineProperty(this, "id", { value: m2++ }), this.uuid = vn(), this.name = "", this.source = new _d(e), this.mipmaps = [], this.mapping = t, this.wrapS = r, this.wrapT = n, this.magFilter = a, this.minFilter = o, this.anisotropy = l, this.format = s, this.internalFormat = null, this.type = c, this.offset = new Re(0, 0), this.repeat = new Re(1, 1), this.center = new Re(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new ei(), this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = u, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
  }
  get image() {
    return this.source.data;
  }
  set image(e) {
    this.source.data = e;
  }
  updateMatrix() {
    this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.name = e.name, this.source = e.source, this.mipmaps = e.mipmaps.slice(0), this.mapping = e.mapping, this.wrapS = e.wrapS, this.wrapT = e.wrapT, this.magFilter = e.magFilter, this.minFilter = e.minFilter, this.anisotropy = e.anisotropy, this.format = e.format, this.internalFormat = e.internalFormat, this.type = e.type, this.offset.copy(e.offset), this.repeat.copy(e.repeat), this.center.copy(e.center), this.rotation = e.rotation, this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrix.copy(e.matrix), this.generateMipmaps = e.generateMipmaps, this.premultiplyAlpha = e.premultiplyAlpha, this.flipY = e.flipY, this.unpackAlignment = e.unpackAlignment, this.encoding = e.encoding, this.userData = JSON.parse(JSON.stringify(e.userData)), this.needsUpdate = !0, this;
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    if (!t && e.textures[this.uuid] !== void 0)
      return e.textures[this.uuid];
    const r = {
      metadata: {
        version: 4.5,
        type: "Texture",
        generator: "Texture.toJSON"
      },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      type: this.type,
      encoding: this.encoding,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment
    };
    return JSON.stringify(this.userData) !== "{}" && (r.userData = this.userData), t || (e.textures[this.uuid] = r), r;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  transformUv(e) {
    if (this.mapping !== yd)
      return e;
    if (e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1)
      switch (this.wrapS) {
        case ks:
          e.x = e.x - Math.floor(e.x);
          break;
        case Pt:
          e.x = e.x < 0 ? 0 : 1;
          break;
        case Ws:
          Math.abs(Math.floor(e.x) % 2) === 1 ? e.x = Math.ceil(e.x) - e.x : e.x = e.x - Math.floor(e.x);
          break;
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case ks:
          e.y = e.y - Math.floor(e.y);
          break;
        case Pt:
          e.y = e.y < 0 ? 0 : 1;
          break;
        case Ws:
          Math.abs(Math.floor(e.y) % 2) === 1 ? e.y = Math.ceil(e.y) - e.y : e.y = e.y - Math.floor(e.y);
          break;
      }
    return this.flipY && (e.y = 1 - e.y), e;
  }
  set needsUpdate(e) {
    e === !0 && (this.version++, this.source.needsUpdate = !0);
  }
}
Gt.DEFAULT_IMAGE = null;
Gt.DEFAULT_MAPPING = yd;
class et {
  constructor(e = 0, t = 0, r = 0, n = 1) {
    this.isVector4 = !0, this.x = e, this.y = t, this.z = r, this.w = n;
  }
  get width() {
    return this.z;
  }
  set width(e) {
    this.z = e;
  }
  get height() {
    return this.w;
  }
  set height(e) {
    this.w = e;
  }
  set(e, t, r, n) {
    return this.x = e, this.y = t, this.z = r, this.w = n, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this.w = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setW(e) {
    return this.w = e, this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      case 3:
        this.w = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      case 3:
        return this.w;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this.w = e.w !== void 0 ? e.w : 1, this;
  }
  add(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this.z += e.z, this.w += e.w, this);
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this.w += e, this;
  }
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this.w = e.w + t.w, this;
  }
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this.w += e.w * t, this;
  }
  sub(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this.z -= e.z, this.w -= e.w, this);
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this.w -= e, this;
  }
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this.w = e.w - t.w, this;
  }
  multiply(e) {
    return this.x *= e.x, this.y *= e.y, this.z *= e.z, this.w *= e.w, this;
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this.w *= e, this;
  }
  applyMatrix4(e) {
    const t = this.x, r = this.y, n = this.z, a = this.w, o = e.elements;
    return this.x = o[0] * t + o[4] * r + o[8] * n + o[12] * a, this.y = o[1] * t + o[5] * r + o[9] * n + o[13] * a, this.z = o[2] * t + o[6] * r + o[10] * n + o[14] * a, this.w = o[3] * t + o[7] * r + o[11] * n + o[15] * a, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w);
    const t = Math.sqrt(1 - e.w * e.w);
    return t < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = e.x / t, this.y = e.y / t, this.z = e.z / t), this;
  }
  setAxisAngleFromRotationMatrix(e) {
    let t, r, n, a;
    const o = e.elements, s = o[0], c = o[4], l = o[8], u = o[1], h = o[5], d = o[9], v = o[2], M = o[6], m = o[10];
    if (Math.abs(c - u) < 0.01 && Math.abs(l - v) < 0.01 && Math.abs(d - M) < 0.01) {
      if (Math.abs(c + u) < 0.1 && Math.abs(l + v) < 0.1 && Math.abs(d + M) < 0.1 && Math.abs(s + h + m - 3) < 0.1)
        return this.set(1, 0, 0, 0), this;
      t = Math.PI;
      const I = (s + 1) / 2, A = (h + 1) / 2, L = (m + 1) / 2, y = (c + u) / 4, D = (l + v) / 4, T = (d + M) / 4;
      return I > A && I > L ? I < 0.01 ? (r = 0, n = 0.707106781, a = 0.707106781) : (r = Math.sqrt(I), n = y / r, a = D / r) : A > L ? A < 0.01 ? (r = 0.707106781, n = 0, a = 0.707106781) : (n = Math.sqrt(A), r = y / n, a = T / n) : L < 0.01 ? (r = 0.707106781, n = 0.707106781, a = 0) : (a = Math.sqrt(L), r = D / a, n = T / a), this.set(r, n, a, t), this;
    }
    let g = Math.sqrt((M - d) * (M - d) + (l - v) * (l - v) + (u - c) * (u - c));
    return Math.abs(g) < 1e-3 && (g = 1), this.x = (M - d) / g, this.y = (l - v) / g, this.z = (u - c) / g, this.w = Math.acos((s + h + m - 1) / 2), this;
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this.w = Math.min(this.w, e.w), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this.w = Math.max(this.w, e.w), this;
  }
  clamp(e, t) {
    return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this.w = Math.max(e.w, Math.min(t.w, this.w)), this;
  }
  clampScalar(e, t) {
    return this.x = Math.max(e, Math.min(t, this.x)), this.y = Math.max(e, Math.min(t, this.y)), this.z = Math.max(e, Math.min(t, this.z)), this.w = Math.max(e, Math.min(t, this.w)), this;
  }
  clampLength(e, t) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(Math.max(e, Math.min(t, r)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this.w += (e.w - this.w) * t, this;
  }
  lerpVectors(e, t, r) {
    return this.x = e.x + (t.x - e.x) * r, this.y = e.y + (t.y - e.y) * r, this.z = e.z + (t.z - e.z) * r, this.w = e.w + (t.w - e.w) * r, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w;
  }
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this.w = e[t + 3], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e[t + 3] = this.w, e;
  }
  fromBufferAttribute(e, t, r) {
    return r !== void 0 && console.warn("THREE.Vector4: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this.w = e.getW(t), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w;
  }
}
class Ci extends jr {
  constructor(e, t, r = {}) {
    super(), this.isWebGLRenderTarget = !0, this.width = e, this.height = t, this.depth = 1, this.scissor = new et(0, 0, e, t), this.scissorTest = !1, this.viewport = new et(0, 0, e, t);
    const n = { width: e, height: t, depth: 1 };
    this.texture = new Gt(n, r.mapping, r.wrapS, r.wrapT, r.magFilter, r.minFilter, r.format, r.type, r.anisotropy, r.encoding), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = r.generateMipmaps !== void 0 ? r.generateMipmaps : !1, this.texture.internalFormat = r.internalFormat !== void 0 ? r.internalFormat : null, this.texture.minFilter = r.minFilter !== void 0 ? r.minFilter : wt, this.depthBuffer = r.depthBuffer !== void 0 ? r.depthBuffer : !0, this.stencilBuffer = r.stencilBuffer !== void 0 ? r.stencilBuffer : !1, this.depthTexture = r.depthTexture !== void 0 ? r.depthTexture : null, this.samples = r.samples !== void 0 ? r.samples : 0;
  }
  setSize(e, t, r = 1) {
    (this.width !== e || this.height !== t || this.depth !== r) && (this.width = e, this.height = t, this.depth = r, this.texture.image.width = e, this.texture.image.height = t, this.texture.image.depth = r, this.dispose()), this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.width = e.width, this.height = e.height, this.depth = e.depth, this.viewport.copy(e.viewport), this.texture = e.texture.clone(), this.texture.isRenderTargetTexture = !0;
    const t = Object.assign({}, e.texture.image);
    return this.texture.source = new _d(t), this.depthBuffer = e.depthBuffer, this.stencilBuffer = e.stencilBuffer, e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()), this.samples = e.samples, this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
class Ad extends Gt {
  constructor(e = null, t = 1, r = 1, n = 1) {
    super(null), this.isDataArrayTexture = !0, this.image = { data: e, width: t, height: r, depth: n }, this.magFilter = pt, this.minFilter = pt, this.wrapR = Pt, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class g2 extends Gt {
  constructor(e = null, t = 1, r = 1, n = 1) {
    super(null), this.isData3DTexture = !0, this.image = { data: e, width: t, height: r, depth: n }, this.magFilter = pt, this.minFilter = pt, this.wrapR = Pt, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
  }
}
class Mn {
  constructor(e = 0, t = 0, r = 0, n = 1) {
    this.isQuaternion = !0, this._x = e, this._y = t, this._z = r, this._w = n;
  }
  static slerp(e, t, r, n) {
    return console.warn("THREE.Quaternion: Static .slerp() has been deprecated. Use qm.slerpQuaternions( qa, qb, t ) instead."), r.slerpQuaternions(e, t, n);
  }
  static slerpFlat(e, t, r, n, a, o, s) {
    let c = r[n + 0], l = r[n + 1], u = r[n + 2], h = r[n + 3];
    const d = a[o + 0], v = a[o + 1], M = a[o + 2], m = a[o + 3];
    if (s === 0) {
      e[t + 0] = c, e[t + 1] = l, e[t + 2] = u, e[t + 3] = h;
      return;
    }
    if (s === 1) {
      e[t + 0] = d, e[t + 1] = v, e[t + 2] = M, e[t + 3] = m;
      return;
    }
    if (h !== m || c !== d || l !== v || u !== M) {
      let g = 1 - s;
      const I = c * d + l * v + u * M + h * m, A = I >= 0 ? 1 : -1, L = 1 - I * I;
      if (L > Number.EPSILON) {
        const D = Math.sqrt(L), T = Math.atan2(D, I * A);
        g = Math.sin(g * T) / D, s = Math.sin(s * T) / D;
      }
      const y = s * A;
      if (c = c * g + d * y, l = l * g + v * y, u = u * g + M * y, h = h * g + m * y, g === 1 - s) {
        const D = 1 / Math.sqrt(c * c + l * l + u * u + h * h);
        c *= D, l *= D, u *= D, h *= D;
      }
    }
    e[t] = c, e[t + 1] = l, e[t + 2] = u, e[t + 3] = h;
  }
  static multiplyQuaternionsFlat(e, t, r, n, a, o) {
    const s = r[n], c = r[n + 1], l = r[n + 2], u = r[n + 3], h = a[o], d = a[o + 1], v = a[o + 2], M = a[o + 3];
    return e[t] = s * M + u * h + c * v - l * d, e[t + 1] = c * M + u * d + l * h - s * v, e[t + 2] = l * M + u * v + s * d - c * h, e[t + 3] = u * M - s * h - c * d - l * v, e;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get w() {
    return this._w;
  }
  set w(e) {
    this._w = e, this._onChangeCallback();
  }
  set(e, t, r, n) {
    return this._x = e, this._y = t, this._z = r, this._w = n, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w);
  }
  copy(e) {
    return this._x = e.x, this._y = e.y, this._z = e.z, this._w = e.w, this._onChangeCallback(), this;
  }
  setFromEuler(e, t) {
    if (!(e && e.isEuler))
      throw new Error("THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.");
    const r = e._x, n = e._y, a = e._z, o = e._order, s = Math.cos, c = Math.sin, l = s(r / 2), u = s(n / 2), h = s(a / 2), d = c(r / 2), v = c(n / 2), M = c(a / 2);
    switch (o) {
      case "XYZ":
        this._x = d * u * h + l * v * M, this._y = l * v * h - d * u * M, this._z = l * u * M + d * v * h, this._w = l * u * h - d * v * M;
        break;
      case "YXZ":
        this._x = d * u * h + l * v * M, this._y = l * v * h - d * u * M, this._z = l * u * M - d * v * h, this._w = l * u * h + d * v * M;
        break;
      case "ZXY":
        this._x = d * u * h - l * v * M, this._y = l * v * h + d * u * M, this._z = l * u * M + d * v * h, this._w = l * u * h - d * v * M;
        break;
      case "ZYX":
        this._x = d * u * h - l * v * M, this._y = l * v * h + d * u * M, this._z = l * u * M - d * v * h, this._w = l * u * h + d * v * M;
        break;
      case "YZX":
        this._x = d * u * h + l * v * M, this._y = l * v * h + d * u * M, this._z = l * u * M - d * v * h, this._w = l * u * h - d * v * M;
        break;
      case "XZY":
        this._x = d * u * h - l * v * M, this._y = l * v * h - d * u * M, this._z = l * u * M + d * v * h, this._w = l * u * h + d * v * M;
        break;
      default:
        console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + o);
    }
    return t !== !1 && this._onChangeCallback(), this;
  }
  setFromAxisAngle(e, t) {
    const r = t / 2, n = Math.sin(r);
    return this._x = e.x * n, this._y = e.y * n, this._z = e.z * n, this._w = Math.cos(r), this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e) {
    const t = e.elements, r = t[0], n = t[4], a = t[8], o = t[1], s = t[5], c = t[9], l = t[2], u = t[6], h = t[10], d = r + s + h;
    if (d > 0) {
      const v = 0.5 / Math.sqrt(d + 1);
      this._w = 0.25 / v, this._x = (u - c) * v, this._y = (a - l) * v, this._z = (o - n) * v;
    } else if (r > s && r > h) {
      const v = 2 * Math.sqrt(1 + r - s - h);
      this._w = (u - c) / v, this._x = 0.25 * v, this._y = (n + o) / v, this._z = (a + l) / v;
    } else if (s > h) {
      const v = 2 * Math.sqrt(1 + s - r - h);
      this._w = (a - l) / v, this._x = (n + o) / v, this._y = 0.25 * v, this._z = (c + u) / v;
    } else {
      const v = 2 * Math.sqrt(1 + h - r - s);
      this._w = (o - n) / v, this._x = (a + l) / v, this._y = (c + u) / v, this._z = 0.25 * v;
    }
    return this._onChangeCallback(), this;
  }
  setFromUnitVectors(e, t) {
    let r = e.dot(t) + 1;
    return r < Number.EPSILON ? (r = 0, Math.abs(e.x) > Math.abs(e.z) ? (this._x = -e.y, this._y = e.x, this._z = 0, this._w = r) : (this._x = 0, this._y = -e.z, this._z = e.y, this._w = r)) : (this._x = e.y * t.z - e.z * t.y, this._y = e.z * t.x - e.x * t.z, this._z = e.x * t.y - e.y * t.x, this._w = r), this.normalize();
  }
  angleTo(e) {
    return 2 * Math.acos(Math.abs(ft(this.dot(e), -1, 1)));
  }
  rotateTowards(e, t) {
    const r = this.angleTo(e);
    if (r === 0)
      return this;
    const n = Math.min(1, t / r);
    return this.slerp(e, n), this;
  }
  identity() {
    return this.set(0, 0, 0, 1);
  }
  invert() {
    return this.conjugate();
  }
  conjugate() {
    return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
  }
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w;
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
  }
  length() {
    return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
  }
  normalize() {
    let e = this.length();
    return e === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (e = 1 / e, this._x = this._x * e, this._y = this._y * e, this._z = this._z * e, this._w = this._w * e), this._onChangeCallback(), this;
  }
  multiply(e, t) {
    return t !== void 0 ? (console.warn("THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead."), this.multiplyQuaternions(e, t)) : this.multiplyQuaternions(this, e);
  }
  premultiply(e) {
    return this.multiplyQuaternions(e, this);
  }
  multiplyQuaternions(e, t) {
    const r = e._x, n = e._y, a = e._z, o = e._w, s = t._x, c = t._y, l = t._z, u = t._w;
    return this._x = r * u + o * s + n * l - a * c, this._y = n * u + o * c + a * s - r * l, this._z = a * u + o * l + r * c - n * s, this._w = o * u - r * s - n * c - a * l, this._onChangeCallback(), this;
  }
  slerp(e, t) {
    if (t === 0)
      return this;
    if (t === 1)
      return this.copy(e);
    const r = this._x, n = this._y, a = this._z, o = this._w;
    let s = o * e._w + r * e._x + n * e._y + a * e._z;
    if (s < 0 ? (this._w = -e._w, this._x = -e._x, this._y = -e._y, this._z = -e._z, s = -s) : this.copy(e), s >= 1)
      return this._w = o, this._x = r, this._y = n, this._z = a, this;
    const c = 1 - s * s;
    if (c <= Number.EPSILON) {
      const v = 1 - t;
      return this._w = v * o + t * this._w, this._x = v * r + t * this._x, this._y = v * n + t * this._y, this._z = v * a + t * this._z, this.normalize(), this._onChangeCallback(), this;
    }
    const l = Math.sqrt(c), u = Math.atan2(l, s), h = Math.sin((1 - t) * u) / l, d = Math.sin(t * u) / l;
    return this._w = o * h + this._w * d, this._x = r * h + this._x * d, this._y = n * h + this._y * d, this._z = a * h + this._z * d, this._onChangeCallback(), this;
  }
  slerpQuaternions(e, t, r) {
    return this.copy(e).slerp(t, r);
  }
  random() {
    const e = Math.random(), t = Math.sqrt(1 - e), r = Math.sqrt(e), n = 2 * Math.PI * Math.random(), a = 2 * Math.PI * Math.random();
    return this.set(
      t * Math.cos(n),
      r * Math.sin(a),
      r * Math.cos(a),
      t * Math.sin(n)
    );
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w;
  }
  fromArray(e, t = 0) {
    return this._x = e[t], this._y = e[t + 1], this._z = e[t + 2], this._w = e[t + 3], this._onChangeCallback(), this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._w, e;
  }
  fromBufferAttribute(e, t) {
    return this._x = e.getX(t), this._y = e.getY(t), this._z = e.getZ(t), this._w = e.getW(t), this;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w;
  }
}
class W {
  constructor(e = 0, t = 0, r = 0) {
    this.isVector3 = !0, this.x = e, this.y = t, this.z = r;
  }
  set(e, t, r) {
    return r === void 0 && (r = this.z), this.x = e, this.y = t, this.z = r, this;
  }
  setScalar(e) {
    return this.x = e, this.y = e, this.z = e, this;
  }
  setX(e) {
    return this.x = e, this;
  }
  setY(e) {
    return this.y = e, this;
  }
  setZ(e) {
    return this.z = e, this;
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t;
        break;
      case 1:
        this.y = t;
        break;
      case 2:
        this.z = t;
        break;
      default:
        throw new Error("index is out of range: " + e);
    }
    return this;
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x;
      case 1:
        return this.y;
      case 2:
        return this.z;
      default:
        throw new Error("index is out of range: " + e);
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z);
  }
  copy(e) {
    return this.x = e.x, this.y = e.y, this.z = e.z, this;
  }
  add(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead."), this.addVectors(e, t)) : (this.x += e.x, this.y += e.y, this.z += e.z, this);
  }
  addScalar(e) {
    return this.x += e, this.y += e, this.z += e, this;
  }
  addVectors(e, t) {
    return this.x = e.x + t.x, this.y = e.y + t.y, this.z = e.z + t.z, this;
  }
  addScaledVector(e, t) {
    return this.x += e.x * t, this.y += e.y * t, this.z += e.z * t, this;
  }
  sub(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead."), this.subVectors(e, t)) : (this.x -= e.x, this.y -= e.y, this.z -= e.z, this);
  }
  subScalar(e) {
    return this.x -= e, this.y -= e, this.z -= e, this;
  }
  subVectors(e, t) {
    return this.x = e.x - t.x, this.y = e.y - t.y, this.z = e.z - t.z, this;
  }
  multiply(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead."), this.multiplyVectors(e, t)) : (this.x *= e.x, this.y *= e.y, this.z *= e.z, this);
  }
  multiplyScalar(e) {
    return this.x *= e, this.y *= e, this.z *= e, this;
  }
  multiplyVectors(e, t) {
    return this.x = e.x * t.x, this.y = e.y * t.y, this.z = e.z * t.z, this;
  }
  applyEuler(e) {
    return e && e.isEuler || console.error("THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order."), this.applyQuaternion(Sc.setFromEuler(e));
  }
  applyAxisAngle(e, t) {
    return this.applyQuaternion(Sc.setFromAxisAngle(e, t));
  }
  applyMatrix3(e) {
    const t = this.x, r = this.y, n = this.z, a = e.elements;
    return this.x = a[0] * t + a[3] * r + a[6] * n, this.y = a[1] * t + a[4] * r + a[7] * n, this.z = a[2] * t + a[5] * r + a[8] * n, this;
  }
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize();
  }
  applyMatrix4(e) {
    const t = this.x, r = this.y, n = this.z, a = e.elements, o = 1 / (a[3] * t + a[7] * r + a[11] * n + a[15]);
    return this.x = (a[0] * t + a[4] * r + a[8] * n + a[12]) * o, this.y = (a[1] * t + a[5] * r + a[9] * n + a[13]) * o, this.z = (a[2] * t + a[6] * r + a[10] * n + a[14]) * o, this;
  }
  applyQuaternion(e) {
    const t = this.x, r = this.y, n = this.z, a = e.x, o = e.y, s = e.z, c = e.w, l = c * t + o * n - s * r, u = c * r + s * t - a * n, h = c * n + a * r - o * t, d = -a * t - o * r - s * n;
    return this.x = l * c + d * -a + u * -s - h * -o, this.y = u * c + d * -o + h * -a - l * -s, this.z = h * c + d * -s + l * -o - u * -a, this;
  }
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix);
  }
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld);
  }
  transformDirection(e) {
    const t = this.x, r = this.y, n = this.z, a = e.elements;
    return this.x = a[0] * t + a[4] * r + a[8] * n, this.y = a[1] * t + a[5] * r + a[9] * n, this.z = a[2] * t + a[6] * r + a[10] * n, this.normalize();
  }
  divide(e) {
    return this.x /= e.x, this.y /= e.y, this.z /= e.z, this;
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e);
  }
  min(e) {
    return this.x = Math.min(this.x, e.x), this.y = Math.min(this.y, e.y), this.z = Math.min(this.z, e.z), this;
  }
  max(e) {
    return this.x = Math.max(this.x, e.x), this.y = Math.max(this.y, e.y), this.z = Math.max(this.z, e.z), this;
  }
  clamp(e, t) {
    return this.x = Math.max(e.x, Math.min(t.x, this.x)), this.y = Math.max(e.y, Math.min(t.y, this.y)), this.z = Math.max(e.z, Math.min(t.z, this.z)), this;
  }
  clampScalar(e, t) {
    return this.x = Math.max(e, Math.min(t, this.x)), this.y = Math.max(e, Math.min(t, this.y)), this.z = Math.max(e, Math.min(t, this.z)), this;
  }
  clampLength(e, t) {
    const r = this.length();
    return this.divideScalar(r || 1).multiplyScalar(Math.max(e, Math.min(t, r)));
  }
  floor() {
    return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
  }
  ceil() {
    return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
  }
  round() {
    return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
  }
  roundToZero() {
    return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
  }
  negate() {
    return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z;
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z;
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
  }
  normalize() {
    return this.divideScalar(this.length() || 1);
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e);
  }
  lerp(e, t) {
    return this.x += (e.x - this.x) * t, this.y += (e.y - this.y) * t, this.z += (e.z - this.z) * t, this;
  }
  lerpVectors(e, t, r) {
    return this.x = e.x + (t.x - e.x) * r, this.y = e.y + (t.y - e.y) * r, this.z = e.z + (t.z - e.z) * r, this;
  }
  cross(e, t) {
    return t !== void 0 ? (console.warn("THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead."), this.crossVectors(e, t)) : this.crossVectors(this, e);
  }
  crossVectors(e, t) {
    const r = e.x, n = e.y, a = e.z, o = t.x, s = t.y, c = t.z;
    return this.x = n * c - a * s, this.y = a * o - r * c, this.z = r * s - n * o, this;
  }
  projectOnVector(e) {
    const t = e.lengthSq();
    if (t === 0)
      return this.set(0, 0, 0);
    const r = e.dot(this) / t;
    return this.copy(e).multiplyScalar(r);
  }
  projectOnPlane(e) {
    return Ka.copy(this).projectOnVector(e), this.sub(Ka);
  }
  reflect(e) {
    return this.sub(Ka.copy(e).multiplyScalar(2 * this.dot(e)));
  }
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq());
    if (t === 0)
      return Math.PI / 2;
    const r = this.dot(e) / t;
    return Math.acos(ft(r, -1, 1));
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e));
  }
  distanceToSquared(e) {
    const t = this.x - e.x, r = this.y - e.y, n = this.z - e.z;
    return t * t + r * r + n * n;
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z);
  }
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta);
  }
  setFromSphericalCoords(e, t, r) {
    const n = Math.sin(t) * e;
    return this.x = n * Math.sin(r), this.y = Math.cos(t) * e, this.z = n * Math.cos(r), this;
  }
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y);
  }
  setFromCylindricalCoords(e, t, r) {
    return this.x = e * Math.sin(t), this.y = r, this.z = e * Math.cos(t), this;
  }
  setFromMatrixPosition(e) {
    const t = e.elements;
    return this.x = t[12], this.y = t[13], this.z = t[14], this;
  }
  setFromMatrixScale(e) {
    const t = this.setFromMatrixColumn(e, 0).length(), r = this.setFromMatrixColumn(e, 1).length(), n = this.setFromMatrixColumn(e, 2).length();
    return this.x = t, this.y = r, this.z = n, this;
  }
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4);
  }
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3);
  }
  setFromEuler(e) {
    return this.x = e._x, this.y = e._y, this.z = e._z, this;
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z;
  }
  fromArray(e, t = 0) {
    return this.x = e[t], this.y = e[t + 1], this.z = e[t + 2], this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this.x, e[t + 1] = this.y, e[t + 2] = this.z, e;
  }
  fromBufferAttribute(e, t, r) {
    return r !== void 0 && console.warn("THREE.Vector3: offset has been removed from .fromBufferAttribute()."), this.x = e.getX(t), this.y = e.getY(t), this.z = e.getZ(t), this;
  }
  random() {
    return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
  }
  randomDirection() {
    const e = (Math.random() - 0.5) * 2, t = Math.random() * Math.PI * 2, r = Math.sqrt(1 - e ** 2);
    return this.x = r * Math.cos(t), this.y = r * Math.sin(t), this.z = e, this;
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z;
  }
}
const Ka = /* @__PURE__ */ new W(), Sc = /* @__PURE__ */ new Mn();
class yn {
  constructor(e = new W(1 / 0, 1 / 0, 1 / 0), t = new W(-1 / 0, -1 / 0, -1 / 0)) {
    this.isBox3 = !0, this.min = e, this.max = t;
  }
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this;
  }
  setFromArray(e) {
    let t = 1 / 0, r = 1 / 0, n = 1 / 0, a = -1 / 0, o = -1 / 0, s = -1 / 0;
    for (let c = 0, l = e.length; c < l; c += 3) {
      const u = e[c], h = e[c + 1], d = e[c + 2];
      u < t && (t = u), h < r && (r = h), d < n && (n = d), u > a && (a = u), h > o && (o = h), d > s && (s = d);
    }
    return this.min.set(t, r, n), this.max.set(a, o, s), this;
  }
  setFromBufferAttribute(e) {
    let t = 1 / 0, r = 1 / 0, n = 1 / 0, a = -1 / 0, o = -1 / 0, s = -1 / 0;
    for (let c = 0, l = e.count; c < l; c++) {
      const u = e.getX(c), h = e.getY(c), d = e.getZ(c);
      u < t && (t = u), h < r && (r = h), d < n && (n = d), u > a && (a = u), h > o && (o = h), d > s && (s = d);
    }
    return this.min.set(t, r, n), this.max.set(a, o, s), this;
  }
  setFromPoints(e) {
    this.makeEmpty();
    for (let t = 0, r = e.length; t < r; t++)
      this.expandByPoint(e[t]);
    return this;
  }
  setFromCenterAndSize(e, t) {
    const r = Oi.copy(t).multiplyScalar(0.5);
    return this.min.copy(e).sub(r), this.max.copy(e).add(r), this;
  }
  setFromObject(e, t = !1) {
    return this.makeEmpty(), this.expandByObject(e, t);
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this;
  }
  makeEmpty() {
    return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
  }
  getCenter(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.addVectors(this.min, this.max).multiplyScalar(0.5);
  }
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min);
  }
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this;
  }
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this;
  }
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this;
  }
  expandByObject(e, t = !1) {
    e.updateWorldMatrix(!1, !1);
    const r = e.geometry;
    if (r !== void 0)
      if (t && r.attributes != null && r.attributes.position !== void 0) {
        const a = r.attributes.position;
        for (let o = 0, s = a.count; o < s; o++)
          Oi.fromBufferAttribute(a, o).applyMatrix4(e.matrixWorld), this.expandByPoint(Oi);
      } else
        r.boundingBox === null && r.computeBoundingBox(), es.copy(r.boundingBox), es.applyMatrix4(e.matrixWorld), this.union(es);
    const n = e.children;
    for (let a = 0, o = n.length; a < o; a++)
      this.expandByObject(n[a], t);
    return this;
  }
  containsPoint(e) {
    return !(e.x < this.min.x || e.x > this.max.x || e.y < this.min.y || e.y > this.max.y || e.z < this.min.z || e.z > this.max.z);
  }
  containsBox(e) {
    return this.min.x <= e.min.x && e.max.x <= this.max.x && this.min.y <= e.min.y && e.max.y <= this.max.y && this.min.z <= e.min.z && e.max.z <= this.max.z;
  }
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z)
    );
  }
  intersectsBox(e) {
    return !(e.max.x < this.min.x || e.min.x > this.max.x || e.max.y < this.min.y || e.min.y > this.max.y || e.max.z < this.min.z || e.min.z > this.max.z);
  }
  intersectsSphere(e) {
    return this.clampPoint(e.center, Oi), Oi.distanceToSquared(e.center) <= e.radius * e.radius;
  }
  intersectsPlane(e) {
    let t, r;
    return e.normal.x > 0 ? (t = e.normal.x * this.min.x, r = e.normal.x * this.max.x) : (t = e.normal.x * this.max.x, r = e.normal.x * this.min.x), e.normal.y > 0 ? (t += e.normal.y * this.min.y, r += e.normal.y * this.max.y) : (t += e.normal.y * this.max.y, r += e.normal.y * this.min.y), e.normal.z > 0 ? (t += e.normal.z * this.min.z, r += e.normal.z * this.max.z) : (t += e.normal.z * this.max.z, r += e.normal.z * this.min.z), t <= -e.constant && r >= -e.constant;
  }
  intersectsTriangle(e) {
    if (this.isEmpty())
      return !1;
    this.getCenter(Ur), Nn.subVectors(this.max, Ur), rr.subVectors(e.a, Ur), nr.subVectors(e.b, Ur), ar.subVectors(e.c, Ur), yi.subVectors(nr, rr), xi.subVectors(ar, nr), zi.subVectors(rr, ar);
    let t = [
      0,
      -yi.z,
      yi.y,
      0,
      -xi.z,
      xi.y,
      0,
      -zi.z,
      zi.y,
      yi.z,
      0,
      -yi.x,
      xi.z,
      0,
      -xi.x,
      zi.z,
      0,
      -zi.x,
      -yi.y,
      yi.x,
      0,
      -xi.y,
      xi.x,
      0,
      -zi.y,
      zi.x,
      0
    ];
    return !ts(t, rr, nr, ar, Nn) || (t = [1, 0, 0, 0, 1, 0, 0, 0, 1], !ts(t, rr, nr, ar, Nn)) ? !1 : (Ln.crossVectors(yi, xi), t = [Ln.x, Ln.y, Ln.z], ts(t, rr, nr, ar, Nn));
  }
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max);
  }
  distanceToPoint(e) {
    return Oi.copy(e).clamp(this.min, this.max).sub(e).length();
  }
  getBoundingSphere(e) {
    return this.getCenter(e.center), e.radius = this.getSize(Oi).length() * 0.5, e;
  }
  intersect(e) {
    return this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this;
  }
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this;
  }
  applyMatrix4(e) {
    return this.isEmpty() ? this : (ai[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e), ai[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e), ai[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e), ai[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e), ai[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e), ai[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e), ai[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e), ai[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e), this.setFromPoints(ai), this);
  }
  translate(e) {
    return this.min.add(e), this.max.add(e), this;
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max);
  }
}
const ai = [
  /* @__PURE__ */ new W(),
  /* @__PURE__ */ new W(),
  /* @__PURE__ */ new W(),
  /* @__PURE__ */ new W(),
  /* @__PURE__ */ new W(),
  /* @__PURE__ */ new W(),
  /* @__PURE__ */ new W(),
  /* @__PURE__ */ new W()
], Oi = /* @__PURE__ */ new W(), es = /* @__PURE__ */ new yn(), rr = /* @__PURE__ */ new W(), nr = /* @__PURE__ */ new W(), ar = /* @__PURE__ */ new W(), yi = /* @__PURE__ */ new W(), xi = /* @__PURE__ */ new W(), zi = /* @__PURE__ */ new W(), Ur = /* @__PURE__ */ new W(), Nn = /* @__PURE__ */ new W(), Ln = /* @__PURE__ */ new W(), Ri = /* @__PURE__ */ new W();
function ts(i, e, t, r, n) {
  for (let a = 0, o = i.length - 3; a <= o; a += 3) {
    Ri.fromArray(i, a);
    const s = n.x * Math.abs(Ri.x) + n.y * Math.abs(Ri.y) + n.z * Math.abs(Ri.z), c = e.dot(Ri), l = t.dot(Ri), u = r.dot(Ri);
    if (Math.max(-Math.max(c, l, u), Math.min(c, l, u)) > s)
      return !1;
  }
  return !0;
}
const v2 = /* @__PURE__ */ new yn(), Dc = /* @__PURE__ */ new W(), Pn = /* @__PURE__ */ new W(), is = /* @__PURE__ */ new W();
class Ta {
  constructor(e = new W(), t = -1) {
    this.center = e, this.radius = t;
  }
  set(e, t) {
    return this.center.copy(e), this.radius = t, this;
  }
  setFromPoints(e, t) {
    const r = this.center;
    t !== void 0 ? r.copy(t) : v2.setFromPoints(e).getCenter(r);
    let n = 0;
    for (let a = 0, o = e.length; a < o; a++)
      n = Math.max(n, r.distanceToSquared(e[a]));
    return this.radius = Math.sqrt(n), this;
  }
  copy(e) {
    return this.center.copy(e.center), this.radius = e.radius, this;
  }
  isEmpty() {
    return this.radius < 0;
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), this.radius = -1, this;
  }
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius;
  }
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius;
  }
  intersectsSphere(e) {
    const t = this.radius + e.radius;
    return e.center.distanceToSquared(this.center) <= t * t;
  }
  intersectsBox(e) {
    return e.intersectsSphere(this);
  }
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius;
  }
  clampPoint(e, t) {
    const r = this.center.distanceToSquared(e);
    return t.copy(e), r > this.radius * this.radius && (t.sub(this.center).normalize(), t.multiplyScalar(this.radius).add(this.center)), t;
  }
  getBoundingBox(e) {
    return this.isEmpty() ? (e.makeEmpty(), e) : (e.set(this.center, this.center), e.expandByScalar(this.radius), e);
  }
  applyMatrix4(e) {
    return this.center.applyMatrix4(e), this.radius = this.radius * e.getMaxScaleOnAxis(), this;
  }
  translate(e) {
    return this.center.add(e), this;
  }
  expandByPoint(e) {
    is.subVectors(e, this.center);
    const t = is.lengthSq();
    if (t > this.radius * this.radius) {
      const r = Math.sqrt(t), n = (r - this.radius) * 0.5;
      this.center.add(is.multiplyScalar(n / r)), this.radius += n;
    }
    return this;
  }
  union(e) {
    return this.center.equals(e.center) === !0 ? Pn.set(0, 0, 1).multiplyScalar(e.radius) : Pn.subVectors(e.center, this.center).normalize().multiplyScalar(e.radius), this.expandByPoint(Dc.copy(e.center).add(Pn)), this.expandByPoint(Dc.copy(e.center).sub(Pn)), this;
  }
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const si = /* @__PURE__ */ new W(), rs = /* @__PURE__ */ new W(), jn = /* @__PURE__ */ new W(), Ii = /* @__PURE__ */ new W(), ns = /* @__PURE__ */ new W(), Bn = /* @__PURE__ */ new W(), as = /* @__PURE__ */ new W();
class Sd {
  constructor(e = new W(), t = new W(0, 0, -1)) {
    this.origin = e, this.direction = t;
  }
  set(e, t) {
    return this.origin.copy(e), this.direction.copy(t), this;
  }
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this;
  }
  at(e, t) {
    return t.copy(this.direction).multiplyScalar(e).add(this.origin);
  }
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this;
  }
  recast(e) {
    return this.origin.copy(this.at(e, si)), this;
  }
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin);
    const r = t.dot(this.direction);
    return r < 0 ? t.copy(this.origin) : t.copy(this.direction).multiplyScalar(r).add(this.origin);
  }
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e));
  }
  distanceSqToPoint(e) {
    const t = si.subVectors(e, this.origin).dot(this.direction);
    return t < 0 ? this.origin.distanceToSquared(e) : (si.copy(this.direction).multiplyScalar(t).add(this.origin), si.distanceToSquared(e));
  }
  distanceSqToSegment(e, t, r, n) {
    rs.copy(e).add(t).multiplyScalar(0.5), jn.copy(t).sub(e).normalize(), Ii.copy(this.origin).sub(rs);
    const a = e.distanceTo(t) * 0.5, o = -this.direction.dot(jn), s = Ii.dot(this.direction), c = -Ii.dot(jn), l = Ii.lengthSq(), u = Math.abs(1 - o * o);
    let h, d, v, M;
    if (u > 0)
      if (h = o * c - s, d = o * s - c, M = a * u, h >= 0)
        if (d >= -M)
          if (d <= M) {
            const m = 1 / u;
            h *= m, d *= m, v = h * (h + o * d + 2 * s) + d * (o * h + d + 2 * c) + l;
          } else
            d = a, h = Math.max(0, -(o * d + s)), v = -h * h + d * (d + 2 * c) + l;
        else
          d = -a, h = Math.max(0, -(o * d + s)), v = -h * h + d * (d + 2 * c) + l;
      else
        d <= -M ? (h = Math.max(0, -(-o * a + s)), d = h > 0 ? -a : Math.min(Math.max(-a, -c), a), v = -h * h + d * (d + 2 * c) + l) : d <= M ? (h = 0, d = Math.min(Math.max(-a, -c), a), v = d * (d + 2 * c) + l) : (h = Math.max(0, -(o * a + s)), d = h > 0 ? a : Math.min(Math.max(-a, -c), a), v = -h * h + d * (d + 2 * c) + l);
    else
      d = o > 0 ? -a : a, h = Math.max(0, -(o * d + s)), v = -h * h + d * (d + 2 * c) + l;
    return r && r.copy(this.direction).multiplyScalar(h).add(this.origin), n && n.copy(jn).multiplyScalar(d).add(rs), v;
  }
  intersectSphere(e, t) {
    si.subVectors(e.center, this.origin);
    const r = si.dot(this.direction), n = si.dot(si) - r * r, a = e.radius * e.radius;
    if (n > a)
      return null;
    const o = Math.sqrt(a - n), s = r - o, c = r + o;
    return s < 0 && c < 0 ? null : s < 0 ? this.at(c, t) : this.at(s, t);
  }
  intersectsSphere(e) {
    return this.distanceSqToPoint(e.center) <= e.radius * e.radius;
  }
  distanceToPlane(e) {
    const t = e.normal.dot(this.direction);
    if (t === 0)
      return e.distanceToPoint(this.origin) === 0 ? 0 : null;
    const r = -(this.origin.dot(e.normal) + e.constant) / t;
    return r >= 0 ? r : null;
  }
  intersectPlane(e, t) {
    const r = this.distanceToPlane(e);
    return r === null ? null : this.at(r, t);
  }
  intersectsPlane(e) {
    const t = e.distanceToPoint(this.origin);
    return t === 0 || e.normal.dot(this.direction) * t < 0;
  }
  intersectBox(e, t) {
    let r, n, a, o, s, c;
    const l = 1 / this.direction.x, u = 1 / this.direction.y, h = 1 / this.direction.z, d = this.origin;
    return l >= 0 ? (r = (e.min.x - d.x) * l, n = (e.max.x - d.x) * l) : (r = (e.max.x - d.x) * l, n = (e.min.x - d.x) * l), u >= 0 ? (a = (e.min.y - d.y) * u, o = (e.max.y - d.y) * u) : (a = (e.max.y - d.y) * u, o = (e.min.y - d.y) * u), r > o || a > n || ((a > r || r !== r) && (r = a), (o < n || n !== n) && (n = o), h >= 0 ? (s = (e.min.z - d.z) * h, c = (e.max.z - d.z) * h) : (s = (e.max.z - d.z) * h, c = (e.min.z - d.z) * h), r > c || s > n) || ((s > r || r !== r) && (r = s), (c < n || n !== n) && (n = c), n < 0) ? null : this.at(r >= 0 ? r : n, t);
  }
  intersectsBox(e) {
    return this.intersectBox(e, si) !== null;
  }
  intersectTriangle(e, t, r, n, a) {
    ns.subVectors(t, e), Bn.subVectors(r, e), as.crossVectors(ns, Bn);
    let o = this.direction.dot(as), s;
    if (o > 0) {
      if (n)
        return null;
      s = 1;
    } else if (o < 0)
      s = -1, o = -o;
    else
      return null;
    Ii.subVectors(this.origin, e);
    const c = s * this.direction.dot(Bn.crossVectors(Ii, Bn));
    if (c < 0)
      return null;
    const l = s * this.direction.dot(ns.cross(Ii));
    if (l < 0 || c + l > o)
      return null;
    const u = -s * Ii.dot(as);
    return u < 0 ? null : this.at(u / o, a);
  }
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this;
  }
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction);
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class tt {
  constructor() {
    this.isMatrix4 = !0, this.elements = [
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ], arguments.length > 0 && console.error("THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.");
  }
  set(e, t, r, n, a, o, s, c, l, u, h, d, v, M, m, g) {
    const I = this.elements;
    return I[0] = e, I[4] = t, I[8] = r, I[12] = n, I[1] = a, I[5] = o, I[9] = s, I[13] = c, I[2] = l, I[6] = u, I[10] = h, I[14] = d, I[3] = v, I[7] = M, I[11] = m, I[15] = g, this;
  }
  identity() {
    return this.set(
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  clone() {
    return new tt().fromArray(this.elements);
  }
  copy(e) {
    const t = this.elements, r = e.elements;
    return t[0] = r[0], t[1] = r[1], t[2] = r[2], t[3] = r[3], t[4] = r[4], t[5] = r[5], t[6] = r[6], t[7] = r[7], t[8] = r[8], t[9] = r[9], t[10] = r[10], t[11] = r[11], t[12] = r[12], t[13] = r[13], t[14] = r[14], t[15] = r[15], this;
  }
  copyPosition(e) {
    const t = this.elements, r = e.elements;
    return t[12] = r[12], t[13] = r[13], t[14] = r[14], this;
  }
  setFromMatrix3(e) {
    const t = e.elements;
    return this.set(
      t[0],
      t[3],
      t[6],
      0,
      t[1],
      t[4],
      t[7],
      0,
      t[2],
      t[5],
      t[8],
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractBasis(e, t, r) {
    return e.setFromMatrixColumn(this, 0), t.setFromMatrixColumn(this, 1), r.setFromMatrixColumn(this, 2), this;
  }
  makeBasis(e, t, r) {
    return this.set(
      e.x,
      t.x,
      r.x,
      0,
      e.y,
      t.y,
      r.y,
      0,
      e.z,
      t.z,
      r.z,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  extractRotation(e) {
    const t = this.elements, r = e.elements, n = 1 / sr.setFromMatrixColumn(e, 0).length(), a = 1 / sr.setFromMatrixColumn(e, 1).length(), o = 1 / sr.setFromMatrixColumn(e, 2).length();
    return t[0] = r[0] * n, t[1] = r[1] * n, t[2] = r[2] * n, t[3] = 0, t[4] = r[4] * a, t[5] = r[5] * a, t[6] = r[6] * a, t[7] = 0, t[8] = r[8] * o, t[9] = r[9] * o, t[10] = r[10] * o, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  makeRotationFromEuler(e) {
    e && e.isEuler || console.error("THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.");
    const t = this.elements, r = e.x, n = e.y, a = e.z, o = Math.cos(r), s = Math.sin(r), c = Math.cos(n), l = Math.sin(n), u = Math.cos(a), h = Math.sin(a);
    if (e.order === "XYZ") {
      const d = o * u, v = o * h, M = s * u, m = s * h;
      t[0] = c * u, t[4] = -c * h, t[8] = l, t[1] = v + M * l, t[5] = d - m * l, t[9] = -s * c, t[2] = m - d * l, t[6] = M + v * l, t[10] = o * c;
    } else if (e.order === "YXZ") {
      const d = c * u, v = c * h, M = l * u, m = l * h;
      t[0] = d + m * s, t[4] = M * s - v, t[8] = o * l, t[1] = o * h, t[5] = o * u, t[9] = -s, t[2] = v * s - M, t[6] = m + d * s, t[10] = o * c;
    } else if (e.order === "ZXY") {
      const d = c * u, v = c * h, M = l * u, m = l * h;
      t[0] = d - m * s, t[4] = -o * h, t[8] = M + v * s, t[1] = v + M * s, t[5] = o * u, t[9] = m - d * s, t[2] = -o * l, t[6] = s, t[10] = o * c;
    } else if (e.order === "ZYX") {
      const d = o * u, v = o * h, M = s * u, m = s * h;
      t[0] = c * u, t[4] = M * l - v, t[8] = d * l + m, t[1] = c * h, t[5] = m * l + d, t[9] = v * l - M, t[2] = -l, t[6] = s * c, t[10] = o * c;
    } else if (e.order === "YZX") {
      const d = o * c, v = o * l, M = s * c, m = s * l;
      t[0] = c * u, t[4] = m - d * h, t[8] = M * h + v, t[1] = h, t[5] = o * u, t[9] = -s * u, t[2] = -l * u, t[6] = v * h + M, t[10] = d - m * h;
    } else if (e.order === "XZY") {
      const d = o * c, v = o * l, M = s * c, m = s * l;
      t[0] = c * u, t[4] = -h, t[8] = l * u, t[1] = d * h + m, t[5] = o * u, t[9] = v * h - M, t[2] = M * h - v, t[6] = s * u, t[10] = m * h + d;
    }
    return t[3] = 0, t[7] = 0, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, this;
  }
  makeRotationFromQuaternion(e) {
    return this.compose(M2, e, y2);
  }
  lookAt(e, t, r) {
    const n = this.elements;
    return gt.subVectors(e, t), gt.lengthSq() === 0 && (gt.z = 1), gt.normalize(), bi.crossVectors(r, gt), bi.lengthSq() === 0 && (Math.abs(r.z) === 1 ? gt.x += 1e-4 : gt.z += 1e-4, gt.normalize(), bi.crossVectors(r, gt)), bi.normalize(), On.crossVectors(gt, bi), n[0] = bi.x, n[4] = On.x, n[8] = gt.x, n[1] = bi.y, n[5] = On.y, n[9] = gt.y, n[2] = bi.z, n[6] = On.z, n[10] = gt.z, this;
  }
  multiply(e, t) {
    return t !== void 0 ? (console.warn("THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead."), this.multiplyMatrices(e, t)) : this.multiplyMatrices(this, e);
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this);
  }
  multiplyMatrices(e, t) {
    const r = e.elements, n = t.elements, a = this.elements, o = r[0], s = r[4], c = r[8], l = r[12], u = r[1], h = r[5], d = r[9], v = r[13], M = r[2], m = r[6], g = r[10], I = r[14], A = r[3], L = r[7], y = r[11], D = r[15], T = n[0], B = n[4], S = n[8], P = n[12], G = n[1], U = n[5], le = n[9], ne = n[13], z = n[2], q = n[6], V = n[10], ie = n[14], K = n[3], Y = n[7], Q = n[11], se = n[15];
    return a[0] = o * T + s * G + c * z + l * K, a[4] = o * B + s * U + c * q + l * Y, a[8] = o * S + s * le + c * V + l * Q, a[12] = o * P + s * ne + c * ie + l * se, a[1] = u * T + h * G + d * z + v * K, a[5] = u * B + h * U + d * q + v * Y, a[9] = u * S + h * le + d * V + v * Q, a[13] = u * P + h * ne + d * ie + v * se, a[2] = M * T + m * G + g * z + I * K, a[6] = M * B + m * U + g * q + I * Y, a[10] = M * S + m * le + g * V + I * Q, a[14] = M * P + m * ne + g * ie + I * se, a[3] = A * T + L * G + y * z + D * K, a[7] = A * B + L * U + y * q + D * Y, a[11] = A * S + L * le + y * V + D * Q, a[15] = A * P + L * ne + y * ie + D * se, this;
  }
  multiplyScalar(e) {
    const t = this.elements;
    return t[0] *= e, t[4] *= e, t[8] *= e, t[12] *= e, t[1] *= e, t[5] *= e, t[9] *= e, t[13] *= e, t[2] *= e, t[6] *= e, t[10] *= e, t[14] *= e, t[3] *= e, t[7] *= e, t[11] *= e, t[15] *= e, this;
  }
  determinant() {
    const e = this.elements, t = e[0], r = e[4], n = e[8], a = e[12], o = e[1], s = e[5], c = e[9], l = e[13], u = e[2], h = e[6], d = e[10], v = e[14], M = e[3], m = e[7], g = e[11], I = e[15];
    return M * (+a * c * h - n * l * h - a * s * d + r * l * d + n * s * v - r * c * v) + m * (+t * c * v - t * l * d + a * o * d - n * o * v + n * l * u - a * c * u) + g * (+t * l * h - t * s * v - a * o * h + r * o * v + a * s * u - r * l * u) + I * (-n * s * u - t * c * h + t * s * d + n * o * h - r * o * d + r * c * u);
  }
  transpose() {
    const e = this.elements;
    let t;
    return t = e[1], e[1] = e[4], e[4] = t, t = e[2], e[2] = e[8], e[8] = t, t = e[6], e[6] = e[9], e[9] = t, t = e[3], e[3] = e[12], e[12] = t, t = e[7], e[7] = e[13], e[13] = t, t = e[11], e[11] = e[14], e[14] = t, this;
  }
  setPosition(e, t, r) {
    const n = this.elements;
    return e.isVector3 ? (n[12] = e.x, n[13] = e.y, n[14] = e.z) : (n[12] = e, n[13] = t, n[14] = r), this;
  }
  invert() {
    const e = this.elements, t = e[0], r = e[1], n = e[2], a = e[3], o = e[4], s = e[5], c = e[6], l = e[7], u = e[8], h = e[9], d = e[10], v = e[11], M = e[12], m = e[13], g = e[14], I = e[15], A = h * g * l - m * d * l + m * c * v - s * g * v - h * c * I + s * d * I, L = M * d * l - u * g * l - M * c * v + o * g * v + u * c * I - o * d * I, y = u * m * l - M * h * l + M * s * v - o * m * v - u * s * I + o * h * I, D = M * h * c - u * m * c - M * s * d + o * m * d + u * s * g - o * h * g, T = t * A + r * L + n * y + a * D;
    if (T === 0)
      return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    const B = 1 / T;
    return e[0] = A * B, e[1] = (m * d * a - h * g * a - m * n * v + r * g * v + h * n * I - r * d * I) * B, e[2] = (s * g * a - m * c * a + m * n * l - r * g * l - s * n * I + r * c * I) * B, e[3] = (h * c * a - s * d * a - h * n * l + r * d * l + s * n * v - r * c * v) * B, e[4] = L * B, e[5] = (u * g * a - M * d * a + M * n * v - t * g * v - u * n * I + t * d * I) * B, e[6] = (M * c * a - o * g * a - M * n * l + t * g * l + o * n * I - t * c * I) * B, e[7] = (o * d * a - u * c * a + u * n * l - t * d * l - o * n * v + t * c * v) * B, e[8] = y * B, e[9] = (M * h * a - u * m * a - M * r * v + t * m * v + u * r * I - t * h * I) * B, e[10] = (o * m * a - M * s * a + M * r * l - t * m * l - o * r * I + t * s * I) * B, e[11] = (u * s * a - o * h * a - u * r * l + t * h * l + o * r * v - t * s * v) * B, e[12] = D * B, e[13] = (u * m * n - M * h * n + M * r * d - t * m * d - u * r * g + t * h * g) * B, e[14] = (M * s * n - o * m * n - M * r * c + t * m * c + o * r * g - t * s * g) * B, e[15] = (o * h * n - u * s * n + u * r * c - t * h * c - o * r * d + t * s * d) * B, this;
  }
  scale(e) {
    const t = this.elements, r = e.x, n = e.y, a = e.z;
    return t[0] *= r, t[4] *= n, t[8] *= a, t[1] *= r, t[5] *= n, t[9] *= a, t[2] *= r, t[6] *= n, t[10] *= a, t[3] *= r, t[7] *= n, t[11] *= a, this;
  }
  getMaxScaleOnAxis() {
    const e = this.elements, t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2], r = e[4] * e[4] + e[5] * e[5] + e[6] * e[6], n = e[8] * e[8] + e[9] * e[9] + e[10] * e[10];
    return Math.sqrt(Math.max(t, r, n));
  }
  makeTranslation(e, t, r) {
    return this.set(
      1,
      0,
      0,
      e,
      0,
      1,
      0,
      t,
      0,
      0,
      1,
      r,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationX(e) {
    const t = Math.cos(e), r = Math.sin(e);
    return this.set(
      1,
      0,
      0,
      0,
      0,
      t,
      -r,
      0,
      0,
      r,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationY(e) {
    const t = Math.cos(e), r = Math.sin(e);
    return this.set(
      t,
      0,
      r,
      0,
      0,
      1,
      0,
      0,
      -r,
      0,
      t,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationZ(e) {
    const t = Math.cos(e), r = Math.sin(e);
    return this.set(
      t,
      -r,
      0,
      0,
      r,
      t,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeRotationAxis(e, t) {
    const r = Math.cos(t), n = Math.sin(t), a = 1 - r, o = e.x, s = e.y, c = e.z, l = a * o, u = a * s;
    return this.set(
      l * o + r,
      l * s - n * c,
      l * c + n * s,
      0,
      l * s + n * c,
      u * s + r,
      u * c - n * o,
      0,
      l * c - n * s,
      u * c + n * o,
      a * c * c + r,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeScale(e, t, r) {
    return this.set(
      e,
      0,
      0,
      0,
      0,
      t,
      0,
      0,
      0,
      0,
      r,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  makeShear(e, t, r, n, a, o) {
    return this.set(
      1,
      r,
      a,
      0,
      e,
      1,
      o,
      0,
      t,
      n,
      1,
      0,
      0,
      0,
      0,
      1
    ), this;
  }
  compose(e, t, r) {
    const n = this.elements, a = t._x, o = t._y, s = t._z, c = t._w, l = a + a, u = o + o, h = s + s, d = a * l, v = a * u, M = a * h, m = o * u, g = o * h, I = s * h, A = c * l, L = c * u, y = c * h, D = r.x, T = r.y, B = r.z;
    return n[0] = (1 - (m + I)) * D, n[1] = (v + y) * D, n[2] = (M - L) * D, n[3] = 0, n[4] = (v - y) * T, n[5] = (1 - (d + I)) * T, n[6] = (g + A) * T, n[7] = 0, n[8] = (M + L) * B, n[9] = (g - A) * B, n[10] = (1 - (d + m)) * B, n[11] = 0, n[12] = e.x, n[13] = e.y, n[14] = e.z, n[15] = 1, this;
  }
  decompose(e, t, r) {
    const n = this.elements;
    let a = sr.set(n[0], n[1], n[2]).length();
    const o = sr.set(n[4], n[5], n[6]).length(), s = sr.set(n[8], n[9], n[10]).length();
    this.determinant() < 0 && (a = -a), e.x = n[12], e.y = n[13], e.z = n[14], Et.copy(this);
    const c = 1 / a, l = 1 / o, u = 1 / s;
    return Et.elements[0] *= c, Et.elements[1] *= c, Et.elements[2] *= c, Et.elements[4] *= l, Et.elements[5] *= l, Et.elements[6] *= l, Et.elements[8] *= u, Et.elements[9] *= u, Et.elements[10] *= u, t.setFromRotationMatrix(Et), r.x = a, r.y = o, r.z = s, this;
  }
  makePerspective(e, t, r, n, a, o) {
    o === void 0 && console.warn("THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.");
    const s = this.elements, c = 2 * a / (t - e), l = 2 * a / (r - n), u = (t + e) / (t - e), h = (r + n) / (r - n), d = -(o + a) / (o - a), v = -2 * o * a / (o - a);
    return s[0] = c, s[4] = 0, s[8] = u, s[12] = 0, s[1] = 0, s[5] = l, s[9] = h, s[13] = 0, s[2] = 0, s[6] = 0, s[10] = d, s[14] = v, s[3] = 0, s[7] = 0, s[11] = -1, s[15] = 0, this;
  }
  makeOrthographic(e, t, r, n, a, o) {
    const s = this.elements, c = 1 / (t - e), l = 1 / (r - n), u = 1 / (o - a), h = (t + e) * c, d = (r + n) * l, v = (o + a) * u;
    return s[0] = 2 * c, s[4] = 0, s[8] = 0, s[12] = -h, s[1] = 0, s[5] = 2 * l, s[9] = 0, s[13] = -d, s[2] = 0, s[6] = 0, s[10] = -2 * u, s[14] = -v, s[3] = 0, s[7] = 0, s[11] = 0, s[15] = 1, this;
  }
  equals(e) {
    const t = this.elements, r = e.elements;
    for (let n = 0; n < 16; n++)
      if (t[n] !== r[n])
        return !1;
    return !0;
  }
  fromArray(e, t = 0) {
    for (let r = 0; r < 16; r++)
      this.elements[r] = e[r + t];
    return this;
  }
  toArray(e = [], t = 0) {
    const r = this.elements;
    return e[t] = r[0], e[t + 1] = r[1], e[t + 2] = r[2], e[t + 3] = r[3], e[t + 4] = r[4], e[t + 5] = r[5], e[t + 6] = r[6], e[t + 7] = r[7], e[t + 8] = r[8], e[t + 9] = r[9], e[t + 10] = r[10], e[t + 11] = r[11], e[t + 12] = r[12], e[t + 13] = r[13], e[t + 14] = r[14], e[t + 15] = r[15], e;
  }
}
const sr = /* @__PURE__ */ new W(), Et = /* @__PURE__ */ new tt(), M2 = /* @__PURE__ */ new W(0, 0, 0), y2 = /* @__PURE__ */ new W(1, 1, 1), bi = /* @__PURE__ */ new W(), On = /* @__PURE__ */ new W(), gt = /* @__PURE__ */ new W(), Tc = /* @__PURE__ */ new tt(), Cc = /* @__PURE__ */ new Mn();
class xn {
  constructor(e = 0, t = 0, r = 0, n = xn.DefaultOrder) {
    this.isEuler = !0, this._x = e, this._y = t, this._z = r, this._order = n;
  }
  get x() {
    return this._x;
  }
  set x(e) {
    this._x = e, this._onChangeCallback();
  }
  get y() {
    return this._y;
  }
  set y(e) {
    this._y = e, this._onChangeCallback();
  }
  get z() {
    return this._z;
  }
  set z(e) {
    this._z = e, this._onChangeCallback();
  }
  get order() {
    return this._order;
  }
  set order(e) {
    this._order = e, this._onChangeCallback();
  }
  set(e, t, r, n = this._order) {
    return this._x = e, this._y = t, this._z = r, this._order = n, this._onChangeCallback(), this;
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order);
  }
  copy(e) {
    return this._x = e._x, this._y = e._y, this._z = e._z, this._order = e._order, this._onChangeCallback(), this;
  }
  setFromRotationMatrix(e, t = this._order, r = !0) {
    const n = e.elements, a = n[0], o = n[4], s = n[8], c = n[1], l = n[5], u = n[9], h = n[2], d = n[6], v = n[10];
    switch (t) {
      case "XYZ":
        this._y = Math.asin(ft(s, -1, 1)), Math.abs(s) < 0.9999999 ? (this._x = Math.atan2(-u, v), this._z = Math.atan2(-o, a)) : (this._x = Math.atan2(d, l), this._z = 0);
        break;
      case "YXZ":
        this._x = Math.asin(-ft(u, -1, 1)), Math.abs(u) < 0.9999999 ? (this._y = Math.atan2(s, v), this._z = Math.atan2(c, l)) : (this._y = Math.atan2(-h, a), this._z = 0);
        break;
      case "ZXY":
        this._x = Math.asin(ft(d, -1, 1)), Math.abs(d) < 0.9999999 ? (this._y = Math.atan2(-h, v), this._z = Math.atan2(-o, l)) : (this._y = 0, this._z = Math.atan2(c, a));
        break;
      case "ZYX":
        this._y = Math.asin(-ft(h, -1, 1)), Math.abs(h) < 0.9999999 ? (this._x = Math.atan2(d, v), this._z = Math.atan2(c, a)) : (this._x = 0, this._z = Math.atan2(-o, l));
        break;
      case "YZX":
        this._z = Math.asin(ft(c, -1, 1)), Math.abs(c) < 0.9999999 ? (this._x = Math.atan2(-u, l), this._y = Math.atan2(-h, a)) : (this._x = 0, this._y = Math.atan2(s, v));
        break;
      case "XZY":
        this._z = Math.asin(-ft(o, -1, 1)), Math.abs(o) < 0.9999999 ? (this._x = Math.atan2(d, l), this._y = Math.atan2(s, a)) : (this._x = Math.atan2(-u, v), this._y = 0);
        break;
      default:
        console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + t);
    }
    return this._order = t, r === !0 && this._onChangeCallback(), this;
  }
  setFromQuaternion(e, t, r) {
    return Tc.makeRotationFromQuaternion(e), this.setFromRotationMatrix(Tc, t, r);
  }
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t);
  }
  reorder(e) {
    return Cc.setFromEuler(this), this.setFromQuaternion(Cc, e);
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._order === this._order;
  }
  fromArray(e) {
    return this._x = e[0], this._y = e[1], this._z = e[2], e[3] !== void 0 && (this._order = e[3]), this._onChangeCallback(), this;
  }
  toArray(e = [], t = 0) {
    return e[t] = this._x, e[t + 1] = this._y, e[t + 2] = this._z, e[t + 3] = this._order, e;
  }
  _onChange(e) {
    return this._onChangeCallback = e, this;
  }
  _onChangeCallback() {
  }
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order;
  }
  toVector3() {
    console.error("THREE.Euler: .toVector3() has been removed. Use Vector3.setFromEuler() instead");
  }
}
xn.DefaultOrder = "XYZ";
xn.RotationOrders = ["XYZ", "YZX", "ZXY", "XZY", "YXZ", "ZYX"];
class Dd {
  constructor() {
    this.mask = 1;
  }
  set(e) {
    this.mask = (1 << e | 0) >>> 0;
  }
  enable(e) {
    this.mask |= 1 << e | 0;
  }
  enableAll() {
    this.mask = -1;
  }
  toggle(e) {
    this.mask ^= 1 << e | 0;
  }
  disable(e) {
    this.mask &= ~(1 << e | 0);
  }
  disableAll() {
    this.mask = 0;
  }
  test(e) {
    return (this.mask & e.mask) !== 0;
  }
  isEnabled(e) {
    return (this.mask & (1 << e | 0)) !== 0;
  }
}
let x2 = 0;
const Ec = /* @__PURE__ */ new W(), or = /* @__PURE__ */ new Mn(), oi = /* @__PURE__ */ new tt(), zn = /* @__PURE__ */ new W(), Hr = /* @__PURE__ */ new W(), I2 = /* @__PURE__ */ new W(), b2 = /* @__PURE__ */ new Mn(), Nc = /* @__PURE__ */ new W(1, 0, 0), Lc = /* @__PURE__ */ new W(0, 1, 0), Pc = /* @__PURE__ */ new W(0, 0, 1), w2 = { type: "added" }, jc = { type: "removed" };
class Ut extends jr {
  constructor() {
    super(), this.isObject3D = !0, Object.defineProperty(this, "id", { value: x2++ }), this.uuid = vn(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Ut.DefaultUp.clone();
    const e = new W(), t = new xn(), r = new Mn(), n = new W(1, 1, 1);
    function a() {
      r.setFromEuler(t, !1);
    }
    function o() {
      t.setFromQuaternion(r, void 0, !1);
    }
    t._onChange(a), r._onChange(o), Object.defineProperties(this, {
      position: {
        configurable: !0,
        enumerable: !0,
        value: e
      },
      rotation: {
        configurable: !0,
        enumerable: !0,
        value: t
      },
      quaternion: {
        configurable: !0,
        enumerable: !0,
        value: r
      },
      scale: {
        configurable: !0,
        enumerable: !0,
        value: n
      },
      modelViewMatrix: {
        value: new tt()
      },
      normalMatrix: {
        value: new ei()
      }
    }), this.matrix = new tt(), this.matrixWorld = new tt(), this.matrixAutoUpdate = Ut.DefaultMatrixAutoUpdate, this.matrixWorldNeedsUpdate = !1, this.layers = new Dd(), this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
  }
  onBeforeRender() {
  }
  onAfterRender() {
  }
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(e), this.matrix.decompose(this.position, this.quaternion, this.scale);
  }
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this;
  }
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t);
  }
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0);
  }
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e);
  }
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e);
  }
  rotateOnAxis(e, t) {
    return or.setFromAxisAngle(e, t), this.quaternion.multiply(or), this;
  }
  rotateOnWorldAxis(e, t) {
    return or.setFromAxisAngle(e, t), this.quaternion.premultiply(or), this;
  }
  rotateX(e) {
    return this.rotateOnAxis(Nc, e);
  }
  rotateY(e) {
    return this.rotateOnAxis(Lc, e);
  }
  rotateZ(e) {
    return this.rotateOnAxis(Pc, e);
  }
  translateOnAxis(e, t) {
    return Ec.copy(e).applyQuaternion(this.quaternion), this.position.add(Ec.multiplyScalar(t)), this;
  }
  translateX(e) {
    return this.translateOnAxis(Nc, e);
  }
  translateY(e) {
    return this.translateOnAxis(Lc, e);
  }
  translateZ(e) {
    return this.translateOnAxis(Pc, e);
  }
  localToWorld(e) {
    return e.applyMatrix4(this.matrixWorld);
  }
  worldToLocal(e) {
    return e.applyMatrix4(oi.copy(this.matrixWorld).invert());
  }
  lookAt(e, t, r) {
    e.isVector3 ? zn.copy(e) : zn.set(e, t, r);
    const n = this.parent;
    this.updateWorldMatrix(!0, !1), Hr.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? oi.lookAt(Hr, zn, this.up) : oi.lookAt(zn, Hr, this.up), this.quaternion.setFromRotationMatrix(oi), n && (oi.extractRotation(n.matrixWorld), or.setFromRotationMatrix(oi), this.quaternion.premultiply(or.invert()));
  }
  add(e) {
    if (arguments.length > 1) {
      for (let t = 0; t < arguments.length; t++)
        this.add(arguments[t]);
      return this;
    }
    return e === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", e), this) : (e && e.isObject3D ? (e.parent !== null && e.parent.remove(e), e.parent = this, this.children.push(e), e.dispatchEvent(w2)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", e), this);
  }
  remove(e) {
    if (arguments.length > 1) {
      for (let r = 0; r < arguments.length; r++)
        this.remove(arguments[r]);
      return this;
    }
    const t = this.children.indexOf(e);
    return t !== -1 && (e.parent = null, this.children.splice(t, 1), e.dispatchEvent(jc)), this;
  }
  removeFromParent() {
    const e = this.parent;
    return e !== null && e.remove(this), this;
  }
  clear() {
    for (let e = 0; e < this.children.length; e++) {
      const t = this.children[e];
      t.parent = null, t.dispatchEvent(jc);
    }
    return this.children.length = 0, this;
  }
  attach(e) {
    return this.updateWorldMatrix(!0, !1), oi.copy(this.matrixWorld).invert(), e.parent !== null && (e.parent.updateWorldMatrix(!0, !1), oi.multiply(e.parent.matrixWorld)), e.applyMatrix4(oi), this.add(e), e.updateWorldMatrix(!1, !0), this;
  }
  getObjectById(e) {
    return this.getObjectByProperty("id", e);
  }
  getObjectByName(e) {
    return this.getObjectByProperty("name", e);
  }
  getObjectByProperty(e, t) {
    if (this[e] === t)
      return this;
    for (let r = 0, n = this.children.length; r < n; r++) {
      const a = this.children[r].getObjectByProperty(e, t);
      if (a !== void 0)
        return a;
    }
  }
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld);
  }
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Hr, e, I2), e;
  }
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(Hr, b2, e), e;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(t[8], t[9], t[10]).normalize();
  }
  raycast() {
  }
  traverse(e) {
    e(this);
    const t = this.children;
    for (let r = 0, n = t.length; r < n; r++)
      t[r].traverse(e);
  }
  traverseVisible(e) {
    if (this.visible === !1)
      return;
    e(this);
    const t = this.children;
    for (let r = 0, n = t.length; r < n; r++)
      t[r].traverseVisible(e);
  }
  traverseAncestors(e) {
    const t = this.parent;
    t !== null && (e(t), t.traverseAncestors(e));
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
  }
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || e) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, e = !0);
    const t = this.children;
    for (let r = 0, n = t.length; r < n; r++)
      t[r].updateMatrixWorld(e);
  }
  updateWorldMatrix(e, t) {
    const r = this.parent;
    if (e === !0 && r !== null && r.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), t === !0) {
      const n = this.children;
      for (let a = 0, o = n.length; a < o; a++)
        n[a].updateWorldMatrix(!1, !0);
    }
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string", r = {};
    t && (e = {
      geometries: {},
      materials: {},
      textures: {},
      images: {},
      shapes: {},
      skeletons: {},
      animations: {},
      nodes: {}
    }, r.metadata = {
      version: 4.5,
      type: "Object",
      generator: "Object3D.toJSON"
    });
    const n = {};
    n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.castShadow === !0 && (n.castShadow = !0), this.receiveShadow === !0 && (n.receiveShadow = !0), this.visible === !1 && (n.visible = !1), this.frustumCulled === !1 && (n.frustumCulled = !1), this.renderOrder !== 0 && (n.renderOrder = this.renderOrder), JSON.stringify(this.userData) !== "{}" && (n.userData = this.userData), n.layers = this.layers.mask, n.matrix = this.matrix.toArray(), this.matrixAutoUpdate === !1 && (n.matrixAutoUpdate = !1), this.isInstancedMesh && (n.type = "InstancedMesh", n.count = this.count, n.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (n.instanceColor = this.instanceColor.toJSON()));
    function a(s, c) {
      return s[c.uuid] === void 0 && (s[c.uuid] = c.toJSON(e)), c.uuid;
    }
    if (this.isScene)
      this.background && (this.background.isColor ? n.background = this.background.toJSON() : this.background.isTexture && (n.background = this.background.toJSON(e).uuid)), this.environment && this.environment.isTexture && (n.environment = this.environment.toJSON(e).uuid);
    else if (this.isMesh || this.isLine || this.isPoints) {
      n.geometry = a(e.geometries, this.geometry);
      const s = this.geometry.parameters;
      if (s !== void 0 && s.shapes !== void 0) {
        const c = s.shapes;
        if (Array.isArray(c))
          for (let l = 0, u = c.length; l < u; l++) {
            const h = c[l];
            a(e.shapes, h);
          }
        else
          a(e.shapes, c);
      }
    }
    if (this.isSkinnedMesh && (n.bindMode = this.bindMode, n.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (a(e.skeletons, this.skeleton), n.skeleton = this.skeleton.uuid)), this.material !== void 0)
      if (Array.isArray(this.material)) {
        const s = [];
        for (let c = 0, l = this.material.length; c < l; c++)
          s.push(a(e.materials, this.material[c]));
        n.material = s;
      } else
        n.material = a(e.materials, this.material);
    if (this.children.length > 0) {
      n.children = [];
      for (let s = 0; s < this.children.length; s++)
        n.children.push(this.children[s].toJSON(e).object);
    }
    if (this.animations.length > 0) {
      n.animations = [];
      for (let s = 0; s < this.animations.length; s++) {
        const c = this.animations[s];
        n.animations.push(a(e.animations, c));
      }
    }
    if (t) {
      const s = o(e.geometries), c = o(e.materials), l = o(e.textures), u = o(e.images), h = o(e.shapes), d = o(e.skeletons), v = o(e.animations), M = o(e.nodes);
      s.length > 0 && (r.geometries = s), c.length > 0 && (r.materials = c), l.length > 0 && (r.textures = l), u.length > 0 && (r.images = u), h.length > 0 && (r.shapes = h), d.length > 0 && (r.skeletons = d), v.length > 0 && (r.animations = v), M.length > 0 && (r.nodes = M);
    }
    return r.object = n, r;
    function o(s) {
      const c = [];
      for (const l in s) {
        const u = s[l];
        delete u.metadata, c.push(u);
      }
      return c;
    }
  }
  clone(e) {
    return new this.constructor().copy(this, e);
  }
  copy(e, t = !0) {
    if (this.name = e.name, this.up.copy(e.up), this.position.copy(e.position), this.rotation.order = e.rotation.order, this.quaternion.copy(e.quaternion), this.scale.copy(e.scale), this.matrix.copy(e.matrix), this.matrixWorld.copy(e.matrixWorld), this.matrixAutoUpdate = e.matrixAutoUpdate, this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate, this.layers.mask = e.layers.mask, this.visible = e.visible, this.castShadow = e.castShadow, this.receiveShadow = e.receiveShadow, this.frustumCulled = e.frustumCulled, this.renderOrder = e.renderOrder, this.userData = JSON.parse(JSON.stringify(e.userData)), t === !0)
      for (let r = 0; r < e.children.length; r++) {
        const n = e.children[r];
        this.add(n.clone());
      }
    return this;
  }
}
Ut.DefaultUp = new W(0, 1, 0);
Ut.DefaultMatrixAutoUpdate = !0;
const Nt = /* @__PURE__ */ new W(), li = /* @__PURE__ */ new W(), ss = /* @__PURE__ */ new W(), ci = /* @__PURE__ */ new W(), lr = /* @__PURE__ */ new W(), cr = /* @__PURE__ */ new W(), Bc = /* @__PURE__ */ new W(), os = /* @__PURE__ */ new W(), ls = /* @__PURE__ */ new W(), cs = /* @__PURE__ */ new W();
class qt {
  constructor(e = new W(), t = new W(), r = new W()) {
    this.a = e, this.b = t, this.c = r;
  }
  static getNormal(e, t, r, n) {
    n.subVectors(r, t), Nt.subVectors(e, t), n.cross(Nt);
    const a = n.lengthSq();
    return a > 0 ? n.multiplyScalar(1 / Math.sqrt(a)) : n.set(0, 0, 0);
  }
  static getBarycoord(e, t, r, n, a) {
    Nt.subVectors(n, t), li.subVectors(r, t), ss.subVectors(e, t);
    const o = Nt.dot(Nt), s = Nt.dot(li), c = Nt.dot(ss), l = li.dot(li), u = li.dot(ss), h = o * l - s * s;
    if (h === 0)
      return a.set(-2, -1, -1);
    const d = 1 / h, v = (l * c - s * u) * d, M = (o * u - s * c) * d;
    return a.set(1 - v - M, M, v);
  }
  static containsPoint(e, t, r, n) {
    return this.getBarycoord(e, t, r, n, ci), ci.x >= 0 && ci.y >= 0 && ci.x + ci.y <= 1;
  }
  static getUV(e, t, r, n, a, o, s, c) {
    return this.getBarycoord(e, t, r, n, ci), c.set(0, 0), c.addScaledVector(a, ci.x), c.addScaledVector(o, ci.y), c.addScaledVector(s, ci.z), c;
  }
  static isFrontFacing(e, t, r, n) {
    return Nt.subVectors(r, t), li.subVectors(e, t), Nt.cross(li).dot(n) < 0;
  }
  set(e, t, r) {
    return this.a.copy(e), this.b.copy(t), this.c.copy(r), this;
  }
  setFromPointsAndIndices(e, t, r, n) {
    return this.a.copy(e[t]), this.b.copy(e[r]), this.c.copy(e[n]), this;
  }
  setFromAttributeAndIndices(e, t, r, n) {
    return this.a.fromBufferAttribute(e, t), this.b.fromBufferAttribute(e, r), this.c.fromBufferAttribute(e, n), this;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this;
  }
  getArea() {
    return Nt.subVectors(this.c, this.b), li.subVectors(this.a, this.b), Nt.cross(li).length() * 0.5;
  }
  getMidpoint(e) {
    return e.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
  }
  getNormal(e) {
    return qt.getNormal(this.a, this.b, this.c, e);
  }
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c);
  }
  getBarycoord(e, t) {
    return qt.getBarycoord(e, this.a, this.b, this.c, t);
  }
  getUV(e, t, r, n, a) {
    return qt.getUV(e, this.a, this.b, this.c, t, r, n, a);
  }
  containsPoint(e) {
    return qt.containsPoint(e, this.a, this.b, this.c);
  }
  isFrontFacing(e) {
    return qt.isFrontFacing(this.a, this.b, this.c, e);
  }
  intersectsBox(e) {
    return e.intersectsTriangle(this);
  }
  closestPointToPoint(e, t) {
    const r = this.a, n = this.b, a = this.c;
    let o, s;
    lr.subVectors(n, r), cr.subVectors(a, r), os.subVectors(e, r);
    const c = lr.dot(os), l = cr.dot(os);
    if (c <= 0 && l <= 0)
      return t.copy(r);
    ls.subVectors(e, n);
    const u = lr.dot(ls), h = cr.dot(ls);
    if (u >= 0 && h <= u)
      return t.copy(n);
    const d = c * h - u * l;
    if (d <= 0 && c >= 0 && u <= 0)
      return o = c / (c - u), t.copy(r).addScaledVector(lr, o);
    cs.subVectors(e, a);
    const v = lr.dot(cs), M = cr.dot(cs);
    if (M >= 0 && v <= M)
      return t.copy(a);
    const m = v * l - c * M;
    if (m <= 0 && l >= 0 && M <= 0)
      return s = l / (l - M), t.copy(r).addScaledVector(cr, s);
    const g = u * M - v * h;
    if (g <= 0 && h - u >= 0 && v - M >= 0)
      return Bc.subVectors(a, n), s = (h - u) / (h - u + (v - M)), t.copy(n).addScaledVector(Bc, s);
    const I = 1 / (g + m + d);
    return o = m * I, s = d * I, t.copy(r).addScaledVector(lr, o).addScaledVector(cr, s);
  }
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c);
  }
}
let _2 = 0;
class st extends jr {
  constructor() {
    super(), this.isMaterial = !0, Object.defineProperty(this, "id", { value: _2++ }), this.uuid = vn(), this.name = "", this.type = "Material", this.blending = Ir, this.side = cn, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = vd, this.blendDst = Md, this.blendEquation = vr, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = Os, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = p2, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Za, this.stencilZFail = Za, this.stencilZPass = Za, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
  }
  get alphaTest() {
    return this._alphaTest;
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, this._alphaTest = e;
  }
  onBuild() {
  }
  onBeforeRender() {
  }
  onBeforeCompile() {
  }
  customProgramCacheKey() {
    return this.onBeforeCompile.toString();
  }
  setValues(e) {
    if (e !== void 0)
      for (const t in e) {
        const r = e[t];
        if (r === void 0) {
          console.warn("THREE.Material: '" + t + "' parameter is undefined.");
          continue;
        }
        if (t === "shading") {
          console.warn("THREE." + this.type + ": .shading has been removed. Use the boolean .flatShading instead."), this.flatShading = r === I1;
          continue;
        }
        const n = this[t];
        if (n === void 0) {
          console.warn("THREE." + this.type + ": '" + t + "' is not a property of this material.");
          continue;
        }
        n && n.isColor ? n.set(r) : n && n.isVector3 && r && r.isVector3 ? n.copy(r) : this[t] = r;
      }
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string";
    t && (e = {
      textures: {},
      images: {}
    });
    const r = {
      metadata: {
        version: 4.5,
        type: "Material",
        generator: "Material.toJSON"
      }
    };
    r.uuid = this.uuid, r.type = this.type, this.name !== "" && (r.name = this.name), this.color && this.color.isColor && (r.color = this.color.getHex()), this.roughness !== void 0 && (r.roughness = this.roughness), this.metalness !== void 0 && (r.metalness = this.metalness), this.sheen !== void 0 && (r.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (r.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (r.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (r.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (r.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (r.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (r.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (r.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (r.shininess = this.shininess), this.clearcoat !== void 0 && (r.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (r.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (r.clearcoatMap = this.clearcoatMap.toJSON(e).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (r.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (r.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid, r.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (r.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (r.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (r.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (r.iridescenceMap = this.iridescenceMap.toJSON(e).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (r.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid), this.map && this.map.isTexture && (r.map = this.map.toJSON(e).uuid), this.matcap && this.matcap.isTexture && (r.matcap = this.matcap.toJSON(e).uuid), this.alphaMap && this.alphaMap.isTexture && (r.alphaMap = this.alphaMap.toJSON(e).uuid), this.lightMap && this.lightMap.isTexture && (r.lightMap = this.lightMap.toJSON(e).uuid, r.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (r.aoMap = this.aoMap.toJSON(e).uuid, r.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (r.bumpMap = this.bumpMap.toJSON(e).uuid, r.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (r.normalMap = this.normalMap.toJSON(e).uuid, r.normalMapType = this.normalMapType, r.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (r.displacementMap = this.displacementMap.toJSON(e).uuid, r.displacementScale = this.displacementScale, r.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (r.roughnessMap = this.roughnessMap.toJSON(e).uuid), this.metalnessMap && this.metalnessMap.isTexture && (r.metalnessMap = this.metalnessMap.toJSON(e).uuid), this.emissiveMap && this.emissiveMap.isTexture && (r.emissiveMap = this.emissiveMap.toJSON(e).uuid), this.specularMap && this.specularMap.isTexture && (r.specularMap = this.specularMap.toJSON(e).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (r.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid), this.specularColorMap && this.specularColorMap.isTexture && (r.specularColorMap = this.specularColorMap.toJSON(e).uuid), this.envMap && this.envMap.isTexture && (r.envMap = this.envMap.toJSON(e).uuid, this.combine !== void 0 && (r.combine = this.combine)), this.envMapIntensity !== void 0 && (r.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (r.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (r.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (r.gradientMap = this.gradientMap.toJSON(e).uuid), this.transmission !== void 0 && (r.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (r.transmissionMap = this.transmissionMap.toJSON(e).uuid), this.thickness !== void 0 && (r.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (r.thicknessMap = this.thicknessMap.toJSON(e).uuid), this.attenuationDistance !== void 0 && (r.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (r.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (r.size = this.size), this.shadowSide !== null && (r.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (r.sizeAttenuation = this.sizeAttenuation), this.blending !== Ir && (r.blending = this.blending), this.side !== cn && (r.side = this.side), this.vertexColors && (r.vertexColors = !0), this.opacity < 1 && (r.opacity = this.opacity), this.transparent === !0 && (r.transparent = this.transparent), r.depthFunc = this.depthFunc, r.depthTest = this.depthTest, r.depthWrite = this.depthWrite, r.colorWrite = this.colorWrite, r.stencilWrite = this.stencilWrite, r.stencilWriteMask = this.stencilWriteMask, r.stencilFunc = this.stencilFunc, r.stencilRef = this.stencilRef, r.stencilFuncMask = this.stencilFuncMask, r.stencilFail = this.stencilFail, r.stencilZFail = this.stencilZFail, r.stencilZPass = this.stencilZPass, this.rotation !== void 0 && this.rotation !== 0 && (r.rotation = this.rotation), this.polygonOffset === !0 && (r.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (r.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (r.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (r.linewidth = this.linewidth), this.dashSize !== void 0 && (r.dashSize = this.dashSize), this.gapSize !== void 0 && (r.gapSize = this.gapSize), this.scale !== void 0 && (r.scale = this.scale), this.dithering === !0 && (r.dithering = !0), this.alphaTest > 0 && (r.alphaTest = this.alphaTest), this.alphaToCoverage === !0 && (r.alphaToCoverage = this.alphaToCoverage), this.premultipliedAlpha === !0 && (r.premultipliedAlpha = this.premultipliedAlpha), this.wireframe === !0 && (r.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (r.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (r.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (r.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (r.flatShading = this.flatShading), this.visible === !1 && (r.visible = !1), this.toneMapped === !1 && (r.toneMapped = !1), this.fog === !1 && (r.fog = !1), JSON.stringify(this.userData) !== "{}" && (r.userData = this.userData);
    function n(a) {
      const o = [];
      for (const s in a) {
        const c = a[s];
        delete c.metadata, o.push(c);
      }
      return o;
    }
    if (t) {
      const a = n(e.textures), o = n(e.images);
      a.length > 0 && (r.textures = a), o.length > 0 && (r.images = o);
    }
    return r;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.name = e.name, this.blending = e.blending, this.side = e.side, this.vertexColors = e.vertexColors, this.opacity = e.opacity, this.transparent = e.transparent, this.blendSrc = e.blendSrc, this.blendDst = e.blendDst, this.blendEquation = e.blendEquation, this.blendSrcAlpha = e.blendSrcAlpha, this.blendDstAlpha = e.blendDstAlpha, this.blendEquationAlpha = e.blendEquationAlpha, this.depthFunc = e.depthFunc, this.depthTest = e.depthTest, this.depthWrite = e.depthWrite, this.stencilWriteMask = e.stencilWriteMask, this.stencilFunc = e.stencilFunc, this.stencilRef = e.stencilRef, this.stencilFuncMask = e.stencilFuncMask, this.stencilFail = e.stencilFail, this.stencilZFail = e.stencilZFail, this.stencilZPass = e.stencilZPass, this.stencilWrite = e.stencilWrite;
    const t = e.clippingPlanes;
    let r = null;
    if (t !== null) {
      const n = t.length;
      r = new Array(n);
      for (let a = 0; a !== n; ++a)
        r[a] = t[a].clone();
    }
    return this.clippingPlanes = r, this.clipIntersection = e.clipIntersection, this.clipShadows = e.clipShadows, this.shadowSide = e.shadowSide, this.colorWrite = e.colorWrite, this.precision = e.precision, this.polygonOffset = e.polygonOffset, this.polygonOffsetFactor = e.polygonOffsetFactor, this.polygonOffsetUnits = e.polygonOffsetUnits, this.dithering = e.dithering, this.alphaTest = e.alphaTest, this.alphaToCoverage = e.alphaToCoverage, this.premultipliedAlpha = e.premultipliedAlpha, this.visible = e.visible, this.toneMapped = e.toneMapped, this.userData = JSON.parse(JSON.stringify(e.userData)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  get vertexTangents() {
    return console.warn("THREE." + this.type + ": .vertexTangents has been removed."), !1;
  }
  set vertexTangents(e) {
    console.warn("THREE." + this.type + ": .vertexTangents has been removed.");
  }
}
st.fromType = function() {
  return null;
};
class Ca extends st {
  constructor(e) {
    super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Ce(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Aa, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
const $e = /* @__PURE__ */ new W(), Rn = /* @__PURE__ */ new Re();
class At {
  constructor(e, t, r) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
    this.isBufferAttribute = !0, this.name = "", this.array = e, this.itemSize = t, this.count = e !== void 0 ? e.length / t : 0, this.normalized = r === !0, this.usage = bc, this.updateRange = { offset: 0, count: -1 }, this.version = 0;
  }
  onUploadCallback() {
  }
  set needsUpdate(e) {
    e === !0 && this.version++;
  }
  setUsage(e) {
    return this.usage = e, this;
  }
  copy(e) {
    return this.name = e.name, this.array = new e.array.constructor(e.array), this.itemSize = e.itemSize, this.count = e.count, this.normalized = e.normalized, this.usage = e.usage, this;
  }
  copyAt(e, t, r) {
    e *= this.itemSize, r *= t.itemSize;
    for (let n = 0, a = this.itemSize; n < a; n++)
      this.array[e + n] = t.array[r + n];
    return this;
  }
  copyArray(e) {
    return this.array.set(e), this;
  }
  copyColorsArray(e) {
    const t = this.array;
    let r = 0;
    for (let n = 0, a = e.length; n < a; n++) {
      let o = e[n];
      o === void 0 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", n), o = new Ce()), t[r++] = o.r, t[r++] = o.g, t[r++] = o.b;
    }
    return this;
  }
  copyVector2sArray(e) {
    const t = this.array;
    let r = 0;
    for (let n = 0, a = e.length; n < a; n++) {
      let o = e[n];
      o === void 0 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", n), o = new Re()), t[r++] = o.x, t[r++] = o.y;
    }
    return this;
  }
  copyVector3sArray(e) {
    const t = this.array;
    let r = 0;
    for (let n = 0, a = e.length; n < a; n++) {
      let o = e[n];
      o === void 0 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", n), o = new W()), t[r++] = o.x, t[r++] = o.y, t[r++] = o.z;
    }
    return this;
  }
  copyVector4sArray(e) {
    const t = this.array;
    let r = 0;
    for (let n = 0, a = e.length; n < a; n++) {
      let o = e[n];
      o === void 0 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", n), o = new et()), t[r++] = o.x, t[r++] = o.y, t[r++] = o.z, t[r++] = o.w;
    }
    return this;
  }
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let t = 0, r = this.count; t < r; t++)
        Rn.fromBufferAttribute(this, t), Rn.applyMatrix3(e), this.setXY(t, Rn.x, Rn.y);
    else if (this.itemSize === 3)
      for (let t = 0, r = this.count; t < r; t++)
        $e.fromBufferAttribute(this, t), $e.applyMatrix3(e), this.setXYZ(t, $e.x, $e.y, $e.z);
    return this;
  }
  applyMatrix4(e) {
    for (let t = 0, r = this.count; t < r; t++)
      $e.fromBufferAttribute(this, t), $e.applyMatrix4(e), this.setXYZ(t, $e.x, $e.y, $e.z);
    return this;
  }
  applyNormalMatrix(e) {
    for (let t = 0, r = this.count; t < r; t++)
      $e.fromBufferAttribute(this, t), $e.applyNormalMatrix(e), this.setXYZ(t, $e.x, $e.y, $e.z);
    return this;
  }
  transformDirection(e) {
    for (let t = 0, r = this.count; t < r; t++)
      $e.fromBufferAttribute(this, t), $e.transformDirection(e), this.setXYZ(t, $e.x, $e.y, $e.z);
    return this;
  }
  set(e, t = 0) {
    return this.array.set(e, t), this;
  }
  getX(e) {
    return this.array[e * this.itemSize];
  }
  setX(e, t) {
    return this.array[e * this.itemSize] = t, this;
  }
  getY(e) {
    return this.array[e * this.itemSize + 1];
  }
  setY(e, t) {
    return this.array[e * this.itemSize + 1] = t, this;
  }
  getZ(e) {
    return this.array[e * this.itemSize + 2];
  }
  setZ(e, t) {
    return this.array[e * this.itemSize + 2] = t, this;
  }
  getW(e) {
    return this.array[e * this.itemSize + 3];
  }
  setW(e, t) {
    return this.array[e * this.itemSize + 3] = t, this;
  }
  setXY(e, t, r) {
    return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = r, this;
  }
  setXYZ(e, t, r, n) {
    return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = r, this.array[e + 2] = n, this;
  }
  setXYZW(e, t, r, n, a) {
    return e *= this.itemSize, this.array[e + 0] = t, this.array[e + 1] = r, this.array[e + 2] = n, this.array[e + 3] = a, this;
  }
  onUpload(e) {
    return this.onUploadCallback = e, this;
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this);
  }
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.prototype.slice.call(this.array),
      normalized: this.normalized
    };
    return this.name !== "" && (e.name = this.name), this.usage !== bc && (e.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (e.updateRange = this.updateRange), e;
  }
}
class Td extends At {
  constructor(e, t, r) {
    super(new Uint16Array(e), t, r);
  }
}
class Cd extends At {
  constructor(e, t, r) {
    super(new Uint32Array(e), t, r);
  }
}
class Ei extends At {
  constructor(e, t, r) {
    super(new Float32Array(e), t, r);
  }
}
let A2 = 0;
const It = /* @__PURE__ */ new tt(), us = /* @__PURE__ */ new Ut(), ur = /* @__PURE__ */ new W(), vt = /* @__PURE__ */ new yn(), Fr = /* @__PURE__ */ new yn(), nt = /* @__PURE__ */ new W();
class ni extends jr {
  constructor() {
    super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", { value: A2++ }), this.uuid = vn(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = { start: 0, count: 1 / 0 }, this.userData = {};
  }
  getIndex() {
    return this.index;
  }
  setIndex(e) {
    return Array.isArray(e) ? this.index = new (Id(e) ? Cd : Td)(e, 1) : this.index = e, this;
  }
  getAttribute(e) {
    return this.attributes[e];
  }
  setAttribute(e, t) {
    return this.attributes[e] = t, this;
  }
  deleteAttribute(e) {
    return delete this.attributes[e], this;
  }
  hasAttribute(e) {
    return this.attributes[e] !== void 0;
  }
  addGroup(e, t, r = 0) {
    this.groups.push({
      start: e,
      count: t,
      materialIndex: r
    });
  }
  clearGroups() {
    this.groups = [];
  }
  setDrawRange(e, t) {
    this.drawRange.start = e, this.drawRange.count = t;
  }
  applyMatrix4(e) {
    const t = this.attributes.position;
    t !== void 0 && (t.applyMatrix4(e), t.needsUpdate = !0);
    const r = this.attributes.normal;
    if (r !== void 0) {
      const a = new ei().getNormalMatrix(e);
      r.applyNormalMatrix(a), r.needsUpdate = !0;
    }
    const n = this.attributes.tangent;
    return n !== void 0 && (n.transformDirection(e), n.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
  }
  applyQuaternion(e) {
    return It.makeRotationFromQuaternion(e), this.applyMatrix4(It), this;
  }
  rotateX(e) {
    return It.makeRotationX(e), this.applyMatrix4(It), this;
  }
  rotateY(e) {
    return It.makeRotationY(e), this.applyMatrix4(It), this;
  }
  rotateZ(e) {
    return It.makeRotationZ(e), this.applyMatrix4(It), this;
  }
  translate(e, t, r) {
    return It.makeTranslation(e, t, r), this.applyMatrix4(It), this;
  }
  scale(e, t, r) {
    return It.makeScale(e, t, r), this.applyMatrix4(It), this;
  }
  lookAt(e) {
    return us.lookAt(e), us.updateMatrix(), this.applyMatrix4(us.matrix), this;
  }
  center() {
    return this.computeBoundingBox(), this.boundingBox.getCenter(ur).negate(), this.translate(ur.x, ur.y, ur.z), this;
  }
  setFromPoints(e) {
    const t = [];
    for (let r = 0, n = e.length; r < n; r++) {
      const a = e[r];
      t.push(a.x, a.y, a.z || 0);
    }
    return this.setAttribute("position", new Ei(t, 3)), this;
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new yn());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(
        new W(-1 / 0, -1 / 0, -1 / 0),
        new W(1 / 0, 1 / 0, 1 / 0)
      );
      return;
    }
    if (e !== void 0) {
      if (this.boundingBox.setFromBufferAttribute(e), t)
        for (let r = 0, n = t.length; r < n; r++) {
          const a = t[r];
          vt.setFromBufferAttribute(a), this.morphTargetsRelative ? (nt.addVectors(this.boundingBox.min, vt.min), this.boundingBox.expandByPoint(nt), nt.addVectors(this.boundingBox.max, vt.max), this.boundingBox.expandByPoint(nt)) : (this.boundingBox.expandByPoint(vt.min), this.boundingBox.expandByPoint(vt.max));
        }
    } else
      this.boundingBox.makeEmpty();
    (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new Ta());
    const e = this.attributes.position, t = this.morphAttributes.position;
    if (e && e.isGLBufferAttribute) {
      console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new W(), 1 / 0);
      return;
    }
    if (e) {
      const r = this.boundingSphere.center;
      if (vt.setFromBufferAttribute(e), t)
        for (let a = 0, o = t.length; a < o; a++) {
          const s = t[a];
          Fr.setFromBufferAttribute(s), this.morphTargetsRelative ? (nt.addVectors(vt.min, Fr.min), vt.expandByPoint(nt), nt.addVectors(vt.max, Fr.max), vt.expandByPoint(nt)) : (vt.expandByPoint(Fr.min), vt.expandByPoint(Fr.max));
        }
      vt.getCenter(r);
      let n = 0;
      for (let a = 0, o = e.count; a < o; a++)
        nt.fromBufferAttribute(e, a), n = Math.max(n, r.distanceToSquared(nt));
      if (t)
        for (let a = 0, o = t.length; a < o; a++) {
          const s = t[a], c = this.morphTargetsRelative;
          for (let l = 0, u = s.count; l < u; l++)
            nt.fromBufferAttribute(s, l), c && (ur.fromBufferAttribute(e, l), nt.add(ur)), n = Math.max(n, r.distanceToSquared(nt));
        }
      this.boundingSphere.radius = Math.sqrt(n), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
    }
  }
  computeTangents() {
    const e = this.index, t = this.attributes;
    if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
      console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
      return;
    }
    const r = e.array, n = t.position.array, a = t.normal.array, o = t.uv.array, s = n.length / 3;
    this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new At(new Float32Array(4 * s), 4));
    const c = this.getAttribute("tangent").array, l = [], u = [];
    for (let G = 0; G < s; G++)
      l[G] = new W(), u[G] = new W();
    const h = new W(), d = new W(), v = new W(), M = new Re(), m = new Re(), g = new Re(), I = new W(), A = new W();
    function L(G, U, le) {
      h.fromArray(n, G * 3), d.fromArray(n, U * 3), v.fromArray(n, le * 3), M.fromArray(o, G * 2), m.fromArray(o, U * 2), g.fromArray(o, le * 2), d.sub(h), v.sub(h), m.sub(M), g.sub(M);
      const ne = 1 / (m.x * g.y - g.x * m.y);
      !isFinite(ne) || (I.copy(d).multiplyScalar(g.y).addScaledVector(v, -m.y).multiplyScalar(ne), A.copy(v).multiplyScalar(m.x).addScaledVector(d, -g.x).multiplyScalar(ne), l[G].add(I), l[U].add(I), l[le].add(I), u[G].add(A), u[U].add(A), u[le].add(A));
    }
    let y = this.groups;
    y.length === 0 && (y = [{
      start: 0,
      count: r.length
    }]);
    for (let G = 0, U = y.length; G < U; ++G) {
      const le = y[G], ne = le.start, z = le.count;
      for (let q = ne, V = ne + z; q < V; q += 3)
        L(
          r[q + 0],
          r[q + 1],
          r[q + 2]
        );
    }
    const D = new W(), T = new W(), B = new W(), S = new W();
    function P(G) {
      B.fromArray(a, G * 3), S.copy(B);
      const U = l[G];
      D.copy(U), D.sub(B.multiplyScalar(B.dot(U))).normalize(), T.crossVectors(S, U);
      const le = T.dot(u[G]) < 0 ? -1 : 1;
      c[G * 4] = D.x, c[G * 4 + 1] = D.y, c[G * 4 + 2] = D.z, c[G * 4 + 3] = le;
    }
    for (let G = 0, U = y.length; G < U; ++G) {
      const le = y[G], ne = le.start, z = le.count;
      for (let q = ne, V = ne + z; q < V; q += 3)
        P(r[q + 0]), P(r[q + 1]), P(r[q + 2]);
    }
  }
  computeVertexNormals() {
    const e = this.index, t = this.getAttribute("position");
    if (t !== void 0) {
      let r = this.getAttribute("normal");
      if (r === void 0)
        r = new At(new Float32Array(t.count * 3), 3), this.setAttribute("normal", r);
      else
        for (let d = 0, v = r.count; d < v; d++)
          r.setXYZ(d, 0, 0, 0);
      const n = new W(), a = new W(), o = new W(), s = new W(), c = new W(), l = new W(), u = new W(), h = new W();
      if (e)
        for (let d = 0, v = e.count; d < v; d += 3) {
          const M = e.getX(d + 0), m = e.getX(d + 1), g = e.getX(d + 2);
          n.fromBufferAttribute(t, M), a.fromBufferAttribute(t, m), o.fromBufferAttribute(t, g), u.subVectors(o, a), h.subVectors(n, a), u.cross(h), s.fromBufferAttribute(r, M), c.fromBufferAttribute(r, m), l.fromBufferAttribute(r, g), s.add(u), c.add(u), l.add(u), r.setXYZ(M, s.x, s.y, s.z), r.setXYZ(m, c.x, c.y, c.z), r.setXYZ(g, l.x, l.y, l.z);
        }
      else
        for (let d = 0, v = t.count; d < v; d += 3)
          n.fromBufferAttribute(t, d + 0), a.fromBufferAttribute(t, d + 1), o.fromBufferAttribute(t, d + 2), u.subVectors(o, a), h.subVectors(n, a), u.cross(h), r.setXYZ(d + 0, u.x, u.y, u.z), r.setXYZ(d + 1, u.x, u.y, u.z), r.setXYZ(d + 2, u.x, u.y, u.z);
      this.normalizeNormals(), r.needsUpdate = !0;
    }
  }
  merge(e, t) {
    if (!(e && e.isBufferGeometry)) {
      console.error("THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.", e);
      return;
    }
    t === void 0 && (t = 0, console.warn(
      "THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge."
    ));
    const r = this.attributes;
    for (const n in r) {
      if (e.attributes[n] === void 0)
        continue;
      const a = r[n].array, o = e.attributes[n], s = o.array, c = o.itemSize * t, l = Math.min(s.length, a.length - c);
      for (let u = 0, h = c; u < l; u++, h++)
        a[h] = s[u];
    }
    return this;
  }
  normalizeNormals() {
    const e = this.attributes.normal;
    for (let t = 0, r = e.count; t < r; t++)
      nt.fromBufferAttribute(e, t), nt.normalize(), e.setXYZ(t, nt.x, nt.y, nt.z);
  }
  toNonIndexed() {
    function e(s, c) {
      const l = s.array, u = s.itemSize, h = s.normalized, d = new l.constructor(c.length * u);
      let v = 0, M = 0;
      for (let m = 0, g = c.length; m < g; m++) {
        s.isInterleavedBufferAttribute ? v = c[m] * s.data.stride + s.offset : v = c[m] * u;
        for (let I = 0; I < u; I++)
          d[M++] = l[v++];
      }
      return new At(d, u, h);
    }
    if (this.index === null)
      return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
    const t = new ni(), r = this.index.array, n = this.attributes;
    for (const s in n) {
      const c = n[s], l = e(c, r);
      t.setAttribute(s, l);
    }
    const a = this.morphAttributes;
    for (const s in a) {
      const c = [], l = a[s];
      for (let u = 0, h = l.length; u < h; u++) {
        const d = l[u], v = e(d, r);
        c.push(v);
      }
      t.morphAttributes[s] = c;
    }
    t.morphTargetsRelative = this.morphTargetsRelative;
    const o = this.groups;
    for (let s = 0, c = o.length; s < c; s++) {
      const l = o[s];
      t.addGroup(l.start, l.count, l.materialIndex);
    }
    return t;
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.5,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON"
      }
    };
    if (e.uuid = this.uuid, e.type = this.type, this.name !== "" && (e.name = this.name), Object.keys(this.userData).length > 0 && (e.userData = this.userData), this.parameters !== void 0) {
      const c = this.parameters;
      for (const l in c)
        c[l] !== void 0 && (e[l] = c[l]);
      return e;
    }
    e.data = { attributes: {} };
    const t = this.index;
    t !== null && (e.data.index = {
      type: t.array.constructor.name,
      array: Array.prototype.slice.call(t.array)
    });
    const r = this.attributes;
    for (const c in r) {
      const l = r[c];
      e.data.attributes[c] = l.toJSON(e.data);
    }
    const n = {};
    let a = !1;
    for (const c in this.morphAttributes) {
      const l = this.morphAttributes[c], u = [];
      for (let h = 0, d = l.length; h < d; h++) {
        const v = l[h];
        u.push(v.toJSON(e.data));
      }
      u.length > 0 && (n[c] = u, a = !0);
    }
    a && (e.data.morphAttributes = n, e.data.morphTargetsRelative = this.morphTargetsRelative);
    const o = this.groups;
    o.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(o)));
    const s = this.boundingSphere;
    return s !== null && (e.data.boundingSphere = {
      center: s.center.toArray(),
      radius: s.radius
    }), e;
  }
  clone() {
    return new this.constructor().copy(this);
  }
  copy(e) {
    this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
    const t = {};
    this.name = e.name;
    const r = e.index;
    r !== null && this.setIndex(r.clone(t));
    const n = e.attributes;
    for (const l in n) {
      const u = n[l];
      this.setAttribute(l, u.clone(t));
    }
    const a = e.morphAttributes;
    for (const l in a) {
      const u = [], h = a[l];
      for (let d = 0, v = h.length; d < v; d++)
        u.push(h[d].clone(t));
      this.morphAttributes[l] = u;
    }
    this.morphTargetsRelative = e.morphTargetsRelative;
    const o = e.groups;
    for (let l = 0, u = o.length; l < u; l++) {
      const h = o[l];
      this.addGroup(h.start, h.count, h.materialIndex);
    }
    const s = e.boundingBox;
    s !== null && (this.boundingBox = s.clone());
    const c = e.boundingSphere;
    return c !== null && (this.boundingSphere = c.clone()), this.drawRange.start = e.drawRange.start, this.drawRange.count = e.drawRange.count, this.userData = e.userData, e.parameters !== void 0 && (this.parameters = Object.assign({}, e.parameters)), this;
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" });
  }
}
const Oc = /* @__PURE__ */ new tt(), dr = /* @__PURE__ */ new Sd(), ds = /* @__PURE__ */ new Ta(), wi = /* @__PURE__ */ new W(), _i = /* @__PURE__ */ new W(), Ai = /* @__PURE__ */ new W(), hs = /* @__PURE__ */ new W(), ps = /* @__PURE__ */ new W(), fs = /* @__PURE__ */ new W(), kn = /* @__PURE__ */ new W(), Wn = /* @__PURE__ */ new W(), Gn = /* @__PURE__ */ new W(), Un = /* @__PURE__ */ new Re(), Hn = /* @__PURE__ */ new Re(), Fn = /* @__PURE__ */ new Re(), ms = /* @__PURE__ */ new W(), Vn = /* @__PURE__ */ new W();
class Di extends Ut {
  constructor(e = new ni(), t = new Ca()) {
    super(), this.isMesh = !0, this.type = "Mesh", this.geometry = e, this.material = t, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), e.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = e.morphTargetInfluences.slice()), e.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)), this.material = e.material, this.geometry = e.geometry, this;
  }
  updateMorphTargets() {
    const e = this.geometry.morphAttributes, t = Object.keys(e);
    if (t.length > 0) {
      const r = e[t[0]];
      if (r !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let n = 0, a = r.length; n < a; n++) {
          const o = r[n].name || String(n);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = n;
        }
      }
    }
  }
  raycast(e, t) {
    const r = this.geometry, n = this.material, a = this.matrixWorld;
    if (n === void 0 || (r.boundingSphere === null && r.computeBoundingSphere(), ds.copy(r.boundingSphere), ds.applyMatrix4(a), e.ray.intersectsSphere(ds) === !1) || (Oc.copy(a).invert(), dr.copy(e.ray).applyMatrix4(Oc), r.boundingBox !== null && dr.intersectsBox(r.boundingBox) === !1))
      return;
    let o;
    const s = r.index, c = r.attributes.position, l = r.morphAttributes.position, u = r.morphTargetsRelative, h = r.attributes.uv, d = r.attributes.uv2, v = r.groups, M = r.drawRange;
    if (s !== null)
      if (Array.isArray(n))
        for (let m = 0, g = v.length; m < g; m++) {
          const I = v[m], A = n[I.materialIndex], L = Math.max(I.start, M.start), y = Math.min(s.count, Math.min(I.start + I.count, M.start + M.count));
          for (let D = L, T = y; D < T; D += 3) {
            const B = s.getX(D), S = s.getX(D + 1), P = s.getX(D + 2);
            o = Yn(this, A, e, dr, c, l, u, h, d, B, S, P), o && (o.faceIndex = Math.floor(D / 3), o.face.materialIndex = I.materialIndex, t.push(o));
          }
        }
      else {
        const m = Math.max(0, M.start), g = Math.min(s.count, M.start + M.count);
        for (let I = m, A = g; I < A; I += 3) {
          const L = s.getX(I), y = s.getX(I + 1), D = s.getX(I + 2);
          o = Yn(this, n, e, dr, c, l, u, h, d, L, y, D), o && (o.faceIndex = Math.floor(I / 3), t.push(o));
        }
      }
    else if (c !== void 0)
      if (Array.isArray(n))
        for (let m = 0, g = v.length; m < g; m++) {
          const I = v[m], A = n[I.materialIndex], L = Math.max(I.start, M.start), y = Math.min(c.count, Math.min(I.start + I.count, M.start + M.count));
          for (let D = L, T = y; D < T; D += 3) {
            const B = D, S = D + 1, P = D + 2;
            o = Yn(this, A, e, dr, c, l, u, h, d, B, S, P), o && (o.faceIndex = Math.floor(D / 3), o.face.materialIndex = I.materialIndex, t.push(o));
          }
        }
      else {
        const m = Math.max(0, M.start), g = Math.min(c.count, M.start + M.count);
        for (let I = m, A = g; I < A; I += 3) {
          const L = I, y = I + 1, D = I + 2;
          o = Yn(this, n, e, dr, c, l, u, h, d, L, y, D), o && (o.faceIndex = Math.floor(I / 3), t.push(o));
        }
      }
  }
}
function S2(i, e, t, r, n, a, o, s) {
  let c;
  if (e.side === zt ? c = r.intersectTriangle(o, a, n, !0, s) : c = r.intersectTriangle(n, a, o, e.side !== Sr, s), c === null)
    return null;
  Vn.copy(s), Vn.applyMatrix4(i.matrixWorld);
  const l = t.ray.origin.distanceTo(Vn);
  return l < t.near || l > t.far ? null : {
    distance: l,
    point: Vn.clone(),
    object: i
  };
}
function Yn(i, e, t, r, n, a, o, s, c, l, u, h) {
  wi.fromBufferAttribute(n, l), _i.fromBufferAttribute(n, u), Ai.fromBufferAttribute(n, h);
  const d = i.morphTargetInfluences;
  if (a && d) {
    kn.set(0, 0, 0), Wn.set(0, 0, 0), Gn.set(0, 0, 0);
    for (let M = 0, m = a.length; M < m; M++) {
      const g = d[M], I = a[M];
      g !== 0 && (hs.fromBufferAttribute(I, l), ps.fromBufferAttribute(I, u), fs.fromBufferAttribute(I, h), o ? (kn.addScaledVector(hs, g), Wn.addScaledVector(ps, g), Gn.addScaledVector(fs, g)) : (kn.addScaledVector(hs.sub(wi), g), Wn.addScaledVector(ps.sub(_i), g), Gn.addScaledVector(fs.sub(Ai), g)));
    }
    wi.add(kn), _i.add(Wn), Ai.add(Gn);
  }
  i.isSkinnedMesh && (i.boneTransform(l, wi), i.boneTransform(u, _i), i.boneTransform(h, Ai));
  const v = S2(i, e, t, r, wi, _i, Ai, ms);
  if (v) {
    s && (Un.fromBufferAttribute(s, l), Hn.fromBufferAttribute(s, u), Fn.fromBufferAttribute(s, h), v.uv = qt.getUV(ms, wi, _i, Ai, Un, Hn, Fn, new Re())), c && (Un.fromBufferAttribute(c, l), Hn.fromBufferAttribute(c, u), Fn.fromBufferAttribute(c, h), v.uv2 = qt.getUV(ms, wi, _i, Ai, Un, Hn, Fn, new Re()));
    const M = {
      a: l,
      b: u,
      c: h,
      normal: new W(),
      materialIndex: 0
    };
    qt.getNormal(wi, _i, Ai, M.normal), v.face = M;
  }
  return v;
}
class In extends ni {
  constructor(e = 1, t = 1, r = 1, n = 1, a = 1, o = 1) {
    super(), this.type = "BoxGeometry", this.parameters = {
      width: e,
      height: t,
      depth: r,
      widthSegments: n,
      heightSegments: a,
      depthSegments: o
    };
    const s = this;
    n = Math.floor(n), a = Math.floor(a), o = Math.floor(o);
    const c = [], l = [], u = [], h = [];
    let d = 0, v = 0;
    M("z", "y", "x", -1, -1, r, t, e, o, a, 0), M("z", "y", "x", 1, -1, r, t, -e, o, a, 1), M("x", "z", "y", 1, 1, e, r, t, n, o, 2), M("x", "z", "y", 1, -1, e, r, -t, n, o, 3), M("x", "y", "z", 1, -1, e, t, r, n, a, 4), M("x", "y", "z", -1, -1, e, t, -r, n, a, 5), this.setIndex(c), this.setAttribute("position", new Ei(l, 3)), this.setAttribute("normal", new Ei(u, 3)), this.setAttribute("uv", new Ei(h, 2));
    function M(m, g, I, A, L, y, D, T, B, S, P) {
      const G = y / B, U = D / S, le = y / 2, ne = D / 2, z = T / 2, q = B + 1, V = S + 1;
      let ie = 0, K = 0;
      const Y = new W();
      for (let Q = 0; Q < V; Q++) {
        const se = Q * U - ne;
        for (let X = 0; X < q; X++) {
          const ue = X * G - le;
          Y[m] = ue * A, Y[g] = se * L, Y[I] = z, l.push(Y.x, Y.y, Y.z), Y[m] = 0, Y[g] = 0, Y[I] = T > 0 ? 1 : -1, u.push(Y.x, Y.y, Y.z), h.push(X / B), h.push(1 - Q / S), ie += 1;
        }
      }
      for (let Q = 0; Q < S; Q++)
        for (let se = 0; se < B; se++) {
          const X = d + se + q * Q, ue = d + se + q * (Q + 1), fe = d + (se + 1) + q * (Q + 1), ye = d + (se + 1) + q * Q;
          c.push(X, ue, ye), c.push(ue, fe, ye), K += 6;
        }
      s.addGroup(v, K, P), v += K, d += ie;
    }
  }
  static fromJSON(e) {
    return new In(e.width, e.height, e.depth, e.widthSegments, e.heightSegments, e.depthSegments);
  }
}
function Er(i) {
  const e = {};
  for (const t in i) {
    e[t] = {};
    for (const r in i[t]) {
      const n = i[t][r];
      n && (n.isColor || n.isMatrix3 || n.isMatrix4 || n.isVector2 || n.isVector3 || n.isVector4 || n.isTexture || n.isQuaternion) ? e[t][r] = n.clone() : Array.isArray(n) ? e[t][r] = n.slice() : e[t][r] = n;
    }
  }
  return e;
}
function ot(i) {
  const e = {};
  for (let t = 0; t < i.length; t++) {
    const r = Er(i[t]);
    for (const n in r)
      e[n] = r[n];
  }
  return e;
}
const D2 = { clone: Er, merge: ot };
var T2 = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, C2 = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`;
class pi extends st {
  constructor(e) {
    super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.vertexShader = T2, this.fragmentShader = C2, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.extensions = {
      derivatives: !1,
      fragDepth: !1,
      drawBuffers: !1,
      shaderTextureLOD: !1
    }, this.defaultAttributeValues = {
      color: [1, 1, 1],
      uv: [0, 0],
      uv2: [0, 0]
    }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, e !== void 0 && (e.attributes !== void 0 && console.error("THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead."), this.setValues(e));
  }
  copy(e) {
    return super.copy(e), this.fragmentShader = e.fragmentShader, this.vertexShader = e.vertexShader, this.uniforms = Er(e.uniforms), this.defines = Object.assign({}, e.defines), this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.fog = e.fog, this.lights = e.lights, this.clipping = e.clipping, this.extensions = Object.assign({}, e.extensions), this.glslVersion = e.glslVersion, this;
  }
  toJSON(e) {
    const t = super.toJSON(e);
    t.glslVersion = this.glslVersion, t.uniforms = {};
    for (const n in this.uniforms) {
      const a = this.uniforms[n].value;
      a && a.isTexture ? t.uniforms[n] = {
        type: "t",
        value: a.toJSON(e).uuid
      } : a && a.isColor ? t.uniforms[n] = {
        type: "c",
        value: a.getHex()
      } : a && a.isVector2 ? t.uniforms[n] = {
        type: "v2",
        value: a.toArray()
      } : a && a.isVector3 ? t.uniforms[n] = {
        type: "v3",
        value: a.toArray()
      } : a && a.isVector4 ? t.uniforms[n] = {
        type: "v4",
        value: a.toArray()
      } : a && a.isMatrix3 ? t.uniforms[n] = {
        type: "m3",
        value: a.toArray()
      } : a && a.isMatrix4 ? t.uniforms[n] = {
        type: "m4",
        value: a.toArray()
      } : t.uniforms[n] = {
        value: a
      };
    }
    Object.keys(this.defines).length > 0 && (t.defines = this.defines), t.vertexShader = this.vertexShader, t.fragmentShader = this.fragmentShader;
    const r = {};
    for (const n in this.extensions)
      this.extensions[n] === !0 && (r[n] = !0);
    return Object.keys(r).length > 0 && (t.extensions = r), t;
  }
}
class Ed extends Ut {
  constructor() {
    super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new tt(), this.projectionMatrix = new tt(), this.projectionMatrixInverse = new tt();
  }
  copy(e, t) {
    return super.copy(e, t), this.matrixWorldInverse.copy(e.matrixWorldInverse), this.projectionMatrix.copy(e.projectionMatrix), this.projectionMatrixInverse.copy(e.projectionMatrixInverse), this;
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1);
    const t = this.matrixWorld.elements;
    return e.set(-t[8], -t[9], -t[10]).normalize();
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  updateWorldMatrix(e, t) {
    super.updateWorldMatrix(e, t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
class Lt extends Ed {
  constructor(e = 50, t = 1, r = 0.1, n = 2e3) {
    super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = e, this.zoom = 1, this.near = r, this.far = n, this.focus = 10, this.aspect = t, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.fov = e.fov, this.zoom = e.zoom, this.near = e.near, this.far = e.far, this.focus = e.focus, this.aspect = e.aspect, this.view = e.view === null ? null : Object.assign({}, e.view), this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this;
  }
  setFocalLength(e) {
    const t = 0.5 * this.getFilmHeight() / e;
    this.fov = _c * 2 * Math.atan(t), this.updateProjectionMatrix();
  }
  getFocalLength() {
    const e = Math.tan(Qa * 0.5 * this.fov);
    return 0.5 * this.getFilmHeight() / e;
  }
  getEffectiveFOV() {
    return _c * 2 * Math.atan(
      Math.tan(Qa * 0.5 * this.fov) / this.zoom
    );
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1);
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1);
  }
  setViewOffset(e, t, r, n, a, o) {
    this.aspect = e / t, this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = r, this.view.offsetY = n, this.view.width = a, this.view.height = o, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = this.near;
    let t = e * Math.tan(Qa * 0.5 * this.fov) / this.zoom, r = 2 * t, n = this.aspect * r, a = -0.5 * n;
    const o = this.view;
    if (this.view !== null && this.view.enabled) {
      const c = o.fullWidth, l = o.fullHeight;
      a += o.offsetX * n / c, t -= o.offsetY * r / l, n *= o.width / c, r *= o.height / l;
    }
    const s = this.filmOffset;
    s !== 0 && (a += e * s / this.getFilmWidth()), this.projectionMatrix.makePerspective(a, a + n, t, t - r, e, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.fov = this.fov, t.object.zoom = this.zoom, t.object.near = this.near, t.object.far = this.far, t.object.focus = this.focus, t.object.aspect = this.aspect, this.view !== null && (t.object.view = Object.assign({}, this.view)), t.object.filmGauge = this.filmGauge, t.object.filmOffset = this.filmOffset, t;
  }
}
const hr = 90, pr = 1;
class E2 extends Ut {
  constructor(e, t, r) {
    if (super(), this.type = "CubeCamera", r.isWebGLCubeRenderTarget !== !0) {
      console.error("THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.");
      return;
    }
    this.renderTarget = r;
    const n = new Lt(hr, pr, e, t);
    n.layers = this.layers, n.up.set(0, -1, 0), n.lookAt(new W(1, 0, 0)), this.add(n);
    const a = new Lt(hr, pr, e, t);
    a.layers = this.layers, a.up.set(0, -1, 0), a.lookAt(new W(-1, 0, 0)), this.add(a);
    const o = new Lt(hr, pr, e, t);
    o.layers = this.layers, o.up.set(0, 0, 1), o.lookAt(new W(0, 1, 0)), this.add(o);
    const s = new Lt(hr, pr, e, t);
    s.layers = this.layers, s.up.set(0, 0, -1), s.lookAt(new W(0, -1, 0)), this.add(s);
    const c = new Lt(hr, pr, e, t);
    c.layers = this.layers, c.up.set(0, -1, 0), c.lookAt(new W(0, 0, 1)), this.add(c);
    const l = new Lt(hr, pr, e, t);
    l.layers = this.layers, l.up.set(0, -1, 0), l.lookAt(new W(0, 0, -1)), this.add(l);
  }
  update(e, t) {
    this.parent === null && this.updateMatrixWorld();
    const r = this.renderTarget, [n, a, o, s, c, l] = this.children, u = e.getRenderTarget(), h = e.toneMapping, d = e.xr.enabled;
    e.toneMapping = hi, e.xr.enabled = !1;
    const v = r.texture.generateMipmaps;
    r.texture.generateMipmaps = !1, e.setRenderTarget(r, 0), e.render(t, n), e.setRenderTarget(r, 1), e.render(t, a), e.setRenderTarget(r, 2), e.render(t, o), e.setRenderTarget(r, 3), e.render(t, s), e.setRenderTarget(r, 4), e.render(t, c), r.texture.generateMipmaps = v, e.setRenderTarget(r, 5), e.render(t, l), e.setRenderTarget(u), e.toneMapping = h, e.xr.enabled = d, r.texture.needsPMREMUpdate = !0;
  }
}
class Nd extends Gt {
  constructor(e, t, r, n, a, o, s, c, l, u) {
    e = e !== void 0 ? e : [], t = t !== void 0 ? t : Dr, super(e, t, r, n, a, o, s, c, l, u), this.isCubeTexture = !0, this.flipY = !1;
  }
  get images() {
    return this.image;
  }
  set images(e) {
    this.image = e;
  }
}
class N2 extends Ci {
  constructor(e, t = {}) {
    super(e, e, t), this.isWebGLCubeRenderTarget = !0;
    const r = { width: e, height: e, depth: 1 }, n = [r, r, r, r, r, r];
    this.texture = new Nd(n, t.mapping, t.wrapS, t.wrapT, t.magFilter, t.minFilter, t.format, t.type, t.anisotropy, t.encoding), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = t.generateMipmaps !== void 0 ? t.generateMipmaps : !1, this.texture.minFilter = t.minFilter !== void 0 ? t.minFilter : wt;
  }
  fromEquirectangularTexture(e, t) {
    this.texture.type = t.type, this.texture.encoding = t.encoding, this.texture.generateMipmaps = t.generateMipmaps, this.texture.minFilter = t.minFilter, this.texture.magFilter = t.magFilter;
    const r = {
      uniforms: {
        tEquirect: { value: null }
      },
      vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
      fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
    }, n = new In(5, 5, 5), a = new pi({
      name: "CubemapFromEquirect",
      uniforms: Er(r.uniforms),
      vertexShader: r.vertexShader,
      fragmentShader: r.fragmentShader,
      side: zt,
      blending: Ti
    });
    a.uniforms.tEquirect.value = t;
    const o = new Di(n, a), s = t.minFilter;
    return t.minFilter === Da && (t.minFilter = wt), new E2(1, 10, this).update(e, o), t.minFilter = s, o.geometry.dispose(), o.material.dispose(), this;
  }
  clear(e, t, r, n) {
    const a = e.getRenderTarget();
    for (let o = 0; o < 6; o++)
      e.setRenderTarget(this, o), e.clear(t, r, n);
    e.setRenderTarget(a);
  }
}
const gs = /* @__PURE__ */ new W(), L2 = /* @__PURE__ */ new W(), P2 = /* @__PURE__ */ new ei();
class Wi {
  constructor(e = new W(1, 0, 0), t = 0) {
    this.isPlane = !0, this.normal = e, this.constant = t;
  }
  set(e, t) {
    return this.normal.copy(e), this.constant = t, this;
  }
  setComponents(e, t, r, n) {
    return this.normal.set(e, t, r), this.constant = n, this;
  }
  setFromNormalAndCoplanarPoint(e, t) {
    return this.normal.copy(e), this.constant = -t.dot(this.normal), this;
  }
  setFromCoplanarPoints(e, t, r) {
    const n = gs.subVectors(r, t).cross(L2.subVectors(e, t)).normalize();
    return this.setFromNormalAndCoplanarPoint(n, e), this;
  }
  copy(e) {
    return this.normal.copy(e.normal), this.constant = e.constant, this;
  }
  normalize() {
    const e = 1 / this.normal.length();
    return this.normal.multiplyScalar(e), this.constant *= e, this;
  }
  negate() {
    return this.constant *= -1, this.normal.negate(), this;
  }
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant;
  }
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius;
  }
  projectPoint(e, t) {
    return t.copy(this.normal).multiplyScalar(-this.distanceToPoint(e)).add(e);
  }
  intersectLine(e, t) {
    const r = e.delta(gs), n = this.normal.dot(r);
    if (n === 0)
      return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null;
    const a = -(e.start.dot(this.normal) + this.constant) / n;
    return a < 0 || a > 1 ? null : t.copy(r).multiplyScalar(a).add(e.start);
  }
  intersectsLine(e) {
    const t = this.distanceToPoint(e.start), r = this.distanceToPoint(e.end);
    return t < 0 && r > 0 || r < 0 && t > 0;
  }
  intersectsBox(e) {
    return e.intersectsPlane(this);
  }
  intersectsSphere(e) {
    return e.intersectsPlane(this);
  }
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant);
  }
  applyMatrix4(e, t) {
    const r = t || P2.getNormalMatrix(e), n = this.coplanarPoint(gs).applyMatrix4(e), a = this.normal.applyMatrix3(r).normalize();
    return this.constant = -n.dot(a), this;
  }
  translate(e) {
    return this.constant -= e.dot(this.normal), this;
  }
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
const fr = /* @__PURE__ */ new Ta(), Zn = /* @__PURE__ */ new W();
class Ld {
  constructor(e = new Wi(), t = new Wi(), r = new Wi(), n = new Wi(), a = new Wi(), o = new Wi()) {
    this.planes = [e, t, r, n, a, o];
  }
  set(e, t, r, n, a, o) {
    const s = this.planes;
    return s[0].copy(e), s[1].copy(t), s[2].copy(r), s[3].copy(n), s[4].copy(a), s[5].copy(o), this;
  }
  copy(e) {
    const t = this.planes;
    for (let r = 0; r < 6; r++)
      t[r].copy(e.planes[r]);
    return this;
  }
  setFromProjectionMatrix(e) {
    const t = this.planes, r = e.elements, n = r[0], a = r[1], o = r[2], s = r[3], c = r[4], l = r[5], u = r[6], h = r[7], d = r[8], v = r[9], M = r[10], m = r[11], g = r[12], I = r[13], A = r[14], L = r[15];
    return t[0].setComponents(s - n, h - c, m - d, L - g).normalize(), t[1].setComponents(s + n, h + c, m + d, L + g).normalize(), t[2].setComponents(s + a, h + l, m + v, L + I).normalize(), t[3].setComponents(s - a, h - l, m - v, L - I).normalize(), t[4].setComponents(s - o, h - u, m - M, L - A).normalize(), t[5].setComponents(s + o, h + u, m + M, L + A).normalize(), this;
  }
  intersectsObject(e) {
    const t = e.geometry;
    return t.boundingSphere === null && t.computeBoundingSphere(), fr.copy(t.boundingSphere).applyMatrix4(e.matrixWorld), this.intersectsSphere(fr);
  }
  intersectsSprite(e) {
    return fr.center.set(0, 0, 0), fr.radius = 0.7071067811865476, fr.applyMatrix4(e.matrixWorld), this.intersectsSphere(fr);
  }
  intersectsSphere(e) {
    const t = this.planes, r = e.center, n = -e.radius;
    for (let a = 0; a < 6; a++)
      if (t[a].distanceToPoint(r) < n)
        return !1;
    return !0;
  }
  intersectsBox(e) {
    const t = this.planes;
    for (let r = 0; r < 6; r++) {
      const n = t[r];
      if (Zn.x = n.normal.x > 0 ? e.max.x : e.min.x, Zn.y = n.normal.y > 0 ? e.max.y : e.min.y, Zn.z = n.normal.z > 0 ? e.max.z : e.min.z, n.distanceToPoint(Zn) < 0)
        return !1;
    }
    return !0;
  }
  containsPoint(e) {
    const t = this.planes;
    for (let r = 0; r < 6; r++)
      if (t[r].distanceToPoint(e) < 0)
        return !1;
    return !0;
  }
  clone() {
    return new this.constructor().copy(this);
  }
}
function Pd() {
  let i = null, e = !1, t = null, r = null;
  function n(a, o) {
    t(a, o), r = i.requestAnimationFrame(n);
  }
  return {
    start: function() {
      e !== !0 && t !== null && (r = i.requestAnimationFrame(n), e = !0);
    },
    stop: function() {
      i.cancelAnimationFrame(r), e = !1;
    },
    setAnimationLoop: function(a) {
      t = a;
    },
    setContext: function(a) {
      i = a;
    }
  };
}
function j2(i, e) {
  const t = e.isWebGL2, r = /* @__PURE__ */ new WeakMap();
  function n(l, u) {
    const h = l.array, d = l.usage, v = i.createBuffer();
    i.bindBuffer(u, v), i.bufferData(u, h, d), l.onUploadCallback();
    let M;
    if (h instanceof Float32Array)
      M = 5126;
    else if (h instanceof Uint16Array)
      if (l.isFloat16BufferAttribute)
        if (t)
          M = 5131;
        else
          throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
      else
        M = 5123;
    else if (h instanceof Int16Array)
      M = 5122;
    else if (h instanceof Uint32Array)
      M = 5125;
    else if (h instanceof Int32Array)
      M = 5124;
    else if (h instanceof Int8Array)
      M = 5120;
    else if (h instanceof Uint8Array)
      M = 5121;
    else if (h instanceof Uint8ClampedArray)
      M = 5121;
    else
      throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + h);
    return {
      buffer: v,
      type: M,
      bytesPerElement: h.BYTES_PER_ELEMENT,
      version: l.version
    };
  }
  function a(l, u, h) {
    const d = u.array, v = u.updateRange;
    i.bindBuffer(h, l), v.count === -1 ? i.bufferSubData(h, 0, d) : (t ? i.bufferSubData(
      h,
      v.offset * d.BYTES_PER_ELEMENT,
      d,
      v.offset,
      v.count
    ) : i.bufferSubData(
      h,
      v.offset * d.BYTES_PER_ELEMENT,
      d.subarray(v.offset, v.offset + v.count)
    ), v.count = -1);
  }
  function o(l) {
    return l.isInterleavedBufferAttribute && (l = l.data), r.get(l);
  }
  function s(l) {
    l.isInterleavedBufferAttribute && (l = l.data);
    const u = r.get(l);
    u && (i.deleteBuffer(u.buffer), r.delete(l));
  }
  function c(l, u) {
    if (l.isGLBufferAttribute) {
      const d = r.get(l);
      (!d || d.version < l.version) && r.set(l, {
        buffer: l.buffer,
        type: l.type,
        bytesPerElement: l.elementSize,
        version: l.version
      });
      return;
    }
    l.isInterleavedBufferAttribute && (l = l.data);
    const h = r.get(l);
    h === void 0 ? r.set(l, n(l, u)) : h.version < l.version && (a(h.buffer, l, u), h.version = l.version);
  }
  return {
    get: o,
    remove: s,
    update: c
  };
}
class so extends ni {
  constructor(e = 1, t = 1, r = 1, n = 1) {
    super(), this.type = "PlaneGeometry", this.parameters = {
      width: e,
      height: t,
      widthSegments: r,
      heightSegments: n
    };
    const a = e / 2, o = t / 2, s = Math.floor(r), c = Math.floor(n), l = s + 1, u = c + 1, h = e / s, d = t / c, v = [], M = [], m = [], g = [];
    for (let I = 0; I < u; I++) {
      const A = I * d - o;
      for (let L = 0; L < l; L++) {
        const y = L * h - a;
        M.push(y, -A, 0), m.push(0, 0, 1), g.push(L / s), g.push(1 - I / c);
      }
    }
    for (let I = 0; I < c; I++)
      for (let A = 0; A < s; A++) {
        const L = A + l * I, y = A + l * (I + 1), D = A + 1 + l * (I + 1), T = A + 1 + l * I;
        v.push(L, y, T), v.push(y, D, T);
      }
    this.setIndex(v), this.setAttribute("position", new Ei(M, 3)), this.setAttribute("normal", new Ei(m, 3)), this.setAttribute("uv", new Ei(g, 2));
  }
  static fromJSON(e) {
    return new so(e.width, e.height, e.widthSegments, e.heightSegments);
  }
}
var B2 = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vUv ).g;
#endif`, O2 = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, z2 = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, R2 = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, k2 = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, W2 = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, G2 = "vec3 transformed = vec3( position );", U2 = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, H2 = `vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
	float D = D_GGX( alpha, dotNH );
	return F * ( V * D );
}
#ifdef USE_IRIDESCENCE
vec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = mix(F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence);
	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
	float D = D_GGX( alpha, dotNH );
	return F * ( V * D );
}
#endif
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif`, F2 = `#ifdef USE_IRIDESCENCE
const mat3 XYZ_TO_REC709 = mat3(
    3.2404542, -0.9692660,  0.0556434,
   -1.5371385,  1.8760108, -0.2040259,
   -0.4985314,  0.0415560,  1.0572252
);
vec3 Fresnel0ToIor( vec3 fresnel0 ) {
   vec3 sqrtF0 = sqrt( fresnel0 );
   return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
}
vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
   return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
}
float IorToFresnel0( float transmittedIor, float incidentIor ) {
   return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
}
vec3 evalSensitivity( float OPD, vec3 shift ) {
   float phase = 2.0 * PI * OPD * 1.0e-9;
   vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
   vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
   vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
   vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( -pow2( phase ) * var );
   xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[0] ) * exp( -4.5282e+09 * pow2( phase ) );
   xyz /= 1.0685e-7;
   vec3 srgb = XYZ_TO_REC709 * xyz;
   return srgb;
}
vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
   vec3 I;
   float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
   float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
   float cosTheta2Sq = 1.0 - sinTheta2Sq;
   if ( cosTheta2Sq < 0.0 ) {
       return vec3( 1.0 );
   }
   float cosTheta2 = sqrt( cosTheta2Sq );
   float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
   float R12 = F_Schlick( R0, 1.0, cosTheta1 );
   float R21 = R12;
   float T121 = 1.0 - R12;
   float phi12 = 0.0;
   if ( iridescenceIOR < outsideIOR ) phi12 = PI;
   float phi21 = PI - phi12;
   vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );   vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
   vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
   vec3 phi23 = vec3( 0.0 );
   if ( baseIOR[0] < iridescenceIOR ) phi23[0] = PI;
   if ( baseIOR[1] < iridescenceIOR ) phi23[1] = PI;
   if ( baseIOR[2] < iridescenceIOR ) phi23[2] = PI;
   float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
   vec3 phi = vec3( phi21 ) + phi23;
   vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
   vec3 r123 = sqrt( R123 );
   vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
   vec3 C0 = R12 + Rs;
   I = C0;
   vec3 Cm = Rs - T121;
   for ( int m = 1; m <= 2; ++m ) {
       Cm *= r123;
       vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
       I += Cm * Sm;
   }
   return max( I, vec3( 0.0 ) );
}
#endif`, V2 = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vUv );
		vec2 dSTdy = dFdy( vUv );
		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );
		vec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, Y2 = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, Z2 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, Q2 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, J2 = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, X2 = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, $2 = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, q2 = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, K2 = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, ey = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float linearToRelativeLuminance( const in vec3 color ) {
	vec3 weights = vec3( 0.2126, 0.7152, 0.0722 );
	return dot( weights, color.rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}`, ty = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define r0 1.0
	#define v0 0.339
	#define m0 - 2.0
	#define r1 0.8
	#define v1 0.276
	#define m1 - 1.0
	#define r4 0.4
	#define v4 0.046
	#define m4 2.0
	#define r5 0.305
	#define v5 0.016
	#define m5 3.0
	#define r6 0.21
	#define v6 0.0038
	#define m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= r1 ) {
			mip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;
		} else if ( roughness >= r4 ) {
			mip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;
		} else if ( roughness >= r5 ) {
			mip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;
		} else if ( roughness >= r6 ) {
			mip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, iy = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, ry = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, ny = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );
#endif`, ay = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, sy = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, oy = "gl_FragColor = linearToOutputTexel( gl_FragColor );", ly = `vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, cy = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, uy = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, dy = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, hy = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, py = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, fy = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, my = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, gy = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, vy = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, My = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		return ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );
	#endif
}`, yy = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vUv2 );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, xy = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, Iy = `vec3 diffuse = vec3( 1.0 );
GeometricContext geometry;
geometry.position = mvPosition.xyz;
geometry.normal = normalize( transformedNormal );
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );
GeometricContext backGeometry;
backGeometry.position = geometry.position;
backGeometry.normal = -geometry.normal;
backGeometry.viewDir = geometry.viewDir;
vLightFront = vec3( 0.0 );
vIndirectFront = vec3( 0.0 );
#ifdef DOUBLE_SIDED
	vLightBack = vec3( 0.0 );
	vIndirectBack = vec3( 0.0 );
#endif
IncidentLight directLight;
float dotNL;
vec3 directLightColor_Diffuse;
vIndirectFront += getAmbientLightIrradiance( ambientLightColor );
vIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );
#ifdef DOUBLE_SIDED
	vIndirectBack += getAmbientLightIrradiance( ambientLightColor );
	vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );
#endif
#if NUM_POINT_LIGHTS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		getPointLightInfo( pointLights[ i ], geometry, directLight );
		dotNL = dot( geometry.normal, directLight.direction );
		directLightColor_Diffuse = directLight.color;
		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
		#ifdef DOUBLE_SIDED
			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;
		#endif
	}
	#pragma unroll_loop_end
#endif
#if NUM_SPOT_LIGHTS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		getSpotLightInfo( spotLights[ i ], geometry, directLight );
		dotNL = dot( geometry.normal, directLight.direction );
		directLightColor_Diffuse = directLight.color;
		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
		#ifdef DOUBLE_SIDED
			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;
		#endif
	}
	#pragma unroll_loop_end
#endif
#if NUM_DIR_LIGHTS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );
		dotNL = dot( geometry.normal, directLight.direction );
		directLightColor_Diffuse = directLight.color;
		vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
		#ifdef DOUBLE_SIDED
			vLightBack += saturate( - dotNL ) * directLightColor_Diffuse;
		#endif
	}
	#pragma unroll_loop_end
#endif
#if NUM_HEMI_LIGHTS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
		vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		#ifdef DOUBLE_SIDED
			vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );
		#endif
	}
	#pragma unroll_loop_end
#endif`, by = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
uniform vec3 lightProbe[ 9 ];
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( PHYSICALLY_CORRECT_LIGHTS )
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#else
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometry.position;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometry.position;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, wy = `#if defined( USE_ENVMAP )
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
#endif`, _y = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, Ay = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon
#define Material_LightProbeLOD( material )	(0)`, Sy = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, Dy = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong
#define Material_LightProbeLOD( material )	(0)`, Ty = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	#ifdef SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULARINTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;
		#endif
		#ifdef USE_SPECULARCOLORMAP
			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( ior - 1.0 ) / ( ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEENCOLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEENROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;
	#endif
#endif`, Cy = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
};
vec3 clearcoatSpecular = vec3( 0.0 );
vec3 sheenSpecular = vec3( 0.0 );
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometry.normal;
		vec3 viewDir = geometry.viewDir;
		vec3 position = geometry.position;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );
	#endif
	#ifdef USE_IRIDESCENCE
		reflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );
	#else
		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );
	#endif
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, Ey = `
GeometricContext geometry;
geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
#ifdef USE_CLEARCOAT
	geometry.clearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
float dotNVi = saturate( dot( normal, geometry.viewDir ) );
if ( material.iridescenceThickness == 0.0 ) {
	material.iridescence = 0.0;
} else {
	material.iridescence = saturate( material.iridescence );
}
if ( material.iridescence > 0.0 ) {
	material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
	material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, Ny = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometry.normal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, Ly = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );
#endif`, Py = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, jy = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, By = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, Oy = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, zy = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, Ry = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, ky = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, Wy = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	uniform mat3 uvTransform;
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, Gy = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vUv );
	metalnessFactor *= texelMetalness.b;
#endif`, Uy = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, Hy = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, Fy = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, Vy = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, Yy = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, Zy = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );
	vec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	#ifdef USE_TANGENT
		vec3 tangent = normalize( vTangent );
		vec3 bitangent = normalize( vBitangent );
		#ifdef DOUBLE_SIDED
			tangent = tangent * faceDirection;
			bitangent = bitangent * faceDirection;
		#endif
		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )
			mat3 vTBN = mat3( tangent, bitangent, normal );
		#endif
	#endif
#endif
vec3 geometryNormal = normal;`, Qy = `#ifdef OBJECTSPACE_NORMALMAP
	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( TANGENTSPACE_NORMALMAP )
	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	#ifdef USE_TANGENT
		normal = normalize( vTBN * mapN );
	#else
		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );
	#endif
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, Jy = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, Xy = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, $y = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, qy = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef OBJECTSPACE_NORMALMAP
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )
	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {
		vec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );
		vec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );
		vec2 st0 = dFdx( vUv.st );
		vec2 st1 = dFdy( vUv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );
		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );
	}
#endif`, Ky = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = geometryNormal;
#endif`, ex = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	#ifdef USE_TANGENT
		clearcoatNormal = normalize( vTBN * clearcoatMapN );
	#else
		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );
	#endif
#endif`, tx = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif`, ix = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, rx = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= transmissionAlpha + 0.1;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, nx = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {
	return linearClipZ * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * invClipZ - far );
}`, ax = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, sx = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, ox = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, lx = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, cx = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vUv );
	roughnessFactor *= texelRoughness.g;
#endif`, ux = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, dx = `#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );
		bool inFrustum = all( inFrustumVec );
		bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );
		bool frustumTest = all( frustumTestVec );
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), 
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), 
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), 
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), 
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), 
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), 
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, hx = `#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];
		varying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, px = `#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0
		vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		vec4 shadowWorldPosition;
	#endif
	#if NUM_DIR_LIGHT_SHADOWS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
		vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );
		vSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
		vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
	#endif
#endif`, fx = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, mx = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, gx = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, vx = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, Mx = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, yx = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, xx = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, Ix = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, bx = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return toneMappingExposure * color;
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, wx = `#ifdef USE_TRANSMISSION
	float transmissionAlpha = 1.0;
	float transmissionFactor = transmission;
	float thicknessFactor = thickness;
	#ifdef USE_TRANSMISSIONMAP
		transmissionFactor *= texture2D( transmissionMap, vUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		thicknessFactor *= texture2D( thicknessMap, vUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmission = getIBLVolumeRefraction(
		n, v, roughnessFactor, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, ior, thicknessFactor,
		attenuationColor, attenuationDistance );
	totalDiffuse = mix( totalDiffuse, transmission.rgb, transmissionFactor );
	transmissionAlpha = mix( transmissionAlpha, transmission.a, transmissionFactor );
#endif`, _x = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		#ifdef texture2DLodEXT
			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#else
			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#endif
	}
	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( attenuationDistance == 0.0 ) {
			return radiance;
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );
	}
#endif`, Ax = `#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )
	varying vec2 vUv;
#endif`, Sx = `#ifdef USE_UV
	#ifdef UVS_VERTEX_ONLY
		vec2 vUv;
	#else
		varying vec2 vUv;
	#endif
	uniform mat3 uvTransform;
#endif`, Dx = `#ifdef USE_UV
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
#endif`, Tx = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	varying vec2 vUv2;
#endif`, Cx = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	attribute vec2 uv2;
	varying vec2 vUv2;
	uniform mat3 uv2Transform;
#endif`, Ex = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;
#endif`, Nx = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION )
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`;
const Lx = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, Px = `uniform sampler2D t2D;
varying vec2 vUv;
void main() {
	gl_FragColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		gl_FragColor = vec4( mix( pow( gl_FragColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), gl_FragColor.rgb * 0.0773993808, vec3( lessThanEqual( gl_FragColor.rgb, vec3( 0.04045 ) ) ) ), gl_FragColor.w );
	#endif
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, jx = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, Bx = `#include <envmap_common_pars_fragment>
uniform float opacity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	vec3 vReflect = vWorldDirection;
	#include <envmap_fragment>
	gl_FragColor = envColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, Ox = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, zx = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, Rx = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, kx = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, Wx = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, Gx = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, Ux = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, Hx = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, Fx = `#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, Vx = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Yx = `#define LAMBERT
varying vec3 vLightFront;
varying vec3 vIndirectFront;
#ifdef DOUBLE_SIDED
	varying vec3 vLightBack;
	varying vec3 vIndirectBack;
#endif
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <bsdfs>
#include <lights_pars_begin>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <lights_lambert_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Zx = `uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
varying vec3 vLightFront;
varying vec3 vIndirectFront;
#ifdef DOUBLE_SIDED
	varying vec3 vLightBack;
	varying vec3 vIndirectBack;
#endif
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <fog_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <emissivemap_fragment>
	#ifdef DOUBLE_SIDED
		reflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;
	#else
		reflectedLight.indirectDiffuse += vIndirectFront;
	#endif
	#include <lightmap_fragment>
	reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );
	#ifdef DOUBLE_SIDED
		reflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;
	#else
		reflectedLight.directDiffuse = vLightFront;
	#endif
	reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Qx = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, Jx = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, Xx = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	vViewPosition = - mvPosition.xyz;
#endif
}`, $x = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, qx = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, Kx = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <cube_uv_reflection_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, eI = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, tI = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULARINTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
	#ifdef USE_SPECULARCOLORMAP
		uniform sampler2D specularColorMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEENCOLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEENROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <bsdfs>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;
	#endif
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, iI = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, rI = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, nI = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, aI = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, sI = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, oI = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, lI = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, cI = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, Ee = {
  alphamap_fragment: B2,
  alphamap_pars_fragment: O2,
  alphatest_fragment: z2,
  alphatest_pars_fragment: R2,
  aomap_fragment: k2,
  aomap_pars_fragment: W2,
  begin_vertex: G2,
  beginnormal_vertex: U2,
  bsdfs: H2,
  iridescence_fragment: F2,
  bumpmap_pars_fragment: V2,
  clipping_planes_fragment: Y2,
  clipping_planes_pars_fragment: Z2,
  clipping_planes_pars_vertex: Q2,
  clipping_planes_vertex: J2,
  color_fragment: X2,
  color_pars_fragment: $2,
  color_pars_vertex: q2,
  color_vertex: K2,
  common: ey,
  cube_uv_reflection_fragment: ty,
  defaultnormal_vertex: iy,
  displacementmap_pars_vertex: ry,
  displacementmap_vertex: ny,
  emissivemap_fragment: ay,
  emissivemap_pars_fragment: sy,
  encodings_fragment: oy,
  encodings_pars_fragment: ly,
  envmap_fragment: cy,
  envmap_common_pars_fragment: uy,
  envmap_pars_fragment: dy,
  envmap_pars_vertex: hy,
  envmap_physical_pars_fragment: wy,
  envmap_vertex: py,
  fog_vertex: fy,
  fog_pars_vertex: my,
  fog_fragment: gy,
  fog_pars_fragment: vy,
  gradientmap_pars_fragment: My,
  lightmap_fragment: yy,
  lightmap_pars_fragment: xy,
  lights_lambert_vertex: Iy,
  lights_pars_begin: by,
  lights_toon_fragment: _y,
  lights_toon_pars_fragment: Ay,
  lights_phong_fragment: Sy,
  lights_phong_pars_fragment: Dy,
  lights_physical_fragment: Ty,
  lights_physical_pars_fragment: Cy,
  lights_fragment_begin: Ey,
  lights_fragment_maps: Ny,
  lights_fragment_end: Ly,
  logdepthbuf_fragment: Py,
  logdepthbuf_pars_fragment: jy,
  logdepthbuf_pars_vertex: By,
  logdepthbuf_vertex: Oy,
  map_fragment: zy,
  map_pars_fragment: Ry,
  map_particle_fragment: ky,
  map_particle_pars_fragment: Wy,
  metalnessmap_fragment: Gy,
  metalnessmap_pars_fragment: Uy,
  morphcolor_vertex: Hy,
  morphnormal_vertex: Fy,
  morphtarget_pars_vertex: Vy,
  morphtarget_vertex: Yy,
  normal_fragment_begin: Zy,
  normal_fragment_maps: Qy,
  normal_pars_fragment: Jy,
  normal_pars_vertex: Xy,
  normal_vertex: $y,
  normalmap_pars_fragment: qy,
  clearcoat_normal_fragment_begin: Ky,
  clearcoat_normal_fragment_maps: ex,
  clearcoat_pars_fragment: tx,
  iridescence_pars_fragment: ix,
  output_fragment: rx,
  packing: nx,
  premultiplied_alpha_fragment: ax,
  project_vertex: sx,
  dithering_fragment: ox,
  dithering_pars_fragment: lx,
  roughnessmap_fragment: cx,
  roughnessmap_pars_fragment: ux,
  shadowmap_pars_fragment: dx,
  shadowmap_pars_vertex: hx,
  shadowmap_vertex: px,
  shadowmask_pars_fragment: fx,
  skinbase_vertex: mx,
  skinning_pars_vertex: gx,
  skinning_vertex: vx,
  skinnormal_vertex: Mx,
  specularmap_fragment: yx,
  specularmap_pars_fragment: xx,
  tonemapping_fragment: Ix,
  tonemapping_pars_fragment: bx,
  transmission_fragment: wx,
  transmission_pars_fragment: _x,
  uv_pars_fragment: Ax,
  uv_pars_vertex: Sx,
  uv_vertex: Dx,
  uv2_pars_fragment: Tx,
  uv2_pars_vertex: Cx,
  uv2_vertex: Ex,
  worldpos_vertex: Nx,
  background_vert: Lx,
  background_frag: Px,
  cube_vert: jx,
  cube_frag: Bx,
  depth_vert: Ox,
  depth_frag: zx,
  distanceRGBA_vert: Rx,
  distanceRGBA_frag: kx,
  equirect_vert: Wx,
  equirect_frag: Gx,
  linedashed_vert: Ux,
  linedashed_frag: Hx,
  meshbasic_vert: Fx,
  meshbasic_frag: Vx,
  meshlambert_vert: Yx,
  meshlambert_frag: Zx,
  meshmatcap_vert: Qx,
  meshmatcap_frag: Jx,
  meshnormal_vert: Xx,
  meshnormal_frag: $x,
  meshphong_vert: qx,
  meshphong_frag: Kx,
  meshphysical_vert: eI,
  meshphysical_frag: tI,
  meshtoon_vert: iI,
  meshtoon_frag: rI,
  points_vert: nI,
  points_frag: aI,
  shadow_vert: sI,
  shadow_frag: oI,
  sprite_vert: lI,
  sprite_frag: cI
}, pe = {
  common: {
    diffuse: { value: new Ce(16777215) },
    opacity: { value: 1 },
    map: { value: null },
    uvTransform: { value: new ei() },
    uv2Transform: { value: new ei() },
    alphaMap: { value: null },
    alphaTest: { value: 0 }
  },
  specularmap: {
    specularMap: { value: null }
  },
  envmap: {
    envMap: { value: null },
    flipEnvMap: { value: -1 },
    reflectivity: { value: 1 },
    ior: { value: 1.5 },
    refractionRatio: { value: 0.98 }
  },
  aomap: {
    aoMap: { value: null },
    aoMapIntensity: { value: 1 }
  },
  lightmap: {
    lightMap: { value: null },
    lightMapIntensity: { value: 1 }
  },
  emissivemap: {
    emissiveMap: { value: null }
  },
  bumpmap: {
    bumpMap: { value: null },
    bumpScale: { value: 1 }
  },
  normalmap: {
    normalMap: { value: null },
    normalScale: { value: new Re(1, 1) }
  },
  displacementmap: {
    displacementMap: { value: null },
    displacementScale: { value: 1 },
    displacementBias: { value: 0 }
  },
  roughnessmap: {
    roughnessMap: { value: null }
  },
  metalnessmap: {
    metalnessMap: { value: null }
  },
  gradientmap: {
    gradientMap: { value: null }
  },
  fog: {
    fogDensity: { value: 25e-5 },
    fogNear: { value: 1 },
    fogFar: { value: 2e3 },
    fogColor: { value: new Ce(16777215) }
  },
  lights: {
    ambientLightColor: { value: [] },
    lightProbe: { value: [] },
    directionalLights: { value: [], properties: {
      direction: {},
      color: {}
    } },
    directionalLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    directionalShadowMap: { value: [] },
    directionalShadowMatrix: { value: [] },
    spotLights: { value: [], properties: {
      color: {},
      position: {},
      direction: {},
      distance: {},
      coneCos: {},
      penumbraCos: {},
      decay: {}
    } },
    spotLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {}
    } },
    spotShadowMap: { value: [] },
    spotShadowMatrix: { value: [] },
    pointLights: { value: [], properties: {
      color: {},
      position: {},
      decay: {},
      distance: {}
    } },
    pointLightShadows: { value: [], properties: {
      shadowBias: {},
      shadowNormalBias: {},
      shadowRadius: {},
      shadowMapSize: {},
      shadowCameraNear: {},
      shadowCameraFar: {}
    } },
    pointShadowMap: { value: [] },
    pointShadowMatrix: { value: [] },
    hemisphereLights: { value: [], properties: {
      direction: {},
      skyColor: {},
      groundColor: {}
    } },
    rectAreaLights: { value: [], properties: {
      color: {},
      position: {},
      width: {},
      height: {}
    } },
    ltc_1: { value: null },
    ltc_2: { value: null }
  },
  points: {
    diffuse: { value: new Ce(16777215) },
    opacity: { value: 1 },
    size: { value: 1 },
    scale: { value: 1 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: new ei() }
  },
  sprite: {
    diffuse: { value: new Ce(16777215) },
    opacity: { value: 1 },
    center: { value: new Re(0.5, 0.5) },
    rotation: { value: 0 },
    map: { value: null },
    alphaMap: { value: null },
    alphaTest: { value: 0 },
    uvTransform: { value: new ei() }
  }
}, $t = {
  basic: {
    uniforms: ot([
      pe.common,
      pe.specularmap,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.fog
    ]),
    vertexShader: Ee.meshbasic_vert,
    fragmentShader: Ee.meshbasic_frag
  },
  lambert: {
    uniforms: ot([
      pe.common,
      pe.specularmap,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: new Ce(0) }
      }
    ]),
    vertexShader: Ee.meshlambert_vert,
    fragmentShader: Ee.meshlambert_frag
  },
  phong: {
    uniforms: ot([
      pe.common,
      pe.specularmap,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: new Ce(0) },
        specular: { value: new Ce(1118481) },
        shininess: { value: 30 }
      }
    ]),
    vertexShader: Ee.meshphong_vert,
    fragmentShader: Ee.meshphong_frag
  },
  standard: {
    uniforms: ot([
      pe.common,
      pe.envmap,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.roughnessmap,
      pe.metalnessmap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: new Ce(0) },
        roughness: { value: 1 },
        metalness: { value: 0 },
        envMapIntensity: { value: 1 }
      }
    ]),
    vertexShader: Ee.meshphysical_vert,
    fragmentShader: Ee.meshphysical_frag
  },
  toon: {
    uniforms: ot([
      pe.common,
      pe.aomap,
      pe.lightmap,
      pe.emissivemap,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.gradientmap,
      pe.fog,
      pe.lights,
      {
        emissive: { value: new Ce(0) }
      }
    ]),
    vertexShader: Ee.meshtoon_vert,
    fragmentShader: Ee.meshtoon_frag
  },
  matcap: {
    uniforms: ot([
      pe.common,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      pe.fog,
      {
        matcap: { value: null }
      }
    ]),
    vertexShader: Ee.meshmatcap_vert,
    fragmentShader: Ee.meshmatcap_frag
  },
  points: {
    uniforms: ot([
      pe.points,
      pe.fog
    ]),
    vertexShader: Ee.points_vert,
    fragmentShader: Ee.points_frag
  },
  dashed: {
    uniforms: ot([
      pe.common,
      pe.fog,
      {
        scale: { value: 1 },
        dashSize: { value: 1 },
        totalSize: { value: 2 }
      }
    ]),
    vertexShader: Ee.linedashed_vert,
    fragmentShader: Ee.linedashed_frag
  },
  depth: {
    uniforms: ot([
      pe.common,
      pe.displacementmap
    ]),
    vertexShader: Ee.depth_vert,
    fragmentShader: Ee.depth_frag
  },
  normal: {
    uniforms: ot([
      pe.common,
      pe.bumpmap,
      pe.normalmap,
      pe.displacementmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Ee.meshnormal_vert,
    fragmentShader: Ee.meshnormal_frag
  },
  sprite: {
    uniforms: ot([
      pe.sprite,
      pe.fog
    ]),
    vertexShader: Ee.sprite_vert,
    fragmentShader: Ee.sprite_frag
  },
  background: {
    uniforms: {
      uvTransform: { value: new ei() },
      t2D: { value: null }
    },
    vertexShader: Ee.background_vert,
    fragmentShader: Ee.background_frag
  },
  cube: {
    uniforms: ot([
      pe.envmap,
      {
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Ee.cube_vert,
    fragmentShader: Ee.cube_frag
  },
  equirect: {
    uniforms: {
      tEquirect: { value: null }
    },
    vertexShader: Ee.equirect_vert,
    fragmentShader: Ee.equirect_frag
  },
  distanceRGBA: {
    uniforms: ot([
      pe.common,
      pe.displacementmap,
      {
        referencePosition: { value: new W() },
        nearDistance: { value: 1 },
        farDistance: { value: 1e3 }
      }
    ]),
    vertexShader: Ee.distanceRGBA_vert,
    fragmentShader: Ee.distanceRGBA_frag
  },
  shadow: {
    uniforms: ot([
      pe.lights,
      pe.fog,
      {
        color: { value: new Ce(0) },
        opacity: { value: 1 }
      }
    ]),
    vertexShader: Ee.shadow_vert,
    fragmentShader: Ee.shadow_frag
  }
};
$t.physical = {
  uniforms: ot([
    $t.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatNormalScale: { value: new Re(1, 1) },
      clearcoatNormalMap: { value: null },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      sheen: { value: 0 },
      sheenColor: { value: new Ce(0) },
      sheenColorMap: { value: null },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionSamplerSize: { value: new Re() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: new Ce(0) },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularColor: { value: new Ce(1, 1, 1) },
      specularColorMap: { value: null }
    }
  ]),
  vertexShader: Ee.meshphysical_vert,
  fragmentShader: Ee.meshphysical_frag
};
function uI(i, e, t, r, n, a) {
  const o = new Ce(0);
  let s = n === !0 ? 0 : 1, c, l, u = null, h = 0, d = null;
  function v(m, g) {
    let I = !1, A = g.isScene === !0 ? g.background : null;
    A && A.isTexture && (A = e.get(A));
    const L = i.xr, y = L.getSession && L.getSession();
    y && y.environmentBlendMode === "additive" && (A = null), A === null ? M(o, s) : A && A.isColor && (M(A, 1), I = !0), (i.autoClear || I) && i.clear(i.autoClearColor, i.autoClearDepth, i.autoClearStencil), A && (A.isCubeTexture || A.mapping === Sa) ? (l === void 0 && (l = new Di(
      new In(1, 1, 1),
      new pi({
        name: "BackgroundCubeMaterial",
        uniforms: Er($t.cube.uniforms),
        vertexShader: $t.cube.vertexShader,
        fragmentShader: $t.cube.fragmentShader,
        side: zt,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), l.geometry.deleteAttribute("normal"), l.geometry.deleteAttribute("uv"), l.onBeforeRender = function(D, T, B) {
      this.matrixWorld.copyPosition(B.matrixWorld);
    }, Object.defineProperty(l.material, "envMap", {
      get: function() {
        return this.uniforms.envMap.value;
      }
    }), r.update(l)), l.material.uniforms.envMap.value = A, l.material.uniforms.flipEnvMap.value = A.isCubeTexture && A.isRenderTargetTexture === !1 ? -1 : 1, (u !== A || h !== A.version || d !== i.toneMapping) && (l.material.needsUpdate = !0, u = A, h = A.version, d = i.toneMapping), l.layers.enableAll(), m.unshift(l, l.geometry, l.material, 0, 0, null)) : A && A.isTexture && (c === void 0 && (c = new Di(
      new so(2, 2),
      new pi({
        name: "BackgroundMaterial",
        uniforms: Er($t.background.uniforms),
        vertexShader: $t.background.vertexShader,
        fragmentShader: $t.background.fragmentShader,
        side: cn,
        depthTest: !1,
        depthWrite: !1,
        fog: !1
      })
    ), c.geometry.deleteAttribute("normal"), Object.defineProperty(c.material, "map", {
      get: function() {
        return this.uniforms.t2D.value;
      }
    }), r.update(c)), c.material.uniforms.t2D.value = A, A.matrixAutoUpdate === !0 && A.updateMatrix(), c.material.uniforms.uvTransform.value.copy(A.matrix), (u !== A || h !== A.version || d !== i.toneMapping) && (c.material.needsUpdate = !0, u = A, h = A.version, d = i.toneMapping), c.layers.enableAll(), m.unshift(c, c.geometry, c.material, 0, 0, null));
  }
  function M(m, g) {
    t.buffers.color.setClear(m.r, m.g, m.b, g, a);
  }
  return {
    getClearColor: function() {
      return o;
    },
    setClearColor: function(m, g = 1) {
      o.set(m), s = g, M(o, s);
    },
    getClearAlpha: function() {
      return s;
    },
    setClearAlpha: function(m) {
      s = m, M(o, s);
    },
    render: v
  };
}
function dI(i, e, t, r) {
  const n = i.getParameter(34921), a = r.isWebGL2 ? null : e.get("OES_vertex_array_object"), o = r.isWebGL2 || a !== null, s = {}, c = g(null);
  let l = c, u = !1;
  function h(z, q, V, ie, K) {
    let Y = !1;
    if (o) {
      const Q = m(ie, V, q);
      l !== Q && (l = Q, v(l.object)), Y = I(z, ie, V, K), Y && A(z, ie, V, K);
    } else {
      const Q = q.wireframe === !0;
      (l.geometry !== ie.id || l.program !== V.id || l.wireframe !== Q) && (l.geometry = ie.id, l.program = V.id, l.wireframe = Q, Y = !0);
    }
    K !== null && t.update(K, 34963), (Y || u) && (u = !1, S(z, q, V, ie), K !== null && i.bindBuffer(34963, t.get(K).buffer));
  }
  function d() {
    return r.isWebGL2 ? i.createVertexArray() : a.createVertexArrayOES();
  }
  function v(z) {
    return r.isWebGL2 ? i.bindVertexArray(z) : a.bindVertexArrayOES(z);
  }
  function M(z) {
    return r.isWebGL2 ? i.deleteVertexArray(z) : a.deleteVertexArrayOES(z);
  }
  function m(z, q, V) {
    const ie = V.wireframe === !0;
    let K = s[z.id];
    K === void 0 && (K = {}, s[z.id] = K);
    let Y = K[q.id];
    Y === void 0 && (Y = {}, K[q.id] = Y);
    let Q = Y[ie];
    return Q === void 0 && (Q = g(d()), Y[ie] = Q), Q;
  }
  function g(z) {
    const q = [], V = [], ie = [];
    for (let K = 0; K < n; K++)
      q[K] = 0, V[K] = 0, ie[K] = 0;
    return {
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: q,
      enabledAttributes: V,
      attributeDivisors: ie,
      object: z,
      attributes: {},
      index: null
    };
  }
  function I(z, q, V, ie) {
    const K = l.attributes, Y = q.attributes;
    let Q = 0;
    const se = V.getAttributes();
    for (const X in se)
      if (se[X].location >= 0) {
        const ue = K[X];
        let fe = Y[X];
        if (fe === void 0 && (X === "instanceMatrix" && z.instanceMatrix && (fe = z.instanceMatrix), X === "instanceColor" && z.instanceColor && (fe = z.instanceColor)), ue === void 0 || ue.attribute !== fe || fe && ue.data !== fe.data)
          return !0;
        Q++;
      }
    return l.attributesNum !== Q || l.index !== ie;
  }
  function A(z, q, V, ie) {
    const K = {}, Y = q.attributes;
    let Q = 0;
    const se = V.getAttributes();
    for (const X in se)
      if (se[X].location >= 0) {
        let ue = Y[X];
        ue === void 0 && (X === "instanceMatrix" && z.instanceMatrix && (ue = z.instanceMatrix), X === "instanceColor" && z.instanceColor && (ue = z.instanceColor));
        const fe = {};
        fe.attribute = ue, ue && ue.data && (fe.data = ue.data), K[X] = fe, Q++;
      }
    l.attributes = K, l.attributesNum = Q, l.index = ie;
  }
  function L() {
    const z = l.newAttributes;
    for (let q = 0, V = z.length; q < V; q++)
      z[q] = 0;
  }
  function y(z) {
    D(z, 0);
  }
  function D(z, q) {
    const V = l.newAttributes, ie = l.enabledAttributes, K = l.attributeDivisors;
    V[z] = 1, ie[z] === 0 && (i.enableVertexAttribArray(z), ie[z] = 1), K[z] !== q && ((r.isWebGL2 ? i : e.get("ANGLE_instanced_arrays"))[r.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](z, q), K[z] = q);
  }
  function T() {
    const z = l.newAttributes, q = l.enabledAttributes;
    for (let V = 0, ie = q.length; V < ie; V++)
      q[V] !== z[V] && (i.disableVertexAttribArray(V), q[V] = 0);
  }
  function B(z, q, V, ie, K, Y) {
    r.isWebGL2 === !0 && (V === 5124 || V === 5125) ? i.vertexAttribIPointer(z, q, V, K, Y) : i.vertexAttribPointer(z, q, V, ie, K, Y);
  }
  function S(z, q, V, ie) {
    if (r.isWebGL2 === !1 && (z.isInstancedMesh || ie.isInstancedBufferGeometry) && e.get("ANGLE_instanced_arrays") === null)
      return;
    L();
    const K = ie.attributes, Y = V.getAttributes(), Q = q.defaultAttributeValues;
    for (const se in Y) {
      const X = Y[se];
      if (X.location >= 0) {
        let ue = K[se];
        if (ue === void 0 && (se === "instanceMatrix" && z.instanceMatrix && (ue = z.instanceMatrix), se === "instanceColor" && z.instanceColor && (ue = z.instanceColor)), ue !== void 0) {
          const fe = ue.normalized, ye = ue.itemSize, $ = t.get(ue);
          if ($ === void 0)
            continue;
          const Le = $.buffer, Me = $.type, we = $.bytesPerElement;
          if (ue.isInterleavedBufferAttribute) {
            const de = ue.data, Oe = de.stride, _e = ue.offset;
            if (de.isInstancedInterleavedBuffer) {
              for (let xe = 0; xe < X.locationSize; xe++)
                D(X.location + xe, de.meshPerAttribute);
              z.isInstancedMesh !== !0 && ie._maxInstanceCount === void 0 && (ie._maxInstanceCount = de.meshPerAttribute * de.count);
            } else
              for (let xe = 0; xe < X.locationSize; xe++)
                y(X.location + xe);
            i.bindBuffer(34962, Le);
            for (let xe = 0; xe < X.locationSize; xe++)
              B(
                X.location + xe,
                ye / X.locationSize,
                Me,
                fe,
                Oe * we,
                (_e + ye / X.locationSize * xe) * we
              );
          } else {
            if (ue.isInstancedBufferAttribute) {
              for (let de = 0; de < X.locationSize; de++)
                D(X.location + de, ue.meshPerAttribute);
              z.isInstancedMesh !== !0 && ie._maxInstanceCount === void 0 && (ie._maxInstanceCount = ue.meshPerAttribute * ue.count);
            } else
              for (let de = 0; de < X.locationSize; de++)
                y(X.location + de);
            i.bindBuffer(34962, Le);
            for (let de = 0; de < X.locationSize; de++)
              B(
                X.location + de,
                ye / X.locationSize,
                Me,
                fe,
                ye * we,
                ye / X.locationSize * de * we
              );
          }
        } else if (Q !== void 0) {
          const fe = Q[se];
          if (fe !== void 0)
            switch (fe.length) {
              case 2:
                i.vertexAttrib2fv(X.location, fe);
                break;
              case 3:
                i.vertexAttrib3fv(X.location, fe);
                break;
              case 4:
                i.vertexAttrib4fv(X.location, fe);
                break;
              default:
                i.vertexAttrib1fv(X.location, fe);
            }
        }
      }
    }
    T();
  }
  function P() {
    le();
    for (const z in s) {
      const q = s[z];
      for (const V in q) {
        const ie = q[V];
        for (const K in ie)
          M(ie[K].object), delete ie[K];
        delete q[V];
      }
      delete s[z];
    }
  }
  function G(z) {
    if (s[z.id] === void 0)
      return;
    const q = s[z.id];
    for (const V in q) {
      const ie = q[V];
      for (const K in ie)
        M(ie[K].object), delete ie[K];
      delete q[V];
    }
    delete s[z.id];
  }
  function U(z) {
    for (const q in s) {
      const V = s[q];
      if (V[z.id] === void 0)
        continue;
      const ie = V[z.id];
      for (const K in ie)
        M(ie[K].object), delete ie[K];
      delete V[z.id];
    }
  }
  function le() {
    ne(), u = !0, l !== c && (l = c, v(l.object));
  }
  function ne() {
    c.geometry = null, c.program = null, c.wireframe = !1;
  }
  return {
    setup: h,
    reset: le,
    resetDefaultState: ne,
    dispose: P,
    releaseStatesOfGeometry: G,
    releaseStatesOfProgram: U,
    initAttributes: L,
    enableAttribute: y,
    disableUnusedAttributes: T
  };
}
function hI(i, e, t, r) {
  const n = r.isWebGL2;
  let a;
  function o(l) {
    a = l;
  }
  function s(l, u) {
    i.drawArrays(a, l, u), t.update(u, a, 1);
  }
  function c(l, u, h) {
    if (h === 0)
      return;
    let d, v;
    if (n)
      d = i, v = "drawArraysInstanced";
    else if (d = e.get("ANGLE_instanced_arrays"), v = "drawArraysInstancedANGLE", d === null) {
      console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    d[v](a, l, u, h), t.update(u, a, h);
  }
  this.setMode = o, this.render = s, this.renderInstances = c;
}
function pI(i, e, t) {
  let r;
  function n() {
    if (r !== void 0)
      return r;
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const B = e.get("EXT_texture_filter_anisotropic");
      r = i.getParameter(B.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
    } else
      r = 0;
    return r;
  }
  function a(B) {
    if (B === "highp") {
      if (i.getShaderPrecisionFormat(35633, 36338).precision > 0 && i.getShaderPrecisionFormat(35632, 36338).precision > 0)
        return "highp";
      B = "mediump";
    }
    return B === "mediump" && i.getShaderPrecisionFormat(35633, 36337).precision > 0 && i.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
  }
  const o = typeof WebGL2RenderingContext < "u" && i instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext < "u" && i instanceof WebGL2ComputeRenderingContext;
  let s = t.precision !== void 0 ? t.precision : "highp";
  const c = a(s);
  c !== s && (console.warn("THREE.WebGLRenderer:", s, "not supported, using", c, "instead."), s = c);
  const l = o || e.has("WEBGL_draw_buffers"), u = t.logarithmicDepthBuffer === !0, h = i.getParameter(34930), d = i.getParameter(35660), v = i.getParameter(3379), M = i.getParameter(34076), m = i.getParameter(34921), g = i.getParameter(36347), I = i.getParameter(36348), A = i.getParameter(36349), L = d > 0, y = o || e.has("OES_texture_float"), D = L && y, T = o ? i.getParameter(36183) : 0;
  return {
    isWebGL2: o,
    drawBuffers: l,
    getMaxAnisotropy: n,
    getMaxPrecision: a,
    precision: s,
    logarithmicDepthBuffer: u,
    maxTextures: h,
    maxVertexTextures: d,
    maxTextureSize: v,
    maxCubemapSize: M,
    maxAttributes: m,
    maxVertexUniforms: g,
    maxVaryings: I,
    maxFragmentUniforms: A,
    vertexTextures: L,
    floatFragmentTextures: y,
    floatVertexTextures: D,
    maxSamples: T
  };
}
function fI(i) {
  const e = this;
  let t = null, r = 0, n = !1, a = !1;
  const o = new Wi(), s = new ei(), c = { value: null, needsUpdate: !1 };
  this.uniform = c, this.numPlanes = 0, this.numIntersection = 0, this.init = function(h, d, v) {
    const M = h.length !== 0 || d || r !== 0 || n;
    return n = d, t = u(h, v, 0), r = h.length, M;
  }, this.beginShadows = function() {
    a = !0, u(null);
  }, this.endShadows = function() {
    a = !1, l();
  }, this.setState = function(h, d, v) {
    const M = h.clippingPlanes, m = h.clipIntersection, g = h.clipShadows, I = i.get(h);
    if (!n || M === null || M.length === 0 || a && !g)
      a ? u(null) : l();
    else {
      const A = a ? 0 : r, L = A * 4;
      let y = I.clippingState || null;
      c.value = y, y = u(M, d, L, v);
      for (let D = 0; D !== L; ++D)
        y[D] = t[D];
      I.clippingState = y, this.numIntersection = m ? this.numPlanes : 0, this.numPlanes += A;
    }
  };
  function l() {
    c.value !== t && (c.value = t, c.needsUpdate = r > 0), e.numPlanes = r, e.numIntersection = 0;
  }
  function u(h, d, v, M) {
    const m = h !== null ? h.length : 0;
    let g = null;
    if (m !== 0) {
      if (g = c.value, M !== !0 || g === null) {
        const I = v + m * 4, A = d.matrixWorldInverse;
        s.getNormalMatrix(A), (g === null || g.length < I) && (g = new Float32Array(I));
        for (let L = 0, y = v; L !== m; ++L, y += 4)
          o.copy(h[L]).applyMatrix4(A, s), o.normal.toArray(g, y), g[y + 3] = o.constant;
      }
      c.value = g, c.needsUpdate = !0;
    }
    return e.numPlanes = m, e.numIntersection = 0, g;
  }
}
function mI(i) {
  let e = /* @__PURE__ */ new WeakMap();
  function t(o, s) {
    return s === zs ? o.mapping = Dr : s === Rs && (o.mapping = Tr), o;
  }
  function r(o) {
    if (o && o.isTexture && o.isRenderTargetTexture === !1) {
      const s = o.mapping;
      if (s === zs || s === Rs)
        if (e.has(o)) {
          const c = e.get(o).texture;
          return t(c, o.mapping);
        } else {
          const c = o.image;
          if (c && c.height > 0) {
            const l = new N2(c.height / 2);
            return l.fromEquirectangularTexture(i, o), e.set(o, l), o.addEventListener("dispose", n), t(l.texture, o.mapping);
          } else
            return null;
        }
    }
    return o;
  }
  function n(o) {
    const s = o.target;
    s.removeEventListener("dispose", n);
    const c = e.get(s);
    c !== void 0 && (e.delete(s), c.dispose());
  }
  function a() {
    e = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: r,
    dispose: a
  };
}
class jd extends Ed {
  constructor(e = -1, t = 1, r = 1, n = -1, a = 0.1, o = 2e3) {
    super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = e, this.right = t, this.top = r, this.bottom = n, this.near = a, this.far = o, this.updateProjectionMatrix();
  }
  copy(e, t) {
    return super.copy(e, t), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.near = e.near, this.far = e.far, this.zoom = e.zoom, this.view = e.view === null ? null : Object.assign({}, e.view), this;
  }
  setViewOffset(e, t, r, n, a, o) {
    this.view === null && (this.view = {
      enabled: !0,
      fullWidth: 1,
      fullHeight: 1,
      offsetX: 0,
      offsetY: 0,
      width: 1,
      height: 1
    }), this.view.enabled = !0, this.view.fullWidth = e, this.view.fullHeight = t, this.view.offsetX = r, this.view.offsetY = n, this.view.width = a, this.view.height = o, this.updateProjectionMatrix();
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
  }
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom), t = (this.top - this.bottom) / (2 * this.zoom), r = (this.right + this.left) / 2, n = (this.top + this.bottom) / 2;
    let a = r - e, o = r + e, s = n + t, c = n - t;
    if (this.view !== null && this.view.enabled) {
      const l = (this.right - this.left) / this.view.fullWidth / this.zoom, u = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
      a += l * this.view.offsetX, o = a + l * this.view.width, s -= u * this.view.offsetY, c = s - u * this.view.height;
    }
    this.projectionMatrix.makeOrthographic(a, o, s, c, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
  }
  toJSON(e) {
    const t = super.toJSON(e);
    return t.object.zoom = this.zoom, t.object.left = this.left, t.object.right = this.right, t.object.top = this.top, t.object.bottom = this.bottom, t.object.near = this.near, t.object.far = this.far, this.view !== null && (t.object.view = Object.assign({}, this.view)), t;
  }
}
const Mr = 4, zc = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582], Ui = 20, vs = /* @__PURE__ */ new jd(), Rc = /* @__PURE__ */ new Ce();
let Ms = null;
const Gi = (1 + Math.sqrt(5)) / 2, mr = 1 / Gi, kc = [
  /* @__PURE__ */ new W(1, 1, 1),
  /* @__PURE__ */ new W(-1, 1, 1),
  /* @__PURE__ */ new W(1, 1, -1),
  /* @__PURE__ */ new W(-1, 1, -1),
  /* @__PURE__ */ new W(0, Gi, mr),
  /* @__PURE__ */ new W(0, Gi, -mr),
  /* @__PURE__ */ new W(mr, 0, Gi),
  /* @__PURE__ */ new W(-mr, 0, Gi),
  /* @__PURE__ */ new W(Gi, mr, 0),
  /* @__PURE__ */ new W(-Gi, mr, 0)
];
class Wc {
  constructor(e) {
    this._renderer = e, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
  }
  fromScene(e, t = 0, r = 0.1, n = 100) {
    Ms = this._renderer.getRenderTarget(), this._setSize(256);
    const a = this._allocateTargets();
    return a.depthBuffer = !0, this._sceneToCubeUV(e, r, n, a), t > 0 && this._blur(a, 0, 0, t), this._applyPMREM(a), this._cleanup(a), a;
  }
  fromEquirectangular(e, t = null) {
    return this._fromTexture(e, t);
  }
  fromCubemap(e, t = null) {
    return this._fromTexture(e, t);
  }
  compileCubemapShader() {
    this._cubemapMaterial === null && (this._cubemapMaterial = Hc(), this._compileMaterial(this._cubemapMaterial));
  }
  compileEquirectangularShader() {
    this._equirectMaterial === null && (this._equirectMaterial = Uc(), this._compileMaterial(this._equirectMaterial));
  }
  dispose() {
    this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
  }
  _setSize(e) {
    this._lodMax = Math.floor(Math.log2(e)), this._cubeSize = Math.pow(2, this._lodMax);
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
    for (let e = 0; e < this._lodPlanes.length; e++)
      this._lodPlanes[e].dispose();
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(Ms), e.scissorTest = !1, Qn(e, 0, 0, e.width, e.height);
  }
  _fromTexture(e, t) {
    e.mapping === Dr || e.mapping === Tr ? this._setSize(e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width) : this._setSize(e.image.width / 4), Ms = this._renderer.getRenderTarget();
    const r = t || this._allocateTargets();
    return this._textureToCubeUV(e, r), this._applyPMREM(r), this._cleanup(r), r;
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112), t = 4 * this._cubeSize, r = {
      magFilter: wt,
      minFilter: wt,
      generateMipmaps: !1,
      type: un,
      format: jt,
      encoding: Xi,
      depthBuffer: !1
    }, n = Gc(e, t, r);
    if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== e) {
      this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = Gc(e, t, r);
      const { _lodMax: a } = this;
      ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = gI(a)), this._blurMaterial = vI(a, e, t);
    }
    return n;
  }
  _compileMaterial(e) {
    const t = new Di(this._lodPlanes[0], e);
    this._renderer.compile(t, vs);
  }
  _sceneToCubeUV(e, t, r, n) {
    const a = new Lt(90, 1, t, r), o = [1, -1, 1, 1, 1, 1], s = [1, 1, 1, -1, -1, -1], c = this._renderer, l = c.autoClear, u = c.toneMapping;
    c.getClearColor(Rc), c.toneMapping = hi, c.autoClear = !1;
    const h = new Ca({
      name: "PMREM.Background",
      side: zt,
      depthWrite: !1,
      depthTest: !1
    }), d = new Di(new In(), h);
    let v = !1;
    const M = e.background;
    M ? M.isColor && (h.color.copy(M), e.background = null, v = !0) : (h.color.copy(Rc), v = !0);
    for (let m = 0; m < 6; m++) {
      const g = m % 3;
      g === 0 ? (a.up.set(0, o[m], 0), a.lookAt(s[m], 0, 0)) : g === 1 ? (a.up.set(0, 0, o[m]), a.lookAt(0, s[m], 0)) : (a.up.set(0, o[m], 0), a.lookAt(0, 0, s[m]));
      const I = this._cubeSize;
      Qn(n, g * I, m > 2 ? I : 0, I, I), c.setRenderTarget(n), v && c.render(d, a), c.render(e, a);
    }
    d.geometry.dispose(), d.material.dispose(), c.toneMapping = u, c.autoClear = l, e.background = M;
  }
  _textureToCubeUV(e, t) {
    const r = this._renderer, n = e.mapping === Dr || e.mapping === Tr;
    n ? (this._cubemapMaterial === null && (this._cubemapMaterial = Hc()), this._cubemapMaterial.uniforms.flipEnvMap.value = e.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = Uc());
    const a = n ? this._cubemapMaterial : this._equirectMaterial, o = new Di(this._lodPlanes[0], a), s = a.uniforms;
    s.envMap.value = e;
    const c = this._cubeSize;
    Qn(t, 0, 0, 3 * c, 2 * c), r.setRenderTarget(t), r.render(o, vs);
  }
  _applyPMREM(e) {
    const t = this._renderer, r = t.autoClear;
    t.autoClear = !1;
    for (let n = 1; n < this._lodPlanes.length; n++) {
      const a = Math.sqrt(this._sigmas[n] * this._sigmas[n] - this._sigmas[n - 1] * this._sigmas[n - 1]), o = kc[(n - 1) % kc.length];
      this._blur(e, n - 1, n, a, o);
    }
    t.autoClear = r;
  }
  _blur(e, t, r, n, a) {
    const o = this._pingPongRenderTarget;
    this._halfBlur(
      e,
      o,
      t,
      r,
      n,
      "latitudinal",
      a
    ), this._halfBlur(
      o,
      e,
      r,
      r,
      n,
      "longitudinal",
      a
    );
  }
  _halfBlur(e, t, r, n, a, o, s) {
    const c = this._renderer, l = this._blurMaterial;
    o !== "latitudinal" && o !== "longitudinal" && console.error(
      "blur direction must be either latitudinal or longitudinal!"
    );
    const u = 3, h = new Di(this._lodPlanes[n], l), d = l.uniforms, v = this._sizeLods[r] - 1, M = isFinite(a) ? Math.PI / (2 * v) : 2 * Math.PI / (2 * Ui - 1), m = a / M, g = isFinite(a) ? 1 + Math.floor(u * m) : Ui;
    g > Ui && console.warn(`sigmaRadians, ${a}, is too large and will clip, as it requested ${g} samples when the maximum is set to ${Ui}`);
    const I = [];
    let A = 0;
    for (let B = 0; B < Ui; ++B) {
      const S = B / m, P = Math.exp(-S * S / 2);
      I.push(P), B === 0 ? A += P : B < g && (A += 2 * P);
    }
    for (let B = 0; B < I.length; B++)
      I[B] = I[B] / A;
    d.envMap.value = e.texture, d.samples.value = g, d.weights.value = I, d.latitudinal.value = o === "latitudinal", s && (d.poleAxis.value = s);
    const { _lodMax: L } = this;
    d.dTheta.value = M, d.mipInt.value = L - r;
    const y = this._sizeLods[n], D = 3 * y * (n > L - Mr ? n - L + Mr : 0), T = 4 * (this._cubeSize - y);
    Qn(t, D, T, 3 * y, 2 * y), c.setRenderTarget(t), c.render(h, vs);
  }
}
function gI(i) {
  const e = [], t = [], r = [];
  let n = i;
  const a = i - Mr + 1 + zc.length;
  for (let o = 0; o < a; o++) {
    const s = Math.pow(2, n);
    t.push(s);
    let c = 1 / s;
    o > i - Mr ? c = zc[o - i + Mr - 1] : o === 0 && (c = 0), r.push(c);
    const l = 1 / (s - 2), u = -l, h = 1 + l, d = [u, u, h, u, h, h, u, u, h, h, u, h], v = 6, M = 6, m = 3, g = 2, I = 1, A = new Float32Array(m * M * v), L = new Float32Array(g * M * v), y = new Float32Array(I * M * v);
    for (let T = 0; T < v; T++) {
      const B = T % 3 * 2 / 3 - 1, S = T > 2 ? 0 : -1, P = [
        B,
        S,
        0,
        B + 2 / 3,
        S,
        0,
        B + 2 / 3,
        S + 1,
        0,
        B,
        S,
        0,
        B + 2 / 3,
        S + 1,
        0,
        B,
        S + 1,
        0
      ];
      A.set(P, m * M * T), L.set(d, g * M * T);
      const G = [T, T, T, T, T, T];
      y.set(G, I * M * T);
    }
    const D = new ni();
    D.setAttribute("position", new At(A, m)), D.setAttribute("uv", new At(L, g)), D.setAttribute("faceIndex", new At(y, I)), e.push(D), n > Mr && n--;
  }
  return { lodPlanes: e, sizeLods: t, sigmas: r };
}
function Gc(i, e, t) {
  const r = new Ci(i, e, t);
  return r.texture.mapping = Sa, r.texture.name = "PMREM.cubeUv", r.scissorTest = !0, r;
}
function Qn(i, e, t, r, n) {
  i.viewport.set(e, t, r, n), i.scissor.set(e, t, r, n);
}
function vI(i, e, t) {
  const r = new Float32Array(Ui), n = new W(0, 1, 0);
  return new pi({
    name: "SphericalGaussianBlur",
    defines: {
      n: Ui,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${i}.0`
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: r },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: n }
    },
    vertexShader: oo(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
    blending: Ti,
    depthTest: !1,
    depthWrite: !1
  });
}
function Uc() {
  return new pi({
    name: "EquirectangularToCubeUV",
    uniforms: {
      envMap: { value: null }
    },
    vertexShader: oo(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
    blending: Ti,
    depthTest: !1,
    depthWrite: !1
  });
}
function Hc() {
  return new pi({
    name: "CubemapToCubeUV",
    uniforms: {
      envMap: { value: null },
      flipEnvMap: { value: -1 }
    },
    vertexShader: oo(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
    blending: Ti,
    depthTest: !1,
    depthWrite: !1
  });
}
function oo() {
  return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function MI(i) {
  let e = /* @__PURE__ */ new WeakMap(), t = null;
  function r(s) {
    if (s && s.isTexture) {
      const c = s.mapping, l = c === zs || c === Rs, u = c === Dr || c === Tr;
      if (l || u)
        if (s.isRenderTargetTexture && s.needsPMREMUpdate === !0) {
          s.needsPMREMUpdate = !1;
          let h = e.get(s);
          return t === null && (t = new Wc(i)), h = l ? t.fromEquirectangular(s, h) : t.fromCubemap(s, h), e.set(s, h), h.texture;
        } else {
          if (e.has(s))
            return e.get(s).texture;
          {
            const h = s.image;
            if (l && h && h.height > 0 || u && h && n(h)) {
              t === null && (t = new Wc(i));
              const d = l ? t.fromEquirectangular(s) : t.fromCubemap(s);
              return e.set(s, d), s.addEventListener("dispose", a), d.texture;
            } else
              return null;
          }
        }
    }
    return s;
  }
  function n(s) {
    let c = 0;
    const l = 6;
    for (let u = 0; u < l; u++)
      s[u] !== void 0 && c++;
    return c === l;
  }
  function a(s) {
    const c = s.target;
    c.removeEventListener("dispose", a);
    const l = e.get(c);
    l !== void 0 && (e.delete(c), l.dispose());
  }
  function o() {
    e = /* @__PURE__ */ new WeakMap(), t !== null && (t.dispose(), t = null);
  }
  return {
    get: r,
    dispose: o
  };
}
function yI(i) {
  const e = {};
  function t(r) {
    if (e[r] !== void 0)
      return e[r];
    let n;
    switch (r) {
      case "WEBGL_depth_texture":
        n = i.getExtension("WEBGL_depth_texture") || i.getExtension("MOZ_WEBGL_depth_texture") || i.getExtension("WEBKIT_WEBGL_depth_texture");
        break;
      case "EXT_texture_filter_anisotropic":
        n = i.getExtension("EXT_texture_filter_anisotropic") || i.getExtension("MOZ_EXT_texture_filter_anisotropic") || i.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
        break;
      case "WEBGL_compressed_texture_s3tc":
        n = i.getExtension("WEBGL_compressed_texture_s3tc") || i.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || i.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
        break;
      case "WEBGL_compressed_texture_pvrtc":
        n = i.getExtension("WEBGL_compressed_texture_pvrtc") || i.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
        break;
      default:
        n = i.getExtension(r);
    }
    return e[r] = n, n;
  }
  return {
    has: function(r) {
      return t(r) !== null;
    },
    init: function(r) {
      r.isWebGL2 ? t("EXT_color_buffer_float") : (t("WEBGL_depth_texture"), t("OES_texture_float"), t("OES_texture_half_float"), t("OES_texture_half_float_linear"), t("OES_standard_derivatives"), t("OES_element_index_uint"), t("OES_vertex_array_object"), t("ANGLE_instanced_arrays")), t("OES_texture_float_linear"), t("EXT_color_buffer_half_float"), t("WEBGL_multisampled_render_to_texture");
    },
    get: function(r) {
      const n = t(r);
      return n === null && console.warn("THREE.WebGLRenderer: " + r + " extension not supported."), n;
    }
  };
}
function xI(i, e, t, r) {
  const n = {}, a = /* @__PURE__ */ new WeakMap();
  function o(h) {
    const d = h.target;
    d.index !== null && e.remove(d.index);
    for (const M in d.attributes)
      e.remove(d.attributes[M]);
    d.removeEventListener("dispose", o), delete n[d.id];
    const v = a.get(d);
    v && (e.remove(v), a.delete(d)), r.releaseStatesOfGeometry(d), d.isInstancedBufferGeometry === !0 && delete d._maxInstanceCount, t.memory.geometries--;
  }
  function s(h, d) {
    return n[d.id] === !0 || (d.addEventListener("dispose", o), n[d.id] = !0, t.memory.geometries++), d;
  }
  function c(h) {
    const d = h.attributes;
    for (const M in d)
      e.update(d[M], 34962);
    const v = h.morphAttributes;
    for (const M in v) {
      const m = v[M];
      for (let g = 0, I = m.length; g < I; g++)
        e.update(m[g], 34962);
    }
  }
  function l(h) {
    const d = [], v = h.index, M = h.attributes.position;
    let m = 0;
    if (v !== null) {
      const A = v.array;
      m = v.version;
      for (let L = 0, y = A.length; L < y; L += 3) {
        const D = A[L + 0], T = A[L + 1], B = A[L + 2];
        d.push(D, T, T, B, B, D);
      }
    } else {
      const A = M.array;
      m = M.version;
      for (let L = 0, y = A.length / 3 - 1; L < y; L += 3) {
        const D = L + 0, T = L + 1, B = L + 2;
        d.push(D, T, T, B, B, D);
      }
    }
    const g = new (Id(d) ? Cd : Td)(d, 1);
    g.version = m;
    const I = a.get(h);
    I && e.remove(I), a.set(h, g);
  }
  function u(h) {
    const d = a.get(h);
    if (d) {
      const v = h.index;
      v !== null && d.version < v.version && l(h);
    } else
      l(h);
    return a.get(h);
  }
  return {
    get: s,
    update: c,
    getWireframeAttribute: u
  };
}
function II(i, e, t, r) {
  const n = r.isWebGL2;
  let a;
  function o(d) {
    a = d;
  }
  let s, c;
  function l(d) {
    s = d.type, c = d.bytesPerElement;
  }
  function u(d, v) {
    i.drawElements(a, v, s, d * c), t.update(v, a, 1);
  }
  function h(d, v, M) {
    if (M === 0)
      return;
    let m, g;
    if (n)
      m = i, g = "drawElementsInstanced";
    else if (m = e.get("ANGLE_instanced_arrays"), g = "drawElementsInstancedANGLE", m === null) {
      console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
      return;
    }
    m[g](a, v, s, d * c, M), t.update(v, a, M);
  }
  this.setMode = o, this.setIndex = l, this.render = u, this.renderInstances = h;
}
function bI(i) {
  const e = {
    geometries: 0,
    textures: 0
  }, t = {
    frame: 0,
    calls: 0,
    triangles: 0,
    points: 0,
    lines: 0
  };
  function r(a, o, s) {
    switch (t.calls++, o) {
      case 4:
        t.triangles += s * (a / 3);
        break;
      case 1:
        t.lines += s * (a / 2);
        break;
      case 3:
        t.lines += s * (a - 1);
        break;
      case 2:
        t.lines += s * a;
        break;
      case 0:
        t.points += s * a;
        break;
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", o);
        break;
    }
  }
  function n() {
    t.frame++, t.calls = 0, t.triangles = 0, t.points = 0, t.lines = 0;
  }
  return {
    memory: e,
    render: t,
    programs: null,
    autoReset: !0,
    reset: n,
    update: r
  };
}
function wI(i, e) {
  return i[0] - e[0];
}
function _I(i, e) {
  return Math.abs(e[1]) - Math.abs(i[1]);
}
function ys(i, e) {
  let t = 1;
  const r = e.isInterleavedBufferAttribute ? e.data.array : e.array;
  r instanceof Int8Array ? t = 127 : r instanceof Int16Array ? t = 32767 : r instanceof Int32Array ? t = 2147483647 : console.error("THREE.WebGLMorphtargets: Unsupported morph attribute data type: ", r), i.divideScalar(t);
}
function AI(i, e, t) {
  const r = {}, n = new Float32Array(8), a = /* @__PURE__ */ new WeakMap(), o = new et(), s = [];
  for (let l = 0; l < 8; l++)
    s[l] = [l, 0];
  function c(l, u, h, d) {
    const v = l.morphTargetInfluences;
    if (e.isWebGL2 === !0) {
      const M = u.morphAttributes.position || u.morphAttributes.normal || u.morphAttributes.color, m = M !== void 0 ? M.length : 0;
      let g = a.get(u);
      if (g === void 0 || g.count !== m) {
        let L = function() {
          z.dispose(), a.delete(u), u.removeEventListener("dispose", L);
        };
        g !== void 0 && g.texture.dispose();
        const y = u.morphAttributes.position !== void 0, D = u.morphAttributes.normal !== void 0, T = u.morphAttributes.color !== void 0, B = u.morphAttributes.position || [], S = u.morphAttributes.normal || [], P = u.morphAttributes.color || [];
        let G = 0;
        y === !0 && (G = 1), D === !0 && (G = 2), T === !0 && (G = 3);
        let U = u.attributes.position.count * G, le = 1;
        U > e.maxTextureSize && (le = Math.ceil(U / e.maxTextureSize), U = e.maxTextureSize);
        const ne = new Float32Array(U * le * 4 * m), z = new Ad(ne, U, le, m);
        z.type = Vi, z.needsUpdate = !0;
        const q = G * 4;
        for (let V = 0; V < m; V++) {
          const ie = B[V], K = S[V], Y = P[V], Q = U * le * 4 * V;
          for (let se = 0; se < ie.count; se++) {
            const X = se * q;
            y === !0 && (o.fromBufferAttribute(ie, se), ie.normalized === !0 && ys(o, ie), ne[Q + X + 0] = o.x, ne[Q + X + 1] = o.y, ne[Q + X + 2] = o.z, ne[Q + X + 3] = 0), D === !0 && (o.fromBufferAttribute(K, se), K.normalized === !0 && ys(o, K), ne[Q + X + 4] = o.x, ne[Q + X + 5] = o.y, ne[Q + X + 6] = o.z, ne[Q + X + 7] = 0), T === !0 && (o.fromBufferAttribute(Y, se), Y.normalized === !0 && ys(o, Y), ne[Q + X + 8] = o.x, ne[Q + X + 9] = o.y, ne[Q + X + 10] = o.z, ne[Q + X + 11] = Y.itemSize === 4 ? o.w : 1);
          }
        }
        g = {
          count: m,
          texture: z,
          size: new Re(U, le)
        }, a.set(u, g), u.addEventListener("dispose", L);
      }
      let I = 0;
      for (let L = 0; L < v.length; L++)
        I += v[L];
      const A = u.morphTargetsRelative ? 1 : 1 - I;
      d.getUniforms().setValue(i, "morphTargetBaseInfluence", A), d.getUniforms().setValue(i, "morphTargetInfluences", v), d.getUniforms().setValue(i, "morphTargetsTexture", g.texture, t), d.getUniforms().setValue(i, "morphTargetsTextureSize", g.size);
    } else {
      const M = v === void 0 ? 0 : v.length;
      let m = r[u.id];
      if (m === void 0 || m.length !== M) {
        m = [];
        for (let y = 0; y < M; y++)
          m[y] = [y, 0];
        r[u.id] = m;
      }
      for (let y = 0; y < M; y++) {
        const D = m[y];
        D[0] = y, D[1] = v[y];
      }
      m.sort(_I);
      for (let y = 0; y < 8; y++)
        y < M && m[y][1] ? (s[y][0] = m[y][0], s[y][1] = m[y][1]) : (s[y][0] = Number.MAX_SAFE_INTEGER, s[y][1] = 0);
      s.sort(wI);
      const g = u.morphAttributes.position, I = u.morphAttributes.normal;
      let A = 0;
      for (let y = 0; y < 8; y++) {
        const D = s[y], T = D[0], B = D[1];
        T !== Number.MAX_SAFE_INTEGER && B ? (g && u.getAttribute("morphTarget" + y) !== g[T] && u.setAttribute("morphTarget" + y, g[T]), I && u.getAttribute("morphNormal" + y) !== I[T] && u.setAttribute("morphNormal" + y, I[T]), n[y] = B, A += B) : (g && u.hasAttribute("morphTarget" + y) === !0 && u.deleteAttribute("morphTarget" + y), I && u.hasAttribute("morphNormal" + y) === !0 && u.deleteAttribute("morphNormal" + y), n[y] = 0);
      }
      const L = u.morphTargetsRelative ? 1 : 1 - A;
      d.getUniforms().setValue(i, "morphTargetBaseInfluence", L), d.getUniforms().setValue(i, "morphTargetInfluences", n);
    }
  }
  return {
    update: c
  };
}
function SI(i, e, t, r) {
  let n = /* @__PURE__ */ new WeakMap();
  function a(c) {
    const l = r.render.frame, u = c.geometry, h = e.get(c, u);
    return n.get(h) !== l && (e.update(h), n.set(h, l)), c.isInstancedMesh && (c.hasEventListener("dispose", s) === !1 && c.addEventListener("dispose", s), t.update(c.instanceMatrix, 34962), c.instanceColor !== null && t.update(c.instanceColor, 34962)), h;
  }
  function o() {
    n = /* @__PURE__ */ new WeakMap();
  }
  function s(c) {
    const l = c.target;
    l.removeEventListener("dispose", s), t.remove(l.instanceMatrix), l.instanceColor !== null && t.remove(l.instanceColor);
  }
  return {
    update: a,
    dispose: o
  };
}
const Bd = new Gt(), Od = new Ad(), zd = new g2(), Rd = new Nd(), Fc = [], Vc = [], Yc = new Float32Array(16), Zc = new Float32Array(9), Qc = new Float32Array(4);
function Br(i, e, t) {
  const r = i[0];
  if (r <= 0 || r > 0)
    return i;
  const n = e * t;
  let a = Fc[n];
  if (a === void 0 && (a = new Float32Array(n), Fc[n] = a), e !== 0) {
    r.toArray(a, 0);
    for (let o = 1, s = 0; o !== e; ++o)
      s += t, i[o].toArray(a, s);
  }
  return a;
}
function ct(i, e) {
  if (i.length !== e.length)
    return !1;
  for (let t = 0, r = i.length; t < r; t++)
    if (i[t] !== e[t])
      return !1;
  return !0;
}
function ut(i, e) {
  for (let t = 0, r = e.length; t < r; t++)
    i[t] = e[t];
}
function Ea(i, e) {
  let t = Vc[e];
  t === void 0 && (t = new Int32Array(e), Vc[e] = t);
  for (let r = 0; r !== e; ++r)
    t[r] = i.allocateTextureUnit();
  return t;
}
function DI(i, e) {
  const t = this.cache;
  t[0] !== e && (i.uniform1f(this.addr, e), t[0] = e);
}
function TI(i, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) && (i.uniform2f(this.addr, e.x, e.y), t[0] = e.x, t[1] = e.y);
  else {
    if (ct(t, e))
      return;
    i.uniform2fv(this.addr, e), ut(t, e);
  }
}
function CI(i, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) && (i.uniform3f(this.addr, e.x, e.y, e.z), t[0] = e.x, t[1] = e.y, t[2] = e.z);
  else if (e.r !== void 0)
    (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) && (i.uniform3f(this.addr, e.r, e.g, e.b), t[0] = e.r, t[1] = e.g, t[2] = e.b);
  else {
    if (ct(t, e))
      return;
    i.uniform3fv(this.addr, e), ut(t, e);
  }
}
function EI(i, e) {
  const t = this.cache;
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) && (i.uniform4f(this.addr, e.x, e.y, e.z, e.w), t[0] = e.x, t[1] = e.y, t[2] = e.z, t[3] = e.w);
  else {
    if (ct(t, e))
      return;
    i.uniform4fv(this.addr, e), ut(t, e);
  }
}
function NI(i, e) {
  const t = this.cache, r = e.elements;
  if (r === void 0) {
    if (ct(t, e))
      return;
    i.uniformMatrix2fv(this.addr, !1, e), ut(t, e);
  } else {
    if (ct(t, r))
      return;
    Qc.set(r), i.uniformMatrix2fv(this.addr, !1, Qc), ut(t, r);
  }
}
function LI(i, e) {
  const t = this.cache, r = e.elements;
  if (r === void 0) {
    if (ct(t, e))
      return;
    i.uniformMatrix3fv(this.addr, !1, e), ut(t, e);
  } else {
    if (ct(t, r))
      return;
    Zc.set(r), i.uniformMatrix3fv(this.addr, !1, Zc), ut(t, r);
  }
}
function PI(i, e) {
  const t = this.cache, r = e.elements;
  if (r === void 0) {
    if (ct(t, e))
      return;
    i.uniformMatrix4fv(this.addr, !1, e), ut(t, e);
  } else {
    if (ct(t, r))
      return;
    Yc.set(r), i.uniformMatrix4fv(this.addr, !1, Yc), ut(t, r);
  }
}
function jI(i, e) {
  const t = this.cache;
  t[0] !== e && (i.uniform1i(this.addr, e), t[0] = e);
}
function BI(i, e) {
  const t = this.cache;
  ct(t, e) || (i.uniform2iv(this.addr, e), ut(t, e));
}
function OI(i, e) {
  const t = this.cache;
  ct(t, e) || (i.uniform3iv(this.addr, e), ut(t, e));
}
function zI(i, e) {
  const t = this.cache;
  ct(t, e) || (i.uniform4iv(this.addr, e), ut(t, e));
}
function RI(i, e) {
  const t = this.cache;
  t[0] !== e && (i.uniform1ui(this.addr, e), t[0] = e);
}
function kI(i, e) {
  const t = this.cache;
  ct(t, e) || (i.uniform2uiv(this.addr, e), ut(t, e));
}
function WI(i, e) {
  const t = this.cache;
  ct(t, e) || (i.uniform3uiv(this.addr, e), ut(t, e));
}
function GI(i, e) {
  const t = this.cache;
  ct(t, e) || (i.uniform4uiv(this.addr, e), ut(t, e));
}
function UI(i, e, t) {
  const r = this.cache, n = t.allocateTextureUnit();
  r[0] !== n && (i.uniform1i(this.addr, n), r[0] = n), t.setTexture2D(e || Bd, n);
}
function HI(i, e, t) {
  const r = this.cache, n = t.allocateTextureUnit();
  r[0] !== n && (i.uniform1i(this.addr, n), r[0] = n), t.setTexture3D(e || zd, n);
}
function FI(i, e, t) {
  const r = this.cache, n = t.allocateTextureUnit();
  r[0] !== n && (i.uniform1i(this.addr, n), r[0] = n), t.setTextureCube(e || Rd, n);
}
function VI(i, e, t) {
  const r = this.cache, n = t.allocateTextureUnit();
  r[0] !== n && (i.uniform1i(this.addr, n), r[0] = n), t.setTexture2DArray(e || Od, n);
}
function YI(i) {
  switch (i) {
    case 5126:
      return DI;
    case 35664:
      return TI;
    case 35665:
      return CI;
    case 35666:
      return EI;
    case 35674:
      return NI;
    case 35675:
      return LI;
    case 35676:
      return PI;
    case 5124:
    case 35670:
      return jI;
    case 35667:
    case 35671:
      return BI;
    case 35668:
    case 35672:
      return OI;
    case 35669:
    case 35673:
      return zI;
    case 5125:
      return RI;
    case 36294:
      return kI;
    case 36295:
      return WI;
    case 36296:
      return GI;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return UI;
    case 35679:
    case 36299:
    case 36307:
      return HI;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return FI;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return VI;
  }
}
function ZI(i, e) {
  i.uniform1fv(this.addr, e);
}
function QI(i, e) {
  const t = Br(e, this.size, 2);
  i.uniform2fv(this.addr, t);
}
function JI(i, e) {
  const t = Br(e, this.size, 3);
  i.uniform3fv(this.addr, t);
}
function XI(i, e) {
  const t = Br(e, this.size, 4);
  i.uniform4fv(this.addr, t);
}
function $I(i, e) {
  const t = Br(e, this.size, 4);
  i.uniformMatrix2fv(this.addr, !1, t);
}
function qI(i, e) {
  const t = Br(e, this.size, 9);
  i.uniformMatrix3fv(this.addr, !1, t);
}
function KI(i, e) {
  const t = Br(e, this.size, 16);
  i.uniformMatrix4fv(this.addr, !1, t);
}
function eb(i, e) {
  i.uniform1iv(this.addr, e);
}
function tb(i, e) {
  i.uniform2iv(this.addr, e);
}
function ib(i, e) {
  i.uniform3iv(this.addr, e);
}
function rb(i, e) {
  i.uniform4iv(this.addr, e);
}
function nb(i, e) {
  i.uniform1uiv(this.addr, e);
}
function ab(i, e) {
  i.uniform2uiv(this.addr, e);
}
function sb(i, e) {
  i.uniform3uiv(this.addr, e);
}
function ob(i, e) {
  i.uniform4uiv(this.addr, e);
}
function lb(i, e, t) {
  const r = e.length, n = Ea(t, r);
  i.uniform1iv(this.addr, n);
  for (let a = 0; a !== r; ++a)
    t.setTexture2D(e[a] || Bd, n[a]);
}
function cb(i, e, t) {
  const r = e.length, n = Ea(t, r);
  i.uniform1iv(this.addr, n);
  for (let a = 0; a !== r; ++a)
    t.setTexture3D(e[a] || zd, n[a]);
}
function ub(i, e, t) {
  const r = e.length, n = Ea(t, r);
  i.uniform1iv(this.addr, n);
  for (let a = 0; a !== r; ++a)
    t.setTextureCube(e[a] || Rd, n[a]);
}
function db(i, e, t) {
  const r = e.length, n = Ea(t, r);
  i.uniform1iv(this.addr, n);
  for (let a = 0; a !== r; ++a)
    t.setTexture2DArray(e[a] || Od, n[a]);
}
function hb(i) {
  switch (i) {
    case 5126:
      return ZI;
    case 35664:
      return QI;
    case 35665:
      return JI;
    case 35666:
      return XI;
    case 35674:
      return $I;
    case 35675:
      return qI;
    case 35676:
      return KI;
    case 5124:
    case 35670:
      return eb;
    case 35667:
    case 35671:
      return tb;
    case 35668:
    case 35672:
      return ib;
    case 35669:
    case 35673:
      return rb;
    case 5125:
      return nb;
    case 36294:
      return ab;
    case 36295:
      return sb;
    case 36296:
      return ob;
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return lb;
    case 35679:
    case 36299:
    case 36307:
      return cb;
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return ub;
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return db;
  }
}
class pb {
  constructor(e, t, r) {
    this.id = e, this.addr = r, this.cache = [], this.setValue = YI(t.type);
  }
}
class fb {
  constructor(e, t, r) {
    this.id = e, this.addr = r, this.cache = [], this.size = t.size, this.setValue = hb(t.type);
  }
}
class mb {
  constructor(e) {
    this.id = e, this.seq = [], this.map = {};
  }
  setValue(e, t, r) {
    const n = this.seq;
    for (let a = 0, o = n.length; a !== o; ++a) {
      const s = n[a];
      s.setValue(e, t[s.id], r);
    }
  }
}
const xs = /(\w+)(\])?(\[|\.)?/g;
function Jc(i, e) {
  i.seq.push(e), i.map[e.id] = e;
}
function gb(i, e, t) {
  const r = i.name, n = r.length;
  for (xs.lastIndex = 0; ; ) {
    const a = xs.exec(r), o = xs.lastIndex;
    let s = a[1];
    const c = a[2] === "]", l = a[3];
    if (c && (s = s | 0), l === void 0 || l === "[" && o + 2 === n) {
      Jc(t, l === void 0 ? new pb(s, i, e) : new fb(s, i, e));
      break;
    } else {
      let u = t.map[s];
      u === void 0 && (u = new mb(s), Jc(t, u)), t = u;
    }
  }
}
class ia {
  constructor(e, t) {
    this.seq = [], this.map = {};
    const r = e.getProgramParameter(t, 35718);
    for (let n = 0; n < r; ++n) {
      const a = e.getActiveUniform(t, n), o = e.getUniformLocation(t, a.name);
      gb(a, o, this);
    }
  }
  setValue(e, t, r, n) {
    const a = this.map[t];
    a !== void 0 && a.setValue(e, r, n);
  }
  setOptional(e, t, r) {
    const n = t[r];
    n !== void 0 && this.setValue(e, r, n);
  }
  static upload(e, t, r, n) {
    for (let a = 0, o = t.length; a !== o; ++a) {
      const s = t[a], c = r[s.id];
      c.needsUpdate !== !1 && s.setValue(e, c.value, n);
    }
  }
  static seqWithValue(e, t) {
    const r = [];
    for (let n = 0, a = e.length; n !== a; ++n) {
      const o = e[n];
      o.id in t && r.push(o);
    }
    return r;
  }
}
function Xc(i, e, t) {
  const r = i.createShader(e);
  return i.shaderSource(r, t), i.compileShader(r), r;
}
let vb = 0;
function Mb(i, e) {
  const t = i.split(`
`), r = [], n = Math.max(e - 6, 0), a = Math.min(e + 6, t.length);
  for (let o = n; o < a; o++) {
    const s = o + 1;
    r.push(`${s === e ? ">" : " "} ${s}: ${t[o]}`);
  }
  return r.join(`
`);
}
function yb(i) {
  switch (i) {
    case Xi:
      return ["Linear", "( value )"];
    case Qe:
      return ["sRGB", "( value )"];
    default:
      return console.warn("THREE.WebGLProgram: Unsupported encoding:", i), ["Linear", "( value )"];
  }
}
function $c(i, e, t) {
  const r = i.getShaderParameter(e, 35713), n = i.getShaderInfoLog(e).trim();
  if (r && n === "")
    return "";
  const a = /ERROR: 0:(\d+)/.exec(n);
  if (a) {
    const o = parseInt(a[1]);
    return t.toUpperCase() + `

` + n + `

` + Mb(i.getShaderSource(e), o);
  } else
    return n;
}
function xb(i, e) {
  const t = yb(e);
  return "vec4 " + i + "( vec4 value ) { return LinearTo" + t[0] + t[1] + "; }";
}
function Ib(i, e) {
  let t;
  switch (e) {
    case H1:
      t = "Linear";
      break;
    case F1:
      t = "Reinhard";
      break;
    case V1:
      t = "OptimizedCineon";
      break;
    case Y1:
      t = "ACESFilmic";
      break;
    case Z1:
      t = "Custom";
      break;
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), t = "Linear";
  }
  return "vec3 " + i + "( vec3 color ) { return " + t + "ToneMapping( color ); }";
}
function bb(i) {
  return [
    i.extensionDerivatives || !!i.envMapCubeUVHeight || i.bumpMap || i.tangentSpaceNormalMap || i.clearcoatNormalMap || i.flatShading || i.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
    (i.extensionFragDepth || i.logarithmicDepthBuffer) && i.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
    i.extensionDrawBuffers && i.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
    (i.extensionShaderTextureLOD || i.envMap || i.transmission) && i.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
  ].filter(Qr).join(`
`);
}
function wb(i) {
  const e = [];
  for (const t in i) {
    const r = i[t];
    r !== !1 && e.push("#define " + t + " " + r);
  }
  return e.join(`
`);
}
function _b(i, e) {
  const t = {}, r = i.getProgramParameter(e, 35721);
  for (let n = 0; n < r; n++) {
    const a = i.getActiveAttrib(e, n), o = a.name;
    let s = 1;
    a.type === 35674 && (s = 2), a.type === 35675 && (s = 3), a.type === 35676 && (s = 4), t[o] = {
      type: a.type,
      location: i.getAttribLocation(e, o),
      locationSize: s
    };
  }
  return t;
}
function Qr(i) {
  return i !== "";
}
function qc(i, e) {
  return i.replace(/NUM_DIR_LIGHTS/g, e.numDirLights).replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, e.numPointLights).replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows);
}
function Kc(i, e) {
  return i.replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection);
}
const Ab = /^[ \t]*#include +<([\w\d./]+)>/gm;
function Hs(i) {
  return i.replace(Ab, Sb);
}
function Sb(i, e) {
  const t = Ee[e];
  if (t === void 0)
    throw new Error("Can not resolve #include <" + e + ">");
  return Hs(t);
}
const Db = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g, Tb = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function eu(i) {
  return i.replace(Tb, kd).replace(Db, Cb);
}
function Cb(i, e, t, r) {
  return console.warn("WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead."), kd(i, e, t, r);
}
function kd(i, e, t, r) {
  let n = "";
  for (let a = parseInt(e); a < parseInt(t); a++)
    n += r.replace(/\[\s*i\s*\]/g, "[ " + a + " ]").replace(/UNROLLED_LOOP_INDEX/g, a);
  return n;
}
function tu(i) {
  let e = "precision " + i.precision + ` float;
precision ` + i.precision + " int;";
  return i.precision === "highp" ? e += `
#define HIGH_PRECISION` : i.precision === "mediump" ? e += `
#define MEDIUM_PRECISION` : i.precision === "lowp" && (e += `
#define LOW_PRECISION`), e;
}
function Eb(i) {
  let e = "SHADOWMAP_TYPE_BASIC";
  return i.shadowMapType === gd ? e = "SHADOWMAP_TYPE_PCF" : i.shadowMapType === x1 ? e = "SHADOWMAP_TYPE_PCF_SOFT" : i.shadowMapType === Zr && (e = "SHADOWMAP_TYPE_VSM"), e;
}
function Nb(i) {
  let e = "ENVMAP_TYPE_CUBE";
  if (i.envMap)
    switch (i.envMapMode) {
      case Dr:
      case Tr:
        e = "ENVMAP_TYPE_CUBE";
        break;
      case Sa:
        e = "ENVMAP_TYPE_CUBE_UV";
        break;
    }
  return e;
}
function Lb(i) {
  let e = "ENVMAP_MODE_REFLECTION";
  if (i.envMap)
    switch (i.envMapMode) {
      case Tr:
        e = "ENVMAP_MODE_REFRACTION";
        break;
    }
  return e;
}
function Pb(i) {
  let e = "ENVMAP_BLENDING_NONE";
  if (i.envMap)
    switch (i.combine) {
      case Aa:
        e = "ENVMAP_BLENDING_MULTIPLY";
        break;
      case G1:
        e = "ENVMAP_BLENDING_MIX";
        break;
      case U1:
        e = "ENVMAP_BLENDING_ADD";
        break;
    }
  return e;
}
function jb(i) {
  const e = i.envMapCubeUVHeight;
  if (e === null)
    return null;
  const t = Math.log2(e) - 2, r = 1 / e;
  return { texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 7 * 16)), texelHeight: r, maxMip: t };
}
function Bb(i, e, t, r) {
  const n = i.getContext(), a = t.defines;
  let o = t.vertexShader, s = t.fragmentShader;
  const c = Eb(t), l = Nb(t), u = Lb(t), h = Pb(t), d = jb(t), v = t.isWebGL2 ? "" : bb(t), M = wb(a), m = n.createProgram();
  let g, I, A = t.glslVersion ? "#version " + t.glslVersion + `
` : "";
  t.isRawShaderMaterial ? (g = [
    M
  ].filter(Qr).join(`
`), g.length > 0 && (g += `
`), I = [
    v,
    M
  ].filter(Qr).join(`
`), I.length > 0 && (I += `
`)) : (g = [
    tu(t),
    "#define SHADER_NAME " + t.shaderName,
    M,
    t.instancing ? "#define USE_INSTANCING" : "",
    t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
    t.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.map ? "#define USE_MAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + u : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMap && t.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
    t.normalMap && t.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.displacementMap && t.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
    t.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
    t.vertexTangents ? "#define USE_TANGENT" : "",
    t.vertexColors ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUvs ? "#define USE_UV" : "",
    t.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.skinning ? "#define USE_SKINNING" : "",
    t.morphTargets ? "#define USE_MORPHTARGETS" : "",
    t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
    t.morphColors && t.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
    t.morphTargetsCount > 0 && t.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
    t.morphTargetsCount > 0 && t.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride : "",
    t.morphTargetsCount > 0 && t.isWebGL2 ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + c : "",
    t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    t.logarithmicDepthBuffer && t.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 modelMatrix;",
    "uniform mat4 modelViewMatrix;",
    "uniform mat4 projectionMatrix;",
    "uniform mat4 viewMatrix;",
    "uniform mat3 normalMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    "#ifdef USE_INSTANCING",
    "	attribute mat4 instanceMatrix;",
    "#endif",
    "#ifdef USE_INSTANCING_COLOR",
    "	attribute vec3 instanceColor;",
    "#endif",
    "attribute vec3 position;",
    "attribute vec3 normal;",
    "attribute vec2 uv;",
    "#ifdef USE_TANGENT",
    "	attribute vec4 tangent;",
    "#endif",
    "#if defined( USE_COLOR_ALPHA )",
    "	attribute vec4 color;",
    "#elif defined( USE_COLOR )",
    "	attribute vec3 color;",
    "#endif",
    "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
    "	attribute vec3 morphTarget0;",
    "	attribute vec3 morphTarget1;",
    "	attribute vec3 morphTarget2;",
    "	attribute vec3 morphTarget3;",
    "	#ifdef USE_MORPHNORMALS",
    "		attribute vec3 morphNormal0;",
    "		attribute vec3 morphNormal1;",
    "		attribute vec3 morphNormal2;",
    "		attribute vec3 morphNormal3;",
    "	#else",
    "		attribute vec3 morphTarget4;",
    "		attribute vec3 morphTarget5;",
    "		attribute vec3 morphTarget6;",
    "		attribute vec3 morphTarget7;",
    "	#endif",
    "#endif",
    "#ifdef USE_SKINNING",
    "	attribute vec4 skinIndex;",
    "	attribute vec4 skinWeight;",
    "#endif",
    `
`
  ].filter(Qr).join(`
`), I = [
    v,
    tu(t),
    "#define SHADER_NAME " + t.shaderName,
    M,
    t.useFog && t.fog ? "#define USE_FOG" : "",
    t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
    t.map ? "#define USE_MAP" : "",
    t.matcap ? "#define USE_MATCAP" : "",
    t.envMap ? "#define USE_ENVMAP" : "",
    t.envMap ? "#define " + l : "",
    t.envMap ? "#define " + u : "",
    t.envMap ? "#define " + h : "",
    d ? "#define CUBEUV_TEXEL_WIDTH " + d.texelWidth : "",
    d ? "#define CUBEUV_TEXEL_HEIGHT " + d.texelHeight : "",
    d ? "#define CUBEUV_MAX_MIP " + d.maxMip + ".0" : "",
    t.lightMap ? "#define USE_LIGHTMAP" : "",
    t.aoMap ? "#define USE_AOMAP" : "",
    t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
    t.bumpMap ? "#define USE_BUMPMAP" : "",
    t.normalMap ? "#define USE_NORMALMAP" : "",
    t.normalMap && t.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
    t.normalMap && t.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
    t.clearcoat ? "#define USE_CLEARCOAT" : "",
    t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
    t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
    t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
    t.iridescence ? "#define USE_IRIDESCENCE" : "",
    t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
    t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
    t.specularMap ? "#define USE_SPECULARMAP" : "",
    t.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
    t.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
    t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
    t.metalnessMap ? "#define USE_METALNESSMAP" : "",
    t.alphaMap ? "#define USE_ALPHAMAP" : "",
    t.alphaTest ? "#define USE_ALPHATEST" : "",
    t.sheen ? "#define USE_SHEEN" : "",
    t.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
    t.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
    t.transmission ? "#define USE_TRANSMISSION" : "",
    t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
    t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
    t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
    t.vertexTangents ? "#define USE_TANGENT" : "",
    t.vertexColors || t.instancingColor ? "#define USE_COLOR" : "",
    t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
    t.vertexUvs ? "#define USE_UV" : "",
    t.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
    t.gradientMap ? "#define USE_GRADIENTMAP" : "",
    t.flatShading ? "#define FLAT_SHADED" : "",
    t.doubleSided ? "#define DOUBLE_SIDED" : "",
    t.flipSided ? "#define FLIP_SIDED" : "",
    t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
    t.shadowMapEnabled ? "#define " + c : "",
    t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
    t.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
    t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
    t.logarithmicDepthBuffer && t.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
    "uniform mat4 viewMatrix;",
    "uniform vec3 cameraPosition;",
    "uniform bool isOrthographic;",
    t.toneMapping !== hi ? "#define TONE_MAPPING" : "",
    t.toneMapping !== hi ? Ee.tonemapping_pars_fragment : "",
    t.toneMapping !== hi ? Ib("toneMapping", t.toneMapping) : "",
    t.dithering ? "#define DITHERING" : "",
    t.opaque ? "#define OPAQUE" : "",
    Ee.encodings_pars_fragment,
    xb("linearToOutputTexel", t.outputEncoding),
    t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
    `
`
  ].filter(Qr).join(`
`)), o = Hs(o), o = qc(o, t), o = Kc(o, t), s = Hs(s), s = qc(s, t), s = Kc(s, t), o = eu(o), s = eu(s), t.isWebGL2 && t.isRawShaderMaterial !== !0 && (A = `#version 300 es
`, g = [
    "precision mediump sampler2DArray;",
    "#define attribute in",
    "#define varying out",
    "#define texture2D texture"
  ].join(`
`) + `
` + g, I = [
    "#define varying in",
    t.glslVersion === wc ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
    t.glslVersion === wc ? "" : "#define gl_FragColor pc_fragColor",
    "#define gl_FragDepthEXT gl_FragDepth",
    "#define texture2D texture",
    "#define textureCube texture",
    "#define texture2DProj textureProj",
    "#define texture2DLodEXT textureLod",
    "#define texture2DProjLodEXT textureProjLod",
    "#define textureCubeLodEXT textureLod",
    "#define texture2DGradEXT textureGrad",
    "#define texture2DProjGradEXT textureProjGrad",
    "#define textureCubeGradEXT textureGrad"
  ].join(`
`) + `
` + I);
  const L = A + g + o, y = A + I + s, D = Xc(n, 35633, L), T = Xc(n, 35632, y);
  if (n.attachShader(m, D), n.attachShader(m, T), t.index0AttributeName !== void 0 ? n.bindAttribLocation(m, 0, t.index0AttributeName) : t.morphTargets === !0 && n.bindAttribLocation(m, 0, "position"), n.linkProgram(m), i.debug.checkShaderErrors) {
    const P = n.getProgramInfoLog(m).trim(), G = n.getShaderInfoLog(D).trim(), U = n.getShaderInfoLog(T).trim();
    let le = !0, ne = !0;
    if (n.getProgramParameter(m, 35714) === !1) {
      le = !1;
      const z = $c(n, D, "vertex"), q = $c(n, T, "fragment");
      console.error(
        "THREE.WebGLProgram: Shader Error " + n.getError() + " - VALIDATE_STATUS " + n.getProgramParameter(m, 35715) + `

Program Info Log: ` + P + `
` + z + `
` + q
      );
    } else
      P !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", P) : (G === "" || U === "") && (ne = !1);
    ne && (this.diagnostics = {
      runnable: le,
      programLog: P,
      vertexShader: {
        log: G,
        prefix: g
      },
      fragmentShader: {
        log: U,
        prefix: I
      }
    });
  }
  n.deleteShader(D), n.deleteShader(T);
  let B;
  this.getUniforms = function() {
    return B === void 0 && (B = new ia(n, m)), B;
  };
  let S;
  return this.getAttributes = function() {
    return S === void 0 && (S = _b(n, m)), S;
  }, this.destroy = function() {
    r.releaseStatesOfProgram(this), n.deleteProgram(m), this.program = void 0;
  }, this.name = t.shaderName, this.id = vb++, this.cacheKey = e, this.usedTimes = 1, this.program = m, this.vertexShader = D, this.fragmentShader = T, this;
}
let Ob = 0;
class zb {
  constructor() {
    this.shaderCache = /* @__PURE__ */ new Map(), this.materialCache = /* @__PURE__ */ new Map();
  }
  update(e) {
    const t = e.vertexShader, r = e.fragmentShader, n = this._getShaderStage(t), a = this._getShaderStage(r), o = this._getShaderCacheForMaterial(e);
    return o.has(n) === !1 && (o.add(n), n.usedTimes++), o.has(a) === !1 && (o.add(a), a.usedTimes++), this;
  }
  remove(e) {
    const t = this.materialCache.get(e);
    for (const r of t)
      r.usedTimes--, r.usedTimes === 0 && this.shaderCache.delete(r.code);
    return this.materialCache.delete(e), this;
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id;
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id;
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear();
  }
  _getShaderCacheForMaterial(e) {
    const t = this.materialCache;
    return t.has(e) === !1 && t.set(e, /* @__PURE__ */ new Set()), t.get(e);
  }
  _getShaderStage(e) {
    const t = this.shaderCache;
    if (t.has(e) === !1) {
      const r = new Rb(e);
      t.set(e, r);
    }
    return t.get(e);
  }
}
class Rb {
  constructor(e) {
    this.id = Ob++, this.code = e, this.usedTimes = 0;
  }
}
function kb(i, e, t, r, n, a, o) {
  const s = new Dd(), c = new zb(), l = [], u = n.isWebGL2, h = n.logarithmicDepthBuffer, d = n.vertexTextures;
  let v = n.precision;
  const M = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite"
  };
  function m(S, P, G, U, le) {
    const ne = U.fog, z = le.geometry, q = S.isMeshStandardMaterial ? U.environment : null, V = (S.isMeshStandardMaterial ? t : e).get(S.envMap || q), ie = !!V && V.mapping === Sa ? V.image.height : null, K = M[S.type];
    S.precision !== null && (v = n.getMaxPrecision(S.precision), v !== S.precision && console.warn("THREE.WebGLProgram.getParameters:", S.precision, "not supported, using", v, "instead."));
    const Y = z.morphAttributes.position || z.morphAttributes.normal || z.morphAttributes.color, Q = Y !== void 0 ? Y.length : 0;
    let se = 0;
    z.morphAttributes.position !== void 0 && (se = 1), z.morphAttributes.normal !== void 0 && (se = 2), z.morphAttributes.color !== void 0 && (se = 3);
    let X, ue, fe, ye;
    if (K) {
      const de = $t[K];
      X = de.vertexShader, ue = de.fragmentShader;
    } else
      X = S.vertexShader, ue = S.fragmentShader, c.update(S), fe = c.getVertexShaderID(S), ye = c.getFragmentShaderID(S);
    const $ = i.getRenderTarget(), Le = S.alphaTest > 0, Me = S.clearcoat > 0, we = S.iridescence > 0;
    return {
      isWebGL2: u,
      shaderID: K,
      shaderName: S.type,
      vertexShader: X,
      fragmentShader: ue,
      defines: S.defines,
      customVertexShaderID: fe,
      customFragmentShaderID: ye,
      isRawShaderMaterial: S.isRawShaderMaterial === !0,
      glslVersion: S.glslVersion,
      precision: v,
      instancing: le.isInstancedMesh === !0,
      instancingColor: le.isInstancedMesh === !0 && le.instanceColor !== null,
      supportsVertexTextures: d,
      outputEncoding: $ === null ? i.outputEncoding : $.isXRRenderTarget === !0 ? $.texture.encoding : Xi,
      map: !!S.map,
      matcap: !!S.matcap,
      envMap: !!V,
      envMapMode: V && V.mapping,
      envMapCubeUVHeight: ie,
      lightMap: !!S.lightMap,
      aoMap: !!S.aoMap,
      emissiveMap: !!S.emissiveMap,
      bumpMap: !!S.bumpMap,
      normalMap: !!S.normalMap,
      objectSpaceNormalMap: S.normalMapType === h2,
      tangentSpaceNormalMap: S.normalMapType === Pr,
      decodeVideoTexture: !!S.map && S.map.isVideoTexture === !0 && S.map.encoding === Qe,
      clearcoat: Me,
      clearcoatMap: Me && !!S.clearcoatMap,
      clearcoatRoughnessMap: Me && !!S.clearcoatRoughnessMap,
      clearcoatNormalMap: Me && !!S.clearcoatNormalMap,
      iridescence: we,
      iridescenceMap: we && !!S.iridescenceMap,
      iridescenceThicknessMap: we && !!S.iridescenceThicknessMap,
      displacementMap: !!S.displacementMap,
      roughnessMap: !!S.roughnessMap,
      metalnessMap: !!S.metalnessMap,
      specularMap: !!S.specularMap,
      specularIntensityMap: !!S.specularIntensityMap,
      specularColorMap: !!S.specularColorMap,
      opaque: S.transparent === !1 && S.blending === Ir,
      alphaMap: !!S.alphaMap,
      alphaTest: Le,
      gradientMap: !!S.gradientMap,
      sheen: S.sheen > 0,
      sheenColorMap: !!S.sheenColorMap,
      sheenRoughnessMap: !!S.sheenRoughnessMap,
      transmission: S.transmission > 0,
      transmissionMap: !!S.transmissionMap,
      thicknessMap: !!S.thicknessMap,
      combine: S.combine,
      vertexTangents: !!S.normalMap && !!z.attributes.tangent,
      vertexColors: S.vertexColors,
      vertexAlphas: S.vertexColors === !0 && !!z.attributes.color && z.attributes.color.itemSize === 4,
      vertexUvs: !!S.map || !!S.bumpMap || !!S.normalMap || !!S.specularMap || !!S.alphaMap || !!S.emissiveMap || !!S.roughnessMap || !!S.metalnessMap || !!S.clearcoatMap || !!S.clearcoatRoughnessMap || !!S.clearcoatNormalMap || !!S.iridescenceMap || !!S.iridescenceThicknessMap || !!S.displacementMap || !!S.transmissionMap || !!S.thicknessMap || !!S.specularIntensityMap || !!S.specularColorMap || !!S.sheenColorMap || !!S.sheenRoughnessMap,
      uvsVertexOnly: !(!!S.map || !!S.bumpMap || !!S.normalMap || !!S.specularMap || !!S.alphaMap || !!S.emissiveMap || !!S.roughnessMap || !!S.metalnessMap || !!S.clearcoatNormalMap || !!S.iridescenceMap || !!S.iridescenceThicknessMap || S.transmission > 0 || !!S.transmissionMap || !!S.thicknessMap || !!S.specularIntensityMap || !!S.specularColorMap || S.sheen > 0 || !!S.sheenColorMap || !!S.sheenRoughnessMap) && !!S.displacementMap,
      fog: !!ne,
      useFog: S.fog === !0,
      fogExp2: ne && ne.isFogExp2,
      flatShading: !!S.flatShading,
      sizeAttenuation: S.sizeAttenuation,
      logarithmicDepthBuffer: h,
      skinning: le.isSkinnedMesh === !0,
      morphTargets: z.morphAttributes.position !== void 0,
      morphNormals: z.morphAttributes.normal !== void 0,
      morphColors: z.morphAttributes.color !== void 0,
      morphTargetsCount: Q,
      morphTextureStride: se,
      numDirLights: P.directional.length,
      numPointLights: P.point.length,
      numSpotLights: P.spot.length,
      numRectAreaLights: P.rectArea.length,
      numHemiLights: P.hemi.length,
      numDirLightShadows: P.directionalShadowMap.length,
      numPointLightShadows: P.pointShadowMap.length,
      numSpotLightShadows: P.spotShadowMap.length,
      numClippingPlanes: o.numPlanes,
      numClipIntersection: o.numIntersection,
      dithering: S.dithering,
      shadowMapEnabled: i.shadowMap.enabled && G.length > 0,
      shadowMapType: i.shadowMap.type,
      toneMapping: S.toneMapped ? i.toneMapping : hi,
      physicallyCorrectLights: i.physicallyCorrectLights,
      premultipliedAlpha: S.premultipliedAlpha,
      doubleSided: S.side === Sr,
      flipSided: S.side === zt,
      useDepthPacking: !!S.depthPacking,
      depthPacking: S.depthPacking || 0,
      index0AttributeName: S.index0AttributeName,
      extensionDerivatives: S.extensions && S.extensions.derivatives,
      extensionFragDepth: S.extensions && S.extensions.fragDepth,
      extensionDrawBuffers: S.extensions && S.extensions.drawBuffers,
      extensionShaderTextureLOD: S.extensions && S.extensions.shaderTextureLOD,
      rendererExtensionFragDepth: u || r.has("EXT_frag_depth"),
      rendererExtensionDrawBuffers: u || r.has("WEBGL_draw_buffers"),
      rendererExtensionShaderTextureLod: u || r.has("EXT_shader_texture_lod"),
      customProgramCacheKey: S.customProgramCacheKey()
    };
  }
  function g(S) {
    const P = [];
    if (S.shaderID ? P.push(S.shaderID) : (P.push(S.customVertexShaderID), P.push(S.customFragmentShaderID)), S.defines !== void 0)
      for (const G in S.defines)
        P.push(G), P.push(S.defines[G]);
    return S.isRawShaderMaterial === !1 && (I(P, S), A(P, S), P.push(i.outputEncoding)), P.push(S.customProgramCacheKey), P.join();
  }
  function I(S, P) {
    S.push(P.precision), S.push(P.outputEncoding), S.push(P.envMapMode), S.push(P.envMapCubeUVHeight), S.push(P.combine), S.push(P.vertexUvs), S.push(P.fogExp2), S.push(P.sizeAttenuation), S.push(P.morphTargetsCount), S.push(P.morphAttributeCount), S.push(P.numDirLights), S.push(P.numPointLights), S.push(P.numSpotLights), S.push(P.numHemiLights), S.push(P.numRectAreaLights), S.push(P.numDirLightShadows), S.push(P.numPointLightShadows), S.push(P.numSpotLightShadows), S.push(P.shadowMapType), S.push(P.toneMapping), S.push(P.numClippingPlanes), S.push(P.numClipIntersection), S.push(P.depthPacking);
  }
  function A(S, P) {
    s.disableAll(), P.isWebGL2 && s.enable(0), P.supportsVertexTextures && s.enable(1), P.instancing && s.enable(2), P.instancingColor && s.enable(3), P.map && s.enable(4), P.matcap && s.enable(5), P.envMap && s.enable(6), P.lightMap && s.enable(7), P.aoMap && s.enable(8), P.emissiveMap && s.enable(9), P.bumpMap && s.enable(10), P.normalMap && s.enable(11), P.objectSpaceNormalMap && s.enable(12), P.tangentSpaceNormalMap && s.enable(13), P.clearcoat && s.enable(14), P.clearcoatMap && s.enable(15), P.clearcoatRoughnessMap && s.enable(16), P.clearcoatNormalMap && s.enable(17), P.iridescence && s.enable(18), P.iridescenceMap && s.enable(19), P.iridescenceThicknessMap && s.enable(20), P.displacementMap && s.enable(21), P.specularMap && s.enable(22), P.roughnessMap && s.enable(23), P.metalnessMap && s.enable(24), P.gradientMap && s.enable(25), P.alphaMap && s.enable(26), P.alphaTest && s.enable(27), P.vertexColors && s.enable(28), P.vertexAlphas && s.enable(29), P.vertexUvs && s.enable(30), P.vertexTangents && s.enable(31), P.uvsVertexOnly && s.enable(32), P.fog && s.enable(33), S.push(s.mask), s.disableAll(), P.useFog && s.enable(0), P.flatShading && s.enable(1), P.logarithmicDepthBuffer && s.enable(2), P.skinning && s.enable(3), P.morphTargets && s.enable(4), P.morphNormals && s.enable(5), P.morphColors && s.enable(6), P.premultipliedAlpha && s.enable(7), P.shadowMapEnabled && s.enable(8), P.physicallyCorrectLights && s.enable(9), P.doubleSided && s.enable(10), P.flipSided && s.enable(11), P.useDepthPacking && s.enable(12), P.dithering && s.enable(13), P.specularIntensityMap && s.enable(14), P.specularColorMap && s.enable(15), P.transmission && s.enable(16), P.transmissionMap && s.enable(17), P.thicknessMap && s.enable(18), P.sheen && s.enable(19), P.sheenColorMap && s.enable(20), P.sheenRoughnessMap && s.enable(21), P.decodeVideoTexture && s.enable(22), P.opaque && s.enable(23), S.push(s.mask);
  }
  function L(S) {
    const P = M[S.type];
    let G;
    if (P) {
      const U = $t[P];
      G = D2.clone(U.uniforms);
    } else
      G = S.uniforms;
    return G;
  }
  function y(S, P) {
    let G;
    for (let U = 0, le = l.length; U < le; U++) {
      const ne = l[U];
      if (ne.cacheKey === P) {
        G = ne, ++G.usedTimes;
        break;
      }
    }
    return G === void 0 && (G = new Bb(i, P, S, a), l.push(G)), G;
  }
  function D(S) {
    if (--S.usedTimes === 0) {
      const P = l.indexOf(S);
      l[P] = l[l.length - 1], l.pop(), S.destroy();
    }
  }
  function T(S) {
    c.remove(S);
  }
  function B() {
    c.dispose();
  }
  return {
    getParameters: m,
    getProgramCacheKey: g,
    getUniforms: L,
    acquireProgram: y,
    releaseProgram: D,
    releaseShaderCache: T,
    programs: l,
    dispose: B
  };
}
function Wb() {
  let i = /* @__PURE__ */ new WeakMap();
  function e(a) {
    let o = i.get(a);
    return o === void 0 && (o = {}, i.set(a, o)), o;
  }
  function t(a) {
    i.delete(a);
  }
  function r(a, o, s) {
    i.get(a)[o] = s;
  }
  function n() {
    i = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    remove: t,
    update: r,
    dispose: n
  };
}
function Gb(i, e) {
  return i.groupOrder !== e.groupOrder ? i.groupOrder - e.groupOrder : i.renderOrder !== e.renderOrder ? i.renderOrder - e.renderOrder : i.material.id !== e.material.id ? i.material.id - e.material.id : i.z !== e.z ? i.z - e.z : i.id - e.id;
}
function iu(i, e) {
  return i.groupOrder !== e.groupOrder ? i.groupOrder - e.groupOrder : i.renderOrder !== e.renderOrder ? i.renderOrder - e.renderOrder : i.z !== e.z ? e.z - i.z : i.id - e.id;
}
function ru() {
  const i = [];
  let e = 0;
  const t = [], r = [], n = [];
  function a() {
    e = 0, t.length = 0, r.length = 0, n.length = 0;
  }
  function o(h, d, v, M, m, g) {
    let I = i[e];
    return I === void 0 ? (I = {
      id: h.id,
      object: h,
      geometry: d,
      material: v,
      groupOrder: M,
      renderOrder: h.renderOrder,
      z: m,
      group: g
    }, i[e] = I) : (I.id = h.id, I.object = h, I.geometry = d, I.material = v, I.groupOrder = M, I.renderOrder = h.renderOrder, I.z = m, I.group = g), e++, I;
  }
  function s(h, d, v, M, m, g) {
    const I = o(h, d, v, M, m, g);
    v.transmission > 0 ? r.push(I) : v.transparent === !0 ? n.push(I) : t.push(I);
  }
  function c(h, d, v, M, m, g) {
    const I = o(h, d, v, M, m, g);
    v.transmission > 0 ? r.unshift(I) : v.transparent === !0 ? n.unshift(I) : t.unshift(I);
  }
  function l(h, d) {
    t.length > 1 && t.sort(h || Gb), r.length > 1 && r.sort(d || iu), n.length > 1 && n.sort(d || iu);
  }
  function u() {
    for (let h = e, d = i.length; h < d; h++) {
      const v = i[h];
      if (v.id === null)
        break;
      v.id = null, v.object = null, v.geometry = null, v.material = null, v.group = null;
    }
  }
  return {
    opaque: t,
    transmissive: r,
    transparent: n,
    init: a,
    push: s,
    unshift: c,
    finish: u,
    sort: l
  };
}
function Ub() {
  let i = /* @__PURE__ */ new WeakMap();
  function e(r, n) {
    let a;
    return i.has(r) === !1 ? (a = new ru(), i.set(r, [a])) : n >= i.get(r).length ? (a = new ru(), i.get(r).push(a)) : a = i.get(r)[n], a;
  }
  function t() {
    i = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: e,
    dispose: t
  };
}
function Hb() {
  const i = {};
  return {
    get: function(e) {
      if (i[e.id] !== void 0)
        return i[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            direction: new W(),
            color: new Ce()
          };
          break;
        case "SpotLight":
          t = {
            position: new W(),
            direction: new W(),
            color: new Ce(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0
          };
          break;
        case "PointLight":
          t = {
            position: new W(),
            color: new Ce(),
            distance: 0,
            decay: 0
          };
          break;
        case "HemisphereLight":
          t = {
            direction: new W(),
            skyColor: new Ce(),
            groundColor: new Ce()
          };
          break;
        case "RectAreaLight":
          t = {
            color: new Ce(),
            position: new W(),
            halfWidth: new W(),
            halfHeight: new W()
          };
          break;
      }
      return i[e.id] = t, t;
    }
  };
}
function Fb() {
  const i = {};
  return {
    get: function(e) {
      if (i[e.id] !== void 0)
        return i[e.id];
      let t;
      switch (e.type) {
        case "DirectionalLight":
          t = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Re()
          };
          break;
        case "SpotLight":
          t = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Re()
          };
          break;
        case "PointLight":
          t = {
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new Re(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3
          };
          break;
      }
      return i[e.id] = t, t;
    }
  };
}
let Vb = 0;
function Yb(i, e) {
  return (e.castShadow ? 1 : 0) - (i.castShadow ? 1 : 0);
}
function Zb(i, e) {
  const t = new Hb(), r = Fb(), n = {
    version: 0,
    hash: {
      directionalLength: -1,
      pointLength: -1,
      spotLength: -1,
      rectAreaLength: -1,
      hemiLength: -1,
      numDirectionalShadows: -1,
      numPointShadows: -1,
      numSpotShadows: -1
    },
    ambient: [0, 0, 0],
    probe: [],
    directional: [],
    directionalShadow: [],
    directionalShadowMap: [],
    directionalShadowMatrix: [],
    spot: [],
    spotShadow: [],
    spotShadowMap: [],
    spotShadowMatrix: [],
    rectArea: [],
    rectAreaLTC1: null,
    rectAreaLTC2: null,
    point: [],
    pointShadow: [],
    pointShadowMap: [],
    pointShadowMatrix: [],
    hemi: []
  };
  for (let u = 0; u < 9; u++)
    n.probe.push(new W());
  const a = new W(), o = new tt(), s = new tt();
  function c(u, h) {
    let d = 0, v = 0, M = 0;
    for (let P = 0; P < 9; P++)
      n.probe[P].set(0, 0, 0);
    let m = 0, g = 0, I = 0, A = 0, L = 0, y = 0, D = 0, T = 0;
    u.sort(Yb);
    const B = h !== !0 ? Math.PI : 1;
    for (let P = 0, G = u.length; P < G; P++) {
      const U = u[P], le = U.color, ne = U.intensity, z = U.distance, q = U.shadow && U.shadow.map ? U.shadow.map.texture : null;
      if (U.isAmbientLight)
        d += le.r * ne * B, v += le.g * ne * B, M += le.b * ne * B;
      else if (U.isLightProbe)
        for (let V = 0; V < 9; V++)
          n.probe[V].addScaledVector(U.sh.coefficients[V], ne);
      else if (U.isDirectionalLight) {
        const V = t.get(U);
        if (V.color.copy(U.color).multiplyScalar(U.intensity * B), U.castShadow) {
          const ie = U.shadow, K = r.get(U);
          K.shadowBias = ie.bias, K.shadowNormalBias = ie.normalBias, K.shadowRadius = ie.radius, K.shadowMapSize = ie.mapSize, n.directionalShadow[m] = K, n.directionalShadowMap[m] = q, n.directionalShadowMatrix[m] = U.shadow.matrix, y++;
        }
        n.directional[m] = V, m++;
      } else if (U.isSpotLight) {
        const V = t.get(U);
        if (V.position.setFromMatrixPosition(U.matrixWorld), V.color.copy(le).multiplyScalar(ne * B), V.distance = z, V.coneCos = Math.cos(U.angle), V.penumbraCos = Math.cos(U.angle * (1 - U.penumbra)), V.decay = U.decay, U.castShadow) {
          const ie = U.shadow, K = r.get(U);
          K.shadowBias = ie.bias, K.shadowNormalBias = ie.normalBias, K.shadowRadius = ie.radius, K.shadowMapSize = ie.mapSize, n.spotShadow[I] = K, n.spotShadowMap[I] = q, n.spotShadowMatrix[I] = U.shadow.matrix, T++;
        }
        n.spot[I] = V, I++;
      } else if (U.isRectAreaLight) {
        const V = t.get(U);
        V.color.copy(le).multiplyScalar(ne), V.halfWidth.set(U.width * 0.5, 0, 0), V.halfHeight.set(0, U.height * 0.5, 0), n.rectArea[A] = V, A++;
      } else if (U.isPointLight) {
        const V = t.get(U);
        if (V.color.copy(U.color).multiplyScalar(U.intensity * B), V.distance = U.distance, V.decay = U.decay, U.castShadow) {
          const ie = U.shadow, K = r.get(U);
          K.shadowBias = ie.bias, K.shadowNormalBias = ie.normalBias, K.shadowRadius = ie.radius, K.shadowMapSize = ie.mapSize, K.shadowCameraNear = ie.camera.near, K.shadowCameraFar = ie.camera.far, n.pointShadow[g] = K, n.pointShadowMap[g] = q, n.pointShadowMatrix[g] = U.shadow.matrix, D++;
        }
        n.point[g] = V, g++;
      } else if (U.isHemisphereLight) {
        const V = t.get(U);
        V.skyColor.copy(U.color).multiplyScalar(ne * B), V.groundColor.copy(U.groundColor).multiplyScalar(ne * B), n.hemi[L] = V, L++;
      }
    }
    A > 0 && (e.isWebGL2 || i.has("OES_texture_float_linear") === !0 ? (n.rectAreaLTC1 = pe.LTC_FLOAT_1, n.rectAreaLTC2 = pe.LTC_FLOAT_2) : i.has("OES_texture_half_float_linear") === !0 ? (n.rectAreaLTC1 = pe.LTC_HALF_1, n.rectAreaLTC2 = pe.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), n.ambient[0] = d, n.ambient[1] = v, n.ambient[2] = M;
    const S = n.hash;
    (S.directionalLength !== m || S.pointLength !== g || S.spotLength !== I || S.rectAreaLength !== A || S.hemiLength !== L || S.numDirectionalShadows !== y || S.numPointShadows !== D || S.numSpotShadows !== T) && (n.directional.length = m, n.spot.length = I, n.rectArea.length = A, n.point.length = g, n.hemi.length = L, n.directionalShadow.length = y, n.directionalShadowMap.length = y, n.pointShadow.length = D, n.pointShadowMap.length = D, n.spotShadow.length = T, n.spotShadowMap.length = T, n.directionalShadowMatrix.length = y, n.pointShadowMatrix.length = D, n.spotShadowMatrix.length = T, S.directionalLength = m, S.pointLength = g, S.spotLength = I, S.rectAreaLength = A, S.hemiLength = L, S.numDirectionalShadows = y, S.numPointShadows = D, S.numSpotShadows = T, n.version = Vb++);
  }
  function l(u, h) {
    let d = 0, v = 0, M = 0, m = 0, g = 0;
    const I = h.matrixWorldInverse;
    for (let A = 0, L = u.length; A < L; A++) {
      const y = u[A];
      if (y.isDirectionalLight) {
        const D = n.directional[d];
        D.direction.setFromMatrixPosition(y.matrixWorld), a.setFromMatrixPosition(y.target.matrixWorld), D.direction.sub(a), D.direction.transformDirection(I), d++;
      } else if (y.isSpotLight) {
        const D = n.spot[M];
        D.position.setFromMatrixPosition(y.matrixWorld), D.position.applyMatrix4(I), D.direction.setFromMatrixPosition(y.matrixWorld), a.setFromMatrixPosition(y.target.matrixWorld), D.direction.sub(a), D.direction.transformDirection(I), M++;
      } else if (y.isRectAreaLight) {
        const D = n.rectArea[m];
        D.position.setFromMatrixPosition(y.matrixWorld), D.position.applyMatrix4(I), s.identity(), o.copy(y.matrixWorld), o.premultiply(I), s.extractRotation(o), D.halfWidth.set(y.width * 0.5, 0, 0), D.halfHeight.set(0, y.height * 0.5, 0), D.halfWidth.applyMatrix4(s), D.halfHeight.applyMatrix4(s), m++;
      } else if (y.isPointLight) {
        const D = n.point[v];
        D.position.setFromMatrixPosition(y.matrixWorld), D.position.applyMatrix4(I), v++;
      } else if (y.isHemisphereLight) {
        const D = n.hemi[g];
        D.direction.setFromMatrixPosition(y.matrixWorld), D.direction.transformDirection(I), g++;
      }
    }
  }
  return {
    setup: c,
    setupView: l,
    state: n
  };
}
function nu(i, e) {
  const t = new Zb(i, e), r = [], n = [];
  function a() {
    r.length = 0, n.length = 0;
  }
  function o(u) {
    r.push(u);
  }
  function s(u) {
    n.push(u);
  }
  function c(u) {
    t.setup(r, u);
  }
  function l(u) {
    t.setupView(r, u);
  }
  return {
    init: a,
    state: {
      lightsArray: r,
      shadowsArray: n,
      lights: t
    },
    setupLights: c,
    setupLightsView: l,
    pushLight: o,
    pushShadow: s
  };
}
function Qb(i, e) {
  let t = /* @__PURE__ */ new WeakMap();
  function r(a, o = 0) {
    let s;
    return t.has(a) === !1 ? (s = new nu(i, e), t.set(a, [s])) : o >= t.get(a).length ? (s = new nu(i, e), t.get(a).push(s)) : s = t.get(a)[o], s;
  }
  function n() {
    t = /* @__PURE__ */ new WeakMap();
  }
  return {
    get: r,
    dispose: n
  };
}
class Wd extends st {
  constructor(e) {
    super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = u2, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.depthPacking = e.depthPacking, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this;
  }
}
class Gd extends st {
  constructor(e) {
    super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.referencePosition = new W(), this.nearDistance = 1, this.farDistance = 1e3, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.referencePosition.copy(e.referencePosition), this.nearDistance = e.nearDistance, this.farDistance = e.farDistance, this.map = e.map, this.alphaMap = e.alphaMap, this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this;
  }
}
const Jb = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, Xb = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function $b(i, e, t) {
  let r = new Ld();
  const n = new Re(), a = new Re(), o = new et(), s = new Wd({ depthPacking: d2 }), c = new Gd(), l = {}, u = t.maxTextureSize, h = { 0: zt, 1: cn, 2: Sr }, d = new pi({
    defines: {
      VSM_SAMPLES: 8
    },
    uniforms: {
      shadow_pass: { value: null },
      resolution: { value: new Re() },
      radius: { value: 4 }
    },
    vertexShader: Jb,
    fragmentShader: Xb
  }), v = d.clone();
  v.defines.HORIZONTAL_PASS = 1;
  const M = new ni();
  M.setAttribute(
    "position",
    new At(
      new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]),
      3
    )
  );
  const m = new Di(M, d), g = this;
  this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = gd, this.render = function(y, D, T) {
    if (g.enabled === !1 || g.autoUpdate === !1 && g.needsUpdate === !1 || y.length === 0)
      return;
    const B = i.getRenderTarget(), S = i.getActiveCubeFace(), P = i.getActiveMipmapLevel(), G = i.state;
    G.setBlending(Ti), G.buffers.color.setClear(1, 1, 1, 1), G.buffers.depth.setTest(!0), G.setScissorTest(!1);
    for (let U = 0, le = y.length; U < le; U++) {
      const ne = y[U], z = ne.shadow;
      if (z === void 0) {
        console.warn("THREE.WebGLShadowMap:", ne, "has no shadow.");
        continue;
      }
      if (z.autoUpdate === !1 && z.needsUpdate === !1)
        continue;
      n.copy(z.mapSize);
      const q = z.getFrameExtents();
      if (n.multiply(q), a.copy(z.mapSize), (n.x > u || n.y > u) && (n.x > u && (a.x = Math.floor(u / q.x), n.x = a.x * q.x, z.mapSize.x = a.x), n.y > u && (a.y = Math.floor(u / q.y), n.y = a.y * q.y, z.mapSize.y = a.y)), z.map === null && !z.isPointLightShadow && this.type === Zr && (z.map = new Ci(n.x, n.y), z.map.texture.name = ne.name + ".shadowMap", z.mapPass = new Ci(n.x, n.y), z.camera.updateProjectionMatrix()), z.map === null) {
        const ie = { minFilter: pt, magFilter: pt, format: jt };
        z.map = new Ci(n.x, n.y, ie), z.map.texture.name = ne.name + ".shadowMap", z.camera.updateProjectionMatrix();
      }
      i.setRenderTarget(z.map), i.clear();
      const V = z.getViewportCount();
      for (let ie = 0; ie < V; ie++) {
        const K = z.getViewport(ie);
        o.set(
          a.x * K.x,
          a.y * K.y,
          a.x * K.z,
          a.y * K.w
        ), G.viewport(o), z.updateMatrices(ne, ie), r = z.getFrustum(), L(D, T, z.camera, ne, this.type);
      }
      !z.isPointLightShadow && this.type === Zr && I(z, T), z.needsUpdate = !1;
    }
    g.needsUpdate = !1, i.setRenderTarget(B, S, P);
  };
  function I(y, D) {
    const T = e.update(m);
    d.defines.VSM_SAMPLES !== y.blurSamples && (d.defines.VSM_SAMPLES = y.blurSamples, v.defines.VSM_SAMPLES = y.blurSamples, d.needsUpdate = !0, v.needsUpdate = !0), d.uniforms.shadow_pass.value = y.map.texture, d.uniforms.resolution.value = y.mapSize, d.uniforms.radius.value = y.radius, i.setRenderTarget(y.mapPass), i.clear(), i.renderBufferDirect(D, null, T, d, m, null), v.uniforms.shadow_pass.value = y.mapPass.texture, v.uniforms.resolution.value = y.mapSize, v.uniforms.radius.value = y.radius, i.setRenderTarget(y.map), i.clear(), i.renderBufferDirect(D, null, T, v, m, null);
  }
  function A(y, D, T, B, S, P) {
    let G = null;
    const U = T.isPointLight === !0 ? y.customDistanceMaterial : y.customDepthMaterial;
    if (U !== void 0 ? G = U : G = T.isPointLight === !0 ? c : s, i.localClippingEnabled && D.clipShadows === !0 && D.clippingPlanes.length !== 0 || D.displacementMap && D.displacementScale !== 0 || D.alphaMap && D.alphaTest > 0) {
      const le = G.uuid, ne = D.uuid;
      let z = l[le];
      z === void 0 && (z = {}, l[le] = z);
      let q = z[ne];
      q === void 0 && (q = G.clone(), z[ne] = q), G = q;
    }
    return G.visible = D.visible, G.wireframe = D.wireframe, P === Zr ? G.side = D.shadowSide !== null ? D.shadowSide : D.side : G.side = D.shadowSide !== null ? D.shadowSide : h[D.side], G.alphaMap = D.alphaMap, G.alphaTest = D.alphaTest, G.clipShadows = D.clipShadows, G.clippingPlanes = D.clippingPlanes, G.clipIntersection = D.clipIntersection, G.displacementMap = D.displacementMap, G.displacementScale = D.displacementScale, G.displacementBias = D.displacementBias, G.wireframeLinewidth = D.wireframeLinewidth, G.linewidth = D.linewidth, T.isPointLight === !0 && G.isMeshDistanceMaterial === !0 && (G.referencePosition.setFromMatrixPosition(T.matrixWorld), G.nearDistance = B, G.farDistance = S), G;
  }
  function L(y, D, T, B, S) {
    if (y.visible === !1)
      return;
    if (y.layers.test(D.layers) && (y.isMesh || y.isLine || y.isPoints) && (y.castShadow || y.receiveShadow && S === Zr) && (!y.frustumCulled || r.intersectsObject(y))) {
      y.modelViewMatrix.multiplyMatrices(T.matrixWorldInverse, y.matrixWorld);
      const G = e.update(y), U = y.material;
      if (Array.isArray(U)) {
        const le = G.groups;
        for (let ne = 0, z = le.length; ne < z; ne++) {
          const q = le[ne], V = U[q.materialIndex];
          if (V && V.visible) {
            const ie = A(y, V, B, T.near, T.far, S);
            i.renderBufferDirect(T, null, G, ie, y, q);
          }
        }
      } else if (U.visible) {
        const le = A(y, U, B, T.near, T.far, S);
        i.renderBufferDirect(T, null, G, le, y, null);
      }
    }
    const P = y.children;
    for (let G = 0, U = P.length; G < U; G++)
      L(P[G], D, T, B, S);
  }
}
function qb(i, e, t) {
  const r = t.isWebGL2;
  function n() {
    let w = !1;
    const j = new et();
    let k = null;
    const ee = new et(0, 0, 0, 0);
    return {
      setMask: function(te) {
        k !== te && !w && (i.colorMask(te, te, te, te), k = te);
      },
      setLocked: function(te) {
        w = te;
      },
      setClear: function(te, ae, oe, ve, Ae) {
        Ae === !0 && (te *= ve, ae *= ve, oe *= ve), j.set(te, ae, oe, ve), ee.equals(j) === !1 && (i.clearColor(te, ae, oe, ve), ee.copy(j));
      },
      reset: function() {
        w = !1, k = null, ee.set(-1, 0, 0, 0);
      }
    };
  }
  function a() {
    let w = !1, j = null, k = null, ee = null;
    return {
      setTest: function(te) {
        te ? ye(2929) : $(2929);
      },
      setMask: function(te) {
        j !== te && !w && (i.depthMask(te), j = te);
      },
      setFunc: function(te) {
        if (k !== te) {
          if (te)
            switch (te) {
              case j1:
                i.depthFunc(512);
                break;
              case B1:
                i.depthFunc(519);
                break;
              case O1:
                i.depthFunc(513);
                break;
              case Os:
                i.depthFunc(515);
                break;
              case z1:
                i.depthFunc(514);
                break;
              case R1:
                i.depthFunc(518);
                break;
              case k1:
                i.depthFunc(516);
                break;
              case W1:
                i.depthFunc(517);
                break;
              default:
                i.depthFunc(515);
            }
          else
            i.depthFunc(515);
          k = te;
        }
      },
      setLocked: function(te) {
        w = te;
      },
      setClear: function(te) {
        ee !== te && (i.clearDepth(te), ee = te);
      },
      reset: function() {
        w = !1, j = null, k = null, ee = null;
      }
    };
  }
  function o() {
    let w = !1, j = null, k = null, ee = null, te = null, ae = null, oe = null, ve = null, Ae = null;
    return {
      setTest: function(Fe) {
        w || (Fe ? ye(2960) : $(2960));
      },
      setMask: function(Fe) {
        j !== Fe && !w && (i.stencilMask(Fe), j = Fe);
      },
      setFunc: function(Fe, Ze, ht) {
        (k !== Fe || ee !== Ze || te !== ht) && (i.stencilFunc(Fe, Ze, ht), k = Fe, ee = Ze, te = ht);
      },
      setOp: function(Fe, Ze, ht) {
        (ae !== Fe || oe !== Ze || ve !== ht) && (i.stencilOp(Fe, Ze, ht), ae = Fe, oe = Ze, ve = ht);
      },
      setLocked: function(Fe) {
        w = Fe;
      },
      setClear: function(Fe) {
        Ae !== Fe && (i.clearStencil(Fe), Ae = Fe);
      },
      reset: function() {
        w = !1, j = null, k = null, ee = null, te = null, ae = null, oe = null, ve = null, Ae = null;
      }
    };
  }
  const s = new n(), c = new a(), l = new o();
  let u = {}, h = {}, d = /* @__PURE__ */ new WeakMap(), v = [], M = null, m = !1, g = null, I = null, A = null, L = null, y = null, D = null, T = null, B = !1, S = null, P = null, G = null, U = null, le = null;
  const ne = i.getParameter(35661);
  let z = !1, q = 0;
  const V = i.getParameter(7938);
  V.indexOf("WebGL") !== -1 ? (q = parseFloat(/^WebGL (\d)/.exec(V)[1]), z = q >= 1) : V.indexOf("OpenGL ES") !== -1 && (q = parseFloat(/^OpenGL ES (\d)/.exec(V)[1]), z = q >= 2);
  let ie = null, K = {};
  const Y = i.getParameter(3088), Q = i.getParameter(2978), se = new et().fromArray(Y), X = new et().fromArray(Q);
  function ue(w, j, k) {
    const ee = new Uint8Array(4), te = i.createTexture();
    i.bindTexture(w, te), i.texParameteri(w, 10241, 9728), i.texParameteri(w, 10240, 9728);
    for (let ae = 0; ae < k; ae++)
      i.texImage2D(j + ae, 0, 6408, 1, 1, 0, 6408, 5121, ee);
    return te;
  }
  const fe = {};
  fe[3553] = ue(3553, 3553, 1), fe[34067] = ue(34067, 34069, 6), s.setClear(0, 0, 0, 1), c.setClear(1), l.setClear(0), ye(2929), c.setFunc(Os), Ue(!1), Xe(Zl), ye(2884), _e(Ti);
  function ye(w) {
    u[w] !== !0 && (i.enable(w), u[w] = !0);
  }
  function $(w) {
    u[w] !== !1 && (i.disable(w), u[w] = !1);
  }
  function Le(w, j) {
    return h[w] !== j ? (i.bindFramebuffer(w, j), h[w] = j, r && (w === 36009 && (h[36160] = j), w === 36160 && (h[36009] = j)), !0) : !1;
  }
  function Me(w, j) {
    let k = v, ee = !1;
    if (w)
      if (k = d.get(j), k === void 0 && (k = [], d.set(j, k)), w.isWebGLMultipleRenderTargets) {
        const te = w.texture;
        if (k.length !== te.length || k[0] !== 36064) {
          for (let ae = 0, oe = te.length; ae < oe; ae++)
            k[ae] = 36064 + ae;
          k.length = te.length, ee = !0;
        }
      } else
        k[0] !== 36064 && (k[0] = 36064, ee = !0);
    else
      k[0] !== 1029 && (k[0] = 1029, ee = !0);
    ee && (t.isWebGL2 ? i.drawBuffers(k) : e.get("WEBGL_draw_buffers").drawBuffersWEBGL(k));
  }
  function we(w) {
    return M !== w ? (i.useProgram(w), M = w, !0) : !1;
  }
  const de = {
    [vr]: 32774,
    [w1]: 32778,
    [_1]: 32779
  };
  if (r)
    de[$l] = 32775, de[ql] = 32776;
  else {
    const w = e.get("EXT_blend_minmax");
    w !== null && (de[$l] = w.MIN_EXT, de[ql] = w.MAX_EXT);
  }
  const Oe = {
    [A1]: 0,
    [S1]: 1,
    [D1]: 768,
    [vd]: 770,
    [P1]: 776,
    [N1]: 774,
    [C1]: 772,
    [T1]: 769,
    [Md]: 771,
    [L1]: 775,
    [E1]: 773
  };
  function _e(w, j, k, ee, te, ae, oe, ve) {
    if (w === Ti) {
      m === !0 && ($(3042), m = !1);
      return;
    }
    if (m === !1 && (ye(3042), m = !0), w !== b1) {
      if (w !== g || ve !== B) {
        if ((I !== vr || y !== vr) && (i.blendEquation(32774), I = vr, y = vr), ve)
          switch (w) {
            case Ir:
              i.blendFuncSeparate(1, 771, 1, 771);
              break;
            case Ql:
              i.blendFunc(1, 1);
              break;
            case Jl:
              i.blendFuncSeparate(0, 769, 0, 1);
              break;
            case Xl:
              i.blendFuncSeparate(0, 768, 0, 770);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", w);
              break;
          }
        else
          switch (w) {
            case Ir:
              i.blendFuncSeparate(770, 771, 1, 771);
              break;
            case Ql:
              i.blendFunc(770, 1);
              break;
            case Jl:
              i.blendFuncSeparate(0, 769, 0, 1);
              break;
            case Xl:
              i.blendFunc(0, 768);
              break;
            default:
              console.error("THREE.WebGLState: Invalid blending: ", w);
              break;
          }
        A = null, L = null, D = null, T = null, g = w, B = ve;
      }
      return;
    }
    te = te || j, ae = ae || k, oe = oe || ee, (j !== I || te !== y) && (i.blendEquationSeparate(de[j], de[te]), I = j, y = te), (k !== A || ee !== L || ae !== D || oe !== T) && (i.blendFuncSeparate(Oe[k], Oe[ee], Oe[ae], Oe[oe]), A = k, L = ee, D = ae, T = oe), g = w, B = null;
  }
  function xe(w, j) {
    w.side === Sr ? $(2884) : ye(2884);
    let k = w.side === zt;
    j && (k = !k), Ue(k), w.blending === Ir && w.transparent === !1 ? _e(Ti) : _e(w.blending, w.blendEquation, w.blendSrc, w.blendDst, w.blendEquationAlpha, w.blendSrcAlpha, w.blendDstAlpha, w.premultipliedAlpha), c.setFunc(w.depthFunc), c.setTest(w.depthTest), c.setMask(w.depthWrite), s.setMask(w.colorWrite);
    const ee = w.stencilWrite;
    l.setTest(ee), ee && (l.setMask(w.stencilWriteMask), l.setFunc(w.stencilFunc, w.stencilRef, w.stencilFuncMask), l.setOp(w.stencilFail, w.stencilZFail, w.stencilZPass)), qe(w.polygonOffset, w.polygonOffsetFactor, w.polygonOffsetUnits), w.alphaToCoverage === !0 ? ye(32926) : $(32926);
  }
  function Ue(w) {
    S !== w && (w ? i.frontFace(2304) : i.frontFace(2305), S = w);
  }
  function Xe(w) {
    w !== M1 ? (ye(2884), w !== P && (w === Zl ? i.cullFace(1029) : w === y1 ? i.cullFace(1028) : i.cullFace(1032))) : $(2884), P = w;
  }
  function Ye(w) {
    w !== G && (z && i.lineWidth(w), G = w);
  }
  function qe(w, j, k) {
    w ? (ye(32823), (U !== j || le !== k) && (i.polygonOffset(j, k), U = j, le = k)) : $(32823);
  }
  function Ve(w) {
    w ? ye(3089) : $(3089);
  }
  function Ne(w) {
    w === void 0 && (w = 33984 + ne - 1), ie !== w && (i.activeTexture(w), ie = w);
  }
  function dt(w, j) {
    ie === null && Ne();
    let k = K[ie];
    k === void 0 && (k = { type: void 0, texture: void 0 }, K[ie] = k), (k.type !== w || k.texture !== j) && (i.bindTexture(w, j || fe[w]), k.type = w, k.texture = j);
  }
  function it() {
    const w = K[ie];
    w !== void 0 && w.type !== void 0 && (i.bindTexture(w.type, null), w.type = void 0, w.texture = void 0);
  }
  function E() {
    try {
      i.compressedTexImage2D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function _() {
    try {
      i.texSubImage2D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function J() {
    try {
      i.texSubImage3D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function ce() {
    try {
      i.compressedTexSubImage2D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function he() {
    try {
      i.texStorage2D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function x() {
    try {
      i.texStorage3D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function f() {
    try {
      i.texImage2D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function p() {
    try {
      i.texImage3D.apply(i, arguments);
    } catch (w) {
      console.error("THREE.WebGLState:", w);
    }
  }
  function b(w) {
    se.equals(w) === !1 && (i.scissor(w.x, w.y, w.z, w.w), se.copy(w));
  }
  function N(w) {
    X.equals(w) === !1 && (i.viewport(w.x, w.y, w.z, w.w), X.copy(w));
  }
  function O() {
    i.disable(3042), i.disable(2884), i.disable(2929), i.disable(32823), i.disable(3089), i.disable(2960), i.disable(32926), i.blendEquation(32774), i.blendFunc(1, 0), i.blendFuncSeparate(1, 0, 1, 0), i.colorMask(!0, !0, !0, !0), i.clearColor(0, 0, 0, 0), i.depthMask(!0), i.depthFunc(513), i.clearDepth(1), i.stencilMask(4294967295), i.stencilFunc(519, 0, 4294967295), i.stencilOp(7680, 7680, 7680), i.clearStencil(0), i.cullFace(1029), i.frontFace(2305), i.polygonOffset(0, 0), i.activeTexture(33984), i.bindFramebuffer(36160, null), r === !0 && (i.bindFramebuffer(36009, null), i.bindFramebuffer(36008, null)), i.useProgram(null), i.lineWidth(1), i.scissor(0, 0, i.canvas.width, i.canvas.height), i.viewport(0, 0, i.canvas.width, i.canvas.height), u = {}, ie = null, K = {}, h = {}, d = /* @__PURE__ */ new WeakMap(), v = [], M = null, m = !1, g = null, I = null, A = null, L = null, y = null, D = null, T = null, B = !1, S = null, P = null, G = null, U = null, le = null, se.set(0, 0, i.canvas.width, i.canvas.height), X.set(0, 0, i.canvas.width, i.canvas.height), s.reset(), c.reset(), l.reset();
  }
  return {
    buffers: {
      color: s,
      depth: c,
      stencil: l
    },
    enable: ye,
    disable: $,
    bindFramebuffer: Le,
    drawBuffers: Me,
    useProgram: we,
    setBlending: _e,
    setMaterial: xe,
    setFlipSided: Ue,
    setCullFace: Xe,
    setLineWidth: Ye,
    setPolygonOffset: qe,
    setScissorTest: Ve,
    activeTexture: Ne,
    bindTexture: dt,
    unbindTexture: it,
    compressedTexImage2D: E,
    texImage2D: f,
    texImage3D: p,
    texStorage2D: he,
    texStorage3D: x,
    texSubImage2D: _,
    texSubImage3D: J,
    compressedTexSubImage2D: ce,
    scissor: b,
    viewport: N,
    reset: O
  };
}
function Kb(i, e, t, r, n, a, o) {
  const s = n.isWebGL2, c = n.maxTextures, l = n.maxCubemapSize, u = n.maxTextureSize, h = n.maxSamples, d = e.has("WEBGL_multisampled_render_to_texture") ? e.get("WEBGL_multisampled_render_to_texture") : null, v = /OculusBrowser/g.test(navigator.userAgent), M = /* @__PURE__ */ new WeakMap();
  let m;
  const g = /* @__PURE__ */ new WeakMap();
  let I = !1;
  try {
    I = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
  } catch {
  }
  function A(E, _) {
    return I ? new OffscreenCanvas(E, _) : ua("canvas");
  }
  function L(E, _, J, ce) {
    let he = 1;
    if ((E.width > ce || E.height > ce) && (he = ce / Math.max(E.width, E.height)), he < 1 || _ === !0)
      if (typeof HTMLImageElement < "u" && E instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && E instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && E instanceof ImageBitmap) {
        const x = _ ? Us : Math.floor, f = x(he * E.width), p = x(he * E.height);
        m === void 0 && (m = A(f, p));
        const b = J ? A(f, p) : m;
        return b.width = f, b.height = p, b.getContext("2d").drawImage(E, 0, 0, f, p), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + E.width + "x" + E.height + ") to (" + f + "x" + p + ")."), b;
      } else
        return "data" in E && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + E.width + "x" + E.height + ")."), E;
    return E;
  }
  function y(E) {
    return Ac(E.width) && Ac(E.height);
  }
  function D(E) {
    return s ? !1 : E.wrapS !== Pt || E.wrapT !== Pt || E.minFilter !== pt && E.minFilter !== wt;
  }
  function T(E, _) {
    return E.generateMipmaps && _ && E.minFilter !== pt && E.minFilter !== wt;
  }
  function B(E) {
    i.generateMipmap(E);
  }
  function S(E, _, J, ce, he = !1) {
    if (s === !1)
      return _;
    if (E !== null) {
      if (i[E] !== void 0)
        return i[E];
      console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + E + "'");
    }
    let x = _;
    return _ === 6403 && (J === 5126 && (x = 33326), J === 5131 && (x = 33325), J === 5121 && (x = 33321)), _ === 33319 && (J === 5126 && (x = 33328), J === 5131 && (x = 33327), J === 5121 && (x = 33323)), _ === 6408 && (J === 5126 && (x = 34836), J === 5131 && (x = 34842), J === 5121 && (x = ce === Qe && he === !1 ? 35907 : 32856), J === 32819 && (x = 32854), J === 32820 && (x = 32855)), (x === 33325 || x === 33326 || x === 33327 || x === 33328 || x === 34842 || x === 34836) && e.get("EXT_color_buffer_float"), x;
  }
  function P(E, _, J) {
    return T(E, J) === !0 || E.isFramebufferTexture && E.minFilter !== pt && E.minFilter !== wt ? Math.log2(Math.max(_.width, _.height)) + 1 : E.mipmaps !== void 0 && E.mipmaps.length > 0 ? E.mipmaps.length : E.isCompressedTexture && Array.isArray(E.image) ? _.mipmaps.length : 1;
  }
  function G(E) {
    return E === pt || E === Kl || E === ec ? 9728 : 9729;
  }
  function U(E) {
    const _ = E.target;
    _.removeEventListener("dispose", U), ne(_), _.isVideoTexture && M.delete(_);
  }
  function le(E) {
    const _ = E.target;
    _.removeEventListener("dispose", le), q(_);
  }
  function ne(E) {
    const _ = r.get(E);
    if (_.__webglInit === void 0)
      return;
    const J = E.source, ce = g.get(J);
    if (ce) {
      const he = ce[_.__cacheKey];
      he.usedTimes--, he.usedTimes === 0 && z(E), Object.keys(ce).length === 0 && g.delete(J);
    }
    r.remove(E);
  }
  function z(E) {
    const _ = r.get(E);
    i.deleteTexture(_.__webglTexture);
    const J = E.source, ce = g.get(J);
    delete ce[_.__cacheKey], o.memory.textures--;
  }
  function q(E) {
    const _ = E.texture, J = r.get(E), ce = r.get(_);
    if (ce.__webglTexture !== void 0 && (i.deleteTexture(ce.__webglTexture), o.memory.textures--), E.depthTexture && E.depthTexture.dispose(), E.isWebGLCubeRenderTarget)
      for (let he = 0; he < 6; he++)
        i.deleteFramebuffer(J.__webglFramebuffer[he]), J.__webglDepthbuffer && i.deleteRenderbuffer(J.__webglDepthbuffer[he]);
    else {
      if (i.deleteFramebuffer(J.__webglFramebuffer), J.__webglDepthbuffer && i.deleteRenderbuffer(J.__webglDepthbuffer), J.__webglMultisampledFramebuffer && i.deleteFramebuffer(J.__webglMultisampledFramebuffer), J.__webglColorRenderbuffer)
        for (let he = 0; he < J.__webglColorRenderbuffer.length; he++)
          J.__webglColorRenderbuffer[he] && i.deleteRenderbuffer(J.__webglColorRenderbuffer[he]);
      J.__webglDepthRenderbuffer && i.deleteRenderbuffer(J.__webglDepthRenderbuffer);
    }
    if (E.isWebGLMultipleRenderTargets)
      for (let he = 0, x = _.length; he < x; he++) {
        const f = r.get(_[he]);
        f.__webglTexture && (i.deleteTexture(f.__webglTexture), o.memory.textures--), r.remove(_[he]);
      }
    r.remove(_), r.remove(E);
  }
  let V = 0;
  function ie() {
    V = 0;
  }
  function K() {
    const E = V;
    return E >= c && console.warn("THREE.WebGLTextures: Trying to use " + E + " texture units while this GPU supports only " + c), V += 1, E;
  }
  function Y(E) {
    const _ = [];
    return _.push(E.wrapS), _.push(E.wrapT), _.push(E.magFilter), _.push(E.minFilter), _.push(E.anisotropy), _.push(E.internalFormat), _.push(E.format), _.push(E.type), _.push(E.generateMipmaps), _.push(E.premultiplyAlpha), _.push(E.flipY), _.push(E.unpackAlignment), _.push(E.encoding), _.join();
  }
  function Q(E, _) {
    const J = r.get(E);
    if (E.isVideoTexture && dt(E), E.isRenderTargetTexture === !1 && E.version > 0 && J.__version !== E.version) {
      const ce = E.image;
      if (ce === null)
        console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
      else if (ce.complete === !1)
        console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
      else {
        Me(J, E, _);
        return;
      }
    }
    t.activeTexture(33984 + _), t.bindTexture(3553, J.__webglTexture);
  }
  function se(E, _) {
    const J = r.get(E);
    if (E.version > 0 && J.__version !== E.version) {
      Me(J, E, _);
      return;
    }
    t.activeTexture(33984 + _), t.bindTexture(35866, J.__webglTexture);
  }
  function X(E, _) {
    const J = r.get(E);
    if (E.version > 0 && J.__version !== E.version) {
      Me(J, E, _);
      return;
    }
    t.activeTexture(33984 + _), t.bindTexture(32879, J.__webglTexture);
  }
  function ue(E, _) {
    const J = r.get(E);
    if (E.version > 0 && J.__version !== E.version) {
      we(J, E, _);
      return;
    }
    t.activeTexture(33984 + _), t.bindTexture(34067, J.__webglTexture);
  }
  const fe = {
    [ks]: 10497,
    [Pt]: 33071,
    [Ws]: 33648
  }, ye = {
    [pt]: 9728,
    [Kl]: 9984,
    [ec]: 9986,
    [wt]: 9729,
    [Q1]: 9985,
    [Da]: 9987
  };
  function $(E, _, J) {
    if (J ? (i.texParameteri(E, 10242, fe[_.wrapS]), i.texParameteri(E, 10243, fe[_.wrapT]), (E === 32879 || E === 35866) && i.texParameteri(E, 32882, fe[_.wrapR]), i.texParameteri(E, 10240, ye[_.magFilter]), i.texParameteri(E, 10241, ye[_.minFilter])) : (i.texParameteri(E, 10242, 33071), i.texParameteri(E, 10243, 33071), (E === 32879 || E === 35866) && i.texParameteri(E, 32882, 33071), (_.wrapS !== Pt || _.wrapT !== Pt) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), i.texParameteri(E, 10240, G(_.magFilter)), i.texParameteri(E, 10241, G(_.minFilter)), _.minFilter !== pt && _.minFilter !== wt && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), e.has("EXT_texture_filter_anisotropic") === !0) {
      const ce = e.get("EXT_texture_filter_anisotropic");
      if (_.type === Vi && e.has("OES_texture_float_linear") === !1 || s === !1 && _.type === un && e.has("OES_texture_half_float_linear") === !1)
        return;
      (_.anisotropy > 1 || r.get(_).__currentAnisotropy) && (i.texParameterf(E, ce.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(_.anisotropy, n.getMaxAnisotropy())), r.get(_).__currentAnisotropy = _.anisotropy);
    }
  }
  function Le(E, _) {
    let J = !1;
    E.__webglInit === void 0 && (E.__webglInit = !0, _.addEventListener("dispose", U));
    const ce = _.source;
    let he = g.get(ce);
    he === void 0 && (he = {}, g.set(ce, he));
    const x = Y(_);
    if (x !== E.__cacheKey) {
      he[x] === void 0 && (he[x] = {
        texture: i.createTexture(),
        usedTimes: 0
      }, o.memory.textures++, J = !0), he[x].usedTimes++;
      const f = he[E.__cacheKey];
      f !== void 0 && (he[E.__cacheKey].usedTimes--, f.usedTimes === 0 && z(_)), E.__cacheKey = x, E.__webglTexture = he[x].texture;
    }
    return J;
  }
  function Me(E, _, J) {
    let ce = 3553;
    _.isDataArrayTexture && (ce = 35866), _.isData3DTexture && (ce = 32879);
    const he = Le(E, _), x = _.source;
    if (t.activeTexture(33984 + J), t.bindTexture(ce, E.__webglTexture), x.version !== x.__currentVersion || he === !0) {
      i.pixelStorei(37440, _.flipY), i.pixelStorei(37441, _.premultiplyAlpha), i.pixelStorei(3317, _.unpackAlignment), i.pixelStorei(37443, 0);
      const f = D(_) && y(_.image) === !1;
      let p = L(_.image, f, !1, u);
      p = it(_, p);
      const b = y(p) || s, N = a.convert(_.format, _.encoding);
      let O = a.convert(_.type), w = S(_.internalFormat, N, O, _.encoding, _.isVideoTexture);
      $(ce, _, b);
      let j;
      const k = _.mipmaps, ee = s && _.isVideoTexture !== !0, te = x.__currentVersion === void 0 || he === !0, ae = P(_, p, b);
      if (_.isDepthTexture)
        w = 6402, s ? _.type === Vi ? w = 36012 : _.type === Fi ? w = 33190 : _.type === br ? w = 35056 : w = 33189 : _.type === Vi && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), _.format === Zi && w === 6402 && _.type !== xd && _.type !== Fi && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), _.type = Fi, O = a.convert(_.type)), _.format === Cr && w === 6402 && (w = 34041, _.type !== br && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), _.type = br, O = a.convert(_.type))), te && (ee ? t.texStorage2D(3553, 1, w, p.width, p.height) : t.texImage2D(3553, 0, w, p.width, p.height, 0, N, O, null));
      else if (_.isDataTexture)
        if (k.length > 0 && b) {
          ee && te && t.texStorage2D(3553, ae, w, k[0].width, k[0].height);
          for (let oe = 0, ve = k.length; oe < ve; oe++)
            j = k[oe], ee ? t.texSubImage2D(3553, oe, 0, 0, j.width, j.height, N, O, j.data) : t.texImage2D(3553, oe, w, j.width, j.height, 0, N, O, j.data);
          _.generateMipmaps = !1;
        } else
          ee ? (te && t.texStorage2D(3553, ae, w, p.width, p.height), t.texSubImage2D(3553, 0, 0, 0, p.width, p.height, N, O, p.data)) : t.texImage2D(3553, 0, w, p.width, p.height, 0, N, O, p.data);
      else if (_.isCompressedTexture) {
        ee && te && t.texStorage2D(3553, ae, w, k[0].width, k[0].height);
        for (let oe = 0, ve = k.length; oe < ve; oe++)
          j = k[oe], _.format !== jt ? N !== null ? ee ? t.compressedTexSubImage2D(3553, oe, 0, 0, j.width, j.height, N, j.data) : t.compressedTexImage2D(3553, oe, w, j.width, j.height, 0, j.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : ee ? t.texSubImage2D(3553, oe, 0, 0, j.width, j.height, N, O, j.data) : t.texImage2D(3553, oe, w, j.width, j.height, 0, N, O, j.data);
      } else if (_.isDataArrayTexture)
        ee ? (te && t.texStorage3D(35866, ae, w, p.width, p.height, p.depth), t.texSubImage3D(35866, 0, 0, 0, 0, p.width, p.height, p.depth, N, O, p.data)) : t.texImage3D(35866, 0, w, p.width, p.height, p.depth, 0, N, O, p.data);
      else if (_.isData3DTexture)
        ee ? (te && t.texStorage3D(32879, ae, w, p.width, p.height, p.depth), t.texSubImage3D(32879, 0, 0, 0, 0, p.width, p.height, p.depth, N, O, p.data)) : t.texImage3D(32879, 0, w, p.width, p.height, p.depth, 0, N, O, p.data);
      else if (_.isFramebufferTexture) {
        if (te)
          if (ee)
            t.texStorage2D(3553, ae, w, p.width, p.height);
          else {
            let oe = p.width, ve = p.height;
            for (let Ae = 0; Ae < ae; Ae++)
              t.texImage2D(3553, Ae, w, oe, ve, 0, N, O, null), oe >>= 1, ve >>= 1;
          }
      } else if (k.length > 0 && b) {
        ee && te && t.texStorage2D(3553, ae, w, k[0].width, k[0].height);
        for (let oe = 0, ve = k.length; oe < ve; oe++)
          j = k[oe], ee ? t.texSubImage2D(3553, oe, 0, 0, N, O, j) : t.texImage2D(3553, oe, w, N, O, j);
        _.generateMipmaps = !1;
      } else
        ee ? (te && t.texStorage2D(3553, ae, w, p.width, p.height), t.texSubImage2D(3553, 0, 0, 0, N, O, p)) : t.texImage2D(3553, 0, w, N, O, p);
      T(_, b) && B(ce), x.__currentVersion = x.version, _.onUpdate && _.onUpdate(_);
    }
    E.__version = _.version;
  }
  function we(E, _, J) {
    if (_.image.length !== 6)
      return;
    const ce = Le(E, _), he = _.source;
    if (t.activeTexture(33984 + J), t.bindTexture(34067, E.__webglTexture), he.version !== he.__currentVersion || ce === !0) {
      i.pixelStorei(37440, _.flipY), i.pixelStorei(37441, _.premultiplyAlpha), i.pixelStorei(3317, _.unpackAlignment), i.pixelStorei(37443, 0);
      const x = _.isCompressedTexture || _.image[0].isCompressedTexture, f = _.image[0] && _.image[0].isDataTexture, p = [];
      for (let oe = 0; oe < 6; oe++)
        !x && !f ? p[oe] = L(_.image[oe], !1, !0, l) : p[oe] = f ? _.image[oe].image : _.image[oe], p[oe] = it(_, p[oe]);
      const b = p[0], N = y(b) || s, O = a.convert(_.format, _.encoding), w = a.convert(_.type), j = S(_.internalFormat, O, w, _.encoding), k = s && _.isVideoTexture !== !0, ee = he.__currentVersion === void 0 || ce === !0;
      let te = P(_, b, N);
      $(34067, _, N);
      let ae;
      if (x) {
        k && ee && t.texStorage2D(34067, te, j, b.width, b.height);
        for (let oe = 0; oe < 6; oe++) {
          ae = p[oe].mipmaps;
          for (let ve = 0; ve < ae.length; ve++) {
            const Ae = ae[ve];
            _.format !== jt ? O !== null ? k ? t.compressedTexSubImage2D(34069 + oe, ve, 0, 0, Ae.width, Ae.height, O, Ae.data) : t.compressedTexImage2D(34069 + oe, ve, j, Ae.width, Ae.height, 0, Ae.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : k ? t.texSubImage2D(34069 + oe, ve, 0, 0, Ae.width, Ae.height, O, w, Ae.data) : t.texImage2D(34069 + oe, ve, j, Ae.width, Ae.height, 0, O, w, Ae.data);
          }
        }
      } else {
        ae = _.mipmaps, k && ee && (ae.length > 0 && te++, t.texStorage2D(34067, te, j, p[0].width, p[0].height));
        for (let oe = 0; oe < 6; oe++)
          if (f) {
            k ? t.texSubImage2D(34069 + oe, 0, 0, 0, p[oe].width, p[oe].height, O, w, p[oe].data) : t.texImage2D(34069 + oe, 0, j, p[oe].width, p[oe].height, 0, O, w, p[oe].data);
            for (let ve = 0; ve < ae.length; ve++) {
              const Ae = ae[ve].image[oe].image;
              k ? t.texSubImage2D(34069 + oe, ve + 1, 0, 0, Ae.width, Ae.height, O, w, Ae.data) : t.texImage2D(34069 + oe, ve + 1, j, Ae.width, Ae.height, 0, O, w, Ae.data);
            }
          } else {
            k ? t.texSubImage2D(34069 + oe, 0, 0, 0, O, w, p[oe]) : t.texImage2D(34069 + oe, 0, j, O, w, p[oe]);
            for (let ve = 0; ve < ae.length; ve++) {
              const Ae = ae[ve];
              k ? t.texSubImage2D(34069 + oe, ve + 1, 0, 0, O, w, Ae.image[oe]) : t.texImage2D(34069 + oe, ve + 1, j, O, w, Ae.image[oe]);
            }
          }
      }
      T(_, N) && B(34067), he.__currentVersion = he.version, _.onUpdate && _.onUpdate(_);
    }
    E.__version = _.version;
  }
  function de(E, _, J, ce, he) {
    const x = a.convert(J.format, J.encoding), f = a.convert(J.type), p = S(J.internalFormat, x, f, J.encoding);
    r.get(_).__hasExternalTextures || (he === 32879 || he === 35866 ? t.texImage3D(he, 0, p, _.width, _.height, _.depth, 0, x, f, null) : t.texImage2D(he, 0, p, _.width, _.height, 0, x, f, null)), t.bindFramebuffer(36160, E), Ne(_) ? d.framebufferTexture2DMultisampleEXT(36160, ce, he, r.get(J).__webglTexture, 0, Ve(_)) : i.framebufferTexture2D(36160, ce, he, r.get(J).__webglTexture, 0), t.bindFramebuffer(36160, null);
  }
  function Oe(E, _, J) {
    if (i.bindRenderbuffer(36161, E), _.depthBuffer && !_.stencilBuffer) {
      let ce = 33189;
      if (J || Ne(_)) {
        const he = _.depthTexture;
        he && he.isDepthTexture && (he.type === Vi ? ce = 36012 : he.type === Fi && (ce = 33190));
        const x = Ve(_);
        Ne(_) ? d.renderbufferStorageMultisampleEXT(36161, x, ce, _.width, _.height) : i.renderbufferStorageMultisample(36161, x, ce, _.width, _.height);
      } else
        i.renderbufferStorage(36161, ce, _.width, _.height);
      i.framebufferRenderbuffer(36160, 36096, 36161, E);
    } else if (_.depthBuffer && _.stencilBuffer) {
      const ce = Ve(_);
      J && Ne(_) === !1 ? i.renderbufferStorageMultisample(36161, ce, 35056, _.width, _.height) : Ne(_) ? d.renderbufferStorageMultisampleEXT(36161, ce, 35056, _.width, _.height) : i.renderbufferStorage(36161, 34041, _.width, _.height), i.framebufferRenderbuffer(36160, 33306, 36161, E);
    } else {
      const ce = _.isWebGLMultipleRenderTargets === !0 ? _.texture : [_.texture];
      for (let he = 0; he < ce.length; he++) {
        const x = ce[he], f = a.convert(x.format, x.encoding), p = a.convert(x.type), b = S(x.internalFormat, f, p, x.encoding), N = Ve(_);
        J && Ne(_) === !1 ? i.renderbufferStorageMultisample(36161, N, b, _.width, _.height) : Ne(_) ? d.renderbufferStorageMultisampleEXT(36161, N, b, _.width, _.height) : i.renderbufferStorage(36161, b, _.width, _.height);
      }
    }
    i.bindRenderbuffer(36161, null);
  }
  function _e(E, _) {
    if (_ && _.isWebGLCubeRenderTarget)
      throw new Error("Depth Texture with cube render targets is not supported");
    if (t.bindFramebuffer(36160, E), !(_.depthTexture && _.depthTexture.isDepthTexture))
      throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
    (!r.get(_.depthTexture).__webglTexture || _.depthTexture.image.width !== _.width || _.depthTexture.image.height !== _.height) && (_.depthTexture.image.width = _.width, _.depthTexture.image.height = _.height, _.depthTexture.needsUpdate = !0), Q(_.depthTexture, 0);
    const J = r.get(_.depthTexture).__webglTexture, ce = Ve(_);
    if (_.depthTexture.format === Zi)
      Ne(_) ? d.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, J, 0, ce) : i.framebufferTexture2D(36160, 36096, 3553, J, 0);
    else if (_.depthTexture.format === Cr)
      Ne(_) ? d.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, J, 0, ce) : i.framebufferTexture2D(36160, 33306, 3553, J, 0);
    else
      throw new Error("Unknown depthTexture format");
  }
  function xe(E) {
    const _ = r.get(E), J = E.isWebGLCubeRenderTarget === !0;
    if (E.depthTexture && !_.__autoAllocateDepthBuffer) {
      if (J)
        throw new Error("target.depthTexture not supported in Cube render targets");
      _e(_.__webglFramebuffer, E);
    } else if (J) {
      _.__webglDepthbuffer = [];
      for (let ce = 0; ce < 6; ce++)
        t.bindFramebuffer(36160, _.__webglFramebuffer[ce]), _.__webglDepthbuffer[ce] = i.createRenderbuffer(), Oe(_.__webglDepthbuffer[ce], E, !1);
    } else
      t.bindFramebuffer(36160, _.__webglFramebuffer), _.__webglDepthbuffer = i.createRenderbuffer(), Oe(_.__webglDepthbuffer, E, !1);
    t.bindFramebuffer(36160, null);
  }
  function Ue(E, _, J) {
    const ce = r.get(E);
    _ !== void 0 && de(ce.__webglFramebuffer, E, E.texture, 36064, 3553), J !== void 0 && xe(E);
  }
  function Xe(E) {
    const _ = E.texture, J = r.get(E), ce = r.get(_);
    E.addEventListener("dispose", le), E.isWebGLMultipleRenderTargets !== !0 && (ce.__webglTexture === void 0 && (ce.__webglTexture = i.createTexture()), ce.__version = _.version, o.memory.textures++);
    const he = E.isWebGLCubeRenderTarget === !0, x = E.isWebGLMultipleRenderTargets === !0, f = y(E) || s;
    if (he) {
      J.__webglFramebuffer = [];
      for (let p = 0; p < 6; p++)
        J.__webglFramebuffer[p] = i.createFramebuffer();
    } else {
      if (J.__webglFramebuffer = i.createFramebuffer(), x)
        if (n.drawBuffers) {
          const p = E.texture;
          for (let b = 0, N = p.length; b < N; b++) {
            const O = r.get(p[b]);
            O.__webglTexture === void 0 && (O.__webglTexture = i.createTexture(), o.memory.textures++);
          }
        } else
          console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
      if (s && E.samples > 0 && Ne(E) === !1) {
        const p = x ? _ : [_];
        J.__webglMultisampledFramebuffer = i.createFramebuffer(), J.__webglColorRenderbuffer = [], t.bindFramebuffer(36160, J.__webglMultisampledFramebuffer);
        for (let b = 0; b < p.length; b++) {
          const N = p[b];
          J.__webglColorRenderbuffer[b] = i.createRenderbuffer(), i.bindRenderbuffer(36161, J.__webglColorRenderbuffer[b]);
          const O = a.convert(N.format, N.encoding), w = a.convert(N.type), j = S(N.internalFormat, O, w, N.encoding), k = Ve(E);
          i.renderbufferStorageMultisample(36161, k, j, E.width, E.height), i.framebufferRenderbuffer(36160, 36064 + b, 36161, J.__webglColorRenderbuffer[b]);
        }
        i.bindRenderbuffer(36161, null), E.depthBuffer && (J.__webglDepthRenderbuffer = i.createRenderbuffer(), Oe(J.__webglDepthRenderbuffer, E, !0)), t.bindFramebuffer(36160, null);
      }
    }
    if (he) {
      t.bindTexture(34067, ce.__webglTexture), $(34067, _, f);
      for (let p = 0; p < 6; p++)
        de(J.__webglFramebuffer[p], E, _, 36064, 34069 + p);
      T(_, f) && B(34067), t.unbindTexture();
    } else if (x) {
      const p = E.texture;
      for (let b = 0, N = p.length; b < N; b++) {
        const O = p[b], w = r.get(O);
        t.bindTexture(3553, w.__webglTexture), $(3553, O, f), de(J.__webglFramebuffer, E, O, 36064 + b, 3553), T(O, f) && B(3553);
      }
      t.unbindTexture();
    } else {
      let p = 3553;
      (E.isWebGL3DRenderTarget || E.isWebGLArrayRenderTarget) && (s ? p = E.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), t.bindTexture(p, ce.__webglTexture), $(p, _, f), de(J.__webglFramebuffer, E, _, 36064, p), T(_, f) && B(p), t.unbindTexture();
    }
    E.depthBuffer && xe(E);
  }
  function Ye(E) {
    const _ = y(E) || s, J = E.isWebGLMultipleRenderTargets === !0 ? E.texture : [E.texture];
    for (let ce = 0, he = J.length; ce < he; ce++) {
      const x = J[ce];
      if (T(x, _)) {
        const f = E.isWebGLCubeRenderTarget ? 34067 : 3553, p = r.get(x).__webglTexture;
        t.bindTexture(f, p), B(f), t.unbindTexture();
      }
    }
  }
  function qe(E) {
    if (s && E.samples > 0 && Ne(E) === !1) {
      const _ = E.isWebGLMultipleRenderTargets ? E.texture : [E.texture], J = E.width, ce = E.height;
      let he = 16384;
      const x = [], f = E.stencilBuffer ? 33306 : 36096, p = r.get(E), b = E.isWebGLMultipleRenderTargets === !0;
      if (b)
        for (let N = 0; N < _.length; N++)
          t.bindFramebuffer(36160, p.__webglMultisampledFramebuffer), i.framebufferRenderbuffer(36160, 36064 + N, 36161, null), t.bindFramebuffer(36160, p.__webglFramebuffer), i.framebufferTexture2D(36009, 36064 + N, 3553, null, 0);
      t.bindFramebuffer(36008, p.__webglMultisampledFramebuffer), t.bindFramebuffer(36009, p.__webglFramebuffer);
      for (let N = 0; N < _.length; N++) {
        x.push(36064 + N), E.depthBuffer && x.push(f);
        const O = p.__ignoreDepthValues !== void 0 ? p.__ignoreDepthValues : !1;
        if (O === !1 && (E.depthBuffer && (he |= 256), E.stencilBuffer && (he |= 1024)), b && i.framebufferRenderbuffer(36008, 36064, 36161, p.__webglColorRenderbuffer[N]), O === !0 && (i.invalidateFramebuffer(36008, [f]), i.invalidateFramebuffer(36009, [f])), b) {
          const w = r.get(_[N]).__webglTexture;
          i.framebufferTexture2D(36009, 36064, 3553, w, 0);
        }
        i.blitFramebuffer(0, 0, J, ce, 0, 0, J, ce, he, 9728), v && i.invalidateFramebuffer(36008, x);
      }
      if (t.bindFramebuffer(36008, null), t.bindFramebuffer(36009, null), b)
        for (let N = 0; N < _.length; N++) {
          t.bindFramebuffer(36160, p.__webglMultisampledFramebuffer), i.framebufferRenderbuffer(36160, 36064 + N, 36161, p.__webglColorRenderbuffer[N]);
          const O = r.get(_[N]).__webglTexture;
          t.bindFramebuffer(36160, p.__webglFramebuffer), i.framebufferTexture2D(36009, 36064 + N, 3553, O, 0);
        }
      t.bindFramebuffer(36009, p.__webglMultisampledFramebuffer);
    }
  }
  function Ve(E) {
    return Math.min(h, E.samples);
  }
  function Ne(E) {
    const _ = r.get(E);
    return s && E.samples > 0 && e.has("WEBGL_multisampled_render_to_texture") === !0 && _.__useRenderToTexture !== !1;
  }
  function dt(E) {
    const _ = o.render.frame;
    M.get(E) !== _ && (M.set(E, _), E.update());
  }
  function it(E, _) {
    const J = E.encoding, ce = E.format, he = E.type;
    return E.isCompressedTexture === !0 || E.isVideoTexture === !0 || E.format === Gs || J !== Xi && (J === Qe ? s === !1 ? e.has("EXT_sRGB") === !0 && ce === jt ? (E.format = Gs, E.minFilter = wt, E.generateMipmaps = !1) : _ = wd.sRGBToLinear(_) : (ce !== jt || he !== Ji) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", J)), _;
  }
  this.allocateTextureUnit = K, this.resetTextureUnits = ie, this.setTexture2D = Q, this.setTexture2DArray = se, this.setTexture3D = X, this.setTextureCube = ue, this.rebindTextures = Ue, this.setupRenderTarget = Xe, this.updateRenderTargetMipmap = Ye, this.updateMultisampleRenderTarget = qe, this.setupDepthRenderbuffer = xe, this.setupFrameBufferTexture = de, this.useMultisampledRTT = Ne;
}
function ew(i, e, t) {
  const r = t.isWebGL2;
  function n(a, o = null) {
    let s;
    if (a === Ji)
      return 5121;
    if (a === q1)
      return 32819;
    if (a === K1)
      return 32820;
    if (a === J1)
      return 5120;
    if (a === X1)
      return 5122;
    if (a === xd)
      return 5123;
    if (a === $1)
      return 5124;
    if (a === Fi)
      return 5125;
    if (a === Vi)
      return 5126;
    if (a === un)
      return r ? 5131 : (s = e.get("OES_texture_half_float"), s !== null ? s.HALF_FLOAT_OES : null);
    if (a === e2)
      return 6406;
    if (a === jt)
      return 6408;
    if (a === i2)
      return 6409;
    if (a === r2)
      return 6410;
    if (a === Zi)
      return 6402;
    if (a === Cr)
      return 34041;
    if (a === n2)
      return 6403;
    if (a === t2)
      return console.warn("THREE.WebGLRenderer: THREE.RGBFormat has been removed. Use THREE.RGBAFormat instead. https://github.com/mrdoob/three.js/pull/23228"), 6408;
    if (a === Gs)
      return s = e.get("EXT_sRGB"), s !== null ? s.SRGB_ALPHA_EXT : null;
    if (a === a2)
      return 36244;
    if (a === s2)
      return 33319;
    if (a === o2)
      return 33320;
    if (a === l2)
      return 36249;
    if (a === Ha || a === Fa || a === Va || a === Ya)
      if (o === Qe)
        if (s = e.get("WEBGL_compressed_texture_s3tc_srgb"), s !== null) {
          if (a === Ha)
            return s.COMPRESSED_SRGB_S3TC_DXT1_EXT;
          if (a === Fa)
            return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
          if (a === Va)
            return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
          if (a === Ya)
            return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        } else
          return null;
      else if (s = e.get("WEBGL_compressed_texture_s3tc"), s !== null) {
        if (a === Ha)
          return s.COMPRESSED_RGB_S3TC_DXT1_EXT;
        if (a === Fa)
          return s.COMPRESSED_RGBA_S3TC_DXT1_EXT;
        if (a === Va)
          return s.COMPRESSED_RGBA_S3TC_DXT3_EXT;
        if (a === Ya)
          return s.COMPRESSED_RGBA_S3TC_DXT5_EXT;
      } else
        return null;
    if (a === tc || a === ic || a === rc || a === nc)
      if (s = e.get("WEBGL_compressed_texture_pvrtc"), s !== null) {
        if (a === tc)
          return s.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
        if (a === ic)
          return s.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
        if (a === rc)
          return s.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
        if (a === nc)
          return s.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
      } else
        return null;
    if (a === c2)
      return s = e.get("WEBGL_compressed_texture_etc1"), s !== null ? s.COMPRESSED_RGB_ETC1_WEBGL : null;
    if (a === ac || a === sc)
      if (s = e.get("WEBGL_compressed_texture_etc"), s !== null) {
        if (a === ac)
          return o === Qe ? s.COMPRESSED_SRGB8_ETC2 : s.COMPRESSED_RGB8_ETC2;
        if (a === sc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : s.COMPRESSED_RGBA8_ETC2_EAC;
      } else
        return null;
    if (a === oc || a === lc || a === cc || a === uc || a === dc || a === hc || a === pc || a === fc || a === mc || a === gc || a === vc || a === Mc || a === yc || a === xc)
      if (s = e.get("WEBGL_compressed_texture_astc"), s !== null) {
        if (a === oc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : s.COMPRESSED_RGBA_ASTC_4x4_KHR;
        if (a === lc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : s.COMPRESSED_RGBA_ASTC_5x4_KHR;
        if (a === cc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : s.COMPRESSED_RGBA_ASTC_5x5_KHR;
        if (a === uc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : s.COMPRESSED_RGBA_ASTC_6x5_KHR;
        if (a === dc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : s.COMPRESSED_RGBA_ASTC_6x6_KHR;
        if (a === hc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : s.COMPRESSED_RGBA_ASTC_8x5_KHR;
        if (a === pc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : s.COMPRESSED_RGBA_ASTC_8x6_KHR;
        if (a === fc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : s.COMPRESSED_RGBA_ASTC_8x8_KHR;
        if (a === mc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : s.COMPRESSED_RGBA_ASTC_10x5_KHR;
        if (a === gc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : s.COMPRESSED_RGBA_ASTC_10x6_KHR;
        if (a === vc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : s.COMPRESSED_RGBA_ASTC_10x8_KHR;
        if (a === Mc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : s.COMPRESSED_RGBA_ASTC_10x10_KHR;
        if (a === yc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : s.COMPRESSED_RGBA_ASTC_12x10_KHR;
        if (a === xc)
          return o === Qe ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : s.COMPRESSED_RGBA_ASTC_12x12_KHR;
      } else
        return null;
    if (a === Ic)
      if (s = e.get("EXT_texture_compression_bptc"), s !== null) {
        if (a === Ic)
          return o === Qe ? s.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : s.COMPRESSED_RGBA_BPTC_UNORM_EXT;
      } else
        return null;
    return a === br ? r ? 34042 : (s = e.get("WEBGL_depth_texture"), s !== null ? s.UNSIGNED_INT_24_8_WEBGL : null) : i[a] !== void 0 ? i[a] : null;
  }
  return { convert: n };
}
class tw extends Lt {
  constructor(e = []) {
    super(), this.isArrayCamera = !0, this.cameras = e;
  }
}
class Jr extends Ut {
  constructor() {
    super(), this.isGroup = !0, this.type = "Group";
  }
}
const iw = { type: "move" };
class Is {
  constructor() {
    this._targetRay = null, this._grip = null, this._hand = null;
  }
  getHandSpace() {
    return this._hand === null && (this._hand = new Jr(), this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = { pinching: !1 }), this._hand;
  }
  getTargetRaySpace() {
    return this._targetRay === null && (this._targetRay = new Jr(), this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new W(), this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new W()), this._targetRay;
  }
  getGripSpace() {
    return this._grip === null && (this._grip = new Jr(), this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new W(), this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new W()), this._grip;
  }
  dispatchEvent(e) {
    return this._targetRay !== null && this._targetRay.dispatchEvent(e), this._grip !== null && this._grip.dispatchEvent(e), this._hand !== null && this._hand.dispatchEvent(e), this;
  }
  disconnect(e) {
    return this.dispatchEvent({ type: "disconnected", data: e }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
  }
  update(e, t, r) {
    let n = null, a = null, o = null;
    const s = this._targetRay, c = this._grip, l = this._hand;
    if (e && t.session.visibilityState !== "visible-blurred")
      if (s !== null && (n = t.getPose(e.targetRaySpace, r), n !== null && (s.matrix.fromArray(n.transform.matrix), s.matrix.decompose(s.position, s.rotation, s.scale), n.linearVelocity ? (s.hasLinearVelocity = !0, s.linearVelocity.copy(n.linearVelocity)) : s.hasLinearVelocity = !1, n.angularVelocity ? (s.hasAngularVelocity = !0, s.angularVelocity.copy(n.angularVelocity)) : s.hasAngularVelocity = !1, this.dispatchEvent(iw))), l && e.hand) {
        o = !0;
        for (const m of e.hand.values()) {
          const g = t.getJointPose(m, r);
          if (l.joints[m.jointName] === void 0) {
            const A = new Jr();
            A.matrixAutoUpdate = !1, A.visible = !1, l.joints[m.jointName] = A, l.add(A);
          }
          const I = l.joints[m.jointName];
          g !== null && (I.matrix.fromArray(g.transform.matrix), I.matrix.decompose(I.position, I.rotation, I.scale), I.jointRadius = g.radius), I.visible = g !== null;
        }
        const u = l.joints["index-finger-tip"], h = l.joints["thumb-tip"], d = u.position.distanceTo(h.position), v = 0.02, M = 5e-3;
        l.inputState.pinching && d > v + M ? (l.inputState.pinching = !1, this.dispatchEvent({
          type: "pinchend",
          handedness: e.handedness,
          target: this
        })) : !l.inputState.pinching && d <= v - M && (l.inputState.pinching = !0, this.dispatchEvent({
          type: "pinchstart",
          handedness: e.handedness,
          target: this
        }));
      } else
        c !== null && e.gripSpace && (a = t.getPose(e.gripSpace, r), a !== null && (c.matrix.fromArray(a.transform.matrix), c.matrix.decompose(c.position, c.rotation, c.scale), a.linearVelocity ? (c.hasLinearVelocity = !0, c.linearVelocity.copy(a.linearVelocity)) : c.hasLinearVelocity = !1, a.angularVelocity ? (c.hasAngularVelocity = !0, c.angularVelocity.copy(a.angularVelocity)) : c.hasAngularVelocity = !1));
    return s !== null && (s.visible = n !== null), c !== null && (c.visible = a !== null), l !== null && (l.visible = o !== null), this;
  }
}
class rw extends Gt {
  constructor(e, t, r, n, a, o, s, c, l, u) {
    if (u = u !== void 0 ? u : Zi, u !== Zi && u !== Cr)
      throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
    r === void 0 && u === Zi && (r = Fi), r === void 0 && u === Cr && (r = br), super(null, n, a, o, s, c, u, r, l), this.isDepthTexture = !0, this.image = { width: e, height: t }, this.magFilter = s !== void 0 ? s : pt, this.minFilter = c !== void 0 ? c : pt, this.flipY = !1, this.generateMipmaps = !1;
  }
}
class nw extends jr {
  constructor(e, t) {
    super();
    const r = this;
    let n = null, a = 1, o = null, s = "local-floor", c = null, l = null, u = null, h = null, d = null, v = null;
    const M = t.getContextAttributes();
    let m = null, g = null;
    const I = [], A = /* @__PURE__ */ new Map(), L = new Lt();
    L.layers.enable(1), L.viewport = new et();
    const y = new Lt();
    y.layers.enable(2), y.viewport = new et();
    const D = [L, y], T = new tw();
    T.layers.enable(1), T.layers.enable(2);
    let B = null, S = null;
    this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(Y) {
      let Q = I[Y];
      return Q === void 0 && (Q = new Is(), I[Y] = Q), Q.getTargetRaySpace();
    }, this.getControllerGrip = function(Y) {
      let Q = I[Y];
      return Q === void 0 && (Q = new Is(), I[Y] = Q), Q.getGripSpace();
    }, this.getHand = function(Y) {
      let Q = I[Y];
      return Q === void 0 && (Q = new Is(), I[Y] = Q), Q.getHandSpace();
    };
    function P(Y) {
      const Q = A.get(Y.inputSource);
      Q !== void 0 && Q.dispatchEvent({ type: Y.type, data: Y.inputSource });
    }
    function G() {
      n.removeEventListener("select", P), n.removeEventListener("selectstart", P), n.removeEventListener("selectend", P), n.removeEventListener("squeeze", P), n.removeEventListener("squeezestart", P), n.removeEventListener("squeezeend", P), n.removeEventListener("end", G), n.removeEventListener("inputsourceschange", U), A.forEach(function(Y, Q) {
        Y !== void 0 && Y.disconnect(Q);
      }), A.clear(), B = null, S = null, e.setRenderTarget(m), d = null, h = null, u = null, n = null, g = null, K.stop(), r.isPresenting = !1, r.dispatchEvent({ type: "sessionend" });
    }
    this.setFramebufferScaleFactor = function(Y) {
      a = Y, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
    }, this.setReferenceSpaceType = function(Y) {
      s = Y, r.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
    }, this.getReferenceSpace = function() {
      return c || o;
    }, this.setReferenceSpace = function(Y) {
      c = Y;
    }, this.getBaseLayer = function() {
      return h !== null ? h : d;
    }, this.getBinding = function() {
      return u;
    }, this.getFrame = function() {
      return v;
    }, this.getSession = function() {
      return n;
    }, this.setSession = async function(Y) {
      if (n = Y, n !== null) {
        if (m = e.getRenderTarget(), n.addEventListener("select", P), n.addEventListener("selectstart", P), n.addEventListener("selectend", P), n.addEventListener("squeeze", P), n.addEventListener("squeezestart", P), n.addEventListener("squeezeend", P), n.addEventListener("end", G), n.addEventListener("inputsourceschange", U), M.xrCompatible !== !0 && await t.makeXRCompatible(), n.renderState.layers === void 0 || e.capabilities.isWebGL2 === !1) {
          const Q = {
            antialias: n.renderState.layers === void 0 ? M.antialias : !0,
            alpha: M.alpha,
            depth: M.depth,
            stencil: M.stencil,
            framebufferScaleFactor: a
          };
          d = new XRWebGLLayer(n, t, Q), n.updateRenderState({ baseLayer: d }), g = new Ci(
            d.framebufferWidth,
            d.framebufferHeight,
            {
              format: jt,
              type: Ji,
              encoding: e.outputEncoding
            }
          );
        } else {
          let Q = null, se = null, X = null;
          M.depth && (X = M.stencil ? 35056 : 33190, Q = M.stencil ? Cr : Zi, se = M.stencil ? br : Fi);
          const ue = {
            colorFormat: e.outputEncoding === Qe ? 35907 : 32856,
            depthFormat: X,
            scaleFactor: a
          };
          u = new XRWebGLBinding(n, t), h = u.createProjectionLayer(ue), n.updateRenderState({ layers: [h] }), g = new Ci(
            h.textureWidth,
            h.textureHeight,
            {
              format: jt,
              type: Ji,
              depthTexture: new rw(h.textureWidth, h.textureHeight, se, void 0, void 0, void 0, void 0, void 0, void 0, Q),
              stencilBuffer: M.stencil,
              encoding: e.outputEncoding,
              samples: M.antialias ? 4 : 0
            }
          );
          const fe = e.properties.get(g);
          fe.__ignoreDepthValues = h.ignoreDepthValues;
        }
        g.isXRRenderTarget = !0, this.setFoveation(1), c = null, o = await n.requestReferenceSpace(s), K.setContext(n), K.start(), r.isPresenting = !0, r.dispatchEvent({ type: "sessionstart" });
      }
    };
    function U(Y) {
      const Q = n.inputSources;
      for (let se = 0; se < Q.length; se++) {
        const X = Q[se].handedness === "right" ? 1 : 0;
        A.set(Q[se], I[X]);
      }
      for (let se = 0; se < Y.removed.length; se++) {
        const X = Y.removed[se], ue = A.get(X);
        ue && (ue.dispatchEvent({ type: "disconnected", data: X }), A.delete(X));
      }
      for (let se = 0; se < Y.added.length; se++) {
        const X = Y.added[se], ue = A.get(X);
        ue && ue.dispatchEvent({ type: "connected", data: X });
      }
    }
    const le = new W(), ne = new W();
    function z(Y, Q, se) {
      le.setFromMatrixPosition(Q.matrixWorld), ne.setFromMatrixPosition(se.matrixWorld);
      const X = le.distanceTo(ne), ue = Q.projectionMatrix.elements, fe = se.projectionMatrix.elements, ye = ue[14] / (ue[10] - 1), $ = ue[14] / (ue[10] + 1), Le = (ue[9] + 1) / ue[5], Me = (ue[9] - 1) / ue[5], we = (ue[8] - 1) / ue[0], de = (fe[8] + 1) / fe[0], Oe = ye * we, _e = ye * de, xe = X / (-we + de), Ue = xe * -we;
      Q.matrixWorld.decompose(Y.position, Y.quaternion, Y.scale), Y.translateX(Ue), Y.translateZ(xe), Y.matrixWorld.compose(Y.position, Y.quaternion, Y.scale), Y.matrixWorldInverse.copy(Y.matrixWorld).invert();
      const Xe = ye + xe, Ye = $ + xe, qe = Oe - Ue, Ve = _e + (X - Ue), Ne = Le * $ / Ye * Xe, dt = Me * $ / Ye * Xe;
      Y.projectionMatrix.makePerspective(qe, Ve, Ne, dt, Xe, Ye);
    }
    function q(Y, Q) {
      Q === null ? Y.matrixWorld.copy(Y.matrix) : Y.matrixWorld.multiplyMatrices(Q.matrixWorld, Y.matrix), Y.matrixWorldInverse.copy(Y.matrixWorld).invert();
    }
    this.updateCamera = function(Y) {
      if (n === null)
        return;
      T.near = y.near = L.near = Y.near, T.far = y.far = L.far = Y.far, (B !== T.near || S !== T.far) && (n.updateRenderState({
        depthNear: T.near,
        depthFar: T.far
      }), B = T.near, S = T.far);
      const Q = Y.parent, se = T.cameras;
      q(T, Q);
      for (let ue = 0; ue < se.length; ue++)
        q(se[ue], Q);
      T.matrixWorld.decompose(T.position, T.quaternion, T.scale), Y.position.copy(T.position), Y.quaternion.copy(T.quaternion), Y.scale.copy(T.scale), Y.matrix.copy(T.matrix), Y.matrixWorld.copy(T.matrixWorld);
      const X = Y.children;
      for (let ue = 0, fe = X.length; ue < fe; ue++)
        X[ue].updateMatrixWorld(!0);
      se.length === 2 ? z(T, L, y) : T.projectionMatrix.copy(L.projectionMatrix);
    }, this.getCamera = function() {
      return T;
    }, this.getFoveation = function() {
      if (h !== null)
        return h.fixedFoveation;
      if (d !== null)
        return d.fixedFoveation;
    }, this.setFoveation = function(Y) {
      h !== null && (h.fixedFoveation = Y), d !== null && d.fixedFoveation !== void 0 && (d.fixedFoveation = Y);
    };
    let V = null;
    function ie(Y, Q) {
      if (l = Q.getViewerPose(c || o), v = Q, l !== null) {
        const X = l.views;
        d !== null && (e.setRenderTargetFramebuffer(g, d.framebuffer), e.setRenderTarget(g));
        let ue = !1;
        X.length !== T.cameras.length && (T.cameras.length = 0, ue = !0);
        for (let fe = 0; fe < X.length; fe++) {
          const ye = X[fe];
          let $ = null;
          if (d !== null)
            $ = d.getViewport(ye);
          else {
            const Me = u.getViewSubImage(h, ye);
            $ = Me.viewport, fe === 0 && (e.setRenderTargetTextures(
              g,
              Me.colorTexture,
              h.ignoreDepthValues ? void 0 : Me.depthStencilTexture
            ), e.setRenderTarget(g));
          }
          let Le = D[fe];
          Le === void 0 && (Le = new Lt(), Le.layers.enable(fe), Le.viewport = new et(), D[fe] = Le), Le.matrix.fromArray(ye.transform.matrix), Le.projectionMatrix.fromArray(ye.projectionMatrix), Le.viewport.set($.x, $.y, $.width, $.height), fe === 0 && T.matrix.copy(Le.matrix), ue === !0 && T.cameras.push(Le);
        }
      }
      const se = n.inputSources;
      for (let X = 0; X < I.length; X++) {
        const ue = se[X], fe = A.get(ue);
        fe !== void 0 && fe.update(ue, Q, c || o);
      }
      V && V(Y, Q), v = null;
    }
    const K = new Pd();
    K.setAnimationLoop(ie), this.setAnimationLoop = function(Y) {
      V = Y;
    }, this.dispose = function() {
    };
  }
}
function aw(i, e) {
  function t(m, g) {
    m.fogColor.value.copy(g.color), g.isFog ? (m.fogNear.value = g.near, m.fogFar.value = g.far) : g.isFogExp2 && (m.fogDensity.value = g.density);
  }
  function r(m, g, I, A, L) {
    g.isMeshBasicMaterial || g.isMeshLambertMaterial ? n(m, g) : g.isMeshToonMaterial ? (n(m, g), u(m, g)) : g.isMeshPhongMaterial ? (n(m, g), l(m, g)) : g.isMeshStandardMaterial ? (n(m, g), h(m, g), g.isMeshPhysicalMaterial && d(m, g, L)) : g.isMeshMatcapMaterial ? (n(m, g), v(m, g)) : g.isMeshDepthMaterial ? n(m, g) : g.isMeshDistanceMaterial ? (n(m, g), M(m, g)) : g.isMeshNormalMaterial ? n(m, g) : g.isLineBasicMaterial ? (a(m, g), g.isLineDashedMaterial && o(m, g)) : g.isPointsMaterial ? s(m, g, I, A) : g.isSpriteMaterial ? c(m, g) : g.isShadowMaterial ? (m.color.value.copy(g.color), m.opacity.value = g.opacity) : g.isShaderMaterial && (g.uniformsNeedUpdate = !1);
  }
  function n(m, g) {
    m.opacity.value = g.opacity, g.color && m.diffuse.value.copy(g.color), g.emissive && m.emissive.value.copy(g.emissive).multiplyScalar(g.emissiveIntensity), g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.bumpMap && (m.bumpMap.value = g.bumpMap, m.bumpScale.value = g.bumpScale, g.side === zt && (m.bumpScale.value *= -1)), g.displacementMap && (m.displacementMap.value = g.displacementMap, m.displacementScale.value = g.displacementScale, m.displacementBias.value = g.displacementBias), g.emissiveMap && (m.emissiveMap.value = g.emissiveMap), g.normalMap && (m.normalMap.value = g.normalMap, m.normalScale.value.copy(g.normalScale), g.side === zt && m.normalScale.value.negate()), g.specularMap && (m.specularMap.value = g.specularMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
    const I = e.get(g).envMap;
    if (I && (m.envMap.value = I, m.flipEnvMap.value = I.isCubeTexture && I.isRenderTargetTexture === !1 ? -1 : 1, m.reflectivity.value = g.reflectivity, m.ior.value = g.ior, m.refractionRatio.value = g.refractionRatio), g.lightMap) {
      m.lightMap.value = g.lightMap;
      const y = i.physicallyCorrectLights !== !0 ? Math.PI : 1;
      m.lightMapIntensity.value = g.lightMapIntensity * y;
    }
    g.aoMap && (m.aoMap.value = g.aoMap, m.aoMapIntensity.value = g.aoMapIntensity);
    let A;
    g.map ? A = g.map : g.specularMap ? A = g.specularMap : g.displacementMap ? A = g.displacementMap : g.normalMap ? A = g.normalMap : g.bumpMap ? A = g.bumpMap : g.roughnessMap ? A = g.roughnessMap : g.metalnessMap ? A = g.metalnessMap : g.alphaMap ? A = g.alphaMap : g.emissiveMap ? A = g.emissiveMap : g.clearcoatMap ? A = g.clearcoatMap : g.clearcoatNormalMap ? A = g.clearcoatNormalMap : g.clearcoatRoughnessMap ? A = g.clearcoatRoughnessMap : g.iridescenceMap ? A = g.iridescenceMap : g.iridescenceThicknessMap ? A = g.iridescenceThicknessMap : g.specularIntensityMap ? A = g.specularIntensityMap : g.specularColorMap ? A = g.specularColorMap : g.transmissionMap ? A = g.transmissionMap : g.thicknessMap ? A = g.thicknessMap : g.sheenColorMap ? A = g.sheenColorMap : g.sheenRoughnessMap && (A = g.sheenRoughnessMap), A !== void 0 && (A.isWebGLRenderTarget && (A = A.texture), A.matrixAutoUpdate === !0 && A.updateMatrix(), m.uvTransform.value.copy(A.matrix));
    let L;
    g.aoMap ? L = g.aoMap : g.lightMap && (L = g.lightMap), L !== void 0 && (L.isWebGLRenderTarget && (L = L.texture), L.matrixAutoUpdate === !0 && L.updateMatrix(), m.uv2Transform.value.copy(L.matrix));
  }
  function a(m, g) {
    m.diffuse.value.copy(g.color), m.opacity.value = g.opacity;
  }
  function o(m, g) {
    m.dashSize.value = g.dashSize, m.totalSize.value = g.dashSize + g.gapSize, m.scale.value = g.scale;
  }
  function s(m, g, I, A) {
    m.diffuse.value.copy(g.color), m.opacity.value = g.opacity, m.size.value = g.size * I, m.scale.value = A * 0.5, g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
    let L;
    g.map ? L = g.map : g.alphaMap && (L = g.alphaMap), L !== void 0 && (L.matrixAutoUpdate === !0 && L.updateMatrix(), m.uvTransform.value.copy(L.matrix));
  }
  function c(m, g) {
    m.diffuse.value.copy(g.color), m.opacity.value = g.opacity, m.rotation.value = g.rotation, g.map && (m.map.value = g.map), g.alphaMap && (m.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (m.alphaTest.value = g.alphaTest);
    let I;
    g.map ? I = g.map : g.alphaMap && (I = g.alphaMap), I !== void 0 && (I.matrixAutoUpdate === !0 && I.updateMatrix(), m.uvTransform.value.copy(I.matrix));
  }
  function l(m, g) {
    m.specular.value.copy(g.specular), m.shininess.value = Math.max(g.shininess, 1e-4);
  }
  function u(m, g) {
    g.gradientMap && (m.gradientMap.value = g.gradientMap);
  }
  function h(m, g) {
    m.roughness.value = g.roughness, m.metalness.value = g.metalness, g.roughnessMap && (m.roughnessMap.value = g.roughnessMap), g.metalnessMap && (m.metalnessMap.value = g.metalnessMap), e.get(g).envMap && (m.envMapIntensity.value = g.envMapIntensity);
  }
  function d(m, g, I) {
    m.ior.value = g.ior, g.sheen > 0 && (m.sheenColor.value.copy(g.sheenColor).multiplyScalar(g.sheen), m.sheenRoughness.value = g.sheenRoughness, g.sheenColorMap && (m.sheenColorMap.value = g.sheenColorMap), g.sheenRoughnessMap && (m.sheenRoughnessMap.value = g.sheenRoughnessMap)), g.clearcoat > 0 && (m.clearcoat.value = g.clearcoat, m.clearcoatRoughness.value = g.clearcoatRoughness, g.clearcoatMap && (m.clearcoatMap.value = g.clearcoatMap), g.clearcoatRoughnessMap && (m.clearcoatRoughnessMap.value = g.clearcoatRoughnessMap), g.clearcoatNormalMap && (m.clearcoatNormalScale.value.copy(g.clearcoatNormalScale), m.clearcoatNormalMap.value = g.clearcoatNormalMap, g.side === zt && m.clearcoatNormalScale.value.negate())), g.iridescence > 0 && (m.iridescence.value = g.iridescence, m.iridescenceIOR.value = g.iridescenceIOR, m.iridescenceThicknessMinimum.value = g.iridescenceThicknessRange[0], m.iridescenceThicknessMaximum.value = g.iridescenceThicknessRange[1], g.iridescenceMap && (m.iridescenceMap.value = g.iridescenceMap), g.iridescenceThicknessMap && (m.iridescenceThicknessMap.value = g.iridescenceThicknessMap)), g.transmission > 0 && (m.transmission.value = g.transmission, m.transmissionSamplerMap.value = I.texture, m.transmissionSamplerSize.value.set(I.width, I.height), g.transmissionMap && (m.transmissionMap.value = g.transmissionMap), m.thickness.value = g.thickness, g.thicknessMap && (m.thicknessMap.value = g.thicknessMap), m.attenuationDistance.value = g.attenuationDistance, m.attenuationColor.value.copy(g.attenuationColor)), m.specularIntensity.value = g.specularIntensity, m.specularColor.value.copy(g.specularColor), g.specularIntensityMap && (m.specularIntensityMap.value = g.specularIntensityMap), g.specularColorMap && (m.specularColorMap.value = g.specularColorMap);
  }
  function v(m, g) {
    g.matcap && (m.matcap.value = g.matcap);
  }
  function M(m, g) {
    m.referencePosition.value.copy(g.referencePosition), m.nearDistance.value = g.nearDistance, m.farDistance.value = g.farDistance;
  }
  return {
    refreshFogUniforms: t,
    refreshMaterialUniforms: r
  };
}
function sw() {
  const i = ua("canvas");
  return i.style.display = "block", i;
}
function Ud(i = {}) {
  this.isWebGLRenderer = !0;
  const e = i.canvas !== void 0 ? i.canvas : sw(), t = i.context !== void 0 ? i.context : null, r = i.depth !== void 0 ? i.depth : !0, n = i.stencil !== void 0 ? i.stencil : !0, a = i.antialias !== void 0 ? i.antialias : !1, o = i.premultipliedAlpha !== void 0 ? i.premultipliedAlpha : !0, s = i.preserveDrawingBuffer !== void 0 ? i.preserveDrawingBuffer : !1, c = i.powerPreference !== void 0 ? i.powerPreference : "default", l = i.failIfMajorPerformanceCaveat !== void 0 ? i.failIfMajorPerformanceCaveat : !1;
  let u;
  t !== null ? u = t.getContextAttributes().alpha : u = i.alpha !== void 0 ? i.alpha : !1;
  let h = null, d = null;
  const v = [], M = [];
  this.domElement = e, this.debug = {
    checkShaderErrors: !0
  }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = Xi, this.physicallyCorrectLights = !1, this.toneMapping = hi, this.toneMappingExposure = 1, Object.defineProperties(this, {
    gammaFactor: {
      get: function() {
        return console.warn("THREE.WebGLRenderer: .gammaFactor has been removed."), 2;
      },
      set: function() {
        console.warn("THREE.WebGLRenderer: .gammaFactor has been removed.");
      }
    }
  });
  const m = this;
  let g = !1, I = 0, A = 0, L = null, y = -1, D = null;
  const T = new et(), B = new et();
  let S = null, P = e.width, G = e.height, U = 1, le = null, ne = null;
  const z = new et(0, 0, P, G), q = new et(0, 0, P, G);
  let V = !1;
  const ie = new Ld();
  let K = !1, Y = !1, Q = null;
  const se = new tt(), X = new Re(), ue = new W(), fe = { background: null, fog: null, environment: null, overrideMaterial: null, isScene: !0 };
  function ye() {
    return L === null ? U : 1;
  }
  let $ = t;
  function Le(C, H) {
    for (let Z = 0; Z < C.length; Z++) {
      const F = C[Z], re = e.getContext(F, H);
      if (re !== null)
        return re;
    }
    return null;
  }
  try {
    const C = {
      alpha: !0,
      depth: r,
      stencil: n,
      antialias: a,
      premultipliedAlpha: o,
      preserveDrawingBuffer: s,
      powerPreference: c,
      failIfMajorPerformanceCaveat: l
    };
    if ("setAttribute" in e && e.setAttribute("data-engine", `three.js r${ao}`), e.addEventListener("webglcontextlost", w, !1), e.addEventListener("webglcontextrestored", j, !1), e.addEventListener("webglcontextcreationerror", k, !1), $ === null) {
      const H = ["webgl2", "webgl", "experimental-webgl"];
      if (m.isWebGL1Renderer === !0 && H.shift(), $ = Le(H, C), $ === null)
        throw Le(H) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
    }
    $.getShaderPrecisionFormat === void 0 && ($.getShaderPrecisionFormat = function() {
      return { rangeMin: 1, rangeMax: 1, precision: 1 };
    });
  } catch (C) {
    throw console.error("THREE.WebGLRenderer: " + C.message), C;
  }
  let Me, we, de, Oe, _e, xe, Ue, Xe, Ye, qe, Ve, Ne, dt, it, E, _, J, ce, he, x, f, p, b;
  function N() {
    Me = new yI($), we = new pI($, Me, i), Me.init(we), p = new ew($, Me, we), de = new qb($, Me, we), Oe = new bI(), _e = new Wb(), xe = new Kb($, Me, de, _e, we, p, Oe), Ue = new mI(m), Xe = new MI(m), Ye = new j2($, we), b = new dI($, Me, Ye, we), qe = new xI($, Ye, Oe, b), Ve = new SI($, qe, Ye, Oe), he = new AI($, we, xe), _ = new fI(_e), Ne = new kb(m, Ue, Xe, Me, we, b, _), dt = new aw(m, _e), it = new Ub(), E = new Qb(Me, we), ce = new uI(m, Ue, de, Ve, u, o), J = new $b(m, Ve, we), x = new hI($, Me, Oe, we), f = new II($, Me, Oe, we), Oe.programs = Ne.programs, m.capabilities = we, m.extensions = Me, m.properties = _e, m.renderLists = it, m.shadowMap = J, m.state = de, m.info = Oe;
  }
  N();
  const O = new nw(m, $);
  this.xr = O, this.getContext = function() {
    return $;
  }, this.getContextAttributes = function() {
    return $.getContextAttributes();
  }, this.forceContextLoss = function() {
    const C = Me.get("WEBGL_lose_context");
    C && C.loseContext();
  }, this.forceContextRestore = function() {
    const C = Me.get("WEBGL_lose_context");
    C && C.restoreContext();
  }, this.getPixelRatio = function() {
    return U;
  }, this.setPixelRatio = function(C) {
    C !== void 0 && (U = C, this.setSize(P, G, !1));
  }, this.getSize = function(C) {
    return C.set(P, G);
  }, this.setSize = function(C, H, Z) {
    if (O.isPresenting) {
      console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
      return;
    }
    P = C, G = H, e.width = Math.floor(C * U), e.height = Math.floor(H * U), Z !== !1 && (e.style.width = C + "px", e.style.height = H + "px"), this.setViewport(0, 0, C, H);
  }, this.getDrawingBufferSize = function(C) {
    return C.set(P * U, G * U).floor();
  }, this.setDrawingBufferSize = function(C, H, Z) {
    P = C, G = H, U = Z, e.width = Math.floor(C * Z), e.height = Math.floor(H * Z), this.setViewport(0, 0, C, H);
  }, this.getCurrentViewport = function(C) {
    return C.copy(T);
  }, this.getViewport = function(C) {
    return C.copy(z);
  }, this.setViewport = function(C, H, Z, F) {
    C.isVector4 ? z.set(C.x, C.y, C.z, C.w) : z.set(C, H, Z, F), de.viewport(T.copy(z).multiplyScalar(U).floor());
  }, this.getScissor = function(C) {
    return C.copy(q);
  }, this.setScissor = function(C, H, Z, F) {
    C.isVector4 ? q.set(C.x, C.y, C.z, C.w) : q.set(C, H, Z, F), de.scissor(B.copy(q).multiplyScalar(U).floor());
  }, this.getScissorTest = function() {
    return V;
  }, this.setScissorTest = function(C) {
    de.setScissorTest(V = C);
  }, this.setOpaqueSort = function(C) {
    le = C;
  }, this.setTransparentSort = function(C) {
    ne = C;
  }, this.getClearColor = function(C) {
    return C.copy(ce.getClearColor());
  }, this.setClearColor = function() {
    ce.setClearColor.apply(ce, arguments);
  }, this.getClearAlpha = function() {
    return ce.getClearAlpha();
  }, this.setClearAlpha = function() {
    ce.setClearAlpha.apply(ce, arguments);
  }, this.clear = function(C = !0, H = !0, Z = !0) {
    let F = 0;
    C && (F |= 16384), H && (F |= 256), Z && (F |= 1024), $.clear(F);
  }, this.clearColor = function() {
    this.clear(!0, !1, !1);
  }, this.clearDepth = function() {
    this.clear(!1, !0, !1);
  }, this.clearStencil = function() {
    this.clear(!1, !1, !0);
  }, this.dispose = function() {
    e.removeEventListener("webglcontextlost", w, !1), e.removeEventListener("webglcontextrestored", j, !1), e.removeEventListener("webglcontextcreationerror", k, !1), it.dispose(), E.dispose(), _e.dispose(), Ue.dispose(), Xe.dispose(), Ve.dispose(), b.dispose(), Ne.dispose(), O.dispose(), O.removeEventListener("sessionstart", Ae), O.removeEventListener("sessionend", Fe), Q && (Q.dispose(), Q = null), Ze.stop();
  };
  function w(C) {
    C.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
  }
  function j() {
    console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
    const C = Oe.autoReset, H = J.enabled, Z = J.autoUpdate, F = J.needsUpdate, re = J.type;
    N(), Oe.autoReset = C, J.enabled = H, J.autoUpdate = Z, J.needsUpdate = F, J.type = re;
  }
  function k(C) {
    console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", C.statusMessage);
  }
  function ee(C) {
    const H = C.target;
    H.removeEventListener("dispose", ee), te(H);
  }
  function te(C) {
    ae(C), _e.remove(C);
  }
  function ae(C) {
    const H = _e.get(C).programs;
    H !== void 0 && (H.forEach(function(Z) {
      Ne.releaseProgram(Z);
    }), C.isShaderMaterial && Ne.releaseShaderCache(C));
  }
  this.renderBufferDirect = function(C, H, Z, F, re, be) {
    H === null && (H = fe);
    const De = re.isMesh && re.matrixWorld.determinant() < 0, Te = dh(C, H, Z, F, re);
    de.setMaterial(F, De);
    let Pe = Z.index;
    const Je = Z.attributes.position;
    if (Pe === null) {
      if (Je === void 0 || Je.count === 0)
        return;
    } else if (Pe.count === 0)
      return;
    let je = 1;
    F.wireframe === !0 && (Pe = qe.getWireframeAttribute(Z), je = 2), b.setup(re, F, Te, Z, Pe);
    let Be, rt = x;
    Pe !== null && (Be = Ye.get(Pe), rt = f, rt.setIndex(Be));
    const ji = Pe !== null ? Pe.count : Je.count, qi = Z.drawRange.start * je, Ki = Z.drawRange.count * je, Vt = be !== null ? be.start * je : 0, ke = be !== null ? be.count * je : 1 / 0, er = Math.max(qi, Vt), Rr = Math.min(ji, qi + Ki, Vt + ke) - 1, Yt = Math.max(0, Rr - er + 1);
    if (Yt !== 0) {
      if (re.isMesh)
        F.wireframe === !0 ? (de.setLineWidth(F.wireframeLinewidth * ye()), rt.setMode(1)) : rt.setMode(4);
      else if (re.isLine) {
        let vi = F.linewidth;
        vi === void 0 && (vi = 1), de.setLineWidth(vi * ye()), re.isLineSegments ? rt.setMode(1) : re.isLineLoop ? rt.setMode(2) : rt.setMode(3);
      } else
        re.isPoints ? rt.setMode(0) : re.isSprite && rt.setMode(4);
      if (re.isInstancedMesh)
        rt.renderInstances(er, Yt, re.count);
      else if (Z.isInstancedBufferGeometry) {
        const vi = Math.min(Z.instanceCount, Z._maxInstanceCount);
        rt.renderInstances(er, Yt, vi);
      } else
        rt.render(er, Yt);
    }
  }, this.compile = function(C, H) {
    d = E.get(C), d.init(), M.push(d), C.traverseVisible(function(Z) {
      Z.isLight && Z.layers.test(H.layers) && (d.pushLight(Z), Z.castShadow && d.pushShadow(Z));
    }), d.setupLights(m.physicallyCorrectLights), C.traverse(function(Z) {
      const F = Z.material;
      if (F)
        if (Array.isArray(F))
          for (let re = 0; re < F.length; re++) {
            const be = F[re];
            gi(be, C, Z);
          }
        else
          gi(F, C, Z);
    }), M.pop(), d = null;
  };
  let oe = null;
  function ve(C) {
    oe && oe(C);
  }
  function Ae() {
    Ze.stop();
  }
  function Fe() {
    Ze.start();
  }
  const Ze = new Pd();
  Ze.setAnimationLoop(ve), typeof self < "u" && Ze.setContext(self), this.setAnimationLoop = function(C) {
    oe = C, O.setAnimationLoop(C), C === null ? Ze.stop() : Ze.start();
  }, O.addEventListener("sessionstart", Ae), O.addEventListener("sessionend", Fe), this.render = function(C, H) {
    if (H !== void 0 && H.isCamera !== !0) {
      console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
      return;
    }
    if (g === !0)
      return;
    C.autoUpdate === !0 && C.updateMatrixWorld(), H.parent === null && H.updateMatrixWorld(), O.enabled === !0 && O.isPresenting === !0 && (O.cameraAutoUpdate === !0 && O.updateCamera(H), H = O.getCamera()), C.isScene === !0 && C.onBeforeRender(m, C, H, L), d = E.get(C, M.length), d.init(), M.push(d), se.multiplyMatrices(H.projectionMatrix, H.matrixWorldInverse), ie.setFromProjectionMatrix(se), Y = this.localClippingEnabled, K = _.init(this.clippingPlanes, Y, H), h = it.get(C, v.length), h.init(), v.push(h), ht(C, H, 0, m.sortObjects), h.finish(), m.sortObjects === !0 && h.sort(le, ne), K === !0 && _.beginShadows();
    const Z = d.state.shadowsArray;
    if (J.render(Z, C, H), K === !0 && _.endShadows(), this.info.autoReset === !0 && this.info.reset(), ce.render(h, C), d.setupLights(m.physicallyCorrectLights), H.isArrayCamera) {
      const F = H.cameras;
      for (let re = 0, be = F.length; re < be; re++) {
        const De = F[re];
        Pi(h, C, De, De.viewport);
      }
    } else
      Pi(h, C, H);
    L !== null && (xe.updateMultisampleRenderTarget(L), xe.updateRenderTargetMipmap(L)), C.isScene === !0 && C.onAfterRender(m, C, H), b.resetDefaultState(), y = -1, D = null, M.pop(), M.length > 0 ? d = M[M.length - 1] : d = null, v.pop(), v.length > 0 ? h = v[v.length - 1] : h = null;
  };
  function ht(C, H, Z, F) {
    if (C.visible === !1)
      return;
    if (C.layers.test(H.layers)) {
      if (C.isGroup)
        Z = C.renderOrder;
      else if (C.isLOD)
        C.autoUpdate === !0 && C.update(H);
      else if (C.isLight)
        d.pushLight(C), C.castShadow && d.pushShadow(C);
      else if (C.isSprite) {
        if (!C.frustumCulled || ie.intersectsSprite(C)) {
          F && ue.setFromMatrixPosition(C.matrixWorld).applyMatrix4(se);
          const be = Ve.update(C), De = C.material;
          De.visible && h.push(C, be, De, Z, ue.z, null);
        }
      } else if ((C.isMesh || C.isLine || C.isPoints) && (C.isSkinnedMesh && C.skeleton.frame !== Oe.render.frame && (C.skeleton.update(), C.skeleton.frame = Oe.render.frame), !C.frustumCulled || ie.intersectsObject(C))) {
        F && ue.setFromMatrixPosition(C.matrixWorld).applyMatrix4(se);
        const be = Ve.update(C), De = C.material;
        if (Array.isArray(De)) {
          const Te = be.groups;
          for (let Pe = 0, Je = Te.length; Pe < Je; Pe++) {
            const je = Te[Pe], Be = De[je.materialIndex];
            Be && Be.visible && h.push(C, be, Be, Z, ue.z, je);
          }
        } else
          De.visible && h.push(C, be, De, Z, ue.z, null);
      }
    }
    const re = C.children;
    for (let be = 0, De = re.length; be < De; be++)
      ht(re[be], H, Z, F);
  }
  function Pi(C, H, Z, F) {
    const re = C.opaque, be = C.transmissive, De = C.transparent;
    d.setupLightsView(Z), be.length > 0 && Or(re, H, Z), F && de.viewport(T.copy(F)), re.length > 0 && $i(re, H, Z), be.length > 0 && $i(be, H, Z), De.length > 0 && $i(De, H, Z), de.buffers.depth.setTest(!0), de.buffers.depth.setMask(!0), de.buffers.color.setMask(!0), de.setPolygonOffset(!1);
  }
  function Or(C, H, Z) {
    const F = we.isWebGL2;
    Q === null && (Q = new Ci(1, 1, {
      generateMipmaps: !0,
      type: Me.has("EXT_color_buffer_half_float") ? un : Ji,
      minFilter: Da,
      samples: F && a === !0 ? 4 : 0
    })), m.getDrawingBufferSize(X), F ? Q.setSize(X.x, X.y) : Q.setSize(Us(X.x), Us(X.y));
    const re = m.getRenderTarget();
    m.setRenderTarget(Q), m.clear();
    const be = m.toneMapping;
    m.toneMapping = hi, $i(C, H, Z), m.toneMapping = be, xe.updateMultisampleRenderTarget(Q), xe.updateRenderTargetMipmap(Q), m.setRenderTarget(re);
  }
  function $i(C, H, Z) {
    const F = H.isScene === !0 ? H.overrideMaterial : null;
    for (let re = 0, be = C.length; re < be; re++) {
      const De = C[re], Te = De.object, Pe = De.geometry, Je = F === null ? De.material : F, je = De.group;
      Te.layers.test(Z.layers) && zr(Te, H, Z, Pe, Je, je);
    }
  }
  function zr(C, H, Z, F, re, be) {
    C.onBeforeRender(m, H, Z, F, re, be), C.modelViewMatrix.multiplyMatrices(Z.matrixWorldInverse, C.matrixWorld), C.normalMatrix.getNormalMatrix(C.modelViewMatrix), re.onBeforeRender(m, H, Z, F, C, be), re.transparent === !0 && re.side === Sr ? (re.side = zt, re.needsUpdate = !0, m.renderBufferDirect(Z, H, F, re, C, be), re.side = cn, re.needsUpdate = !0, m.renderBufferDirect(Z, H, F, re, C, be), re.side = Sr) : m.renderBufferDirect(Z, H, F, re, C, be), C.onAfterRender(m, H, Z, F, re, be);
  }
  function gi(C, H, Z) {
    H.isScene !== !0 && (H = fe);
    const F = _e.get(C), re = d.state.lights, be = d.state.shadowsArray, De = re.state.version, Te = Ne.getParameters(C, re.state, be, H, Z), Pe = Ne.getProgramCacheKey(Te);
    let Je = F.programs;
    F.environment = C.isMeshStandardMaterial ? H.environment : null, F.fog = H.fog, F.envMap = (C.isMeshStandardMaterial ? Xe : Ue).get(C.envMap || F.environment), Je === void 0 && (C.addEventListener("dispose", ee), Je = /* @__PURE__ */ new Map(), F.programs = Je);
    let je = Je.get(Pe);
    if (je !== void 0) {
      if (F.currentProgram === je && F.lightsStateVersion === De)
        return mo(C, Te), je;
    } else
      Te.uniforms = Ne.getUniforms(C), C.onBuild(Z, Te, m), C.onBeforeCompile(Te, m), je = Ne.acquireProgram(Te, Pe), Je.set(Pe, je), F.uniforms = Te.uniforms;
    const Be = F.uniforms;
    (!C.isShaderMaterial && !C.isRawShaderMaterial || C.clipping === !0) && (Be.clippingPlanes = _.uniform), mo(C, Te), F.needsLights = ph(C), F.lightsStateVersion = De, F.needsLights && (Be.ambientLightColor.value = re.state.ambient, Be.lightProbe.value = re.state.probe, Be.directionalLights.value = re.state.directional, Be.directionalLightShadows.value = re.state.directionalShadow, Be.spotLights.value = re.state.spot, Be.spotLightShadows.value = re.state.spotShadow, Be.rectAreaLights.value = re.state.rectArea, Be.ltc_1.value = re.state.rectAreaLTC1, Be.ltc_2.value = re.state.rectAreaLTC2, Be.pointLights.value = re.state.point, Be.pointLightShadows.value = re.state.pointShadow, Be.hemisphereLights.value = re.state.hemi, Be.directionalShadowMap.value = re.state.directionalShadowMap, Be.directionalShadowMatrix.value = re.state.directionalShadowMatrix, Be.spotShadowMap.value = re.state.spotShadowMap, Be.spotShadowMatrix.value = re.state.spotShadowMatrix, Be.pointShadowMap.value = re.state.pointShadowMap, Be.pointShadowMatrix.value = re.state.pointShadowMatrix);
    const rt = je.getUniforms(), ji = ia.seqWithValue(rt.seq, Be);
    return F.currentProgram = je, F.uniformsList = ji, je;
  }
  function mo(C, H) {
    const Z = _e.get(C);
    Z.outputEncoding = H.outputEncoding, Z.instancing = H.instancing, Z.skinning = H.skinning, Z.morphTargets = H.morphTargets, Z.morphNormals = H.morphNormals, Z.morphColors = H.morphColors, Z.morphTargetsCount = H.morphTargetsCount, Z.numClippingPlanes = H.numClippingPlanes, Z.numIntersection = H.numClipIntersection, Z.vertexAlphas = H.vertexAlphas, Z.vertexTangents = H.vertexTangents, Z.toneMapping = H.toneMapping;
  }
  function dh(C, H, Z, F, re) {
    H.isScene !== !0 && (H = fe), xe.resetTextureUnits();
    const be = H.fog, De = F.isMeshStandardMaterial ? H.environment : null, Te = L === null ? m.outputEncoding : L.isXRRenderTarget === !0 ? L.texture.encoding : Xi, Pe = (F.isMeshStandardMaterial ? Xe : Ue).get(F.envMap || De), Je = F.vertexColors === !0 && !!Z.attributes.color && Z.attributes.color.itemSize === 4, je = !!F.normalMap && !!Z.attributes.tangent, Be = !!Z.morphAttributes.position, rt = !!Z.morphAttributes.normal, ji = !!Z.morphAttributes.color, qi = F.toneMapped ? m.toneMapping : hi, Ki = Z.morphAttributes.position || Z.morphAttributes.normal || Z.morphAttributes.color, Vt = Ki !== void 0 ? Ki.length : 0, ke = _e.get(F), er = d.state.lights;
    if (K === !0 && (Y === !0 || C !== D)) {
      const Zt = C === D && F.id === y;
      _.setState(F, C, Zt);
    }
    let Rr = !1;
    F.version === ke.__version ? (ke.needsLights && ke.lightsStateVersion !== er.state.version || ke.outputEncoding !== Te || re.isInstancedMesh && ke.instancing === !1 || !re.isInstancedMesh && ke.instancing === !0 || re.isSkinnedMesh && ke.skinning === !1 || !re.isSkinnedMesh && ke.skinning === !0 || ke.envMap !== Pe || F.fog === !0 && ke.fog !== be || ke.numClippingPlanes !== void 0 && (ke.numClippingPlanes !== _.numPlanes || ke.numIntersection !== _.numIntersection) || ke.vertexAlphas !== Je || ke.vertexTangents !== je || ke.morphTargets !== Be || ke.morphNormals !== rt || ke.morphColors !== ji || ke.toneMapping !== qi || we.isWebGL2 === !0 && ke.morphTargetsCount !== Vt) && (Rr = !0) : (Rr = !0, ke.__version = F.version);
    let Yt = ke.currentProgram;
    Rr === !0 && (Yt = gi(F, H, re));
    let vi = !1, kr = !1, La = !1;
    const lt = Yt.getUniforms(), Wr = ke.uniforms;
    if (de.useProgram(Yt.program) && (vi = !0, kr = !0, La = !0), F.id !== y && (y = F.id, kr = !0), vi || D !== C) {
      if (lt.setValue($, "projectionMatrix", C.projectionMatrix), we.logarithmicDepthBuffer && lt.setValue(
        $,
        "logDepthBufFC",
        2 / (Math.log(C.far + 1) / Math.LN2)
      ), D !== C && (D = C, kr = !0, La = !0), F.isShaderMaterial || F.isMeshPhongMaterial || F.isMeshToonMaterial || F.isMeshStandardMaterial || F.envMap) {
        const Zt = lt.map.cameraPosition;
        Zt !== void 0 && Zt.setValue(
          $,
          ue.setFromMatrixPosition(C.matrixWorld)
        );
      }
      (F.isMeshPhongMaterial || F.isMeshToonMaterial || F.isMeshLambertMaterial || F.isMeshBasicMaterial || F.isMeshStandardMaterial || F.isShaderMaterial) && lt.setValue($, "isOrthographic", C.isOrthographicCamera === !0), (F.isMeshPhongMaterial || F.isMeshToonMaterial || F.isMeshLambertMaterial || F.isMeshBasicMaterial || F.isMeshStandardMaterial || F.isShaderMaterial || F.isShadowMaterial || re.isSkinnedMesh) && lt.setValue($, "viewMatrix", C.matrixWorldInverse);
    }
    if (re.isSkinnedMesh) {
      lt.setOptional($, re, "bindMatrix"), lt.setOptional($, re, "bindMatrixInverse");
      const Zt = re.skeleton;
      Zt && (we.floatVertexTextures ? (Zt.boneTexture === null && Zt.computeBoneTexture(), lt.setValue($, "boneTexture", Zt.boneTexture, xe), lt.setValue($, "boneTextureSize", Zt.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
    }
    const Pa = Z.morphAttributes;
    return (Pa.position !== void 0 || Pa.normal !== void 0 || Pa.color !== void 0 && we.isWebGL2 === !0) && he.update(re, Z, F, Yt), (kr || ke.receiveShadow !== re.receiveShadow) && (ke.receiveShadow = re.receiveShadow, lt.setValue($, "receiveShadow", re.receiveShadow)), kr && (lt.setValue($, "toneMappingExposure", m.toneMappingExposure), ke.needsLights && hh(Wr, La), be && F.fog === !0 && dt.refreshFogUniforms(Wr, be), dt.refreshMaterialUniforms(Wr, F, U, G, Q), ia.upload($, ke.uniformsList, Wr, xe)), F.isShaderMaterial && F.uniformsNeedUpdate === !0 && (ia.upload($, ke.uniformsList, Wr, xe), F.uniformsNeedUpdate = !1), F.isSpriteMaterial && lt.setValue($, "center", re.center), lt.setValue($, "modelViewMatrix", re.modelViewMatrix), lt.setValue($, "normalMatrix", re.normalMatrix), lt.setValue($, "modelMatrix", re.matrixWorld), Yt;
  }
  function hh(C, H) {
    C.ambientLightColor.needsUpdate = H, C.lightProbe.needsUpdate = H, C.directionalLights.needsUpdate = H, C.directionalLightShadows.needsUpdate = H, C.pointLights.needsUpdate = H, C.pointLightShadows.needsUpdate = H, C.spotLights.needsUpdate = H, C.spotLightShadows.needsUpdate = H, C.rectAreaLights.needsUpdate = H, C.hemisphereLights.needsUpdate = H;
  }
  function ph(C) {
    return C.isMeshLambertMaterial || C.isMeshToonMaterial || C.isMeshPhongMaterial || C.isMeshStandardMaterial || C.isShadowMaterial || C.isShaderMaterial && C.lights === !0;
  }
  this.getActiveCubeFace = function() {
    return I;
  }, this.getActiveMipmapLevel = function() {
    return A;
  }, this.getRenderTarget = function() {
    return L;
  }, this.setRenderTargetTextures = function(C, H, Z) {
    _e.get(C.texture).__webglTexture = H, _e.get(C.depthTexture).__webglTexture = Z;
    const F = _e.get(C);
    F.__hasExternalTextures = !0, F.__hasExternalTextures && (F.__autoAllocateDepthBuffer = Z === void 0, F.__autoAllocateDepthBuffer || Me.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), F.__useRenderToTexture = !1));
  }, this.setRenderTargetFramebuffer = function(C, H) {
    const Z = _e.get(C);
    Z.__webglFramebuffer = H, Z.__useDefaultFramebuffer = H === void 0;
  }, this.setRenderTarget = function(C, H = 0, Z = 0) {
    L = C, I = H, A = Z;
    let F = !0;
    if (C) {
      const Te = _e.get(C);
      Te.__useDefaultFramebuffer !== void 0 ? (de.bindFramebuffer(36160, null), F = !1) : Te.__webglFramebuffer === void 0 ? xe.setupRenderTarget(C) : Te.__hasExternalTextures && xe.rebindTextures(C, _e.get(C.texture).__webglTexture, _e.get(C.depthTexture).__webglTexture);
    }
    let re = null, be = !1, De = !1;
    if (C) {
      const Te = C.texture;
      (Te.isData3DTexture || Te.isDataArrayTexture) && (De = !0);
      const Pe = _e.get(C).__webglFramebuffer;
      C.isWebGLCubeRenderTarget ? (re = Pe[H], be = !0) : we.isWebGL2 && C.samples > 0 && xe.useMultisampledRTT(C) === !1 ? re = _e.get(C).__webglMultisampledFramebuffer : re = Pe, T.copy(C.viewport), B.copy(C.scissor), S = C.scissorTest;
    } else
      T.copy(z).multiplyScalar(U).floor(), B.copy(q).multiplyScalar(U).floor(), S = V;
    if (de.bindFramebuffer(36160, re) && we.drawBuffers && F && de.drawBuffers(C, re), de.viewport(T), de.scissor(B), de.setScissorTest(S), be) {
      const Te = _e.get(C.texture);
      $.framebufferTexture2D(36160, 36064, 34069 + H, Te.__webglTexture, Z);
    } else if (De) {
      const Te = _e.get(C.texture), Pe = H || 0;
      $.framebufferTextureLayer(36160, 36064, Te.__webglTexture, Z || 0, Pe);
    }
    y = -1;
  }, this.readRenderTargetPixels = function(C, H, Z, F, re, be, De) {
    if (!(C && C.isWebGLRenderTarget)) {
      console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
      return;
    }
    let Te = _e.get(C).__webglFramebuffer;
    if (C.isWebGLCubeRenderTarget && De !== void 0 && (Te = Te[De]), Te) {
      de.bindFramebuffer(36160, Te);
      try {
        const Pe = C.texture, Je = Pe.format, je = Pe.type;
        if (Je !== jt && p.convert(Je) !== $.getParameter(35739)) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
          return;
        }
        const Be = je === un && (Me.has("EXT_color_buffer_half_float") || we.isWebGL2 && Me.has("EXT_color_buffer_float"));
        if (je !== Ji && p.convert(je) !== $.getParameter(35738) && !(je === Vi && (we.isWebGL2 || Me.has("OES_texture_float") || Me.has("WEBGL_color_buffer_float"))) && !Be) {
          console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
          return;
        }
        H >= 0 && H <= C.width - F && Z >= 0 && Z <= C.height - re && $.readPixels(H, Z, F, re, p.convert(Je), p.convert(je), be);
      } finally {
        const Pe = L !== null ? _e.get(L).__webglFramebuffer : null;
        de.bindFramebuffer(36160, Pe);
      }
    }
  }, this.copyFramebufferToTexture = function(C, H, Z = 0) {
    const F = Math.pow(2, -Z), re = Math.floor(H.image.width * F), be = Math.floor(H.image.height * F);
    xe.setTexture2D(H, 0), $.copyTexSubImage2D(3553, Z, 0, 0, C.x, C.y, re, be), de.unbindTexture();
  }, this.copyTextureToTexture = function(C, H, Z, F = 0) {
    const re = H.image.width, be = H.image.height, De = p.convert(Z.format), Te = p.convert(Z.type);
    xe.setTexture2D(Z, 0), $.pixelStorei(37440, Z.flipY), $.pixelStorei(37441, Z.premultiplyAlpha), $.pixelStorei(3317, Z.unpackAlignment), H.isDataTexture ? $.texSubImage2D(3553, F, C.x, C.y, re, be, De, Te, H.image.data) : H.isCompressedTexture ? $.compressedTexSubImage2D(3553, F, C.x, C.y, H.mipmaps[0].width, H.mipmaps[0].height, De, H.mipmaps[0].data) : $.texSubImage2D(3553, F, C.x, C.y, De, Te, H.image), F === 0 && Z.generateMipmaps && $.generateMipmap(3553), de.unbindTexture();
  }, this.copyTextureToTexture3D = function(C, H, Z, F, re = 0) {
    if (m.isWebGL1Renderer) {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
      return;
    }
    const be = C.max.x - C.min.x + 1, De = C.max.y - C.min.y + 1, Te = C.max.z - C.min.z + 1, Pe = p.convert(F.format), Je = p.convert(F.type);
    let je;
    if (F.isData3DTexture)
      xe.setTexture3D(F, 0), je = 32879;
    else if (F.isDataArrayTexture)
      xe.setTexture2DArray(F, 0), je = 35866;
    else {
      console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
      return;
    }
    $.pixelStorei(37440, F.flipY), $.pixelStorei(37441, F.premultiplyAlpha), $.pixelStorei(3317, F.unpackAlignment);
    const Be = $.getParameter(3314), rt = $.getParameter(32878), ji = $.getParameter(3316), qi = $.getParameter(3315), Ki = $.getParameter(32877), Vt = Z.isCompressedTexture ? Z.mipmaps[0] : Z.image;
    $.pixelStorei(3314, Vt.width), $.pixelStorei(32878, Vt.height), $.pixelStorei(3316, C.min.x), $.pixelStorei(3315, C.min.y), $.pixelStorei(32877, C.min.z), Z.isDataTexture || Z.isData3DTexture ? $.texSubImage3D(je, re, H.x, H.y, H.z, be, De, Te, Pe, Je, Vt.data) : Z.isCompressedTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), $.compressedTexSubImage3D(je, re, H.x, H.y, H.z, be, De, Te, Pe, Vt.data)) : $.texSubImage3D(je, re, H.x, H.y, H.z, be, De, Te, Pe, Je, Vt), $.pixelStorei(3314, Be), $.pixelStorei(32878, rt), $.pixelStorei(3316, ji), $.pixelStorei(3315, qi), $.pixelStorei(32877, Ki), re === 0 && F.generateMipmaps && $.generateMipmap(je), de.unbindTexture();
  }, this.initTexture = function(C) {
    xe.setTexture2D(C, 0), de.unbindTexture();
  }, this.resetState = function() {
    I = 0, A = 0, L = null, de.reset(), b.reset();
  }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }));
}
class ow extends Ud {
}
ow.prototype.isWebGL1Renderer = !0;
class lw extends st {
  constructor(e) {
    super(), this.isSpriteMaterial = !0, this.type = "SpriteMaterial", this.color = new Ce(16777215), this.map = null, this.alphaMap = null, this.rotation = 0, this.sizeAttenuation = !0, this.transparent = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.rotation = e.rotation, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
class lo extends st {
  constructor(e) {
    super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Ce(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.linewidth = e.linewidth, this.linecap = e.linecap, this.linejoin = e.linejoin, this.fog = e.fog, this;
  }
}
const au = /* @__PURE__ */ new W(), su = /* @__PURE__ */ new W(), ou = /* @__PURE__ */ new tt(), bs = /* @__PURE__ */ new Sd(), Jn = /* @__PURE__ */ new Ta();
class Hd extends Ut {
  constructor(e = new ni(), t = new lo()) {
    super(), this.isLine = !0, this.type = "Line", this.geometry = e, this.material = t, this.updateMorphTargets();
  }
  copy(e, t) {
    return super.copy(e, t), this.material = e.material, this.geometry = e.geometry, this;
  }
  computeLineDistances() {
    const e = this.geometry;
    if (e.index === null) {
      const t = e.attributes.position, r = [0];
      for (let n = 1, a = t.count; n < a; n++)
        au.fromBufferAttribute(t, n - 1), su.fromBufferAttribute(t, n), r[n] = r[n - 1], r[n] += au.distanceTo(su);
      e.setAttribute("lineDistance", new Ei(r, 1));
    } else
      console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
    return this;
  }
  raycast(e, t) {
    const r = this.geometry, n = this.matrixWorld, a = e.params.Line.threshold, o = r.drawRange;
    if (r.boundingSphere === null && r.computeBoundingSphere(), Jn.copy(r.boundingSphere), Jn.applyMatrix4(n), Jn.radius += a, e.ray.intersectsSphere(Jn) === !1)
      return;
    ou.copy(n).invert(), bs.copy(e.ray).applyMatrix4(ou);
    const s = a / ((this.scale.x + this.scale.y + this.scale.z) / 3), c = s * s, l = new W(), u = new W(), h = new W(), d = new W(), v = this.isLineSegments ? 2 : 1, M = r.index, m = r.attributes.position;
    if (M !== null) {
      const g = Math.max(0, o.start), I = Math.min(M.count, o.start + o.count);
      for (let A = g, L = I - 1; A < L; A += v) {
        const y = M.getX(A), D = M.getX(A + 1);
        if (l.fromBufferAttribute(m, y), u.fromBufferAttribute(m, D), bs.distanceSqToSegment(l, u, d, h) > c)
          continue;
        d.applyMatrix4(this.matrixWorld);
        const T = e.ray.origin.distanceTo(d);
        T < e.near || T > e.far || t.push({
          distance: T,
          point: h.clone().applyMatrix4(this.matrixWorld),
          index: A,
          face: null,
          faceIndex: null,
          object: this
        });
      }
    } else {
      const g = Math.max(0, o.start), I = Math.min(m.count, o.start + o.count);
      for (let A = g, L = I - 1; A < L; A += v) {
        if (l.fromBufferAttribute(m, A), u.fromBufferAttribute(m, A + 1), bs.distanceSqToSegment(l, u, d, h) > c)
          continue;
        d.applyMatrix4(this.matrixWorld);
        const y = e.ray.origin.distanceTo(d);
        y < e.near || y > e.far || t.push({
          distance: y,
          point: h.clone().applyMatrix4(this.matrixWorld),
          index: A,
          face: null,
          faceIndex: null,
          object: this
        });
      }
    }
  }
  updateMorphTargets() {
    const e = this.geometry.morphAttributes, t = Object.keys(e);
    if (t.length > 0) {
      const r = e[t[0]];
      if (r !== void 0) {
        this.morphTargetInfluences = [], this.morphTargetDictionary = {};
        for (let n = 0, a = r.length; n < a; n++) {
          const o = r[n].name || String(n);
          this.morphTargetInfluences.push(0), this.morphTargetDictionary[o] = n;
        }
      }
    }
  }
}
class cw extends st {
  constructor(e) {
    super(), this.isPointsMaterial = !0, this.type = "PointsMaterial", this.color = new Ce(16777215), this.map = null, this.alphaMap = null, this.size = 1, this.sizeAttenuation = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.alphaMap = e.alphaMap, this.size = e.size, this.sizeAttenuation = e.sizeAttenuation, this.fog = e.fog, this;
  }
}
new W();
new W();
new W();
new W();
new qt();
class uw extends st {
  constructor(e) {
    super(), this.isShadowMaterial = !0, this.type = "ShadowMaterial", this.color = new Ce(0), this.transparent = !0, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.fog = e.fog, this;
  }
}
class co extends pi {
  constructor(e) {
    super(e), this.isRawShaderMaterial = !0, this.type = "RawShaderMaterial";
  }
}
class Fd extends st {
  constructor(e) {
    super(), this.isMeshStandardMaterial = !0, this.defines = { STANDARD: "" }, this.type = "MeshStandardMaterial", this.color = new Ce(16777215), this.roughness = 1, this.metalness = 0, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Ce(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Pr, this.normalScale = new Re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.roughnessMap = null, this.metalnessMap = null, this.alphaMap = null, this.envMap = null, this.envMapIntensity = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.defines = { STANDARD: "" }, this.color.copy(e.color), this.roughness = e.roughness, this.metalness = e.metalness, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.roughnessMap = e.roughnessMap, this.metalnessMap = e.metalnessMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.envMapIntensity = e.envMapIntensity, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class dw extends Fd {
  constructor(e) {
    super(), this.isMeshPhysicalMaterial = !0, this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.type = "MeshPhysicalMaterial", this.clearcoatMap = null, this.clearcoatRoughness = 0, this.clearcoatRoughnessMap = null, this.clearcoatNormalScale = new Re(1, 1), this.clearcoatNormalMap = null, this.ior = 1.5, Object.defineProperty(this, "reflectivity", {
      get: function() {
        return ft(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
      },
      set: function(t) {
        this.ior = (1 + 0.4 * t) / (1 - 0.4 * t);
      }
    }), this.iridescenceMap = null, this.iridescenceIOR = 1.3, this.iridescenceThicknessRange = [100, 400], this.iridescenceThicknessMap = null, this.sheenColor = new Ce(0), this.sheenColorMap = null, this.sheenRoughness = 1, this.sheenRoughnessMap = null, this.transmissionMap = null, this.thickness = 0, this.thicknessMap = null, this.attenuationDistance = 0, this.attenuationColor = new Ce(1, 1, 1), this.specularIntensity = 1, this.specularIntensityMap = null, this.specularColor = new Ce(1, 1, 1), this.specularColorMap = null, this._sheen = 0, this._clearcoat = 0, this._iridescence = 0, this._transmission = 0, this.setValues(e);
  }
  get sheen() {
    return this._sheen;
  }
  set sheen(e) {
    this._sheen > 0 != e > 0 && this.version++, this._sheen = e;
  }
  get clearcoat() {
    return this._clearcoat;
  }
  set clearcoat(e) {
    this._clearcoat > 0 != e > 0 && this.version++, this._clearcoat = e;
  }
  get iridescence() {
    return this._iridescence;
  }
  set iridescence(e) {
    this._iridescence > 0 != e > 0 && this.version++, this._iridescence = e;
  }
  get transmission() {
    return this._transmission;
  }
  set transmission(e) {
    this._transmission > 0 != e > 0 && this.version++, this._transmission = e;
  }
  copy(e) {
    return super.copy(e), this.defines = {
      STANDARD: "",
      PHYSICAL: ""
    }, this.clearcoat = e.clearcoat, this.clearcoatMap = e.clearcoatMap, this.clearcoatRoughness = e.clearcoatRoughness, this.clearcoatRoughnessMap = e.clearcoatRoughnessMap, this.clearcoatNormalMap = e.clearcoatNormalMap, this.clearcoatNormalScale.copy(e.clearcoatNormalScale), this.ior = e.ior, this.iridescence = e.iridescence, this.iridescenceMap = e.iridescenceMap, this.iridescenceIOR = e.iridescenceIOR, this.iridescenceThicknessRange = [...e.iridescenceThicknessRange], this.iridescenceThicknessMap = e.iridescenceThicknessMap, this.sheen = e.sheen, this.sheenColor.copy(e.sheenColor), this.sheenColorMap = e.sheenColorMap, this.sheenRoughness = e.sheenRoughness, this.sheenRoughnessMap = e.sheenRoughnessMap, this.transmission = e.transmission, this.transmissionMap = e.transmissionMap, this.thickness = e.thickness, this.thicknessMap = e.thicknessMap, this.attenuationDistance = e.attenuationDistance, this.attenuationColor.copy(e.attenuationColor), this.specularIntensity = e.specularIntensity, this.specularIntensityMap = e.specularIntensityMap, this.specularColor.copy(e.specularColor), this.specularColorMap = e.specularColorMap, this;
  }
}
class hw extends st {
  constructor(e) {
    super(), this.isMeshPhongMaterial = !0, this.type = "MeshPhongMaterial", this.color = new Ce(16777215), this.specular = new Ce(1118481), this.shininess = 30, this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Ce(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Pr, this.normalScale = new Re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Aa, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.specular.copy(e.specular), this.shininess = e.shininess, this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class pw extends st {
  constructor(e) {
    super(), this.isMeshToonMaterial = !0, this.defines = { TOON: "" }, this.type = "MeshToonMaterial", this.color = new Ce(16777215), this.map = null, this.gradientMap = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Ce(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Pr, this.normalScale = new Re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.gradientMap = e.gradientMap, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.alphaMap = e.alphaMap, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
class fw extends st {
  constructor(e) {
    super(), this.isMeshNormalMaterial = !0, this.type = "MeshNormalMaterial", this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Pr, this.normalScale = new Re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.flatShading = !1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.flatShading = e.flatShading, this;
  }
}
class mw extends st {
  constructor(e) {
    super(), this.isMeshLambertMaterial = !0, this.type = "MeshLambertMaterial", this.color = new Ce(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.emissive = new Ce(0), this.emissiveIntensity = 1, this.emissiveMap = null, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = Aa, this.reflectivity = 1, this.refractionRatio = 0.98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), this.map = e.map, this.lightMap = e.lightMap, this.lightMapIntensity = e.lightMapIntensity, this.aoMap = e.aoMap, this.aoMapIntensity = e.aoMapIntensity, this.emissive.copy(e.emissive), this.emissiveMap = e.emissiveMap, this.emissiveIntensity = e.emissiveIntensity, this.specularMap = e.specularMap, this.alphaMap = e.alphaMap, this.envMap = e.envMap, this.combine = e.combine, this.reflectivity = e.reflectivity, this.refractionRatio = e.refractionRatio, this.wireframe = e.wireframe, this.wireframeLinewidth = e.wireframeLinewidth, this.wireframeLinecap = e.wireframeLinecap, this.wireframeLinejoin = e.wireframeLinejoin, this.fog = e.fog, this;
  }
}
class gw extends st {
  constructor(e) {
    super(), this.isMeshMatcapMaterial = !0, this.defines = { MATCAP: "" }, this.type = "MeshMatcapMaterial", this.color = new Ce(16777215), this.matcap = null, this.map = null, this.bumpMap = null, this.bumpScale = 1, this.normalMap = null, this.normalMapType = Pr, this.normalScale = new Re(1, 1), this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.alphaMap = null, this.flatShading = !1, this.fog = !0, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.defines = { MATCAP: "" }, this.color.copy(e.color), this.matcap = e.matcap, this.map = e.map, this.bumpMap = e.bumpMap, this.bumpScale = e.bumpScale, this.normalMap = e.normalMap, this.normalMapType = e.normalMapType, this.normalScale.copy(e.normalScale), this.displacementMap = e.displacementMap, this.displacementScale = e.displacementScale, this.displacementBias = e.displacementBias, this.alphaMap = e.alphaMap, this.flatShading = e.flatShading, this.fog = e.fog, this;
  }
}
class vw extends lo {
  constructor(e) {
    super(), this.isLineDashedMaterial = !0, this.type = "LineDashedMaterial", this.scale = 1, this.dashSize = 3, this.gapSize = 1, this.setValues(e);
  }
  copy(e) {
    return super.copy(e), this.scale = e.scale, this.dashSize = e.dashSize, this.gapSize = e.gapSize, this;
  }
}
const Mw = {
  ShadowMaterial: uw,
  SpriteMaterial: lw,
  RawShaderMaterial: co,
  ShaderMaterial: pi,
  PointsMaterial: cw,
  MeshPhysicalMaterial: dw,
  MeshStandardMaterial: Fd,
  MeshPhongMaterial: hw,
  MeshToonMaterial: pw,
  MeshNormalMaterial: fw,
  MeshLambertMaterial: mw,
  MeshDepthMaterial: Wd,
  MeshDistanceMaterial: Gd,
  MeshBasicMaterial: Ca,
  MeshMatcapMaterial: gw,
  LineDashedMaterial: vw,
  LineBasicMaterial: lo,
  Material: st
};
st.fromType = function(i) {
  return new Mw[i]();
};
const Vd = "\\[\\]\\.:\\/", uo = "[^" + Vd + "]", yw = "[^" + Vd.replace("\\.", "") + "]";
/((?:WC+[\/:])*)/.source.replace("WC", uo);
/(WCOD+)?/.source.replace("WCOD", yw);
/(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", uo);
/\.(WC+)(?:\[(.+)\])?/.source.replace("WC", uo);
class ho {
  constructor(e) {
    typeof e == "string" && (console.warn("THREE.Uniform: Type parameter is no longer needed."), e = arguments[1]), this.value = e;
  }
  clone() {
    return new ho(this.value.clone === void 0 ? this.value : this.value.clone());
  }
}
const Qt = new Uint32Array(512), Jt = new Uint32Array(512);
for (let i = 0; i < 256; ++i) {
  const e = i - 127;
  e < -27 ? (Qt[i] = 0, Qt[i | 256] = 32768, Jt[i] = 24, Jt[i | 256] = 24) : e < -14 ? (Qt[i] = 1024 >> -e - 14, Qt[i | 256] = 1024 >> -e - 14 | 32768, Jt[i] = -e - 1, Jt[i | 256] = -e - 1) : e <= 15 ? (Qt[i] = e + 15 << 10, Qt[i | 256] = e + 15 << 10 | 32768, Jt[i] = 13, Jt[i | 256] = 13) : e < 128 ? (Qt[i] = 31744, Qt[i | 256] = 64512, Jt[i] = 24, Jt[i | 256] = 24) : (Qt[i] = 31744, Qt[i | 256] = 64512, Jt[i] = 13, Jt[i | 256] = 13);
}
const Yd = new Uint32Array(2048), bn = new Uint32Array(64), xw = new Uint32Array(64);
for (let i = 1; i < 1024; ++i) {
  let e = i << 13, t = 0;
  for (; (e & 8388608) === 0; )
    e <<= 1, t -= 8388608;
  e &= -8388609, t += 947912704, Yd[i] = e | t;
}
for (let i = 1024; i < 2048; ++i)
  Yd[i] = 939524096 + (i - 1024 << 13);
for (let i = 1; i < 31; ++i)
  bn[i] = i << 23;
bn[31] = 1199570944;
bn[32] = 2147483648;
for (let i = 33; i < 63; ++i)
  bn[i] = 2147483648 + (i - 32 << 23);
bn[63] = 3347054592;
for (let i = 1; i < 64; ++i)
  i !== 32 && (xw[i] = 1024);
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", { detail: {
  revision: ao
} }));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = ao);
const Xn = (i) => {
  const e = new Float32Array(2);
  return e[0] = i, e[1] = i - e[0], e;
}, Zd = (i) => {
  const e = parseInt(i, 16), t = e >> 16 & 255, r = e >> 8 & 255, n = e & 255;
  return new W(t / 255, r / 255, n / 255);
}, Qd = (i, e) => ({
  x: i.x < e.x ? i.x : e.x,
  y: i.y < e.y ? i.y : e.y
}), Jd = (i, e) => ({
  x: i.x > e.x ? i.x : e.x,
  y: i.y > e.y ? i.y : e.y
}), lu = (i, e, t) => i > e && i < t, Xd = (i, e, t) => lu(e.x, i.left, i.right) || lu(t.x, i.left, i.right) || e.x < i.left && t.x > i.right, Iw = (i) => typeof i == "string" ? document.querySelector(i) : i, po = (i) => {
  let e = document.createElement("div");
  if (i && (e = Iw(i)), !e)
    throw new Error("el is not a valid HTMLElement");
  return e;
}, ra = class {
  constructor(i, e) {
    this.max = { x: -1 / 0, y: -1 / 0 }, this.min = { x: 1 / 0, y: 1 / 0 }, this.index = 0, this.bufferLength = e, this.positions = new Float32Array(e * ra.numberOfElements), this.geometry = new ni(), this.geometry = this.geometry.setAttribute(
      "position",
      new At(this.positions, ra.numberOfElements)
    ), this.line = new Hd(this.geometry, i.element()), this.line.frustumCulled = !1;
  }
  element() {
    return this.line;
  }
  push(i) {
    return this.max = Jd(i, this.max), this.min = Qd(i, this.min), this.positions[this.index++] = i.x, this.positions[this.index++] = i.y, this.positions[this.index++] = 0, this.geometry.attributes.position.needsUpdate = !0, this.geometry.setDrawRange(0, this.index / ra.numberOfElements), this.isFull();
  }
  render(i, e) {
    i.render(this.line, e.element());
  }
  isFull() {
    return this.index + 1 >= this.bufferLength;
  }
  isVisible(i) {
    return Xd(i, this.min, this.max);
  }
  reset() {
    this.index = 0, this.max.x = -1 / 0, this.max.y = -1 / 0, this.min.x = 1 / 0, this.min.y = 1 / 0;
  }
  viewport() {
    return { left: this.min.x, bottom: this.min.y, right: this.max.x, top: this.max.y };
  }
};
let Fs = ra;
Fs.numberOfElements = 3;
const na = class {
  constructor(i, e) {
    this.max = { x: -1 / 0, y: -1 / 0 }, this.min = { x: 1 / 0, y: 1 / 0 }, this.index = 0, this.material = i, this.bufferLength = e, this.positions = new Float32Array(e * na.numberOfElements), this.geometry = new ni(), this.geometry = this.geometry.setAttribute(
      "position",
      new At(this.positions, na.numberOfElements)
    ), this.line = new Hd(this.geometry, i.element()), this.line.frustumCulled = !1;
  }
  push(i) {
    this.max = Jd(i, this.max), this.min = Qd(i, this.min);
    const e = Xn(i.x), t = Xn(i.y);
    return this.positions[this.index++] = e[0], this.positions[this.index++] = e[1], this.positions[this.index++] = t[0], this.positions[this.index++] = t[1], this.geometry.setDrawRange(0, this.index / na.numberOfElements), this.geometry.attributes.position.needsUpdate = !0, this.isFull();
  }
  render(i, e) {
    const t = this.material.uniforms(), r = t.projMatrix.value;
    r.copy(e.projectionMatrix());
    const n = new W();
    n.setFromMatrixPosition(r), n.x /= r.elements[0], n.y /= r.elements[5];
    const a = Xn(n.x), o = Xn(n.y);
    t.origin.value = new et(a[0], a[1], o[0], o[1]), r.setPosition(new W(0, 0, 0)), i.render(this.line, e.element());
  }
  element() {
    return this.line;
  }
  isFull() {
    return this.index + 1 >= this.bufferLength;
  }
  isVisible(i) {
    return Xd(i, this.min, this.max);
  }
  reset() {
    this.index = 0, this.max.x = -1 / 0, this.max.y = -1 / 0, this.min.x = 1 / 0, this.min.y = 1 / 0;
  }
  viewport() {
    return { left: this.min.x, bottom: this.min.y, right: this.max.x, top: this.max.y };
  }
};
let $d = na;
$d.numberOfElements = 4;
class bw {
  static getType(e) {
    switch (e) {
      case "mesh":
        return Fs;
      case "32bit":
        return Fs;
      case "64bit":
        return $d;
      default:
        throw "Unknown geometry type: " + e;
    }
  }
}
class ww {
  constructor(e) {
    this.material = new Ca({
      opacity: e.opacity,
      color: parseInt(e.color, 16),
      wireframeLinewidth: e.lineWidth,
      depthTest: !1
    }), this.uni = new ho({});
  }
  uniforms() {
    return this.uni;
  }
  element() {
    return this.material;
  }
}
class da {
  constructor(e) {
    this.uni = {
      origin: { value: new et() },
      projMatrix: { value: new tt() },
      opacity: { value: e.opacity },
      colorRGB: { value: Zd(e.color) }
    }, this.material = new co({
      vertexShader: da.vertexShader(),
      fragmentShader: da.fragmentShader(),
      uniforms: this.uni
    });
  }
  uniforms() {
    return this.uni;
  }
  element() {
    return this.material;
  }
  static vertexShader() {
    return `
    uniform mat4 modelViewMatrix; // optional
		uniform mat4 projectionMatrix; // optional
    attribute vec3 position;
    void main() {
	    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0 );
    }`;
  }
  static fragmentShader() {
    return `
    precision mediump float;
		precision mediump int;
    uniform vec3 colorRGB;
    uniform float opacity;
    void main() {
      gl_FragColor =  vec4(colorRGB, opacity);
    }`;
  }
}
class ha {
  constructor(e) {
    this.uni = {
      origin: { value: new et() },
      projMatrix: { value: new tt() },
      opacity: { value: e.opacity },
      colorRGB: { value: Zd(e.color) }
    }, this.material = new co({
      vertexShader: ha.vertexShader(),
      fragmentShader: ha.fragmentShader(),
      uniforms: this.uni
    });
  }
  uniforms() {
    return this.uni;
  }
  element() {
    return this.material;
  }
  static vertexShader() {
    return `
    /* vec4 -> [xHigh, xLow, yHigh, yLow]*/
    uniform vec4 origin;
    uniform mat4 projMatrix;
    attribute vec4 position;
    void main() {
      /* the order of operations is important */
      gl_Position = projMatrix * vec4((position[0] + origin[0]) + (position[1] + origin[1]),
                                      (position[2] + origin[2]) + (position[3] + origin[3]), 0, 1);
    }`;
  }
  static fragmentShader() {
    return `
    precision mediump float;
    uniform vec3 colorRGB;
    uniform float opacity;
    void main() {
      gl_FragColor =  vec4(colorRGB, opacity);
    }`;
  }
}
class _w {
  static getType(e) {
    switch (e) {
      case "mesh":
        return ww;
      case "32bit":
        return da;
      case "64bit":
        return ha;
      default:
        throw "Unknown material type: " + e;
    }
  }
}
class Aw {
  constructor() {
    this.selectedColors = /* @__PURE__ */ new Map();
    for (const e of this.colors())
      this.selectedColors[e] = 0;
  }
  colors() {
    return [
      "0x3366CC",
      "0xDC3912",
      "0xFF9900",
      "0x109618",
      "0x990099",
      "0x3B3EAC",
      "0x0099C6",
      "0xDD4477",
      "0x66AA00",
      "0xB82E2E",
      "0x316395",
      "0x994499",
      "0x22AA99",
      "0xAAAA11",
      "0x6633CC",
      "0xE67300",
      "0x8B0707",
      "0x329262",
      "0x5574A6",
      "0x3B3EAC"
    ];
  }
  select() {
    let e = 0, t = 999;
    const r = this.colors();
    for (let a = 0; a < r.length; a++) {
      const o = r[a];
      if (this.selectedColors[o] < t && (t = this.selectedColors[o], e = a, t === 0))
        break;
    }
    const n = r[e];
    return this.selectedColors[n]++, n;
  }
  release(e) {
    this.selectedColors[e] && this.selectedColors[e]--;
  }
}
const Sw = new Aw();
class Dw {
  constructor(e = {}) {
    this.renderBuffer = [];
    const {
      type: t = "64bit",
      numberOfBuffers: r = 64,
      opacity: n = 0.7,
      lineWidth: a = 1,
      bufferLength: o = 8192,
      color: s = Sw.select(),
      group: c = null
    } = e;
    this.color = s, this.uuid = crypto.randomUUID(), this.group = new Jr(), c && (this.groupName = c);
    const l = _w.getType(t), u = bw.getType(t);
    this.ringBuffer = new v1();
    const h = new l({ color: s, opacity: n, lineWidth: a });
    for (let d = 0; d < r; d++) {
      const v = new u(h, o);
      this.group.add(v.element()), this.ringBuffer.push(v);
    }
    if (!this.ringBuffer.validate())
      throw "Geometry ring buffer must have length 2^n";
  }
  getVisibleArray(e) {
    return this.ringBuffer.getVisibleArray(e);
  }
  getLastGeom() {
    return this.ringBuffer.getActive();
  }
  render(e, t) {
    this.renderBuffer = this.ringBuffer.getVisibleArray(t), this.renderBuffer.forEach((r) => {
      r.render(e, t);
    });
  }
  push(e) {
    let t = this.ringBuffer.getActive();
    t.push(e) && (t = this.ringBuffer.next(), t.reset(), t.push(e));
  }
}
const Vs = Number.EPSILON * 10, qd = class {
  constructor(i = 0.5, e = { left: 0, right: 60, top: 0, bottom: 0 }) {
    this.verticalUpdateCounter = 0, this.horizontalUpdateCounter = 0, this.view = e, this.camera = new jd(
      e.left,
      e.right,
      e.top + this.verticalMargin(),
      e.bottom + this.verticalMargin(),
      0,
      1
    ), this.updateRate = this.setUpdateRate(i), this.initialized = !1;
  }
  setUpdateRate(i) {
    return Math.max(0, Math.min(1, i));
  }
  getUpdateRate() {
    return this.updateRate;
  }
  width() {
    return this.camera.right - this.camera.left;
  }
  height() {
    return this.camera.top - this.camera.bottom;
  }
  isVerticalUpdaged(i) {
    return {
      isUpdated: this.verticalUpdateCounter !== i,
      counter: this.verticalUpdateCounter
    };
  }
  isHorizontalUpdated(i) {
    return {
      isUpdated: this.horizontalUpdateCounter !== i,
      counter: this.horizontalUpdateCounter
    };
  }
  isUpdated(i) {
    const e = this.horizontalUpdateCounter + this.verticalUpdateCounter;
    return {
      isUpdated: e !== i,
      counter: e
    };
  }
  verticalMargin() {
    const i = Math.abs(this.view.top - this.view.bottom) * qd.verticalMarginPercent;
    return i < Vs ? Vs : i;
  }
  update(i) {
    return [this.updateX(i), this.updateY(i)];
  }
  updateX(i) {
    const e = this.width(), t = e * this.updateRate;
    return i.right > this.camera.right ? (this.camera.right += t, this.camera.left = this.camera.right - e, this.horizontalUpdateCounter++, this.camera.updateProjectionMatrix(), !0) : !1;
  }
  updateY(i) {
    const e = this.verticalUpdateCounter;
    return this.initialized ? (i.top > this.view.top && (this.view.top = i.top, this.verticalUpdateCounter++), i.bottom < this.view.bottom && (this.view.bottom = i.bottom, this.verticalUpdateCounter++)) : (this.view = i, this.initialized = !0, this.verticalUpdateCounter++), e != this.verticalUpdateCounter ? (this.camera.top = this.view.top + this.verticalMargin(), this.camera.bottom = this.view.bottom - this.verticalMargin(), this.camera.updateProjectionMatrix(), !0) : !1;
  }
  resetY() {
    this.initialized = !1;
  }
  element() {
    return this.camera;
  }
  projectionMatrix() {
    return this.camera.projectionMatrix;
  }
  viewport() {
    return {
      left: this.camera.left,
      right: this.camera.right,
      top: this.view.top,
      bottom: this.view.bottom
    };
  }
};
let Kd = qd;
Kd.verticalMarginPercent = 0.01;
var Nr = /* @__PURE__ */ ((i) => (i[i.Vertical = 0] = "Vertical", i[i.Horizontal = 1] = "Horizontal", i))(Nr || {});
class pa {
  constructor(e) {
    this.fixedPrecision = 6, this.exponentialPrecision = 3, this.type = e.type, this.title = e.title, typeof e.fixedPrecision < "u" && this.setFixedPrecision(e.fixedPrecision), typeof e.exponentialPrecision < "u" && this.setExponentialPrecision(e.exponentialPrecision);
    const t = po(e.el);
    t.classList.add("axis", Nr[this.type].toLowerCase()), this.el = this.createAxisElement(t), this.canvasEl = this.el.querySelector("canvas"), this.context = this.canvasEl.getContext("2d");
  }
  createAxisElement(e) {
    const t = document.createElement("canvas");
    return e.appendChild(t), e;
  }
  drawTickVertical(e, t, r, n, a) {
    const o = parseInt(e.font) / 2 - 2, s = (r + a) * n;
    e.fillText(t, 8, e.canvas.clientHeight - s + o), e.beginPath(), e.moveTo(0, s), e.lineTo(5, s), e.stroke();
  }
  drawTickHorizontal(e, t, r, n, a) {
    const o = e.measureText(t).width / 2, s = r * n + a * 0;
    e.fillText(t, s - o, 15), e.beginPath(), e.moveTo(s, 5), e.lineTo(s, 0), e.stroke();
  }
  drawAxis(e, t, r, n, a, o, s, c) {
    Math.abs(r.end - r.start) < Vs && (r.start = r.start - 1, r.end = r.end + 1);
    const l = Math.abs(r.end - r.start), u = l / n;
    let h = -Math.floor(Math.log10(u) + 1) + 1;
    (h < 0 || !Number.isFinite(h)) && (h = 0);
    const d = l + 2 * o, v = a == 1 ? t.width / d : t.height / d, M = a == 1 ? this.drawTickHorizontal : this.drawTickVertical;
    e.clearRect(0, 0, t.width, t.height);
    for (let m = 0; m <= l + o; m += u) {
      let g;
      h < s ? g = (r.start + m).toFixed(h + 2) : g = (r.start + m).toExponential(c), M(e, g, m, v, o);
    }
  }
  getElementSize() {
    return {
      width: this.el.clientWidth,
      height: this.el.clientHeight
    };
  }
  render(e, t = 0) {
    const r = this.getElementSize(), n = window.devicePixelRatio;
    this.canvasEl.width = this.el.clientWidth * n, this.canvasEl.height = this.el.clientHeight * n;
    const a = this.canvasEl.getContext("2d");
    a == null || a.scale(n, n), e.start <= e.end && this.drawAxis(
      this.context,
      r,
      e,
      10,
      this.type,
      t,
      this.fixedPrecision,
      this.exponentialPrecision
    );
  }
  setFixedPrecision(e) {
    e > 0 && Number.isFinite(e) && (this.fixedPrecision = e);
  }
  getFixedPrecision() {
    return this.fixedPrecision;
  }
  setExponentialPrecision(e) {
    e > 0 && Number.isFinite(e) && (this.exponentialPrecision = e);
  }
  getExponentialPrecision() {
    return this.exponentialPrecision;
  }
}
class Tw {
  constructor(e) {
    this.traces = new Set(e.traces || []), this.camera = e.camera ? e.camera : new Kd(), this.name = e.name, this.horizontalAxis = e.horizontalAxis ? e.horizontalAxis : new pa({ title: "X", type: Nr.Horizontal }), this.verticalAxis = e.verticalAxis ? e.verticalAxis : new pa({ title: this.name, type: Nr.Vertical });
  }
  get hasTraces() {
    return this.traces.size > 0;
  }
  add(e) {
    e.groupName = this.name, this.traces.add(e);
  }
  remove(e) {
    e.groupName = null, this.traces.delete(e), this.camera.resetY();
  }
  hasTrace(e) {
    return this.traces.has(e);
  }
  render(e) {
    this.renderAxes(this.syncCameraToGeometry());
    let t = [];
    this.traces.forEach((r) => {
      t = [...t, ...r.getVisibleArray(this.camera)];
    }), this.renderGeometries(e, t);
  }
  syncCameraToGeometry() {
    let e = !1, t = !1;
    return this.traces.forEach((r) => {
      const n = r.getLastGeom().viewport();
      e = e || this.camera.updateX(n), t = t || this.camera.updateY(n);
    }), [e, t];
  }
  renderGeometries(e, t) {
    t.forEach((r) => {
      r.render(e, this.camera);
    });
  }
  renderAxes(e = [!0, !0]) {
    const t = this.camera.viewport();
    e.at(0) && this.horizontalAxis.render({ start: t.left, end: t.right }, 0), e.at(0) && this.verticalAxis.render({ start: t.bottom, end: t.top }, this.camera.verticalMargin());
  }
}
class Cw {
  constructor(e) {
    this.currentAnimationFrame = 0, this._isVue = !0, this.el = po(e == null ? void 0 : e.el), this.el.classList.add("plot-area");
    const t = document.createElement("canvas");
    this.el.appendChild(t);
    const r = t.getContext("webgl2");
    if (!r)
      throw new Error("webgl2 is not supported");
    this.glRenderer = new Ud({
      antialias: !0,
      alpha: !0,
      depth: !1,
      canvas: t,
      context: r,
      preserveDrawingBuffer: !0
    }), this.glRenderer.autoClear = !1, this.glRenderer.setPixelRatio(window.devicePixelRatio);
  }
  resizeCanvasToDisplaySize() {
    const e = this.glRenderer.domElement, t = e.clientWidth, r = e.clientHeight;
    (e.width !== t || e.height !== r) && this.glRenderer.setSize(t, r, !1);
  }
  render(e, t = !1) {
    this.resizeCanvasToDisplaySize(), e.forEach((r) => {
      r.render(this.glRenderer);
    }), t || (this.currentAnimationFrame = requestAnimationFrame(this.render.bind(this, e, !1)));
  }
  stopRendering() {
    cancelAnimationFrame(this.currentAnimationFrame);
  }
}
const cu = (i) => {
  let e = null, t;
  const r = () => () => {
    e = null, i(t);
  }, n = function(...a) {
    t = a, e === null && (e = requestAnimationFrame(r()));
  };
  return n.cancel = () => {
    e !== null && (cancelAnimationFrame(e), e = null);
  }, n;
};
class Ew {
  constructor(e) {
    this.isMouseDown = !1, this.onWheel = cu((t) => {
    }), this.onMouseMove = cu((t) => {
      this.isMouseDown;
    }), this.manager = e, this.events = [
      {
        name: "wheel",
        handler: this.onWheel.bind(this)
      },
      {
        name: "mousedown",
        handler: this.onMouseDown.bind(this)
      },
      {
        name: "mouseup",
        handler: this.onMouseUp.bind(this)
      },
      {
        name: "mousemove",
        handler: this.onMouseMove.bind(this)
      }
    ], this.bind();
  }
  get rootEl() {
    return this.manager.rootEl;
  }
  bind() {
    this.events.forEach((e) => {
      this.rootEl.addEventListener(e.name, e.handler);
    });
  }
  unbind() {
    this.events.forEach((e) => {
      this.rootEl.removeEventListener(e.name, e.handler);
    });
  }
  onMouseDown(e) {
    this.isMouseDown = !0;
  }
  onMouseUp(e) {
    this.isMouseDown = !1;
  }
}
class Nw {
  constructor(e) {
    this.xAxes = [], this.yAxes = [], this.traceGroups = [], this.rootEl = po(e.el), this.rootEl.classList.contains("plot") || this.rootEl.classList.add("plot"), this.xAxes.push(new pa({ title: "x", type: Nr.Horizontal })), this.yAxes.push(new pa({ title: "y", type: Nr.Vertical })), this.plot = new Cw(), this.eventsHandler = new Ew(this), this.addDefaultGroup(), this.layout();
  }
  get traces() {
    return this.traceGroups.map((e) => [...e.traces]).flat();
  }
  get defaultGroup() {
    return this.traceGroups.find((e) => e.name === "default");
  }
  get commonXAxis() {
    return this.xAxes[0];
  }
  get commonYAxis() {
    return this.yAxes[0];
  }
  get allAxes() {
    return [...this.xAxes, ...this.yAxes];
  }
  addTrace(e = this.defaultGroup) {
    const t = new Dw();
    return e.add(t), t;
  }
  removeTrace(e) {
    this.traceGroups.find((t) => t.hasTrace(e)).remove(e);
  }
  moveTrace(e, t) {
    return this.removeTrace(e), t || (t = this.defaultGroup), t.add(e), e;
  }
  removeGroup(e) {
    const t = this.traceGroups.indexOf(e);
    t > -1 && this.traceGroups.splice(t, 1), this.syncAxes(), this.layout();
  }
  addGroup(e) {
    const t = new Tw({ horizontalAxis: this.commonXAxis, ...e });
    return this.yAxes.includes(t.verticalAxis) || this.yAxes.push(t.verticalAxis), this.xAxes.includes(t.horizontalAxis) || this.xAxes.push(t.horizontalAxis), this.layout(), this.traceGroups.push(t), t;
  }
  render(e = !1) {
    this.plot.render(this.traceGroups, e);
  }
  unbindListeners() {
    this.eventsHandler.unbind();
  }
  bind() {
    this.eventsHandler.bind();
  }
  addDefaultGroup() {
    this.addGroup({
      name: "default",
      horizontalAxis: this.commonXAxis,
      verticalAxis: this.commonYAxis
    });
  }
  syncAxes() {
    const e = this.traceGroups.map((r) => r.horizontalAxis), t = this.traceGroups.map((r) => r.verticalAxis);
    this.xAxes = this.xAxes.filter((r) => e.includes(r)), this.yAxes = this.yAxes.filter((r) => t.includes(r));
  }
  layout() {
    this.rootEl.innerHTML = "", this.rootEl.style.setProperty("--y-axis-count", this.yAxes.length.toString()), this.rootEl.style.setProperty("--x-axis-count", this.xAxes.length.toString()), this.rootEl.appendChild(this.plot.el), [...this.yAxes, ...this.xAxes].forEach((e) => {
      this.rootEl.appendChild(e.el);
    }), this.allAxes.forEach((e) => e.render({ start: 0, end: 60 }));
  }
}
const Vr = Se({
  plots: /* @__PURE__ */ new Map()
});
function Lw() {
  return {
    register: (r, n) => {
      if (Vr.plots.has(r))
        throw new Error(`Plot name "${r}" is already registered.`);
      Vr.plots.set(r, n);
    },
    unregister: (r) => {
      Vr.plots.delete(r);
    },
    getPlot: (r) => {
      if (!Vr.plots.has(r))
        throw new Error(`Plot name "${r}" is not registered.`);
      return Vr.plots.get(r);
    }
  };
}
const Pw = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    name: null
  },
  emits: ["ready"],
  setup(i, { emit: e }) {
    const { name: t = crypto.randomUUID() } = i, { register: r, unregister: n } = Lw(), a = R(null), o = R();
    return Ht(() => {
      a.value && (o.value = new Nw({ el: a.value }), o.value.render(), r(t, o.value), e("ready", { name: t }));
    }), Ma(() => {
      n(t);
    }), { __sfc: !0, register: r, unregister: n, plot: a, plotManager: o, emit: e };
  }
});
var jw = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("div", { staticClass: "v-plot" }, [t("div", { ref: "plot", staticClass: "plot" })]);
}, Bw = [], Ow = /* @__PURE__ */ Ge(
  Pw,
  jw,
  Bw,
  !1,
  null,
  null,
  null,
  null
);
const zw = Ow.exports, Rw = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zw
}, Symbol.toStringTag, { value: "Module" }));
var eh = {}, Na = {};
Na.byteLength = Gw;
Na.toByteArray = Hw;
Na.fromByteArray = Yw;
var Kt = [], bt = [], kw = typeof Uint8Array < "u" ? Uint8Array : Array, ws = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var gr = 0, Ww = ws.length; gr < Ww; ++gr)
  Kt[gr] = ws[gr], bt[ws.charCodeAt(gr)] = gr;
bt["-".charCodeAt(0)] = 62;
bt["_".charCodeAt(0)] = 63;
function th(i) {
  var e = i.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var t = i.indexOf("=");
  t === -1 && (t = e);
  var r = t === e ? 0 : 4 - t % 4;
  return [t, r];
}
function Gw(i) {
  var e = th(i), t = e[0], r = e[1];
  return (t + r) * 3 / 4 - r;
}
function Uw(i, e, t) {
  return (e + t) * 3 / 4 - t;
}
function Hw(i) {
  var e, t = th(i), r = t[0], n = t[1], a = new kw(Uw(i, r, n)), o = 0, s = n > 0 ? r - 4 : r, c;
  for (c = 0; c < s; c += 4)
    e = bt[i.charCodeAt(c)] << 18 | bt[i.charCodeAt(c + 1)] << 12 | bt[i.charCodeAt(c + 2)] << 6 | bt[i.charCodeAt(c + 3)], a[o++] = e >> 16 & 255, a[o++] = e >> 8 & 255, a[o++] = e & 255;
  return n === 2 && (e = bt[i.charCodeAt(c)] << 2 | bt[i.charCodeAt(c + 1)] >> 4, a[o++] = e & 255), n === 1 && (e = bt[i.charCodeAt(c)] << 10 | bt[i.charCodeAt(c + 1)] << 4 | bt[i.charCodeAt(c + 2)] >> 2, a[o++] = e >> 8 & 255, a[o++] = e & 255), a;
}
function Fw(i) {
  return Kt[i >> 18 & 63] + Kt[i >> 12 & 63] + Kt[i >> 6 & 63] + Kt[i & 63];
}
function Vw(i, e, t) {
  for (var r, n = [], a = e; a < t; a += 3)
    r = (i[a] << 16 & 16711680) + (i[a + 1] << 8 & 65280) + (i[a + 2] & 255), n.push(Fw(r));
  return n.join("");
}
function Yw(i) {
  for (var e, t = i.length, r = t % 3, n = [], a = 16383, o = 0, s = t - r; o < s; o += a)
    n.push(Vw(i, o, o + a > s ? s : o + a));
  return r === 1 ? (e = i[t - 1], n.push(
    Kt[e >> 2] + Kt[e << 4 & 63] + "=="
  )) : r === 2 && (e = (i[t - 2] << 8) + i[t - 1], n.push(
    Kt[e >> 10] + Kt[e >> 4 & 63] + Kt[e << 2 & 63] + "="
  )), n.join("");
}
var fo = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
fo.read = function(i, e, t, r, n) {
  var a, o, s = n * 8 - r - 1, c = (1 << s) - 1, l = c >> 1, u = -7, h = t ? n - 1 : 0, d = t ? -1 : 1, v = i[e + h];
  for (h += d, a = v & (1 << -u) - 1, v >>= -u, u += s; u > 0; a = a * 256 + i[e + h], h += d, u -= 8)
    ;
  for (o = a & (1 << -u) - 1, a >>= -u, u += r; u > 0; o = o * 256 + i[e + h], h += d, u -= 8)
    ;
  if (a === 0)
    a = 1 - l;
  else {
    if (a === c)
      return o ? NaN : (v ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), a = a - l;
  }
  return (v ? -1 : 1) * o * Math.pow(2, a - r);
};
fo.write = function(i, e, t, r, n, a) {
  var o, s, c, l = a * 8 - n - 1, u = (1 << l) - 1, h = u >> 1, d = n === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, v = r ? 0 : a - 1, M = r ? 1 : -1, m = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (s = isNaN(e) ? 1 : 0, o = u) : (o = Math.floor(Math.log(e) / Math.LN2), e * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + h >= 1 ? e += d / c : e += d * Math.pow(2, 1 - h), e * c >= 2 && (o++, c /= 2), o + h >= u ? (s = 0, o = u) : o + h >= 1 ? (s = (e * c - 1) * Math.pow(2, n), o = o + h) : (s = e * Math.pow(2, h - 1) * Math.pow(2, n), o = 0)); n >= 8; i[t + v] = s & 255, v += M, s /= 256, n -= 8)
    ;
  for (o = o << n | s, l += n; l > 0; i[t + v] = o & 255, v += M, o /= 256, l -= 8)
    ;
  i[t + v - M] |= m * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(i) {
  const e = Na, t = fo, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  i.Buffer = s, i.SlowBuffer = A, i.INSPECT_MAX_BYTES = 50;
  const n = 2147483647;
  i.kMaxLength = n, s.TYPED_ARRAY_SUPPORT = a(), !s.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function a() {
    try {
      const x = new Uint8Array(1), f = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(f, Uint8Array.prototype), Object.setPrototypeOf(x, f), x.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(s.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (!!s.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(s.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (!!s.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(x) {
    if (x > n)
      throw new RangeError('The value "' + x + '" is invalid for option "size"');
    const f = new Uint8Array(x);
    return Object.setPrototypeOf(f, s.prototype), f;
  }
  function s(x, f, p) {
    if (typeof x == "number") {
      if (typeof f == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return h(x);
    }
    return c(x, f, p);
  }
  s.poolSize = 8192;
  function c(x, f, p) {
    if (typeof x == "string")
      return d(x, f);
    if (ArrayBuffer.isView(x))
      return M(x);
    if (x == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof x
      );
    if (E(x, ArrayBuffer) || x && E(x.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (E(x, SharedArrayBuffer) || x && E(x.buffer, SharedArrayBuffer)))
      return m(x, f, p);
    if (typeof x == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const b = x.valueOf && x.valueOf();
    if (b != null && b !== x)
      return s.from(b, f, p);
    const N = g(x);
    if (N)
      return N;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof x[Symbol.toPrimitive] == "function")
      return s.from(x[Symbol.toPrimitive]("string"), f, p);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof x
    );
  }
  s.from = function(x, f, p) {
    return c(x, f, p);
  }, Object.setPrototypeOf(s.prototype, Uint8Array.prototype), Object.setPrototypeOf(s, Uint8Array);
  function l(x) {
    if (typeof x != "number")
      throw new TypeError('"size" argument must be of type number');
    if (x < 0)
      throw new RangeError('The value "' + x + '" is invalid for option "size"');
  }
  function u(x, f, p) {
    return l(x), x <= 0 ? o(x) : f !== void 0 ? typeof p == "string" ? o(x).fill(f, p) : o(x).fill(f) : o(x);
  }
  s.alloc = function(x, f, p) {
    return u(x, f, p);
  };
  function h(x) {
    return l(x), o(x < 0 ? 0 : I(x) | 0);
  }
  s.allocUnsafe = function(x) {
    return h(x);
  }, s.allocUnsafeSlow = function(x) {
    return h(x);
  };
  function d(x, f) {
    if ((typeof f != "string" || f === "") && (f = "utf8"), !s.isEncoding(f))
      throw new TypeError("Unknown encoding: " + f);
    const p = L(x, f) | 0;
    let b = o(p);
    const N = b.write(x, f);
    return N !== p && (b = b.slice(0, N)), b;
  }
  function v(x) {
    const f = x.length < 0 ? 0 : I(x.length) | 0, p = o(f);
    for (let b = 0; b < f; b += 1)
      p[b] = x[b] & 255;
    return p;
  }
  function M(x) {
    if (E(x, Uint8Array)) {
      const f = new Uint8Array(x);
      return m(f.buffer, f.byteOffset, f.byteLength);
    }
    return v(x);
  }
  function m(x, f, p) {
    if (f < 0 || x.byteLength < f)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (x.byteLength < f + (p || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let b;
    return f === void 0 && p === void 0 ? b = new Uint8Array(x) : p === void 0 ? b = new Uint8Array(x, f) : b = new Uint8Array(x, f, p), Object.setPrototypeOf(b, s.prototype), b;
  }
  function g(x) {
    if (s.isBuffer(x)) {
      const f = I(x.length) | 0, p = o(f);
      return p.length === 0 || x.copy(p, 0, 0, f), p;
    }
    if (x.length !== void 0)
      return typeof x.length != "number" || _(x.length) ? o(0) : v(x);
    if (x.type === "Buffer" && Array.isArray(x.data))
      return v(x.data);
  }
  function I(x) {
    if (x >= n)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + n.toString(16) + " bytes");
    return x | 0;
  }
  function A(x) {
    return +x != x && (x = 0), s.alloc(+x);
  }
  s.isBuffer = function(f) {
    return f != null && f._isBuffer === !0 && f !== s.prototype;
  }, s.compare = function(f, p) {
    if (E(f, Uint8Array) && (f = s.from(f, f.offset, f.byteLength)), E(p, Uint8Array) && (p = s.from(p, p.offset, p.byteLength)), !s.isBuffer(f) || !s.isBuffer(p))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (f === p)
      return 0;
    let b = f.length, N = p.length;
    for (let O = 0, w = Math.min(b, N); O < w; ++O)
      if (f[O] !== p[O]) {
        b = f[O], N = p[O];
        break;
      }
    return b < N ? -1 : N < b ? 1 : 0;
  }, s.isEncoding = function(f) {
    switch (String(f).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, s.concat = function(f, p) {
    if (!Array.isArray(f))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (f.length === 0)
      return s.alloc(0);
    let b;
    if (p === void 0)
      for (p = 0, b = 0; b < f.length; ++b)
        p += f[b].length;
    const N = s.allocUnsafe(p);
    let O = 0;
    for (b = 0; b < f.length; ++b) {
      let w = f[b];
      if (E(w, Uint8Array))
        O + w.length > N.length ? (s.isBuffer(w) || (w = s.from(w)), w.copy(N, O)) : Uint8Array.prototype.set.call(
          N,
          w,
          O
        );
      else if (s.isBuffer(w))
        w.copy(N, O);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      O += w.length;
    }
    return N;
  };
  function L(x, f) {
    if (s.isBuffer(x))
      return x.length;
    if (ArrayBuffer.isView(x) || E(x, ArrayBuffer))
      return x.byteLength;
    if (typeof x != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof x
      );
    const p = x.length, b = arguments.length > 2 && arguments[2] === !0;
    if (!b && p === 0)
      return 0;
    let N = !1;
    for (; ; )
      switch (f) {
        case "ascii":
        case "latin1":
        case "binary":
          return p;
        case "utf8":
        case "utf-8":
          return qe(x).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return p * 2;
        case "hex":
          return p >>> 1;
        case "base64":
          return dt(x).length;
        default:
          if (N)
            return b ? -1 : qe(x).length;
          f = ("" + f).toLowerCase(), N = !0;
      }
  }
  s.byteLength = L;
  function y(x, f, p) {
    let b = !1;
    if ((f === void 0 || f < 0) && (f = 0), f > this.length || ((p === void 0 || p > this.length) && (p = this.length), p <= 0) || (p >>>= 0, f >>>= 0, p <= f))
      return "";
    for (x || (x = "utf8"); ; )
      switch (x) {
        case "hex":
          return Y(this, f, p);
        case "utf8":
        case "utf-8":
          return z(this, f, p);
        case "ascii":
          return ie(this, f, p);
        case "latin1":
        case "binary":
          return K(this, f, p);
        case "base64":
          return ne(this, f, p);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Q(this, f, p);
        default:
          if (b)
            throw new TypeError("Unknown encoding: " + x);
          x = (x + "").toLowerCase(), b = !0;
      }
  }
  s.prototype._isBuffer = !0;
  function D(x, f, p) {
    const b = x[f];
    x[f] = x[p], x[p] = b;
  }
  s.prototype.swap16 = function() {
    const f = this.length;
    if (f % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let p = 0; p < f; p += 2)
      D(this, p, p + 1);
    return this;
  }, s.prototype.swap32 = function() {
    const f = this.length;
    if (f % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let p = 0; p < f; p += 4)
      D(this, p, p + 3), D(this, p + 1, p + 2);
    return this;
  }, s.prototype.swap64 = function() {
    const f = this.length;
    if (f % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let p = 0; p < f; p += 8)
      D(this, p, p + 7), D(this, p + 1, p + 6), D(this, p + 2, p + 5), D(this, p + 3, p + 4);
    return this;
  }, s.prototype.toString = function() {
    const f = this.length;
    return f === 0 ? "" : arguments.length === 0 ? z(this, 0, f) : y.apply(this, arguments);
  }, s.prototype.toLocaleString = s.prototype.toString, s.prototype.equals = function(f) {
    if (!s.isBuffer(f))
      throw new TypeError("Argument must be a Buffer");
    return this === f ? !0 : s.compare(this, f) === 0;
  }, s.prototype.inspect = function() {
    let f = "";
    const p = i.INSPECT_MAX_BYTES;
    return f = this.toString("hex", 0, p).replace(/(.{2})/g, "$1 ").trim(), this.length > p && (f += " ... "), "<Buffer " + f + ">";
  }, r && (s.prototype[r] = s.prototype.inspect), s.prototype.compare = function(f, p, b, N, O) {
    if (E(f, Uint8Array) && (f = s.from(f, f.offset, f.byteLength)), !s.isBuffer(f))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof f
      );
    if (p === void 0 && (p = 0), b === void 0 && (b = f ? f.length : 0), N === void 0 && (N = 0), O === void 0 && (O = this.length), p < 0 || b > f.length || N < 0 || O > this.length)
      throw new RangeError("out of range index");
    if (N >= O && p >= b)
      return 0;
    if (N >= O)
      return -1;
    if (p >= b)
      return 1;
    if (p >>>= 0, b >>>= 0, N >>>= 0, O >>>= 0, this === f)
      return 0;
    let w = O - N, j = b - p;
    const k = Math.min(w, j), ee = this.slice(N, O), te = f.slice(p, b);
    for (let ae = 0; ae < k; ++ae)
      if (ee[ae] !== te[ae]) {
        w = ee[ae], j = te[ae];
        break;
      }
    return w < j ? -1 : j < w ? 1 : 0;
  };
  function T(x, f, p, b, N) {
    if (x.length === 0)
      return -1;
    if (typeof p == "string" ? (b = p, p = 0) : p > 2147483647 ? p = 2147483647 : p < -2147483648 && (p = -2147483648), p = +p, _(p) && (p = N ? 0 : x.length - 1), p < 0 && (p = x.length + p), p >= x.length) {
      if (N)
        return -1;
      p = x.length - 1;
    } else if (p < 0)
      if (N)
        p = 0;
      else
        return -1;
    if (typeof f == "string" && (f = s.from(f, b)), s.isBuffer(f))
      return f.length === 0 ? -1 : B(x, f, p, b, N);
    if (typeof f == "number")
      return f = f & 255, typeof Uint8Array.prototype.indexOf == "function" ? N ? Uint8Array.prototype.indexOf.call(x, f, p) : Uint8Array.prototype.lastIndexOf.call(x, f, p) : B(x, [f], p, b, N);
    throw new TypeError("val must be string, number or Buffer");
  }
  function B(x, f, p, b, N) {
    let O = 1, w = x.length, j = f.length;
    if (b !== void 0 && (b = String(b).toLowerCase(), b === "ucs2" || b === "ucs-2" || b === "utf16le" || b === "utf-16le")) {
      if (x.length < 2 || f.length < 2)
        return -1;
      O = 2, w /= 2, j /= 2, p /= 2;
    }
    function k(te, ae) {
      return O === 1 ? te[ae] : te.readUInt16BE(ae * O);
    }
    let ee;
    if (N) {
      let te = -1;
      for (ee = p; ee < w; ee++)
        if (k(x, ee) === k(f, te === -1 ? 0 : ee - te)) {
          if (te === -1 && (te = ee), ee - te + 1 === j)
            return te * O;
        } else
          te !== -1 && (ee -= ee - te), te = -1;
    } else
      for (p + j > w && (p = w - j), ee = p; ee >= 0; ee--) {
        let te = !0;
        for (let ae = 0; ae < j; ae++)
          if (k(x, ee + ae) !== k(f, ae)) {
            te = !1;
            break;
          }
        if (te)
          return ee;
      }
    return -1;
  }
  s.prototype.includes = function(f, p, b) {
    return this.indexOf(f, p, b) !== -1;
  }, s.prototype.indexOf = function(f, p, b) {
    return T(this, f, p, b, !0);
  }, s.prototype.lastIndexOf = function(f, p, b) {
    return T(this, f, p, b, !1);
  };
  function S(x, f, p, b) {
    p = Number(p) || 0;
    const N = x.length - p;
    b ? (b = Number(b), b > N && (b = N)) : b = N;
    const O = f.length;
    b > O / 2 && (b = O / 2);
    let w;
    for (w = 0; w < b; ++w) {
      const j = parseInt(f.substr(w * 2, 2), 16);
      if (_(j))
        return w;
      x[p + w] = j;
    }
    return w;
  }
  function P(x, f, p, b) {
    return it(qe(f, x.length - p), x, p, b);
  }
  function G(x, f, p, b) {
    return it(Ve(f), x, p, b);
  }
  function U(x, f, p, b) {
    return it(dt(f), x, p, b);
  }
  function le(x, f, p, b) {
    return it(Ne(f, x.length - p), x, p, b);
  }
  s.prototype.write = function(f, p, b, N) {
    if (p === void 0)
      N = "utf8", b = this.length, p = 0;
    else if (b === void 0 && typeof p == "string")
      N = p, b = this.length, p = 0;
    else if (isFinite(p))
      p = p >>> 0, isFinite(b) ? (b = b >>> 0, N === void 0 && (N = "utf8")) : (N = b, b = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const O = this.length - p;
    if ((b === void 0 || b > O) && (b = O), f.length > 0 && (b < 0 || p < 0) || p > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    N || (N = "utf8");
    let w = !1;
    for (; ; )
      switch (N) {
        case "hex":
          return S(this, f, p, b);
        case "utf8":
        case "utf-8":
          return P(this, f, p, b);
        case "ascii":
        case "latin1":
        case "binary":
          return G(this, f, p, b);
        case "base64":
          return U(this, f, p, b);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return le(this, f, p, b);
        default:
          if (w)
            throw new TypeError("Unknown encoding: " + N);
          N = ("" + N).toLowerCase(), w = !0;
      }
  }, s.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ne(x, f, p) {
    return f === 0 && p === x.length ? e.fromByteArray(x) : e.fromByteArray(x.slice(f, p));
  }
  function z(x, f, p) {
    p = Math.min(x.length, p);
    const b = [];
    let N = f;
    for (; N < p; ) {
      const O = x[N];
      let w = null, j = O > 239 ? 4 : O > 223 ? 3 : O > 191 ? 2 : 1;
      if (N + j <= p) {
        let k, ee, te, ae;
        switch (j) {
          case 1:
            O < 128 && (w = O);
            break;
          case 2:
            k = x[N + 1], (k & 192) === 128 && (ae = (O & 31) << 6 | k & 63, ae > 127 && (w = ae));
            break;
          case 3:
            k = x[N + 1], ee = x[N + 2], (k & 192) === 128 && (ee & 192) === 128 && (ae = (O & 15) << 12 | (k & 63) << 6 | ee & 63, ae > 2047 && (ae < 55296 || ae > 57343) && (w = ae));
            break;
          case 4:
            k = x[N + 1], ee = x[N + 2], te = x[N + 3], (k & 192) === 128 && (ee & 192) === 128 && (te & 192) === 128 && (ae = (O & 15) << 18 | (k & 63) << 12 | (ee & 63) << 6 | te & 63, ae > 65535 && ae < 1114112 && (w = ae));
        }
      }
      w === null ? (w = 65533, j = 1) : w > 65535 && (w -= 65536, b.push(w >>> 10 & 1023 | 55296), w = 56320 | w & 1023), b.push(w), N += j;
    }
    return V(b);
  }
  const q = 4096;
  function V(x) {
    const f = x.length;
    if (f <= q)
      return String.fromCharCode.apply(String, x);
    let p = "", b = 0;
    for (; b < f; )
      p += String.fromCharCode.apply(
        String,
        x.slice(b, b += q)
      );
    return p;
  }
  function ie(x, f, p) {
    let b = "";
    p = Math.min(x.length, p);
    for (let N = f; N < p; ++N)
      b += String.fromCharCode(x[N] & 127);
    return b;
  }
  function K(x, f, p) {
    let b = "";
    p = Math.min(x.length, p);
    for (let N = f; N < p; ++N)
      b += String.fromCharCode(x[N]);
    return b;
  }
  function Y(x, f, p) {
    const b = x.length;
    (!f || f < 0) && (f = 0), (!p || p < 0 || p > b) && (p = b);
    let N = "";
    for (let O = f; O < p; ++O)
      N += J[x[O]];
    return N;
  }
  function Q(x, f, p) {
    const b = x.slice(f, p);
    let N = "";
    for (let O = 0; O < b.length - 1; O += 2)
      N += String.fromCharCode(b[O] + b[O + 1] * 256);
    return N;
  }
  s.prototype.slice = function(f, p) {
    const b = this.length;
    f = ~~f, p = p === void 0 ? b : ~~p, f < 0 ? (f += b, f < 0 && (f = 0)) : f > b && (f = b), p < 0 ? (p += b, p < 0 && (p = 0)) : p > b && (p = b), p < f && (p = f);
    const N = this.subarray(f, p);
    return Object.setPrototypeOf(N, s.prototype), N;
  };
  function se(x, f, p) {
    if (x % 1 !== 0 || x < 0)
      throw new RangeError("offset is not uint");
    if (x + f > p)
      throw new RangeError("Trying to access beyond buffer length");
  }
  s.prototype.readUintLE = s.prototype.readUIntLE = function(f, p, b) {
    f = f >>> 0, p = p >>> 0, b || se(f, p, this.length);
    let N = this[f], O = 1, w = 0;
    for (; ++w < p && (O *= 256); )
      N += this[f + w] * O;
    return N;
  }, s.prototype.readUintBE = s.prototype.readUIntBE = function(f, p, b) {
    f = f >>> 0, p = p >>> 0, b || se(f, p, this.length);
    let N = this[f + --p], O = 1;
    for (; p > 0 && (O *= 256); )
      N += this[f + --p] * O;
    return N;
  }, s.prototype.readUint8 = s.prototype.readUInt8 = function(f, p) {
    return f = f >>> 0, p || se(f, 1, this.length), this[f];
  }, s.prototype.readUint16LE = s.prototype.readUInt16LE = function(f, p) {
    return f = f >>> 0, p || se(f, 2, this.length), this[f] | this[f + 1] << 8;
  }, s.prototype.readUint16BE = s.prototype.readUInt16BE = function(f, p) {
    return f = f >>> 0, p || se(f, 2, this.length), this[f] << 8 | this[f + 1];
  }, s.prototype.readUint32LE = s.prototype.readUInt32LE = function(f, p) {
    return f = f >>> 0, p || se(f, 4, this.length), (this[f] | this[f + 1] << 8 | this[f + 2] << 16) + this[f + 3] * 16777216;
  }, s.prototype.readUint32BE = s.prototype.readUInt32BE = function(f, p) {
    return f = f >>> 0, p || se(f, 4, this.length), this[f] * 16777216 + (this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3]);
  }, s.prototype.readBigUInt64LE = ce(function(f) {
    f = f >>> 0, xe(f, "offset");
    const p = this[f], b = this[f + 7];
    (p === void 0 || b === void 0) && Ue(f, this.length - 8);
    const N = p + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + this[++f] * 2 ** 24, O = this[++f] + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + b * 2 ** 24;
    return BigInt(N) + (BigInt(O) << BigInt(32));
  }), s.prototype.readBigUInt64BE = ce(function(f) {
    f = f >>> 0, xe(f, "offset");
    const p = this[f], b = this[f + 7];
    (p === void 0 || b === void 0) && Ue(f, this.length - 8);
    const N = p * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + this[++f], O = this[++f] * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + b;
    return (BigInt(N) << BigInt(32)) + BigInt(O);
  }), s.prototype.readIntLE = function(f, p, b) {
    f = f >>> 0, p = p >>> 0, b || se(f, p, this.length);
    let N = this[f], O = 1, w = 0;
    for (; ++w < p && (O *= 256); )
      N += this[f + w] * O;
    return O *= 128, N >= O && (N -= Math.pow(2, 8 * p)), N;
  }, s.prototype.readIntBE = function(f, p, b) {
    f = f >>> 0, p = p >>> 0, b || se(f, p, this.length);
    let N = p, O = 1, w = this[f + --N];
    for (; N > 0 && (O *= 256); )
      w += this[f + --N] * O;
    return O *= 128, w >= O && (w -= Math.pow(2, 8 * p)), w;
  }, s.prototype.readInt8 = function(f, p) {
    return f = f >>> 0, p || se(f, 1, this.length), this[f] & 128 ? (255 - this[f] + 1) * -1 : this[f];
  }, s.prototype.readInt16LE = function(f, p) {
    f = f >>> 0, p || se(f, 2, this.length);
    const b = this[f] | this[f + 1] << 8;
    return b & 32768 ? b | 4294901760 : b;
  }, s.prototype.readInt16BE = function(f, p) {
    f = f >>> 0, p || se(f, 2, this.length);
    const b = this[f + 1] | this[f] << 8;
    return b & 32768 ? b | 4294901760 : b;
  }, s.prototype.readInt32LE = function(f, p) {
    return f = f >>> 0, p || se(f, 4, this.length), this[f] | this[f + 1] << 8 | this[f + 2] << 16 | this[f + 3] << 24;
  }, s.prototype.readInt32BE = function(f, p) {
    return f = f >>> 0, p || se(f, 4, this.length), this[f] << 24 | this[f + 1] << 16 | this[f + 2] << 8 | this[f + 3];
  }, s.prototype.readBigInt64LE = ce(function(f) {
    f = f >>> 0, xe(f, "offset");
    const p = this[f], b = this[f + 7];
    (p === void 0 || b === void 0) && Ue(f, this.length - 8);
    const N = this[f + 4] + this[f + 5] * 2 ** 8 + this[f + 6] * 2 ** 16 + (b << 24);
    return (BigInt(N) << BigInt(32)) + BigInt(p + this[++f] * 2 ** 8 + this[++f] * 2 ** 16 + this[++f] * 2 ** 24);
  }), s.prototype.readBigInt64BE = ce(function(f) {
    f = f >>> 0, xe(f, "offset");
    const p = this[f], b = this[f + 7];
    (p === void 0 || b === void 0) && Ue(f, this.length - 8);
    const N = (p << 24) + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + this[++f];
    return (BigInt(N) << BigInt(32)) + BigInt(this[++f] * 2 ** 24 + this[++f] * 2 ** 16 + this[++f] * 2 ** 8 + b);
  }), s.prototype.readFloatLE = function(f, p) {
    return f = f >>> 0, p || se(f, 4, this.length), t.read(this, f, !0, 23, 4);
  }, s.prototype.readFloatBE = function(f, p) {
    return f = f >>> 0, p || se(f, 4, this.length), t.read(this, f, !1, 23, 4);
  }, s.prototype.readDoubleLE = function(f, p) {
    return f = f >>> 0, p || se(f, 8, this.length), t.read(this, f, !0, 52, 8);
  }, s.prototype.readDoubleBE = function(f, p) {
    return f = f >>> 0, p || se(f, 8, this.length), t.read(this, f, !1, 52, 8);
  };
  function X(x, f, p, b, N, O) {
    if (!s.isBuffer(x))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (f > N || f < O)
      throw new RangeError('"value" argument is out of bounds');
    if (p + b > x.length)
      throw new RangeError("Index out of range");
  }
  s.prototype.writeUintLE = s.prototype.writeUIntLE = function(f, p, b, N) {
    if (f = +f, p = p >>> 0, b = b >>> 0, !N) {
      const j = Math.pow(2, 8 * b) - 1;
      X(this, f, p, b, j, 0);
    }
    let O = 1, w = 0;
    for (this[p] = f & 255; ++w < b && (O *= 256); )
      this[p + w] = f / O & 255;
    return p + b;
  }, s.prototype.writeUintBE = s.prototype.writeUIntBE = function(f, p, b, N) {
    if (f = +f, p = p >>> 0, b = b >>> 0, !N) {
      const j = Math.pow(2, 8 * b) - 1;
      X(this, f, p, b, j, 0);
    }
    let O = b - 1, w = 1;
    for (this[p + O] = f & 255; --O >= 0 && (w *= 256); )
      this[p + O] = f / w & 255;
    return p + b;
  }, s.prototype.writeUint8 = s.prototype.writeUInt8 = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 1, 255, 0), this[p] = f & 255, p + 1;
  }, s.prototype.writeUint16LE = s.prototype.writeUInt16LE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 2, 65535, 0), this[p] = f & 255, this[p + 1] = f >>> 8, p + 2;
  }, s.prototype.writeUint16BE = s.prototype.writeUInt16BE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 2, 65535, 0), this[p] = f >>> 8, this[p + 1] = f & 255, p + 2;
  }, s.prototype.writeUint32LE = s.prototype.writeUInt32LE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 4, 4294967295, 0), this[p + 3] = f >>> 24, this[p + 2] = f >>> 16, this[p + 1] = f >>> 8, this[p] = f & 255, p + 4;
  }, s.prototype.writeUint32BE = s.prototype.writeUInt32BE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 4, 4294967295, 0), this[p] = f >>> 24, this[p + 1] = f >>> 16, this[p + 2] = f >>> 8, this[p + 3] = f & 255, p + 4;
  };
  function ue(x, f, p, b, N) {
    _e(f, b, N, x, p, 7);
    let O = Number(f & BigInt(4294967295));
    x[p++] = O, O = O >> 8, x[p++] = O, O = O >> 8, x[p++] = O, O = O >> 8, x[p++] = O;
    let w = Number(f >> BigInt(32) & BigInt(4294967295));
    return x[p++] = w, w = w >> 8, x[p++] = w, w = w >> 8, x[p++] = w, w = w >> 8, x[p++] = w, p;
  }
  function fe(x, f, p, b, N) {
    _e(f, b, N, x, p, 7);
    let O = Number(f & BigInt(4294967295));
    x[p + 7] = O, O = O >> 8, x[p + 6] = O, O = O >> 8, x[p + 5] = O, O = O >> 8, x[p + 4] = O;
    let w = Number(f >> BigInt(32) & BigInt(4294967295));
    return x[p + 3] = w, w = w >> 8, x[p + 2] = w, w = w >> 8, x[p + 1] = w, w = w >> 8, x[p] = w, p + 8;
  }
  s.prototype.writeBigUInt64LE = ce(function(f, p = 0) {
    return ue(this, f, p, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeBigUInt64BE = ce(function(f, p = 0) {
    return fe(this, f, p, BigInt(0), BigInt("0xffffffffffffffff"));
  }), s.prototype.writeIntLE = function(f, p, b, N) {
    if (f = +f, p = p >>> 0, !N) {
      const k = Math.pow(2, 8 * b - 1);
      X(this, f, p, b, k - 1, -k);
    }
    let O = 0, w = 1, j = 0;
    for (this[p] = f & 255; ++O < b && (w *= 256); )
      f < 0 && j === 0 && this[p + O - 1] !== 0 && (j = 1), this[p + O] = (f / w >> 0) - j & 255;
    return p + b;
  }, s.prototype.writeIntBE = function(f, p, b, N) {
    if (f = +f, p = p >>> 0, !N) {
      const k = Math.pow(2, 8 * b - 1);
      X(this, f, p, b, k - 1, -k);
    }
    let O = b - 1, w = 1, j = 0;
    for (this[p + O] = f & 255; --O >= 0 && (w *= 256); )
      f < 0 && j === 0 && this[p + O + 1] !== 0 && (j = 1), this[p + O] = (f / w >> 0) - j & 255;
    return p + b;
  }, s.prototype.writeInt8 = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 1, 127, -128), f < 0 && (f = 255 + f + 1), this[p] = f & 255, p + 1;
  }, s.prototype.writeInt16LE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 2, 32767, -32768), this[p] = f & 255, this[p + 1] = f >>> 8, p + 2;
  }, s.prototype.writeInt16BE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 2, 32767, -32768), this[p] = f >>> 8, this[p + 1] = f & 255, p + 2;
  }, s.prototype.writeInt32LE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 4, 2147483647, -2147483648), this[p] = f & 255, this[p + 1] = f >>> 8, this[p + 2] = f >>> 16, this[p + 3] = f >>> 24, p + 4;
  }, s.prototype.writeInt32BE = function(f, p, b) {
    return f = +f, p = p >>> 0, b || X(this, f, p, 4, 2147483647, -2147483648), f < 0 && (f = 4294967295 + f + 1), this[p] = f >>> 24, this[p + 1] = f >>> 16, this[p + 2] = f >>> 8, this[p + 3] = f & 255, p + 4;
  }, s.prototype.writeBigInt64LE = ce(function(f, p = 0) {
    return ue(this, f, p, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), s.prototype.writeBigInt64BE = ce(function(f, p = 0) {
    return fe(this, f, p, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ye(x, f, p, b, N, O) {
    if (p + b > x.length)
      throw new RangeError("Index out of range");
    if (p < 0)
      throw new RangeError("Index out of range");
  }
  function $(x, f, p, b, N) {
    return f = +f, p = p >>> 0, N || ye(x, f, p, 4), t.write(x, f, p, b, 23, 4), p + 4;
  }
  s.prototype.writeFloatLE = function(f, p, b) {
    return $(this, f, p, !0, b);
  }, s.prototype.writeFloatBE = function(f, p, b) {
    return $(this, f, p, !1, b);
  };
  function Le(x, f, p, b, N) {
    return f = +f, p = p >>> 0, N || ye(x, f, p, 8), t.write(x, f, p, b, 52, 8), p + 8;
  }
  s.prototype.writeDoubleLE = function(f, p, b) {
    return Le(this, f, p, !0, b);
  }, s.prototype.writeDoubleBE = function(f, p, b) {
    return Le(this, f, p, !1, b);
  }, s.prototype.copy = function(f, p, b, N) {
    if (!s.isBuffer(f))
      throw new TypeError("argument should be a Buffer");
    if (b || (b = 0), !N && N !== 0 && (N = this.length), p >= f.length && (p = f.length), p || (p = 0), N > 0 && N < b && (N = b), N === b || f.length === 0 || this.length === 0)
      return 0;
    if (p < 0)
      throw new RangeError("targetStart out of bounds");
    if (b < 0 || b >= this.length)
      throw new RangeError("Index out of range");
    if (N < 0)
      throw new RangeError("sourceEnd out of bounds");
    N > this.length && (N = this.length), f.length - p < N - b && (N = f.length - p + b);
    const O = N - b;
    return this === f && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(p, b, N) : Uint8Array.prototype.set.call(
      f,
      this.subarray(b, N),
      p
    ), O;
  }, s.prototype.fill = function(f, p, b, N) {
    if (typeof f == "string") {
      if (typeof p == "string" ? (N = p, p = 0, b = this.length) : typeof b == "string" && (N = b, b = this.length), N !== void 0 && typeof N != "string")
        throw new TypeError("encoding must be a string");
      if (typeof N == "string" && !s.isEncoding(N))
        throw new TypeError("Unknown encoding: " + N);
      if (f.length === 1) {
        const w = f.charCodeAt(0);
        (N === "utf8" && w < 128 || N === "latin1") && (f = w);
      }
    } else
      typeof f == "number" ? f = f & 255 : typeof f == "boolean" && (f = Number(f));
    if (p < 0 || this.length < p || this.length < b)
      throw new RangeError("Out of range index");
    if (b <= p)
      return this;
    p = p >>> 0, b = b === void 0 ? this.length : b >>> 0, f || (f = 0);
    let O;
    if (typeof f == "number")
      for (O = p; O < b; ++O)
        this[O] = f;
    else {
      const w = s.isBuffer(f) ? f : s.from(f, N), j = w.length;
      if (j === 0)
        throw new TypeError('The value "' + f + '" is invalid for argument "value"');
      for (O = 0; O < b - p; ++O)
        this[O + p] = w[O % j];
    }
    return this;
  };
  const Me = {};
  function we(x, f, p) {
    Me[x] = class extends p {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: f.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${x}]`, this.stack, delete this.name;
      }
      get code() {
        return x;
      }
      set code(N) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: N,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${x}]: ${this.message}`;
      }
    };
  }
  we(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(x) {
      return x ? `${x} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), we(
    "ERR_INVALID_ARG_TYPE",
    function(x, f) {
      return `The "${x}" argument must be of type number. Received type ${typeof f}`;
    },
    TypeError
  ), we(
    "ERR_OUT_OF_RANGE",
    function(x, f, p) {
      let b = `The value of "${x}" is out of range.`, N = p;
      return Number.isInteger(p) && Math.abs(p) > 2 ** 32 ? N = de(String(p)) : typeof p == "bigint" && (N = String(p), (p > BigInt(2) ** BigInt(32) || p < -(BigInt(2) ** BigInt(32))) && (N = de(N)), N += "n"), b += ` It must be ${f}. Received ${N}`, b;
    },
    RangeError
  );
  function de(x) {
    let f = "", p = x.length;
    const b = x[0] === "-" ? 1 : 0;
    for (; p >= b + 4; p -= 3)
      f = `_${x.slice(p - 3, p)}${f}`;
    return `${x.slice(0, p)}${f}`;
  }
  function Oe(x, f, p) {
    xe(f, "offset"), (x[f] === void 0 || x[f + p] === void 0) && Ue(f, x.length - (p + 1));
  }
  function _e(x, f, p, b, N, O) {
    if (x > p || x < f) {
      const w = typeof f == "bigint" ? "n" : "";
      let j;
      throw O > 3 ? f === 0 || f === BigInt(0) ? j = `>= 0${w} and < 2${w} ** ${(O + 1) * 8}${w}` : j = `>= -(2${w} ** ${(O + 1) * 8 - 1}${w}) and < 2 ** ${(O + 1) * 8 - 1}${w}` : j = `>= ${f}${w} and <= ${p}${w}`, new Me.ERR_OUT_OF_RANGE("value", j, x);
    }
    Oe(b, N, O);
  }
  function xe(x, f) {
    if (typeof x != "number")
      throw new Me.ERR_INVALID_ARG_TYPE(f, "number", x);
  }
  function Ue(x, f, p) {
    throw Math.floor(x) !== x ? (xe(x, p), new Me.ERR_OUT_OF_RANGE(p || "offset", "an integer", x)) : f < 0 ? new Me.ERR_BUFFER_OUT_OF_BOUNDS() : new Me.ERR_OUT_OF_RANGE(
      p || "offset",
      `>= ${p ? 1 : 0} and <= ${f}`,
      x
    );
  }
  const Xe = /[^+/0-9A-Za-z-_]/g;
  function Ye(x) {
    if (x = x.split("=")[0], x = x.trim().replace(Xe, ""), x.length < 2)
      return "";
    for (; x.length % 4 !== 0; )
      x = x + "=";
    return x;
  }
  function qe(x, f) {
    f = f || 1 / 0;
    let p;
    const b = x.length;
    let N = null;
    const O = [];
    for (let w = 0; w < b; ++w) {
      if (p = x.charCodeAt(w), p > 55295 && p < 57344) {
        if (!N) {
          if (p > 56319) {
            (f -= 3) > -1 && O.push(239, 191, 189);
            continue;
          } else if (w + 1 === b) {
            (f -= 3) > -1 && O.push(239, 191, 189);
            continue;
          }
          N = p;
          continue;
        }
        if (p < 56320) {
          (f -= 3) > -1 && O.push(239, 191, 189), N = p;
          continue;
        }
        p = (N - 55296 << 10 | p - 56320) + 65536;
      } else
        N && (f -= 3) > -1 && O.push(239, 191, 189);
      if (N = null, p < 128) {
        if ((f -= 1) < 0)
          break;
        O.push(p);
      } else if (p < 2048) {
        if ((f -= 2) < 0)
          break;
        O.push(
          p >> 6 | 192,
          p & 63 | 128
        );
      } else if (p < 65536) {
        if ((f -= 3) < 0)
          break;
        O.push(
          p >> 12 | 224,
          p >> 6 & 63 | 128,
          p & 63 | 128
        );
      } else if (p < 1114112) {
        if ((f -= 4) < 0)
          break;
        O.push(
          p >> 18 | 240,
          p >> 12 & 63 | 128,
          p >> 6 & 63 | 128,
          p & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return O;
  }
  function Ve(x) {
    const f = [];
    for (let p = 0; p < x.length; ++p)
      f.push(x.charCodeAt(p) & 255);
    return f;
  }
  function Ne(x, f) {
    let p, b, N;
    const O = [];
    for (let w = 0; w < x.length && !((f -= 2) < 0); ++w)
      p = x.charCodeAt(w), b = p >> 8, N = p % 256, O.push(N), O.push(b);
    return O;
  }
  function dt(x) {
    return e.toByteArray(Ye(x));
  }
  function it(x, f, p, b) {
    let N;
    for (N = 0; N < b && !(N + p >= f.length || N >= x.length); ++N)
      f[N + p] = x[N];
    return N;
  }
  function E(x, f) {
    return x instanceof f || x != null && x.constructor != null && x.constructor.name != null && x.constructor.name === f.name;
  }
  function _(x) {
    return x !== x;
  }
  const J = function() {
    const x = "0123456789abcdef", f = new Array(256);
    for (let p = 0; p < 16; ++p) {
      const b = p * 16;
      for (let N = 0; N < 16; ++N)
        f[b + N] = x[p] + x[N];
    }
    return f;
  }();
  function ce(x) {
    return typeof BigInt > "u" ? he : x;
  }
  function he() {
    throw new Error("BigInt not supported");
  }
})(eh);
function Zw(i) {
  return /^[0-9A-F]{1,2}$/i.test(i);
}
function Qw(i) {
  var e;
  return (e = i.match(/.{2}/g)) != null ? e : [];
}
function Jw(i) {
  return !isNaN(parseInt(i, 16));
}
function Xw(i) {
  return i = i.replace(/\s/g, ""), i.length % 2 === 0 && Jw(i) ? "hex" : "text";
}
function $w(i, e) {
  return e ? i.toUpperCase() : i.charCodeAt(0).toString(16).toUpperCase();
}
class qw {
  constructor(e = 8, t = 2, r = null, n = "utf-8") {
    var a;
    this.rows = t, this.maxBytes = r, this.byteCount = e, this.minSize = (a = this.maxBytes) != null ? a : this.byteCount * this.rows, this.value = new Uint8Array(this.minSize), this.encoding = n;
  }
  setTextValue(e) {
    const t = this.setupValues(e, "\0").join("");
    this.value = new TextEncoder().encode(t);
  }
  setHexValue(e) {
    const t = e.match(/.{2}/g);
    if (!t || !t.length)
      throw new Error("Invalid hex value");
    const r = this.setupValues(t.map((n) => parseInt(n, 16)));
    this.value = new Uint8Array(r);
  }
  setupValues(e, t = 0) {
    return e = Array.isArray(e) ? e : e.split(""), e.length < this.minSize && (e = e.concat(new Array(this.minSize - e.length).fill(t))), this.byteCount - e.length > 0 && (e = e.concat(new Array(this.getRowPaddingCount(e.length)).fill(t))), this.maxBytes && e.length > this.maxBytes && (e = e.slice(0, this.maxBytes), console.warn(
      `\u26A0\uFE0F Value is too long, truncating to ${this.maxBytes} bytes, consider increasing the maxBytes property`
    )), e;
  }
  setValue(e, t) {
    t === "hex" ? this.setHexValue(e) : this.setTextValue(e);
  }
  addRow() {
    const { value: e } = this, t = new Uint8Array(e.length + this.byteCount);
    t.set(e), this.value = t;
  }
  toBuffer() {
    return eh.Buffer.from(this.value);
  }
  toHex() {
    return this.toBuffer().toString("hex").toUpperCase();
  }
  toHexArray() {
    return Qw(this.toHex());
  }
  toText() {
    return new TextDecoder(this.encoding).decode(this.value);
  }
  toTextArray() {
    var e;
    return (e = this.toText().split("")) != null ? e : [];
  }
  getValueArray(e) {
    return e === "hex" ? this.toHexArray() : this.toTextArray();
  }
  getHexValue() {
    return this.toHex();
  }
  getRowPaddingCount(e) {
    return (e < this.minSize ? this.minSize : this.byteCount) - e % this.byteCount;
  }
  get shouldAddRow() {
    return this.maxBytes ? this.value.length < this.maxBytes : !0;
  }
  get isConstrained() {
    return this.maxBytes !== null;
  }
  toJSON() {
    return {
      hex: this.toHex(),
      text: this.toText(),
      value: [...this.value]
    };
  }
}
const uu = R(null), du = R(null), hu = R(0), Kw = R([]), e_ = R([]);
function t_(i = !1) {
  return {
    setActiveIndex: (e) => {
      hu.value = e;
    },
    setHoverIndex: (e) => {
      uu.value = e;
    },
    setCursorIndex: (e) => {
      du.value = e;
    },
    activeIndex: hu,
    hoverIndex: uu,
    cursorIndex: du,
    valueArray: Kw,
    hexArray: e_
  };
}
const i_ = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    encoder: null,
    type: null,
    emptyValue: { default: "." }
  },
  setup(i) {
    const e = i, t = R([]), r = R([]), n = R([]), { activeIndex: a, hoverIndex: o, cursorIndex: s, setActiveIndex: c, setHoverIndex: l, setCursorIndex: u } = t_(), h = me(() => matchMedia("(pointer:coarse)").matches), d = me(() => e.type === "hex"), v = me(() => d.value ? 2 : 1), M = me(() => (D) => !d.value && D === "\0" ? e.emptyValue : D), m = (D) => {
      let T = Math.max(D, 0);
      e.encoder.shouldAddRow || (T = Math.min(T, r.value.length - 1));
      let B = r.value.at(a.value);
      r.value.splice(a.value, 1, B.padStart(v.value, "0")), c(T);
    }, g = (D) => {
      if (t.value) {
        const T = t.value.at(D);
        T && T.focus();
      }
      m(D), u(D);
    }, I = (D) => !(d.value && !Zw(D) || D.length > v.value), A = (D) => {
      switch (D.preventDefault(), D.stopPropagation(), D.key) {
        case "Control":
        case "Alt":
        case "Tab":
        case "Delete":
        case "Shift":
        case "Meta":
          break;
        case "ArrowLeft":
          m(a.value - 1);
          break;
        case "Enter":
        case "ArrowRight":
          m(a.value + 1);
          break;
        case "ArrowUp":
          m(a.value - e.encoder.byteCount);
          break;
        case "ArrowDown":
          m(a.value + e.encoder.byteCount);
          break;
        case "Backspace":
          m(a.value - 1), r.value.length > 1 && e.encoder.isConstrained ? r.value.splice(a.value, 1) : L(), e.encoder.setValue(r.value.join(""), e.type);
          break;
        default:
          if (!I(D.key))
            return;
          let T = r.value[a.value];
          T.length === v.value ? T = D.key : T += D.key, d.value && (T = T.toUpperCase()), n.value.splice(a.value, 1, $w(T, d.value)), r.value.splice(a.value, 1, T), T.length === v.value && (e.encoder.setHexValue(n.value.join("")), m(a.value + 1));
          break;
      }
    }, L = () => {
      r.value[a.value] = d.value ? "00" : "\0";
    }, y = (D) => {
      u(D ? 0 : null);
    };
    return ze(
      () => e.encoder.value,
      () => {
        r.value = e.encoder.getValueArray(e.type), n.value = e.encoder.toHexArray();
      },
      { immediate: !0 }
    ), fu(() => {
      a.value >= r.value.length && e.encoder.shouldAddRow && d.value && e.encoder.addRow();
    }), { __sfc: !0, props: e, inputRefs: t, valueArray: r, hexArray: n, activeIndex: a, hoverIndex: o, cursorIndex: s, setActiveIndex: c, setHoverIndex: l, setCursorIndex: u, isTouch: h, isHex: d, maxInputLength: v, formatOutput: M, setConstrainedActiveIndex: m, onClick: g, isInputValid: I, onKeyPress: A, resetActiveValue: L, onFocus: y };
  }
});
var r_ = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", { staticClass: "v-hex-value", class: [e.type], attrs: { tabindex: "0" }, on: { keydown: r.onKeyPress, focus: r.onFocus, blur: function(n) {
    return r.onFocus(null);
  } } }, e._l(r.valueArray, function(n, a) {
    return t("span", { key: a, class: { hover: a === r.hoverIndex, active: a === r.activeIndex, cursor: a === r.cursorIndex }, attrs: { "data-offset": a }, on: { mouseover: function(o) {
      return r.setHoverIndex(a);
    }, mouseleave: function(o) {
      return r.setHoverIndex(null);
    }, click: function(o) {
      return o.preventDefault(), r.onClick(a);
    } } }, [e._v(" " + e._s(r.formatOutput(n)) + " "), r.isTouch ? t("input", { ref: "inputRefs", refInFor: !0, staticClass: "span-input", attrs: { type: "text" }, on: { blur: function(o) {
      return r.onFocus(null);
    } } }) : e._e()]);
  }), 0);
}, n_ = [], a_ = /* @__PURE__ */ Ge(
  i_,
  r_,
  n_,
  !1,
  null,
  null,
  null,
  null
);
const ih = a_.exports, s_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ih
}, Symbol.toStringTag, { value: "Module" })), o_ = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    bytesPerRow: { default: 8 },
    rows: { default: 2 },
    maxBytes: { default: null },
    value: { default: null },
    encoding: { default: "utf-8" }
  },
  emits: ["input", "dataChanged"],
  setup(i, { emit: e }) {
    const t = i, r = () => new qw(t.bytesPerRow, t.rows, t.maxBytes, t.encoding), n = R(null), a = R(r()), o = R(null), s = me(() => Xw(t.value)), c = me(() => ({
      "--columns": t.bytesPerRow
    }));
    ze(
      () => a.value.value,
      () => {
        e("input", a.value.getHexValue()), e("dataChanged", a.value.toJSON());
      }
    ), ze(
      () => [t.maxBytes, t.bytesPerRow, t.rows],
      () => {
        let u = t.value;
        o.value && u !== o.value && (u = o.value), a.value = r(), a.value.setValue(u, s.value), o.value = u;
      }
    ), fu(() => {
      t.value && a.value.setValue(t.value, s.value);
    });
    const l = Zs();
    return Ht(async () => {
      var u;
      l.hasOwnProperty("autofocus") && l.autofocus !== "false" && l.autofocus !== !1 && ((u = document.querySelector(".v-hex-value.hex")) == null || u.focus());
    }), { __sfc: !0, props: t, emit: e, createEncoder: r, hexRef: n, encoder: a, previousValue: o, valueType: s, cssVars: c, attrs: l, vHexValue: ih };
  }
});
var l_ = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", { staticClass: "v-hex" }, [t("div", { staticClass: "value" }, [t(r.vHexValue, { ref: "hexRef", style: r.cssVars, attrs: { type: "hex", encoder: r.encoder } }), t(r.vHexValue, { style: r.cssVars, attrs: { type: "text", encoder: r.encoder } })], 1)]);
}, c_ = [], u_ = /* @__PURE__ */ Ge(
  o_,
  l_,
  c_,
  !1,
  null,
  null,
  null,
  null
);
const d_ = u_.exports, h_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: d_
}, Symbol.toStringTag, { value: "Module" })), p_ = /* @__PURE__ */ ge({
  __name: "index",
  setup(i) {
    const e = Eu({
      selector: "html",
      attribute: "color-scheme",
      valueDark: "dark",
      valueLight: "light"
    }), t = wu(e);
    return { __sfc: !0, isDark: e, toggleDark: t };
  }
});
var f_ = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("v-switch", { staticClass: "inline", attrs: { "label-on": "on", "label-off": "off", value: r.isDark }, on: { input: r.toggleDark } }, [t("v-icon", { attrs: { name: "moon" } })], 1);
}, m_ = [], g_ = /* @__PURE__ */ Ge(
  p_,
  f_,
  m_,
  !1,
  null,
  null,
  null,
  null
);
const v_ = g_.exports, M_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: v_
}, Symbol.toStringTag, { value: "Module" })), rh = {
  type: "alert",
  active: !1,
  message: "",
  title: "",
  okText: "Ok",
  cancelText: "Cancel",
  inputType: "text",
  html: !1
}, yr = Se(Object.assign({}, rh));
let Ys;
const y_ = () => new Promise((i) => Ys = i), _s = (i) => (Object.assign(yr, {
  message: i,
  active: !0
}), document.body.classList.add("no-scroll"), y_()), x_ = () => {
  Object.assign(yr, rh), document.body.classList.remove("no-scroll");
};
class I_ {
  get state() {
    return yr;
  }
  get isActive() {
    return this.state.active;
  }
  title(e) {
    return this.updateState({ title: e }), this;
  }
  okText(e) {
    return this.updateState({ okText: e }), this;
  }
  cancelText(e) {
    return this.updateState({ cancelText: e }), this;
  }
  inputType(e) {
    return this.updateState({ inputType: e }), this;
  }
  html(e = !0) {
    return this.updateState({ html: e }), this;
  }
  alert(e) {
    return this.updateState({ type: "alert" }), _s(e);
  }
  confirm(e) {
    return this.updateState({ type: "confirm" }), _s(e);
  }
  prompt(e) {
    return this.updateState({ type: "prompt" }), _s(e);
  }
  cancel() {
    Ys(!1), this.hide();
  }
  ok(e = !0) {
    e = yr.type === "prompt" ? e : !0, Ys(e), this.hide();
  }
  hide() {
    yr.active = !1, setTimeout(x_, 500);
  }
  updateState(e) {
    Object.assign(yr, e);
  }
}
const Hi = new I_(), b_ = /* @__PURE__ */ ge({
  __name: "index",
  setup(i) {
    const e = R(""), t = R(null), r = "#dialog", n = me(
      () => Hi.state.type === "prompt" ? e.value.length > 0 : !0
    ), a = () => {
      t.value && t.value.focus();
    }, o = (l) => {
      l.code.toLowerCase() === "enter" && n.value && Hi.ok(e.value), l.code.toLowerCase() === "escape" && Hi.cancel();
    }, s = () => {
      window.addEventListener("keyup", o);
    }, c = () => {
      window.removeEventListener("keyup", o);
    };
    return ze(
      () => Hi.isActive,
      (l) => l ? s() : c()
    ), { __sfc: !0, userInput: e, inputRef: t, selector: r, canSubmit: n, focusInput: a, onKeyPress: o, bindListeners: s, unbindListeners: c, Portal: ba, dialog: Hi };
  }
});
var w_ = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t(r.Portal, { attrs: { selector: r.selector } }, [t("transition", { attrs: { name: "show-dialog" }, on: { "after-enter": r.focusInput } }, [r.dialog.isActive ? t("div", { staticClass: "v-dialog" }, [t("div", { staticClass: "bg", on: { click: function(n) {
    return r.dialog.cancel();
  } } }), t("v-panel", { staticClass: "inner rounded", scopedSlots: e._u([r.dialog.state.title ? { key: "header", fn: function() {
    return [t("h3", [e._v(e._s(r.dialog.state.title))])];
  }, proxy: !0 } : null, { key: "default", fn: function() {
    return [r.dialog.state.html ? t("p", { domProps: { innerHTML: e._s(r.dialog.state.message) } }) : t("p", [e._v(e._s(r.dialog.state.message))]), r.dialog.state.type === "prompt" ? t("form", { on: { submit: function(n) {
      n.preventDefault();
    } } }, [r.dialog.state.inputType === "checkbox" ? t("input", { directives: [{ name: "model", rawName: "v-model", value: r.userInput, expression: "userInput" }], ref: "inputRef", attrs: { type: "checkbox" }, domProps: { checked: Array.isArray(r.userInput) ? e._i(r.userInput, null) > -1 : r.userInput }, on: { change: function(n) {
      var a = r.userInput, o = n.target, s = !!o.checked;
      if (Array.isArray(a)) {
        var c = null, l = e._i(a, c);
        o.checked ? l < 0 && (r.userInput = a.concat([c])) : l > -1 && (r.userInput = a.slice(0, l).concat(a.slice(l + 1)));
      } else
        r.userInput = s;
    } } }) : r.dialog.state.inputType === "radio" ? t("input", { directives: [{ name: "model", rawName: "v-model", value: r.userInput, expression: "userInput" }], ref: "inputRef", attrs: { type: "radio" }, domProps: { checked: e._q(r.userInput, null) }, on: { change: function(n) {
      r.userInput = null;
    } } }) : t("input", { directives: [{ name: "model", rawName: "v-model", value: r.userInput, expression: "userInput" }], ref: "inputRef", attrs: { type: r.dialog.state.inputType }, domProps: { value: r.userInput }, on: { input: function(n) {
      n.target.composing || (r.userInput = n.target.value);
    } } })]) : e._e()];
  }, proxy: !0 }, { key: "footer", fn: function() {
    return [t("ul", [t("li", [r.dialog.state.type !== "alert" ? t("button", { staticClass: "secondary", on: { click: function(n) {
      return r.dialog.cancel();
    } } }, [e._v(" " + e._s(r.dialog.state.cancelText) + " ")]) : e._e()]), t("li", [t("button", { staticClass: "primary", on: { click: function(n) {
      return r.dialog.ok(r.userInput);
    } } }, [e._v(e._s(r.dialog.state.okText))])])])];
  }, proxy: !0 }], null, !0) })], 1) : e._e()])], 1);
}, __ = [], A_ = /* @__PURE__ */ Ge(
  b_,
  w_,
  __,
  !1,
  null,
  null,
  null,
  null
);
const S_ = A_.exports, nh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: S_
}, Symbol.toStringTag, { value: "Module" })), ah = Symbol("Dialog");
function d3() {
  dn(ah, Hi);
}
function h3() {
  const i = hn(ah);
  if (!i)
    throw new Error("Dialog is not provided");
  return i;
}
const D_ = {
  install(i, e = "$dialog") {
    i.prototype[e] = Hi, i.component("v-dialog", () => Promise.resolve().then(() => nh));
  }
};
class T_ {
  constructor() {
    this.items = [];
  }
  addMultiple(e) {
    e.forEach((t, r) => {
      setTimeout(() => {
        this.add(t);
      }, r * 300 + 50);
    });
  }
  add(e, t = 8e3) {
    return typeof e == "string" && (e = this.makeFlitsItem(e)), this.items.push(e), setTimeout(() => {
      this.remove(e);
    }, t), e;
  }
  remove(e) {
    const t = this.items.findIndex((r) => r.id === e.id);
    this.items.splice(t, 1);
  }
  makeFlitsItem(e, t = "error") {
    return {
      level: t,
      message: e,
      id: $0()
    };
  }
  success(e) {
    this.add({
      level: "success",
      message: e
    });
  }
  error(e) {
    this.add({
      level: "error",
      message: e
    });
  }
  warning(e) {
    this.add({
      level: "warning",
      message: e
    });
  }
  info(e) {
    this.add({
      level: "info",
      message: e
    });
  }
}
const sh = Symbol("Flits"), oh = Se(new T_());
function p3() {
  dn(sh, oh);
}
function C_() {
  const i = hn(sh);
  if (!i)
    throw new Error("Flits is not provided");
  return i;
}
const E_ = {
  install(i, e = "$flits") {
    i.prototype[e] = oh, i.component("v-flits", lh);
  }
}, N_ = /* @__PURE__ */ ge({
  __name: "index",
  setup(i) {
    const e = C_();
    return { __sfc: !0, flits: e };
  }
});
var L_ = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", { staticClass: "flits" }, [t("ul", [t("transition-group", { attrs: { name: "flitsfade" } }, e._l(r.flits.items, function(n, a) {
    return t("li", { key: `flits-${a}`, class: [n.level] }, [t("div", [t("p", [e._v(e._s(n.message))])]), t("a", { attrs: { href: "#" }, on: { click: function(o) {
      return o.preventDefault(), r.flits.remove(n);
    } } }, [t("v-icon", { attrs: { name: "x" } })], 1)]);
  }), 0)], 1)]);
}, P_ = [], j_ = /* @__PURE__ */ Ge(
  N_,
  L_,
  P_,
  !1,
  null,
  null,
  null,
  null
);
const lh = j_.exports, B_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: lh
}, Symbol.toStringTag, { value: "Module" }));
class O_ {
  constructor() {
    this.modals = /* @__PURE__ */ new Map();
  }
  register(e) {
    if (!e.name)
      throw new Error("Modal components requires name");
    this.getModal(e.name) && (this.unregister(e), console.warn(`Modal names must be unique, name "${e.name}" has already been registered.`)), this.modals.set(e.name, e);
  }
  unregister(e) {
    const t = typeof e == "string" ? e : e.name;
    t && this.modals.delete(t);
  }
  toggle(e) {
    const t = this.getModal(e);
    t && (t.isVisible.value ? t.hide() : t.show());
  }
  show(e, t) {
    const r = this.getModal(e);
    r && (r.show(), t && r.emitProps(t));
  }
  hide(e) {
    const t = this.getModal(e);
    t && t.hide();
  }
  getModal(e) {
    return this.modals.get(e);
  }
}
const ch = Symbol("Modal"), fa = new O_();
function f3() {
  dn(ch, fa);
}
function m3() {
  const i = hn(ch);
  if (!i)
    throw new Error("Modal is not provided");
  return i;
}
const z_ = {
  install(i, e = "$modal") {
    i.prototype[e] = fa, i.component("v-modal", () => Promise.resolve().then(() => uh));
  }
}, R_ = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    name: null,
    keepAlive: { type: Boolean }
  },
  emits: ["modalShow", "modalHide", "callback"],
  setup(i, { expose: e, emit: t }) {
    const r = i, n = "#modal", a = R(!1), o = () => {
      a.value = !0, document.body.classList.add("no-scroll"), t("modalShow", r.name);
    }, s = () => {
      a.value = !1, document.body.classList.remove("no-scroll"), t("modalHide", r.name);
    }, c = (u) => {
      t("callback", u);
    }, l = (u) => {
      u.key === "Escape" && s();
    };
    return Ma(() => {
      document.body.classList.remove("no-scroll"), document.removeEventListener("keyup", l), fa.unregister(r.name);
    }), Ht(() => {
      document.addEventListener("keyup", l), fa.register({ name: r.name, isVisible: a, show: o, hide: s, emitProps: c });
    }), e({ name: r.name, isVisible: a, show: o, hide: s, emitProps: c }), { __sfc: !0, selector: n, props: r, emit: t, isVisible: a, show: o, hide: s, emitProps: c, onKeypress: l, Portal: ba };
  }
});
var k_ = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t(r.Portal, { attrs: { selector: r.selector } }, [t("transition", { attrs: { name: "show-modal" } }, [e.keepAlive || r.isVisible ? t("div", e._b({ directives: [{ name: "show", rawName: "v-show", value: e.keepAlive ? r.isVisible : !0, expression: "!keepAlive ? true : isVisible" }], staticClass: "modal" }, "div", e.$attrs, !1), [t("button", { staticClass: "close squared small primary icon", on: { click: r.hide } }, [t("v-icon", { attrs: { name: "x" } })], 1), e._t("default")], 2) : e._e()])], 1);
}, W_ = [], G_ = /* @__PURE__ */ Ge(
  R_,
  k_,
  W_,
  !1,
  null,
  null,
  null,
  null
);
const U_ = G_.exports, uh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: U_
}, Symbol.toStringTag, { value: "Module" }));
class H_ {
  load() {
    qu() ? Promise.resolve().then(() => Q_).then((e) => {
      const t = e.default.replace("data:image/svg+xml;base64,", "");
      this.insert(atob(t));
    }) : Promise.resolve().then(() => X_).then((e) => this.insert(e.default));
  }
  insert(e) {
    const t = document.createElement("div"), r = document.body, n = "border: 0; clip: rect(0 0 0 0); height: 0; overflow: hidden; padding: 0; position: absolute; width: 0;";
    t.style.cssText = n, t.innerHTML = e, r.insertBefore(t, r.childNodes[0]);
  }
}
function F_(i) {
  qu() ? Y_(i) : V_(i), new H_().load(), i.use(z_), i.use(E_), i.use(D_);
  const e = document.querySelector("html");
  e !== null && e.setAttribute("v-ui", "");
}
function V_(i) {
  let e = /* @__PURE__ */ Object.assign({ "./components/v-checkbox/index.vue": () => Promise.resolve().then(() => Ah), "./components/v-collapse/index.vue": () => Promise.resolve().then(() => jh), "./components/v-contextmenu/index.vue": () => Promise.resolve().then(() => kh), "./components/v-dialog/index.vue": () => Promise.resolve().then(() => nh), "./components/v-file/index.vue": () => Promise.resolve().then(() => Xh), "./components/v-flits/index.vue": () => Promise.resolve().then(() => B_), "./components/v-hex/index.vue": () => Promise.resolve().then(() => h_), "./components/v-hex/v-hex-value/index.vue": () => Promise.resolve().then(() => s_), "./components/v-icon/index.vue": () => Promise.resolve().then(() => Fh), "./components/v-input/index.vue": () => Promise.resolve().then(() => dm), "./components/v-loader/index.vue": () => Promise.resolve().then(() => vm), "./components/v-logo/index.vue": () => Promise.resolve().then(() => g1), "./components/v-modal/index.vue": () => Promise.resolve().then(() => uh), "./components/v-more/index.vue": () => Promise.resolve().then(() => Lm), "./components/v-panel/index.vue": () => Promise.resolve().then(() => Rm), "./components/v-plot/index.vue": () => Promise.resolve().then(() => Rw), "./components/v-popover/index.vue": () => Promise.resolve().then(() => X0), "./components/v-promise-button/index.vue": () => Promise.resolve().then(() => ng), "./components/v-radio/index.vue": () => Promise.resolve().then(() => ug), "./components/v-select/index.vue": () => Promise.resolve().then(() => gg), "./components/v-splitter/index.vue": () => Promise.resolve().then(() => bg), "./components/v-splitter/v-split-area/index.vue": () => Promise.resolve().then(() => i3), "./components/v-switch/index.vue": () => Promise.resolve().then(() => Tg), "./components/v-tabs/index.vue": () => Promise.resolve().then(() => jg), "./components/v-tabs/v-tab/index.vue": () => Promise.resolve().then(() => l3), "./components/v-textarea/index.vue": () => Promise.resolve().then(() => Wg), "./components/v-toggle-darkmode/index.vue": () => Promise.resolve().then(() => M_), "./components/v-tooltip/index.vue": () => Promise.resolve().then(() => bv), "./components/v-tree/index.vue": () => Promise.resolve().then(() => u1) });
  for (const t in e) {
    const r = e[t], n = t.split("/"), a = n[n.length - 2];
    i.component(a, r);
  }
}
function Y_(i) {
  const e = require.context("@theme/components/", !0, /\.(js|vue)$/i);
  e.keys().filter((t) => !t.includes("modal")).forEach((t) => {
    const r = t.split("/"), n = r[r.length - 2];
    return i.component(n, e(t).default);
  });
}
const g3 = { install: F_ }, Z_ = "data:image/svg+xml;base64,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", Q_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z_
}, Symbol.toStringTag, { value: "Module" })), J_ = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs/><symbol id="activity" viewBox="0 0 24 24"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></symbol><symbol id="airplay" viewBox="0 0 24 24"><path d="M5 17H4a2 2 0 01-2-2V5a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2h-1"/><path d="M12 15l5 6H7l5-6z"/></symbol><symbol id="alert-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></symbol><symbol id="alert-octagon" viewBox="0 0 24 24"><path d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM12 8v4M12 16h.01"/></symbol><symbol id="alert-triangle" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01"/></symbol><symbol id="align-center" viewBox="0 0 24 24"><path d="M18 10H6M21 6H3M21 14H3M18 18H6"/></symbol><symbol id="align-justify" viewBox="0 0 24 24"><path d="M21 10H3M21 6H3M21 14H3M21 18H3"/></symbol><symbol id="align-left" viewBox="0 0 24 24"><path d="M17 10H3M21 6H3M21 14H3M17 18H3"/></symbol><symbol id="align-right" viewBox="0 0 24 24"><path d="M21 10H7M21 6H3M21 14H3M21 18H7"/></symbol><symbol id="anchor" viewBox="0 0 24 24"><circle cx="12" cy="5" r="3"/><path d="M12 22V8M5 12H2a10 10 0 0020 0h-3"/></symbol><symbol id="aperture" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M14.31 8l5.74 9.94M9.69 8h11.48M7.38 12l5.74-9.94M9.69 16L3.95 6.06M14.31 16H2.83M16.62 12l-5.74 9.94"/></symbol><symbol id="archive" viewBox="0 0 24 24"><path d="M21 8v13H3V8M1 3h22v5H1zM10 12h4"/></symbol><symbol id="arrow-down-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 12l4 4 4-4M12 8v8"/></symbol><symbol id="arrow-down-left" viewBox="0 0 24 24"><path d="M17 7L7 17M17 17H7V7"/></symbol><symbol id="arrow-down-right" viewBox="0 0 24 24"><path d="M7 7l10 10M17 7v10H7"/></symbol><symbol id="arrow-down" viewBox="0 0 24 24"><path d="M12 5v14M19 12l-7 7-7-7"/></symbol><symbol id="arrow-left-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8l-4 4 4 4M16 12H8"/></symbol><symbol id="arrow-left" viewBox="0 0 24 24"><path d="M19 12H5M12 19l-7-7 7-7"/></symbol><symbol id="arrow-right-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 16l4-4-4-4M8 12h8"/></symbol><symbol id="arrow-right" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></symbol><symbol id="arrow-up-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M16 12l-4-4-4 4M12 16V8"/></symbol><symbol id="arrow-up-left" viewBox="0 0 24 24"><path d="M17 17L7 7M7 17V7h10"/></symbol><symbol id="arrow-up-right" viewBox="0 0 24 24"><path d="M7 17L17 7M7 7h10v10"/></symbol><symbol id="arrow-up" viewBox="0 0 24 24"><path d="M12 19V5M5 12l7-7 7 7"/></symbol><symbol id="at-sign" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M16 8v5a3 3 0 006 0v-1a10 10 0 10-3.92 7.94"/></symbol><symbol id="award" viewBox="0 0 24 24"><circle cx="12" cy="8" r="7"/><path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12"/></symbol><symbol id="bar-chart-2" viewBox="0 0 24 24"><path d="M18 20V10M12 20V4M6 20v-6"/></symbol><symbol id="bar-chart" viewBox="0 0 24 24"><path d="M12 20V10M18 20V4M6 20v-4"/></symbol><symbol id="battery-charging" viewBox="0 0 24 24"><path d="M5 18H3a2 2 0 01-2-2V8a2 2 0 012-2h3.19M15 6h2a2 2 0 012 2v8a2 2 0 01-2 2h-3.19M23 13v-2M11 6l-4 6h6l-4 6"/></symbol><symbol id="battery" viewBox="0 0 24 24"><rect x="1" y="6" width="18" height="12" rx="2" ry="2"/><path d="M23 13v-2"/></symbol><symbol id="bell-off" viewBox="0 0 24 24"><path d="M13.73 21a2 2 0 01-3.46 0M18.63 13A17.89 17.89 0 0118 8M6.26 6.26A5.86 5.86 0 006 8c0 7-3 9-3 9h14M18 8a6 6 0 00-9.33-5M1 1l22 22"/></symbol><symbol id="bell" viewBox="0 0 24 24"><path d="M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 01-3.46 0"/></symbol><symbol id="bluetooth" viewBox="0 0 24 24"><path d="M6.5 6.5l11 11L12 23V1l5.5 5.5-11 11"/></symbol><symbol id="bold" viewBox="0 0 24 24"><path d="M6 4h8a4 4 0 014 4 4 4 0 01-4 4H6zM6 12h9a4 4 0 014 4 4 4 0 01-4 4H6z"/></symbol><symbol id="book-open" viewBox="0 0 24 24"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></symbol><symbol id="book" viewBox="0 0 24 24"><path d="M4 19.5A2.5 2.5 0 016.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z"/></symbol><symbol id="bookmark" viewBox="0 0 24 24"><path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"/></symbol><symbol id="box" viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></symbol><symbol id="briefcase" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="14" rx="2" ry="2"/><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/></symbol><symbol id="calendar" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><path d="M16 2v4M8 2v4M3 10h18"/></symbol><symbol id="camera-off" viewBox="0 0 24 24"><path d="M1 1l22 22M21 21H3a2 2 0 01-2-2V8a2 2 0 012-2h3m3-3h6l2 3h4a2 2 0 012 2v9.34m-7.72-2.06a4 4 0 11-5.56-5.56"/></symbol><symbol id="camera" viewBox="0 0 24 24"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></symbol><symbol id="cast" viewBox="0 0 24 24"><path d="M2 16.1A5 5 0 015.9 20M2 12.05A9 9 0 019.95 20M2 8V6a2 2 0 012-2h16a2 2 0 012 2v12a2 2 0 01-2 2h-6M2 20h.01"/></symbol><symbol id="check-circle" viewBox="0 0 24 24"><path d="M22 11.08V12a10 10 0 11-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></symbol><symbol id="check-square" viewBox="0 0 24 24"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></symbol><symbol id="check" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></symbol><symbol id="chevron-down" viewBox="0 0 24 24"><path d="M6 9l6 6 6-6"/></symbol><symbol id="chevron-left" viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></symbol><symbol id="chevron-right" viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></symbol><symbol id="chevron-up" viewBox="0 0 24 24"><path d="M18 15l-6-6-6 6"/></symbol><symbol id="chevrons-down" viewBox="0 0 24 24"><path d="M7 13l5 5 5-5M7 6l5 5 5-5"/></symbol><symbol id="chevrons-left" viewBox="0 0 24 24"><path d="M11 17l-5-5 5-5M18 17l-5-5 5-5"/></symbol><symbol id="chevrons-right" viewBox="0 0 24 24"><path d="M13 17l5-5-5-5M6 17l5-5-5-5"/></symbol><symbol id="chevrons-up" viewBox="0 0 24 24"><path d="M17 11l-5-5-5 5M17 18l-5-5-5 5"/></symbol><symbol id="chrome" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/><path d="M21.17 8H12M3.95 6.06L8.54 14M10.88 21.94L15.46 14"/></symbol><symbol id="circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/></symbol><symbol id="clipboard" viewBox="0 0 24 24"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/><rect x="8" y="2" width="8" height="4" rx="1" ry="1"/></symbol><symbol id="clock" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></symbol><symbol id="cloud-drizzle" viewBox="0 0 24 24"><path d="M8 19v2M8 13v2M16 19v2M16 13v2M12 21v2M12 15v2M20 16.58A5 5 0 0018 7h-1.26A8 8 0 104 15.25"/></symbol><symbol id="cloud-lightning" viewBox="0 0 24 24"><path d="M19 16.9A5 5 0 0018 7h-1.26a8 8 0 10-11.62 9"/><path d="M13 11l-4 6h6l-4 6"/></symbol><symbol id="cloud-off" viewBox="0 0 24 24"><path d="M22.61 16.95A5 5 0 0018 10h-1.26a8 8 0 00-7.05-6M5 5a8 8 0 004 15h9a5 5 0 001.7-.3M1 1l22 22"/></symbol><symbol id="cloud-rain" viewBox="0 0 24 24"><path d="M16 13v8M8 13v8M12 15v8M20 16.58A5 5 0 0018 7h-1.26A8 8 0 104 15.25"/></symbol><symbol id="cloud-snow" viewBox="0 0 24 24"><path d="M20 17.58A5 5 0 0018 8h-1.26A8 8 0 104 16.25M8 16h.01M8 20h.01M12 18h.01M12 22h.01M16 16h.01M16 20h.01"/></symbol><symbol id="cloud" viewBox="0 0 24 24"><path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"/></symbol><symbol id="code" viewBox="0 0 24 24"><path d="M16 18l6-6-6-6M8 6l-6 6 6 6"/></symbol><symbol id="codepen" viewBox="0 0 24 24"><path d="M12 2l10 6.5v7L12 22 2 15.5v-7L12 2zM12 22v-6.5"/><path d="M22 8.5l-10 7-10-7"/><path d="M2 15.5l10-7 10 7M12 2v6.5"/></symbol><symbol id="codesandbox" viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M7.5 4.21l4.5 2.6 4.5-2.6M7.5 19.79V14.6L3 12M21 12l-4.5 2.6v5.19M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></symbol><symbol id="coffee" viewBox="0 0 24 24"><path d="M18 8h1a4 4 0 010 8h-1M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8zM6 1v3M10 1v3M14 1v3"/></symbol><symbol id="columns" viewBox="0 0 24 24"><path d="M12 3h7a2 2 0 012 2v14a2 2 0 01-2 2h-7m0-18H5a2 2 0 00-2 2v14a2 2 0 002 2h7m0-18v18"/></symbol><symbol id="command" viewBox="0 0 24 24"><path d="M18 3a3 3 0 00-3 3v12a3 3 0 003 3 3 3 0 003-3 3 3 0 00-3-3H6a3 3 0 00-3 3 3 3 0 003 3 3 3 0 003-3V6a3 3 0 00-3-3 3 3 0 00-3 3 3 3 0 003 3h12a3 3 0 003-3 3 3 0 00-3-3z"/></symbol><symbol id="compass" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M16.24 7.76l-2.12 6.36-6.36 2.12 2.12-6.36 6.36-2.12z"/></symbol><symbol id="copy" viewBox="0 0 24 24"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></symbol><symbol id="corner-down-left" viewBox="0 0 24 24"><path d="M9 10l-5 5 5 5"/><path d="M20 4v7a4 4 0 01-4 4H4"/></symbol><symbol id="corner-down-right" viewBox="0 0 24 24"><path d="M15 10l5 5-5 5"/><path d="M4 4v7a4 4 0 004 4h12"/></symbol><symbol id="corner-left-down" viewBox="0 0 24 24"><path d="M14 15l-5 5-5-5"/><path d="M20 4h-7a4 4 0 00-4 4v12"/></symbol><symbol id="corner-left-up" viewBox="0 0 24 24"><path d="M14 9L9 4 4 9"/><path d="M20 20h-7a4 4 0 01-4-4V4"/></symbol><symbol id="corner-right-down" viewBox="0 0 24 24"><path d="M10 15l5 5 5-5"/><path d="M4 4h7a4 4 0 014 4v12"/></symbol><symbol id="corner-right-up" viewBox="0 0 24 24"><path d="M10 9l5-5 5 5"/><path d="M4 20h7a4 4 0 004-4V4"/></symbol><symbol id="corner-up-left" viewBox="0 0 24 24"><path d="M9 14L4 9l5-5"/><path d="M20 20v-7a4 4 0 00-4-4H4"/></symbol><symbol id="corner-up-right" viewBox="0 0 24 24"><path d="M15 14l5-5-5-5"/><path d="M4 20v-7a4 4 0 014-4h12"/></symbol><symbol id="cpu" viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"/><path d="M9 9h6v6H9zM9 1v3M15 1v3M9 20v3M15 20v3M20 9h3M20 14h3M1 9h3M1 14h3"/></symbol><symbol id="credit-card" viewBox="0 0 24 24"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><path d="M1 10h22"/></symbol><symbol id="crop" viewBox="0 0 24 24"><path d="M6.13 1L6 16a2 2 0 002 2h15"/><path d="M1 6.13L16 6a2 2 0 012 2v15"/></symbol><symbol id="crosshair" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M22 12h-4M6 12H2M12 6V2M12 22v-4"/></symbol><symbol id="database" viewBox="0 0 24 24"><ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"/><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"/></symbol><symbol id="delete" viewBox="0 0 24 24"><path d="M21 4H8l-7 8 7 8h13a2 2 0 002-2V6a2 2 0 00-2-2zM18 9l-6 6M12 9l6 6"/></symbol><symbol id="disc" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="3"/></symbol><symbol id="divide-circle" viewBox="0 0 24 24"><path d="M8 12h8M12 16h0M12 8h0"/><circle cx="12" cy="12" r="10"/></symbol><symbol id="divide-square" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><path d="M8 12h8M12 16h0M12 8h0"/></symbol><symbol id="divide" viewBox="0 0 24 24"><circle cx="12" cy="6" r="2"/><path d="M5 12h14"/><circle cx="12" cy="18" r="2"/></symbol><symbol id="dollar-sign" viewBox="0 0 24 24"><path d="M12 1v22M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6"/></symbol><symbol id="download-cloud" viewBox="0 0 24 24"><path d="M8 17l4 4 4-4M12 12v9"/><path d="M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29"/></symbol><symbol id="download" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3"/></symbol><symbol id="dribbble" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"/></symbol><symbol id="droplet" viewBox="0 0 24 24"><path d="M12 2.69l5.66 5.66a8 8 0 11-11.31 0z"/></symbol><symbol id="edit-2" viewBox="0 0 24 24"><path d="M17 3a2.828 2.828 0 114 4L7.5 20.5 2 22l1.5-5.5L17 3z"/></symbol><symbol id="edit-3" viewBox="0 0 24 24"><path d="M12 20h9M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></symbol><symbol id="edit" viewBox="0 0 24 24"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/></symbol><symbol id="external-link" viewBox="0 0 24 24"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3"/></symbol><symbol id="eye-off" viewBox="0 0 24 24"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24M1 1l22 22"/></symbol><symbol id="eye" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></symbol><symbol id="facebook" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></symbol><symbol id="fast-forward" viewBox="0 0 24 24"><path d="M13 19l9-7-9-7v14zM2 19l9-7-9-7v14z"/></symbol><symbol id="feather" viewBox="0 0 24 24"><path d="M20.24 12.24a6 6 0 00-8.49-8.49L5 10.5V19h8.5zM16 8L2 22M17.5 15H9"/></symbol><symbol id="figma" viewBox="0 0 24 24"><path d="M5 5.5A3.5 3.5 0 018.5 2H12v7H8.5A3.5 3.5 0 015 5.5zM12 2h3.5a3.5 3.5 0 110 7H12V2z"/><path d="M12 12.5a3.5 3.5 0 117 0 3.5 3.5 0 11-7 0zM5 19.5A3.5 3.5 0 018.5 16H12v3.5a3.5 3.5 0 11-7 0zM5 12.5A3.5 3.5 0 018.5 9H12v7H8.5A3.5 3.5 0 015 12.5z"/></symbol><symbol id="file-minus" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M9 15h6"/></symbol><symbol id="file-plus" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M12 18v-6M9 15h6"/></symbol><symbol id="file-text" viewBox="0 0 24 24"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/></symbol><symbol id="file" viewBox="0 0 24 24"><path d="M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z"/><path d="M13 2v7h7"/></symbol><symbol id="film" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"/><path d="M7 2v20M17 2v20M2 12h20M2 7h5M2 17h5M17 17h5M17 7h5"/></symbol><symbol id="filter" viewBox="0 0 24 24"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></symbol><symbol id="flag" viewBox="0 0 24 24"><path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1zM4 22v-7"/></symbol><symbol id="folder-closed" viewBox="0 0 20 16"><g stroke="currentColor" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M17.393 15.143H2.607c-.887 0-1.607-.72-1.607-1.607V2.607C1 1.72 1.72 1 2.607 1h3.05c.317 0 .627.094.89.27l1.12.746c.263.176.574.27.891.27h8.835c.887 0 1.607.72 1.607 1.607v9.643c0 .887-.72 1.607-1.607 1.607zM1 5.536h18"/></g></symbol><symbol id="folder-minus" viewBox="0 0 24 24"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2zM9 14h6"/></symbol><symbol id="folder-open" viewBox="0 0 20 16"><g stroke="currentColor" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M2.286 5.5V2.607C2.286 1.72 3.006 1 3.893 1h3.049c.317 0 .628.094.892.27l1.118.746c.264.176.574.27.892.27h6.263c.888 0 1.607.72 1.607 1.607V5.5"/><path d="M18.996 6.888l-.652 6.648c0 .886-.718 1.605-1.604 1.607H3.26a1.607 1.607 0 01-1.604-1.607l-.652-6.648A1.286 1.286 0 012.286 5.5h15.432a1.286 1.286 0 011.278 1.388z"/></g></symbol><symbol id="folder-plus" viewBox="0 0 24 24"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2zM12 11v6M9 14h6"/></symbol><symbol id="folder" viewBox="0 0 24 24"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></symbol><symbol id="framer" viewBox="0 0 24 24"><path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"/></symbol><symbol id="frown" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M16 16s-1.5-2-4-2-4 2-4 2M9 9h.01M15 9h.01"/></symbol><symbol id="gift" viewBox="0 0 24 24"><path d="M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></symbol><symbol id="git-branch" viewBox="0 0 24 24"><path d="M6 3v12"/><circle cx="18" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M18 9a9 9 0 01-9 9"/></symbol><symbol id="git-commit" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4"/><path d="M1.05 12H7M17.01 12h5.95"/></symbol><symbol id="git-merge" viewBox="0 0 24 24"><circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><path d="M6 21V9a9 9 0 009 9"/></symbol><symbol id="git-pull-request" viewBox="0 0 24 24"><circle cx="18" cy="18" r="3"/><circle cx="6" cy="6" r="3"/><path d="M13 6h3a2 2 0 012 2v7M6 9v12"/></symbol><symbol id="github" viewBox="0 0 24 24"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 00-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0020 4.77 5.07 5.07 0 0019.91 1S18.73.65 16 2.48a13.38 13.38 0 00-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 005 4.77a5.44 5.44 0 00-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 009 18.13V22"/></symbol><symbol id="gitlab" viewBox="0 0 24 24"><path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 01-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 014.82 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0118.6 2a.43.43 0 01.58 0 .42.42 0 01.11.18l2.44 7.51L23 13.45a.84.84 0 01-.35.94z"/></symbol><symbol id="globe" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></symbol><symbol id="grid" viewBox="0 0 24 24"><path d="M3 3h7v7H3zM14 3h7v7h-7zM14 14h7v7h-7zM3 14h7v7H3z"/></symbol><symbol id="hard-drive" viewBox="0 0 24 24"><path d="M22 12H2M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11zM6 16h.01M10 16h.01"/></symbol><symbol id="hash" viewBox="0 0 24 24"><path d="M4 9h16M4 15h16M10 3L8 21M16 3l-2 18"/></symbol><symbol id="headphones" viewBox="0 0 24 24"><path d="M3 18v-6a9 9 0 0118 0v6"/><path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z"/></symbol><symbol id="heart" viewBox="0 0 24 24"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></symbol><symbol id="help-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"/></symbol><symbol id="hexagon" viewBox="0 0 24 24"><path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/></symbol><symbol id="home" viewBox="0 0 24 24"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><path d="M9 22V12h6v10"/></symbol><symbol id="image" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></symbol><symbol id="inbox" viewBox="0 0 24 24"><path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z"/></symbol><symbol id="info" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4M12 8h.01"/></symbol><symbol id="instagram" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37zM17.5 6.5h.01"/></symbol><symbol id="italic" viewBox="0 0 24 24"><path d="M19 4h-9M14 20H5M15 4L9 20"/></symbol><symbol id="key" viewBox="0 0 24 24"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></symbol><symbol id="layers" viewBox="0 0 24 24"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></symbol><symbol id="layout" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><path d="M3 9h18M9 21V9"/></symbol><symbol id="life-buoy" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/><path d="M4.93 4.93l4.24 4.24M14.83 14.83l4.24 4.24M14.83 9.17l4.24-4.24M14.83 9.17l3.53-3.53M4.93 19.07l4.24-4.24"/></symbol><symbol id="link-2" viewBox="0 0 24 24"><path d="M15 7h3a5 5 0 015 5 5 5 0 01-5 5h-3m-6 0H6a5 5 0 01-5-5 5 5 0 015-5h3M8 12h8"/></symbol><symbol id="link" viewBox="0 0 24 24"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71"/></symbol><symbol id="linkedin" viewBox="0 0 24 24"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></symbol><symbol id="list" viewBox="0 0 24 24"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></symbol><symbol id="loader" viewBox="0 0 24 24"><path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/></symbol><symbol id="lock" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></symbol><symbol id="log-in" viewBox="0 0 24 24"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"/></symbol><symbol id="log-out" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></symbol><symbol id="mail" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><path d="M22 6l-10 7L2 6"/></symbol><symbol id="map-pin" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></symbol><symbol id="map" viewBox="0 0 24 24"><path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4zM8 2v16M16 6v16"/></symbol><symbol id="maximize-2" viewBox="0 0 24 24"><path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/></symbol><symbol id="maximize" viewBox="0 0 24 24"><path d="M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"/></symbol><symbol id="meh" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 15h8M9 9h.01M15 9h.01"/></symbol><symbol id="menu" viewBox="0 0 24 24"><path d="M3 12h18M3 6h18M3 18h18"/></symbol><symbol id="message-circle" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"/></symbol><symbol id="message-square" viewBox="0 0 24 24"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></symbol><symbol id="mic-off" viewBox="0 0 24 24"><path d="M1 1l22 22M9 9v3a3 3 0 005.12 2.12M15 9.34V4a3 3 0 00-5.94-.6"/><path d="M17 16.95A7 7 0 015 12v-2m14 0v2a7 7 0 01-.11 1.23M12 19v4M8 23h8"/></symbol><symbol id="mic" viewBox="0 0 24 24"><path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/><path d="M19 10v2a7 7 0 01-14 0v-2M12 19v4M8 23h8"/></symbol><symbol id="minimize-2" viewBox="0 0 24 24"><path d="M4 14h6v6M20 10h-6V4M14 10l7-7M3 21l7-7"/></symbol><symbol id="minimize" viewBox="0 0 24 24"><path d="M8 3v3a2 2 0 01-2 2H3m18 0h-3a2 2 0 01-2-2V3m0 18v-3a2 2 0 012-2h3M3 16h3a2 2 0 012 2v3"/></symbol><symbol id="minus-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/></symbol><symbol id="minus-square" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><path d="M8 12h8"/></symbol><symbol id="minus" viewBox="0 0 24 24"><path d="M5 12h14"/></symbol><symbol id="monitor" viewBox="0 0 24 24"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><path d="M8 21h8M12 17v4"/></symbol><symbol id="moon" viewBox="0 0 24 24"><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></symbol><symbol id="more-horizontal" viewBox="0 0 24 24"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></symbol><symbol id="more-vertical" viewBox="0 0 24 24"><circle cx="12" cy="12" r="1"/><circle cx="12" cy="5" r="1"/><circle cx="12" cy="19" r="1"/></symbol><symbol id="mouse-pointer" viewBox="0 0 24 24"><path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3zM13 13l6 6"/></symbol><symbol id="move" viewBox="0 0 24 24"><path d="M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20"/></symbol><symbol id="music" viewBox="0 0 24 24"><path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/></symbol><symbol id="navigation-2" viewBox="0 0 24 24"><path d="M12 2l7 19-7-4-7 4 7-19z"/></symbol><symbol id="navigation" viewBox="0 0 24 24"><path d="M3 11l19-9-9 19-2-8-8-2z"/></symbol><symbol id="octagon" viewBox="0 0 24 24"><path d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2z"/></symbol><symbol id="package" viewBox="0 0 24 24"><path d="M16.5 9.4l-9-5.19M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><path d="M3.27 6.96L12 12.01l8.73-5.05M12 22.08V12"/></symbol><symbol id="paperclip" viewBox="0 0 24 24"><path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"/></symbol><symbol id="pause-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M10 15V9M14 15V9"/></symbol><symbol id="pause" viewBox="0 0 24 24"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></symbol><symbol id="pen-tool" viewBox="0 0 24 24"><path d="M12 19l7-7 3 3-7 7-3-3z"/><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5zM2 2l7.586 7.586"/><circle cx="11" cy="11" r="2"/></symbol><symbol id="percent" viewBox="0 0 24 24"><path d="M19 5L5 19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></symbol><symbol id="phone-call" viewBox="0 0 24 24"><path d="M15.05 5A5 5 0 0119 8.95M15.05 1A9 9 0 0123 8.94m-1 7.98v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></symbol><symbol id="phone-forwarded" viewBox="0 0 24 24"><path d="M19 1l4 4-4 4M15 5h8M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></symbol><symbol id="phone-incoming" viewBox="0 0 24 24"><path d="M16 2v6h6M23 1l-7 7M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></symbol><symbol id="phone-missed" viewBox="0 0 24 24"><path d="M23 1l-6 6M17 1l6 6M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></symbol><symbol id="phone-off" viewBox="0 0 24 24"><path d="M10.68 13.31a16 16 0 003.41 2.6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7 2 2 0 011.72 2v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.42 19.42 0 01-3.33-2.67m-2.67-3.34a19.79 19.79 0 01-3.07-8.63A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91M23 1L1 23"/></symbol><symbol id="phone-outgoing" viewBox="0 0 24 24"><path d="M23 7V1h-6M16 8l7-7M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></symbol><symbol id="phone" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"/></symbol><symbol id="pie-chart" viewBox="0 0 24 24"><path d="M21.21 15.89A10 10 0 118 2.83M22 12A10 10 0 0012 2v10z"/></symbol><symbol id="play-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M10 8l6 4-6 4V8z"/></symbol><symbol id="play" viewBox="0 0 24 24"><path d="M5 3l14 9-14 9V3z"/></symbol><symbol id="plus-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M12 8v8M8 12h8"/></symbol><symbol id="plus-square" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><path d="M12 8v8M8 12h8"/></symbol><symbol id="plus" viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></symbol><symbol id="pocket" viewBox="0 0 24 24"><path d="M4 3h16a2 2 0 012 2v6a10 10 0 01-10 10A10 10 0 012 11V5a2 2 0 012-2z"/><path d="M8 10l4 4 4-4"/></symbol><symbol id="power" viewBox="0 0 24 24"><path d="M18.36 6.64a9 9 0 11-12.73 0M12 2v10"/></symbol><symbol id="printer" viewBox="0 0 24 24"><path d="M6 9V2h12v7M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><path d="M6 14h12v8H6z"/></symbol><symbol id="radio" viewBox="0 0 24 24"><circle cx="12" cy="12" r="2"/><path d="M16.24 7.76a6 6 0 010 8.49m-8.48-.01a6 6 0 010-8.49m11.31-2.82a10 10 0 010 14.14m-14.14 0a10 10 0 010-14.14"/></symbol><symbol id="refresh-ccw" viewBox="0 0 24 24"><path d="M1 4v6h6M23 20v-6h-6"/><path d="M20.49 9A9 9 0 005.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 013.51 15"/></symbol><symbol id="refresh-cw" viewBox="0 0 24 24"><path d="M23 4v6h-6M1 20v-6h6"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/></symbol><symbol id="repeat" viewBox="0 0 24 24"><path d="M17 1l4 4-4 4"/><path d="M3 11V9a4 4 0 014-4h14M7 23l-4-4 4-4"/><path d="M21 13v2a4 4 0 01-4 4H3"/></symbol><symbol id="rewind" viewBox="0 0 24 24"><path d="M11 19l-9-7 9-7v14zM22 19l-9-7 9-7v14z"/></symbol><symbol id="rotate-ccw" viewBox="0 0 24 24"><path d="M1 4v6h6"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></symbol><symbol id="rotate-cw" viewBox="0 0 24 24"><path d="M23 4v6h-6"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></symbol><symbol id="rss" viewBox="0 0 24 24"><path d="M4 11a9 9 0 019 9M4 4a16 16 0 0116 16"/><circle cx="5" cy="19" r="1"/></symbol><symbol id="save" viewBox="0 0 24 24"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z"/><path d="M17 21v-8H7v8M7 3v5h8"/></symbol><symbol id="scissors" viewBox="0 0 24 24"><circle cx="6" cy="6" r="3"/><circle cx="6" cy="18" r="3"/><path d="M20 4L8.12 15.88M14.47 14.48L20 20M8.12 8.12L12 12"/></symbol><symbol id="search" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></symbol><symbol id="send" viewBox="0 0 24 24"><path d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z"/></symbol><symbol id="server" viewBox="0 0 24 24"><rect x="2" y="2" width="20" height="8" rx="2" ry="2"/><rect x="2" y="14" width="20" height="8" rx="2" ry="2"/><path d="M6 6h.01M6 18h.01"/></symbol><symbol id="settings" viewBox="0 0 24 24"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"/></symbol><symbol id="share-2" viewBox="0 0 24 24"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98"/></symbol><symbol id="share" viewBox="0 0 24 24"><path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13"/></symbol><symbol id="shield-off" viewBox="0 0 24 24"><path d="M19.69 14a6.9 6.9 0 00.31-2V5l-8-3-3.16 1.18M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 005.62-4.38M1 1l22 22"/></symbol><symbol id="shield" viewBox="0 0 24 24"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></symbol><symbol id="shopping-bag" viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></symbol><symbol id="shopping-cart" viewBox="0 0 24 24"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></symbol><symbol id="shuffle" viewBox="0 0 24 24"><path d="M16 3h5v5M4 20L21 3M21 16v5h-5M15 15l6 6M4 4l5 5"/></symbol><symbol id="sidebar" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><path d="M9 3v18"/></symbol><symbol id="skip-back" viewBox="0 0 24 24"><path d="M19 20L9 12l10-8v16zM5 19V5"/></symbol><symbol id="skip-forward" viewBox="0 0 24 24"><path d="M5 4l10 8-10 8V4zM19 5v14"/></symbol><symbol id="slack" viewBox="0 0 24 24"><path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5zM20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5zM3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14zM14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5zM15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zM10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5zM8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"/></symbol><symbol id="slash" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M4.93 4.93l14.14 14.14"/></symbol><symbol id="sliders" viewBox="0 0 24 24"><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"/></symbol><symbol id="smartphone" viewBox="0 0 24 24"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><path d="M12 18h.01"/></symbol><symbol id="smile" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2M9 9h.01M15 9h.01"/></symbol><symbol id="speaker" viewBox="0 0 24 24"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"/><circle cx="12" cy="14" r="4"/><path d="M12 6h.01"/></symbol><symbol id="square" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/></symbol><symbol id="star" viewBox="0 0 24 24"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></symbol><symbol id="stop-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9 9h6v6H9z"/></symbol><symbol id="sun" viewBox="0 0 24 24"><circle cx="12" cy="12" r="5"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></symbol><symbol id="sunrise" viewBox="0 0 24 24"><path d="M17 18a5 5 0 00-10 0M12 2v7M4.22 10.22l1.42 1.42M1 18h2M21 18h2M18.36 11.64l1.42-1.42M23 22H1M8 6l4-4 4 4"/></symbol><symbol id="sunset" viewBox="0 0 24 24"><path d="M17 18a5 5 0 00-10 0M12 9V2M4.22 10.22l1.42 1.42M1 18h2M21 18h2M18.36 11.64l1.42-1.42M23 22H1M16 5l-4 4-4-4"/></symbol><symbol id="tablet" viewBox="0 0 24 24"><rect x="4" y="2" width="16" height="20" rx="2" ry="2"/><path d="M12 18h.01"/></symbol><symbol id="tag" viewBox="0 0 24 24"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82zM7 7h.01"/></symbol><symbol id="target" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></symbol><symbol id="terminal" viewBox="0 0 24 24"><path d="M4 17l6-6-6-6M12 19h8"/></symbol><symbol id="thermometer" viewBox="0 0 24 24"><path d="M14 14.76V3.5a2.5 2.5 0 00-5 0v11.26a4.5 4.5 0 105 0z"/></symbol><symbol id="thumbs-down" viewBox="0 0 24 24"><path d="M10 15v4a3 3 0 003 3l4-9V2H5.72a2 2 0 00-2 1.7l-1.38 9a2 2 0 002 2.3zm7-13h2.67A2.31 2.31 0 0122 4v7a2.31 2.31 0 01-2.33 2H17"/></symbol><symbol id="thumbs-up" viewBox="0 0 24 24"><path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3zM7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3"/></symbol><symbol id="toggle-left" viewBox="0 0 24 24"><rect x="1" y="5" width="22" height="14" rx="7" ry="7"/><circle cx="8" cy="12" r="3"/></symbol><symbol id="toggle-right" viewBox="0 0 24 24"><rect x="1" y="5" width="22" height="14" rx="7" ry="7"/><circle cx="16" cy="12" r="3"/></symbol><symbol id="tool" viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></symbol><symbol id="trash-2" viewBox="0 0 24 24"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6"/></symbol><symbol id="trash" viewBox="0 0 24 24"><path d="M3 6h18M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></symbol><symbol id="tree-input" viewBox="0 0 24 24"><path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4M10 17l5-5-5-5M15 12H3"/></symbol><symbol id="tree-output" viewBox="0 0 24 24"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></symbol><symbol id="tree-parameter" viewBox="0 0 24 24"><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6"/></symbol><symbol id="tree-unknown" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3M12 17h.01"/></symbol><symbol id="trello" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><path d="M7 7h3v9H7zM14 7h3v5h-3z"/></symbol><symbol id="trending-down" viewBox="0 0 24 24"><path d="M23 18l-9.5-9.5-5 5L1 6"/><path d="M17 18h6v-6"/></symbol><symbol id="trending-up" viewBox="0 0 24 24"><path d="M23 6l-9.5 9.5-5-5L1 18"/><path d="M17 6h6v6"/></symbol><symbol id="triangle" viewBox="0 0 24 24"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/></symbol><symbol id="truck" viewBox="0 0 24 24"><path d="M1 3h15v13H1zM16 8h4l3 3v5h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></symbol><symbol id="tv" viewBox="0 0 24 24"><rect x="2" y="7" width="20" height="15" rx="2" ry="2"/><path d="M17 2l-5 5-5-5"/></symbol><symbol id="twitch" viewBox="0 0 24 24"><path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"/></symbol><symbol id="twitter" viewBox="0 0 24 24"><path d="M23 3a10.9 10.9 0 01-3.14 1.53 4.48 4.48 0 00-7.86 3v1A10.66 10.66 0 013 4s-4 9 5 13a11.64 11.64 0 01-7 2c9 5 20 0 20-11.5a4.5 4.5 0 00-.08-.83A7.72 7.72 0 0023 3z"/></symbol><symbol id="type" viewBox="0 0 24 24"><path d="M4 7V4h16v3M9 20h6M12 4v16"/></symbol><symbol id="umbrella" viewBox="0 0 24 24"><path d="M23 12a11.05 11.05 0 00-22 0zm-5 7a3 3 0 01-6 0v-7"/></symbol><symbol id="underline" viewBox="0 0 24 24"><path d="M6 3v7a6 6 0 006 6 6 6 0 006-6V3M4 21h16"/></symbol><symbol id="unlock" viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 019.9-1"/></symbol><symbol id="upload-cloud" viewBox="0 0 24 24"><path d="M16 16l-4-4-4 4M12 12v9"/><path d="M20.39 18.39A5 5 0 0018 9h-1.26A8 8 0 103 16.3"/><path d="M16 16l-4-4-4 4"/></symbol><symbol id="upload" viewBox="0 0 24 24"><path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"/></symbol><symbol id="user-check" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M17 11l2 2 4-4"/></symbol><symbol id="user-minus" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M23 11h-6"/></symbol><symbol id="user-plus" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M20 8v6M23 11h-6"/></symbol><symbol id="user-x" viewBox="0 0 24 24"><path d="M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="8.5" cy="7" r="4"/><path d="M18 8l5 5M23 8l-5 5"/></symbol><symbol id="user" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></symbol><symbol id="users" viewBox="0 0 24 24"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></symbol><symbol id="video-off" viewBox="0 0 24 24"><path d="M16 16v1a2 2 0 01-2 2H3a2 2 0 01-2-2V7a2 2 0 012-2h2m5.66 0H14a2 2 0 012 2v3.34l1 1L23 7v10M1 1l22 22"/></symbol><symbol id="video" viewBox="0 0 24 24"><path d="M23 7l-7 5 7 5V7z"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></symbol><symbol id="voicemail" viewBox="0 0 24 24"><circle cx="5.5" cy="11.5" r="4.5"/><circle cx="18.5" cy="11.5" r="4.5"/><path d="M5.5 16h13"/></symbol><symbol id="volume-1" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5zM15.54 8.46a5 5 0 010 7.07"/></symbol><symbol id="volume-2" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5zM19.07 4.93a10 10 0 010 14.14M15.54 8.46a5 5 0 010 7.07"/></symbol><symbol id="volume-x" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5zM23 9l-6 6M17 9l6 6"/></symbol><symbol id="volume" viewBox="0 0 24 24"><path d="M11 5L6 9H2v6h4l5 4V5z"/></symbol><symbol id="watch" viewBox="0 0 24 24"><circle cx="12" cy="12" r="7"/><path d="M12 9v3l1.5 1.5M16.51 17.35l-.35 3.83a2 2 0 01-2 1.82H9.83a2 2 0 01-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 019.83 1h4.35a2 2 0 012 1.82l.35 3.83"/></symbol><symbol id="wifi-off" viewBox="0 0 24 24"><path d="M1 1l22 22M16.72 11.06A10.94 10.94 0 0119 12.55M5 12.55a10.94 10.94 0 015.17-2.39M10.71 5.05A16 16 0 0122.58 9M1.42 9a15.91 15.91 0 014.7-2.88M8.53 16.11a6 6 0 016.95 0M12 20h.01"/></symbol><symbol id="wifi" viewBox="0 0 24 24"><path d="M5 12.55a11 11 0 0114.08 0M1.42 9a16 16 0 0121.16 0M8.53 16.11a6 6 0 016.95 0M12 20h.01"/></symbol><symbol id="wind" viewBox="0 0 24 24"><path d="M9.59 4.59A2 2 0 1111 8H2m10.59 11.41A2 2 0 1014 16H2m15.73-8.27A2.5 2.5 0 1119.5 12H2"/></symbol><symbol id="x-circle" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><path d="M15 9l-6 6M9 9l6 6"/></symbol><symbol id="x-octagon" viewBox="0 0 24 24"><path d="M7.86 2h8.28L22 7.86v8.28L16.14 22H7.86L2 16.14V7.86L7.86 2zM15 9l-6 6M9 9l6 6"/></symbol><symbol id="x-square" viewBox="0 0 24 24"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><path d="M9 9l6 6M15 9l-6 6"/></symbol><symbol id="x" viewBox="0 0 24 24"><path d="M18 6L6 18M6 6l12 12"/></symbol><symbol id="youtube" viewBox="0 0 24 24"><path d="M22.54 6.42a2.78 2.78 0 00-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 00-1.94 2A29 29 0 001 11.75a29 29 0 00.46 5.33A2.78 2.78 0 003.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 001.94-2 29 29 0 00.46-5.25 29 29 0 00-.46-5.33z"/><path d="M9.75 15.02l5.75-3.27-5.75-3.27v6.54z"/></symbol><symbol id="zap-off" viewBox="0 0 24 24"><path d="M12.41 6.75L13 2l-2.43 2.92M18.57 12.91L21 10h-5.34M8 8l-5 6h9l-1 8 5-6M1 1l22 22"/></symbol><symbol id="zap" viewBox="0 0 24 24"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></symbol><symbol id="zoom-in" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M11 8v6M8 11h6"/></symbol><symbol id="zoom-out" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35M8 11h6"/></symbol></svg>', X_ = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: J_
}, Symbol.toStringTag, { value: "Module" })), $_ = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    defaultSize: null,
    minSize: { default: 250 },
    maxSize: { default: null }
  },
  setup(i, { expose: e }) {
    const t = i, { isHorizontal: r, onAreaAdd: n } = hn(Ku), a = R(null), o = R(!0), s = R(null), c = R(null), l = me(() => a.value !== null), u = me(() => ({
      ...l.value && {
        flex: `0 0 ${a.value}px`
      },
      ...!r && {
        "flex-direction": "column"
      }
    })), h = () => {
      o.value = !1, a.value = null;
    }, d = (I) => {
      const A = c.value, L = s.value;
      let y = 0;
      if (L && (y = r ? L.clientWidth / 2 : L.clientHeight / 2), r) {
        const D = Math.min(I.clientX, document.body.clientWidth - y * 2);
        a.value = Math.max(D + y - A.offsetLeft, t.minSize);
      } else {
        const D = Math.min(I.clientY, document.body.clientHeight - y * 2);
        a.value = Math.max(D + y - A.offsetTop, t.minSize);
      }
      t.maxSize !== null && (a.value = Math.min(a.value, t.maxSize));
    }, v = () => {
      m();
    }, M = () => {
      g();
    }, m = () => {
      window.addEventListener("mousemove", d), window.addEventListener("mouseup", M), window.addEventListener("contextmenu", M);
    }, g = () => {
      window.removeEventListener("mousemove", d), window.removeEventListener("mouseup", M), window.removeEventListener("contextmenu", M);
    };
    return Ht(() => {
      var I;
      if (t.defaultSize)
        a.value = t.defaultSize;
      else {
        const A = c.value;
        a.value = r ? A.clientWidth : A.clientHeight;
      }
      n((I = fi()) == null ? void 0 : I.proxy), t.maxSize && t.minSize > t.maxSize && console.warn("Your minsize is bigger than your maxSize, this won't work");
    }), e({ disableResizer: h }), { __sfc: !0, props: t, isHorizontal: r, onAreaAdd: n, size: a, isResizeable: o, resizerRef: s, splitAreaRef: c, hasSize: l, styleObject: u, disableResizer: h, onMouseMove: d, onMouseDown: v, onMouseUp: M, bindEvents: m, unbindEvents: g };
  }
});
var q_ = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return t("div", { ref: "splitAreaRef", staticClass: "v-split-area", style: r.styleObject }, [t("div", { staticClass: "v-split-inner" }, [e._t("default")], 2), r.isResizeable ? t("div", { ref: "resizerRef", staticClass: "resizer", class: { horizontal: r.isHorizontal, vertical: !r.isHorizontal }, on: { mousedown: r.onMouseDown } }) : e._e()]);
}, K_ = [], e3 = /* @__PURE__ */ Ge(
  $_,
  q_,
  K_,
  !1,
  null,
  null,
  null,
  null
);
const t3 = e3.exports, i3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t3
}, Symbol.toStringTag, { value: "Module" })), r3 = /* @__PURE__ */ ge({
  __name: "index",
  props: {
    name: null,
    isDisabled: { type: Boolean, default: !1 },
    id: null,
    prefix: { default: "" },
    suffix: { default: "" }
  },
  setup(i, { expose: e }) {
    const t = i, r = R(!1), n = me(() => t.id ? t.id : t.name.toLowerCase().replace(/ /g, "-")), a = me(() => t.prefix + t.name + t.suffix), o = me(() => t.isDisabled ? "#" : `#${n.value}`), s = () => {
      r.value = !r.value;
    }, c = () => {
      r.value = !1;
    }, l = () => {
      r.value = !0;
    };
    return Ht(() => {
      var h;
      const u = hn(ed);
      u == null || u.addTab((h = fi()) == null ? void 0 : h.proxy);
    }), e({
      header: a,
      hash: o,
      isActive: r,
      toggle: s,
      deActivate: c,
      activate: l
    }), { __sfc: !0, props: t, isActive: r, computedID: n, header: a, hash: o, toggle: s, deActivate: c, activate: l };
  }
});
var n3 = function() {
  var e = this, t = e._self._c, r = e._self._setupProxy;
  return r.isActive ? t("section", e._b({ staticClass: "v-tab" }, "section", e.$attrs, !1), [e._t("default")], 2) : e._e();
}, a3 = [], s3 = /* @__PURE__ */ Ge(
  r3,
  n3,
  a3,
  !1,
  null,
  null,
  null,
  null
);
const o3 = s3.exports, l3 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: o3
}, Symbol.toStringTag, { value: "Module" }));
export {
  g3 as Bootstrap,
  Aw as ColorManager,
  ah as DialogKey,
  sh as FlitsKey,
  H_ as Iconloader,
  ch as ModalKey,
  z_ as ModalPlugin,
  Cw as Plot,
  D_ as dialogPlugin,
  E_ as flitsPlugin,
  d3 as provideDialog,
  p3 as provideFlits,
  f3 as provideModal,
  h3 as useDialog,
  C_ as useFlits,
  m3 as useModal,
  Lw as usePlot,
  _h as vCheckbox,
  Ph as vCollapse,
  vu as vContextmenu,
  S_ as vDialog,
  Jh as vFile,
  lh as vFlits,
  d_ as vHex,
  pn as vIcon,
  um as vInput,
  gm as vLoader,
  m1 as vLogo,
  U_ as vModal,
  Nm as vMore,
  zm as vPanel,
  zw as vPlot,
  J0 as vPopover,
  rg as vPromiseButton,
  cg as vRadio,
  mg as vSelect,
  Ig as vSplitter,
  Dg as vSwitch,
  Pg as vTabs,
  kg as vTextarea,
  v_ as vToggleDarkmode,
  Iv as vTooltip,
  c1 as vTree
};
